export const bzAgendaSessions = [
    {
        "id": "UGxhbm5pbmdfMjEwOTc4NQ==",
        "titleTranslations": [
            {
                "value": "Padel Tournament at Jumeirah Al Qasr J Club Tennis and Padel Court",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 07:00:00",
        "endsAt": "2024-09-30 08:30:00",
        "descriptionTranslations": [
            {
                "value": "<p>Scheduled for a vibrant morning session, this activity promises not only a competitive edge but also a refreshing start to your day. Engaging in this fast-paced, fun-filled game will not only invigorate your body but also sharpen your mind, offering a unique opportunity to network and bond with fellow attendees. Embrace the spirit of hospitality through sport, and kick start your day with energy and inspiration.</p><p>Location: Jumeirah Al Qasr J Club Tennis and Padel Court(<a href=\"https://maps.app.goo.gl/vJWds568BbwDBukR8\">https://maps.app.goo.gl/vJWds568BbwDBukR8</a>)</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDk1MjgwMQ==",
                "definition": {
                    "isDefault": false,
                    "name": "Experiences"
                },
                "value": "experiences",
                "translations": [
                    {
                        "value": "Experiences"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjEwOTc3Nw==",
        "titleTranslations": [
            {
                "value": "Golf Tournament at Emirates Golf Club",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 08:00:00",
        "endsAt": "2024-09-30 10:30:00",
        "descriptionTranslations": [
            {
                "value": "<br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDk1MjgwMQ==",
                "definition": {
                    "isDefault": false,
                    "name": "Experiences"
                },
                "value": "experiences",
                "translations": [
                    {
                        "value": "Experiences"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzkzNQ==",
        "titleTranslations": [
            {
                "value": "Registration",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 09:00:00",
        "endsAt": "2024-09-30 11:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [],
        "speakers": [],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU1Mw==",
        "titleTranslations": [
            {
                "value": "Official Opening FHS World 2024",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 11:00:00",
        "endsAt": "2024-09-30 11:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/2yIzmcXkCt8?si=uBW8R4qsr40G_mo5\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE5Mjg0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/17a7878fe072462dbdfaa73230f5d186.jpeg",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU2MA==",
        "titleTranslations": [
            {
                "value": "The Future Growth of Tourism in Dubai: Harnessing Innovation, Sustainability, Accessibility and Leadership",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 11:15:00",
        "endsAt": "2024-09-30 11:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/PnEBzX0LWT0?si=dgsSAibY4O4UrEq8\" target=\"_blank\">Click here to watch online</a></p><p>Moderator: <strong>Jonathan Worsley</strong>, Chairman & CEO, the bench</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "green-construction-and-smart-cities",
                "translations": [
                    {
                        "value": "Green Construction & Smart Cities"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "His Excellency Issam AbdulRahim",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTI3NTQ1LFVzZXJfMTE4ODM4Nyk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Kazim",
                "photoUrl": "https://static.swapcard.com/public/images/cc09bac7d02c41b9bda4d21209c2863c.png",
                "organization": "Dubai Corporation for Tourism and Commerce Marketing (DCTCM)",
                "biography": "Issam Kazim is the CEO of Dubai Corporation for Tourism and Commerce Marketing (DCTCM), established in December 2013 as a subsidiary of Dubai Department of Economy and Tourism (DET).\n\nWith a global responsibility, Kazim has built DCTCM’s now 200+ person team and network of 40+ international offices from the ground up. He is the driving force behind a comprehensive branding, promotion, and marketing agenda, designed to support efforts to further consolidate Dubai’s position as a leading global city for business and leisure in line with the Dubai Economic Agenda, D33, as well as positioning it as the best city to visit, live and work in.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE5Mjg0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/17a7878fe072462dbdfaa73230f5d186.jpeg",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Green Construction & Smart Cities",
            "Sustainability & Innovation"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyOTkzOA==",
        "titleTranslations": [
            {
                "value": "Empowering Connections: Networking Session",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 11:15:00",
        "endsAt": "2024-09-30 12:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3MzE2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "women-leadership",
                "translations": [
                    {
                        "value": "Women Leadership"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Naureen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTQ4MDc3LFVzZXJfMjA0NDkzODIp",
                "jobTitle": "Founder",
                "lastName": "Ahmed",
                "photoUrl": "https://static.swapcard.com/public/images/80178a5951204f6190802570f888975e.jpeg",
                "organization": "Inspiring Women in Hospitality",
                "biography": "Naureen Ahmed is a seasoned hospitality professional, a fervent community builder, an engaging storyteller, and the visionary founder of ‘Inspiring Women in Hospitality’. \nRecognising the underrepresentation of women in hospitality, Naureen launched the ‘Inspiring Women in Hospitality’ podcast to amplify female voices and inspire change within the industry. Her efforts expanded in September 2023 with the creation of the Inspire Community, a platform designed to foster support among women through mentorship and career development discussions globally.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital",
            "Workshop",
            "Women Leadership"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMjAyNjc3Mg==",
        "titleTranslations": [
            {
                "value": "From Boom to Doom and Gloom – Overtourism’s Deja Woes",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 11:30:00",
        "endsAt": "2024-09-30 11:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/3BR3jll3XBQ?si=KSjI-WjW8ORAu2F6\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Aradhana",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTU5NTU4LFVzZXJfMTAwMzI1ODMp",
                "jobTitle": "CEO & Founder",
                "lastName": "Khowala",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1db9674ed24c4de5807e41f7e15ac1f1.jpeg",
                "organization": "Aptamind Partners",
                "biography": "Aradhana Khowala is globally identified as an authority on the travel, tourism, and hospitality industries and has over two decades of experience across 75 countries in 5 continents. She is currently CEO & Founder of Aptamind Partners a Private Client Advisory that is a trusted advisor to ambitious leaders in Governments, Family Offices, Private UHNW Attendeess, and International Organisations. Previously she was the MD of the Tourism Sector at NEOM - the US$ 500 Billion land of the future purpose built for a sustainable and a new way of living.\n\nAn experienced Board Member she has an active portfolio of Board roles and currently serves as the Chair of the Advisory Board of the Red Sea Project in Saudi Arabia which is a signature “Giga” project of Saudi Arabia Vision 2030, which, through breakthrough models for international tourism, sets new standards for sustainable development and environmental stewardship.\n\nAradhana also serves as a Board Member and Steering Committee member of World Tourism Forum Lucerne a highly focused, top level, strategic body that brings together selected leaders around the world to reflect on the big challenges facing the industry. She is also a Board Member of Elaf Group, the leisure arm of a sustainable and publicly listed holding company - SEDCO. In the past, she has worked for Jones Lang LaSalle, covering the UK, Benelux, and Scandinavian markets, a Strategy Consulting practice in Europe and Asia as well as in Hospitality Operations in India.\n\nAradhana has won multiple awards including the 21st Century Icon Awards in 2017 in association with CNBC and the London School of Economics as an Inspirational Game Changer in Tourism. In 2014, she was featured as one of the 50 most Influential Next Generation leaders who will likely define the future of the Tourism sector by Swiss Economic magazine Bilan (Forbes equivalent), and in 2021 she was featured as an inspirational woman rethinking a sustainable future of tourism by City Nation Place.\n\nA keen industry practitioner, she is a regular speaker and moderator well known for her international advocacy on sustainable tourism, climate change, women and diversity and has participated in global policy discussions in United Nations bodies, WEF as well as the G20 apart from some of the foremost Family Office conferences as well as Tourism and Leadership Summits around the world. She read at Cornell University in the US, is a certified NLP Coach, has an MBA from Ecole Hôtelière de Lausanne in Switzerland, and an International Director Certification from INSEAD in France.\n\nA passionate advocate of the transformative power of tourism and the prospect it presents for combining conservation with community, culture, and commerce, she spends a lot of her time engaging Presidents, Prime Ministers, and Tourism Ministers lobbying for travel and tourism as a force for good. She also guest lectures on tourism, authentic leadership, and entrepreneurship at different Universities globally.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0NQ==",
                                    "title": "Data Talks: The Future of Wellness - New Data on Wellness Travel",
                                    "beginsAt": "2024-04-29 13:50:00",
                                    "endsAt": "2024-04-29 14:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Mw==",
                                    "title": "TenX Leadership Talks: The Longevity Revolution and what the 100-year Life means for You and the Future of Hospitality",
                                    "beginsAt": "2024-04-30 14:00:00",
                                    "endsAt": "2024-04-30 14:25:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTU0Ng==",
        "titleTranslations": [
            {
                "value": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 11:30:00",
        "endsAt": "2024-09-30 12:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/yZCmr6xLGwI?si=YDqYbBgKapiLoM-6\" target=\"_blank\">Click here to watch online</a></p><p>Securing the Future of Hospitality and Tourism in The Maldives</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Tony",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjEwNzAyLFVzZXJfODc3ODYyMCk=",
                "jobTitle": "Partner",
                "lastName": "Miki",
                "photoUrl": "https://static.swapcard.com/public/images/c4507dfe7e6f47218b9f1ef46bda730c.jpeg",
                "organization": "Foster & Partners",
                "biography": "Tony studied architecture at the Wentworth Institute of Technology in Boston. Upon graduation in 1999 he joined Foster + Partners and worked on the Petronas University of Technology in Malaysia. Since then, he has been involved in a wide range of international projects including the design of a fleet of ten yachts for YachtPlus, The Waterfront, Japan; Gaafaru Masterplan in the Maldives and multiple projects in Saudi Arabia including Haramain High-Speed Rail, Jeddah Metro and King Salman International Airport. Tony was promoted to partner in 2014.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Eezan Shahul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTI3OTI3LFVzZXJfMTkxMzQ5MDMp",
                "jobTitle": "Chief Commercial Officer",
                "lastName": "Hameed",
                "photoUrl": "https://static.swapcard.com/public/images/277c33646dca4feea257ed48adeb7371.jpeg",
                "organization": "Maldives Fund Management Corporation",
                "biography": "Eezan Shahul Hameed, Chief Commercial Officer at Maldives Fund Management Corporation (MFMC), a Maldivian state-owned fund, investment, and asset management corporation, is currently developing unique hospitality projects in the Maldives. In his current role, Eezan manages the growth and operations of MFMC’s entire commercial portfolio. He has been instrumental in accelerating MFMC’s groundbreaking initiatives, setting unprecedented benchmarks across the Maldivian economy.\nPrior to being appointed as the CCO at MFMC, Eezan served as a Trade & Investment Consultant to the Ministry of Economic Development in the Maldives, where he focused on implementing the government’s trade and investment policies. His efforts were particularly notable in large-scale projects such as the new gateway port in Male’ and the international airport in northern Maldives. His key achievements include launching the country’s first unemployment benefit scheme, which positively impacted the local economy during the COVID-19 pandemic.\nEezan is also well-accomplished in the hospitality field, a sector he is passionate about. He has advised new investors on property acquisitions and provided project management services for resort developments. Moreover, he has led negotiations securing contracts with renowned hotel brands.\nAs the CCO of MFMC, Eezan is a driving force behind groundbreaking integrated tourism projects being introduced for the first time in the Maldives. His ability to identify and capitalize on new business opportunities and foster relationships with key stakeholders has been a hallmark of his career, enabling MFMC to secure long-term partnerships with elite corporations across various industries.\nEezan’s track record of successfully leading high-profile projects, combined with his supportive and approachable leadership style, makes him stand out in his field. His expertise and strategic insights continue to drive impactful results for MFMC and the broader Maldivian economy.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Ben",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNzE0OTYyLFVzZXJfMTE5MTc1Nik=",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Baseley-Walker",
                "photoUrl": "https://static.swapcard.com/public/images/d56dd714dff84ff7aaf1c558c1c30e56.jpeg",
                "organization": "Andart Global",
                "biography": "Ben is the Managing Partner of Andart Global, a boutique strategy and advisory firm based in the GCC .He leads Andart’s strategy and reputation management work, delivering flagship projects across the GCC region.\n\nBen has extensive experience working in diplomacy, technology and global affairs for both private and public sector stakeholders including governments, the UN and multinational corporations.\n\nBen and his team excel in helping clients effectively craft a compelling and authentic position while actively safeguarding reputation. Notable GCC projects focused on situation-specific tactical advisory for destination marketing strategy, and increasing awareness of emerging markets and tourist destinations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                                    "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                                    "beginsAt": "2024-04-30 15:30:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Global Investments"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU1NA==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talk: Building Tomorrow's Foundation for the Future of Travel",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 11:45:00",
        "endsAt": "2024-09-30 12:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/w6axh7ntUDU?si=rRWDHL96PL_B-VKk\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nick van",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMjEwMjc0LFVzZXJfMTQ0NjYyNSk=",
                "jobTitle": "Managing Director",
                "lastName": "Marken",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ed2db4e72efa4ce59d4a89da87348f17.jpeg",
                "organization": "van Marken Limited",
                "biography": "Nick is currently acting as senior adviser to a range of hospitality owners, investors and operators. He serves a wide spectrum of clients, including Family Offices; Private Equity; Sovereign Wealth Funds and Corporates. Nick spent the early part of his career in hotel operations in Africa and Europe, working with Holiday Inn, Sun International, Gleneagles and Meridien. Thereafter he spent close to 30 years in Professional Services - with PKF, Arthur Andersen and Deloitte, based variously in London, Hong Kong and the Gulf. He has worked in over 125 countries and 250 markets and both lived and worked in the Region for close to four decades. Nick and his family split their time between Dubai, Cape Town and London.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Paul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNTg2OTAyLFVzZXJfMTE4ODU0MSk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Griffiths",
                "photoUrl": "https://static.swapcard.com/public/images/5a2b9cf9f3544a5e89a8cbe61d6e9902.jpeg",
                "organization": "Dubai Airports",
                "biography": "As CEO of Dubai Airports, Paul Griffiths oversees the operation and development of Dubai International (DXB) and Dubai World Central (DWC). Since joining Dubai Airports in 2007, Paul has headed the launch of major infrastructure projects including Terminal 3, Concourses A, B, and D, and DWC. Under his leadership, Dubai Airports successfully managed the Covid-19 crisis, leading the aviation industry’s global efforts to reconnect the world and enable social and economic recovery. Prior to moving to Dubai, Paul was the MD of London’s Gatwick Airport. Earlier he spent 14 years with the Virgin Group, working closely with Sir Richard Branson as a Board Director of the Virgin Travel Group.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Talks",
            "Projects & Destinations"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjEzNDk0Mg==",
        "titleTranslations": [
            {
                "value": "India 2047: Unlocking the Future of Hospitality in a Rising Global Power",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 12:00:00",
        "endsAt": "2024-09-30 12:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/hE3waHZrIZA?si=mVTX9tnjvFTrfkEp\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr. Suruchi",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzA0NjI5LFVzZXJfMjExNTMwMTQp",
                "jobTitle": "Chief Industry Officer and Senior Vice President",
                "lastName": "Mittar",
                "photoUrl": "https://static.swapcard.com/public/images/02b261c04d354fd79eb59ec48642de8c.jpeg",
                "organization": "Invest India",
                "biography": "Dr. Suruchi Mittar is a seasoned leader with over 25 years of experience in academia, corporate governance, and policy advocacy. As Chief Industry Officer at Invest India, she drives investment in key sectors like tourism, media, and pharmaceuticals. With her Ph.D. in Philosophy, Dr. Mittar brings unique insights to her leadership. She has led initiatives to promote innovation, sustainability, and inclusive growth in India and globally.\n\nPrior to her current role, Dr. Mittar founded Sanai Changemakers, where she focused on strategic HR, leadership development, and organizational design. She has also served as a senior faculty member at the prestigious National Institute of Fashion Technology for more than 15 years.\n\nDr. Mittar has leveraged her expertise across diverse geographies, including the UK, Europe, Australia, Bangladesh, Jordan, and Ethiopia, to optimize operations and empower communities. Her leadership is characterized by a holistic approach, encompassing strategic vision, operational excellence, and a deep-seated commitment to ethical business practices.\n\nAt Invest India, Dr. Mittar has been instrumental in transforming the Tourism Team into a strategic hub that bridges the gap between government and private investment opportunities. She has developed a unified framework to align diverse stakeholders, fostering a favorable environment for increased investment in India's tourism sector.\n\nHer leadership extends to elevating India's art and craft sector, as well as developing strategic frameworks for promoting Indian industries in countries like Myanmar. Collaborating with global organizations such as the International Labour Organization (ILO) and the United Nations Environment Programme (UNEP), Dr. Mittar's work underscores her global vision, commitment to sustainable development, and passion for inclusive growth.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Amit",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMDkxNDIxLFVzZXJfMTYyMTI2NSk=",
                "jobTitle": "Vice President",
                "lastName": "Nayak, CHA",
                "photoUrl": "https://static.swapcard.com/public/images/1de1fe42566f4d0dbdb24885e0724c4b.jpeg",
                "organization": "HAMA MEA",
                "biography": "Amit Nayak is a seasoned Senior Asset Management Specialist with expertise in Property Development, Private Equity, and Family Office operations. Until recently, he served as Vice President of Asset Management at Dubai Holding, overseeing & supporting the strategic management of over 50 global properties. Currently, Amit is a member of the Hospitality Advisory Committee under the UAE Ministry of Economy, contributing to the growth and competitiveness of the UAE's tourism sector. His career began at One & Only Royal Mirage, and he holds advanced qualifications from Harvard and Cornell. Amit is also actively involved in mentoring and industry associations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjE0MzMxMw==",
        "titleTranslations": [
            {
                "value": "Announcement #1",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 12:00:00",
        "endsAt": "2024-09-30 12:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjE0OTEyOQ==",
        "titleTranslations": [
            {
                "value": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 12:00:00",
        "endsAt": "2024-09-30 12:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/8FCgQIURFXo?si=92uOgQVM9yv8y92D\" target=\"_blank\">Click here to watch online</a></p><p>Investing in the Maldives: Past and Future</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ben",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNzE0OTYyLFVzZXJfMTE5MTc1Nik=",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Baseley-Walker",
                "photoUrl": "https://static.swapcard.com/public/images/d56dd714dff84ff7aaf1c558c1c30e56.jpeg",
                "organization": "Andart Global",
                "biography": "Ben is the Managing Partner of Andart Global, a boutique strategy and advisory firm based in the GCC .He leads Andart’s strategy and reputation management work, delivering flagship projects across the GCC region.\n\nBen has extensive experience working in diplomacy, technology and global affairs for both private and public sector stakeholders including governments, the UN and multinational corporations.\n\nBen and his team excel in helping clients effectively craft a compelling and authentic position while actively safeguarding reputation. Notable GCC projects focused on situation-specific tactical advisory for destination marketing strategy, and increasing awareness of emerging markets and tourist destinations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                                    "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                                    "beginsAt": "2024-04-30 15:30:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Eezan Shahul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTI3OTI3LFVzZXJfMTkxMzQ5MDMp",
                "jobTitle": "Chief Commercial Officer",
                "lastName": "Hameed",
                "photoUrl": "https://static.swapcard.com/public/images/277c33646dca4feea257ed48adeb7371.jpeg",
                "organization": "Maldives Fund Management Corporation",
                "biography": "Eezan Shahul Hameed, Chief Commercial Officer at Maldives Fund Management Corporation (MFMC), a Maldivian state-owned fund, investment, and asset management corporation, is currently developing unique hospitality projects in the Maldives. In his current role, Eezan manages the growth and operations of MFMC’s entire commercial portfolio. He has been instrumental in accelerating MFMC’s groundbreaking initiatives, setting unprecedented benchmarks across the Maldivian economy.\nPrior to being appointed as the CCO at MFMC, Eezan served as a Trade & Investment Consultant to the Ministry of Economic Development in the Maldives, where he focused on implementing the government’s trade and investment policies. His efforts were particularly notable in large-scale projects such as the new gateway port in Male’ and the international airport in northern Maldives. His key achievements include launching the country’s first unemployment benefit scheme, which positively impacted the local economy during the COVID-19 pandemic.\nEezan is also well-accomplished in the hospitality field, a sector he is passionate about. He has advised new investors on property acquisitions and provided project management services for resort developments. Moreover, he has led negotiations securing contracts with renowned hotel brands.\nAs the CCO of MFMC, Eezan is a driving force behind groundbreaking integrated tourism projects being introduced for the first time in the Maldives. His ability to identify and capitalize on new business opportunities and foster relationships with key stakeholders has been a hallmark of his career, enabling MFMC to secure long-term partnerships with elite corporations across various industries.\nEezan’s track record of successfully leading high-profile projects, combined with his supportive and approachable leadership style, makes him stand out in his field. His expertise and strategic insights continue to drive impactful results for MFMC and the broader Maldivian economy.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Majd",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNzIwMzg0LFVzZXJfMTU3NjU1Njcp",
                "jobTitle": "Corporate Business Development Director",
                "lastName": "Hamamouchi",
                "photoUrl": "https://static.swapcard.com/public/images/40b37be6c6274e68bf11b6b4bce3393f.jpeg",
                "organization": "TIME Hotels",
                "biography": "Mr. Majd Hamamouchi is a Hospitality Business Development Executive with over 20 years of experience in leading strategic initiatives and driving revenue growth within the hospitality industry. He has a proven track record in identifying and capitalizing on new market opportunities, forging strong partnerships, and expanding brand presence across diverse regions.\n\nMr. Majd is passionate about leveraging industry expertise to drive long-term success. He is a goal - oriented person and recognized for exceptional negotiation skills, and strategic thinking. Mr. Majd has the ability to deliver sustainable growth in highly competitive markets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Amman",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzI4MTMxLFVzZXJfMjExNjgxMjQp",
                "jobTitle": "Executive Director",
                "lastName": "Shah",
                "photoUrl": "https://static.swapcard.com/public/images/9da5058d1bd54547acd5ede417a976ca.png",
                "organization": "Dubai Holding Investments",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Global Investments"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU1Nw==",
        "titleTranslations": [
            {
                "value": "Innovations and Trends Shaping the Future of Mobility",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 12:15:00",
        "endsAt": "2024-09-30 12:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/tvRionMf10k?si=f--XyPtCnM8hg1Ek\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Yasmine",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNjE0NjU5LFVzZXJfMTgyMzk3MTQp",
                "jobTitle": "Founder & Owner",
                "lastName": "Vanda Trofast",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bc950859492046ad952ecf3bfa045a74.jpeg",
                "organization": "YVT Consulting",
                "biography": "In the dynamic landscape of the creative economy, Yasmine Vanda Trofast stands out as a seasoned entrepreneur with a remarkable 17-year journey dedicated to fostering creativity and innovation. As the founder of YVT Consultancy, Yasmine has become a driving force in the cultural, creative, and event sectors, leaving an indelible mark on the industry.\n\nEstablished in 2021, YVT Consultancy has swiftly emerged as a sought-after consultancy ﬁrm, catering to prestigious clients such as the Royal Commission for AlUla, Abu Dhabi Government, the Diriyah Gate Development Authority (DGDA), and the Dubai Government. In the past year alone, YVT Consultancy has successfully executed 14 diverse projects, ranging from strategic consultancy to experiential development, communication and design, and operations management.\n\nOne of Yasmine's most notable contributions to the creative landscape is the inception of \"Creative Dialogues\" under the YVT umbrella. This event-based platform serves as a nexus for connecting and supporting creatives across the Arab world. Yasmine has taken the Creative Dialogues on a journey, traversing different cities to explore and interlink their vibrant creative scenes. This initiative not only showcases Yasmine's commitment to fostering collaboration but also highlights her visionary approach to empowering the creative community.\n\nYasmine's impact extends beyond consultancy and events; she has been a catalyst for growth in service of various businesses, ranging from startups and SMEs to government organizations. Her unwavering dedication ensures that her clients develop into their optimal positioning while also gaining a clear competitive advantage within their respective industries.\n\nDriven by an innate passion for the creative economy, Yasmine's career has been marked by successful initiatives spanning ideation, IP portfolio development, marketing communications, digital transformation, and business development negotiations. Her unique blend of skills, coupled with an in-depth agency background, allows Yasmine to bring genuine value to every industry she operates in.\n\nYasmine's inﬂuence is not conﬁned to a speciﬁc geographical region; she has worked with a broad spectrum of clients in the Middle East. Her ability to leverage her extensive experience and skills ensures that YVT Consultancy remains at the forefront of the creative economy, contributing signiﬁcantly to the growth and evolution of the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MTg0MQ==",
                                    "title": "Empowering Hospitality: Leading the Way in Crafting a Diverse, Inclusive Lifestyle Brand and Transforming Human Experience",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Dr. Martin",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMzgwMzE5LFVzZXJfODAwNTE4Myk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Šoltés",
                "photoUrl": "https://static.swapcard.com/public/images/505ed2fdbe6f4f1082e9cd7248e61887.jpeg",
                "organization": "EVUM Motors",
                "biography": "As Founder and Managing Director of EVUM Motors, Martin Šoltés is based in Munich, where he started the company in 2017 as a spin-off of the Technical University of Munich. He previously studied aerospace engineering in Stuttgart. From 2013 to 2018, he worked on vehicle concepts and mobility in developing countries at the Technical University of Munich. \nEVUM Motors' goal is to make a simple, modular and robust electric vehicle that can be used on roads around the world and enable everyone to access mobility. We see the electric vehicle as a source of power and energy and we want to enhance their impact on the way the work is done.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Sustainability & Innovation"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTU0OA==",
        "titleTranslations": [
            {
                "value": "Invest in Morocco:  Showcasing Unique Hospitality Projects",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 12:15:00",
        "endsAt": "2024-09-30 13:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/7xcasGn0lnk?si=8aovAaohLBD6o5R_\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-africa",
                "translations": [
                    {
                        "value": "Focus on Africa"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Younes",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyODI4NDg0LFVzZXJfNDk4NTk0Nik=",
                "jobTitle": "Director of Investment Development",
                "lastName": "Hajoui",
                "photoUrl": "https://static.swapcard.com/public/images/53c45e883355424bbfc9e6557b54be50.jpeg",
                "organization": "Moroccan Agency for Tourism Development SMIT",
                "biography": "Younes Hajoui is the Investment development manager at the Morrocan Agency for Tourism Development; he’s in charge of dealing with both national and international investors interested by the Moroccan tourism sector. Previously, Younes worked in multinational companies in Canada, USA and Mexico, and was in charge of international sales teams. \nHe’s also a part time professor in the entrepreneurship, sales and marketing fields.\nPassionate about international investment, Younes speaks four languages (English, Spanish, French and Arabic) and has an MBA in marketing from the ESG business School in the University of Quebec in Montreal, Canada.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Nada",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE5MjQ1LFVzZXJfNDQ2NDA0Mik=",
                "jobTitle": "Tourism Investment Maketing Department Head",
                "lastName": "Serhir",
                "photoUrl": "https://static.swapcard.com/public/images/547c4cf2a4684accaf92740cf0470983.jpeg",
                "organization": "The Moroccan Agency for Tourism Development (SMIT)",
                "biography": "Leading the effort to showcase tourism investment prospects in the Kingdom of Morocco, Nada Serhir spearheads the development and execution of the company's marketing and promotional strategy. Prior to her role at SMIT, Nada served in a prominent multinational company headquartered in Paris overseeing the marketing and communication strategies of the Group.\n\nNada Serhir holds  a DESA (Diplome des Etudes Superieures Approfondies) Degree from the Faculty of Education Sciences in Rabat, Morocco. With her extensive background and expertise, she brings a wealth of knowledge to her current position, driving initiatives to enhance the allure of Morocco as a prime destination for tourism investment.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Focus on Africa",
            "Global Investments"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjE0MzMyMA==",
        "titleTranslations": [
            {
                "value": "Annoucement #2",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 12:30:00",
        "endsAt": "2024-09-30 12:45:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjE0OTk3OA==",
        "titleTranslations": [
            {
                "value": "Masterplanning Hotels: Driving Strategic Decisions through Sentiment Data",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 12:30:00",
        "endsAt": "2024-09-30 12:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/OO61NKg2aqg?si=RRnzYlHQr3vMWki0\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Gustavo De",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODUwMzE3LFVzZXJfMTU3NTcyOTMp",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Hostos",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/7f3d496d1fa84a62b29c020bff30bed5.jpeg",
                "organization": "Forsite Creative",
                "biography": "Gustavo is the Founder and Managing Partner of Forsite Creative. He has worked on approximately 200 projects across Europe, the Middle East, and Africa over the past 12 years of which 10 years in the region.\n\nWith a strategic mind, operational background, and an eye for design; he manages several in-house multi-disciplinary teams (including Research, Data Analytics, Concept Developers, Interior Designers, Branding and Kitchen Designers) for coordinated end-results.\n\nToday Gustavo and his team work together with leading restaurant groups, hotel groups, but also work with real estate developers and government initiatives.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1Ng==",
                                    "title": "GRIF Data Report - Using Data to Competition Proof your Business and Invest in the Right Places",
                                    "beginsAt": "2024-04-29 10:50:00",
                                    "endsAt": "2024-04-29 11:05:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU1OQ==",
        "titleTranslations": [
            {
                "value": "The World's First AI-Created Restaurant",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 12:40:00",
        "endsAt": "2024-09-30 13:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ZadHq56Z3ck?si=XkFBfkLr1ZGFsf8Z\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Investment"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Techology & AI"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "James",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTM4ODA4LFVzZXJfMTYyNTA1MDkp",
                "jobTitle": "Founding Partner",
                "lastName": "Hacon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
                "organization": "Think Hospitality",
                "biography": "James is one of the leading names in hospitality growth, marketing & brand strategy, he has been an executive, board member, Attendees and consultant in the hospitality brand and technology sector for the past twenty years, having worked with more than 80 hospitality brands in 22 countries, from independent Michelin starred restaurants to leading restaurant brands, international hotel companies & contract caterers. \n\nHis brand experience includes Accor, IHG, Sodexo, Compass Group, Krispy Kreme, Costa Coffee, Diageo, AMREST, Jamie Oliver Group, Wagamama, Gleneagles & Pret. \n\nHe is regularly called upon as a commentator, writer, speaker & facilitator, giving him a unique insight into global trends and the very best brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                                    "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                                    "beginsAt": "2024-04-30 09:45:00",
                                    "endsAt": "2024-04-30 10:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                                    "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                                    "beginsAt": "2024-04-30 15:10:00",
                                    "endsAt": "2024-04-30 15:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Investment",
            "Techology & AI"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU2Ng==",
        "titleTranslations": [
            {
                "value": "Lunch",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 13:00:00",
        "endsAt": "2024-09-30 14:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg5Mw==",
        "titleTranslations": [
            {
                "value": "Sustainable Cook Off",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 13:00:00",
        "endsAt": "2024-09-30 14:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><strong>Judges:</strong></p><ul><li><strong>Atul Chopra</strong>, Founder & CEO, Fresh on Table</li><li><strong>Bhatt Dwarika</strong>, Dubai Chairman, Emirates Culinary Guild</li><li><strong>Amit Nayak, CHA</strong>, Vice President, HAMA MEA</li><li><strong>Majed Al Sabagh</strong>, Manager / Owner Chef Training and Consultancy</li><li><strong>Atim Suyatim</strong>, Vice President Public Relations, Emirates Culinary Guild</li><li><strong>Jonathan Worsley</strong>, Chairman & CEO, The Bench</li></ul>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "competitions",
                "translations": [
                    {
                        "value": "Competitions"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Competitions"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg5NA==",
        "titleTranslations": [
            {
                "value": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:00:00",
        "endsAt": "2024-09-30 15:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ISq0mcmzw0g\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "competitions",
                "translations": [
                    {
                        "value": "Competitions"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Lorelei",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjU5MTI0LFVzZXJfMTg2NjUzMCk=",
                "jobTitle": "Founder & CEO",
                "lastName": "Regragui",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/76a30635a1ac4c9f9ea238fae8fb80dd.jpeg",
                "organization": "StayK",
                "biography": "Lorelei is the MasterKey Keeper (Founder & CEO) of StayK; and a hoteliere at heart.\n\nLaunched in the summer of 2023, StayK is a Dubai-born experience-driven and domestic-focused Online Travel Agency, bridging the gap between staycation-fit hotels and local travelers, with a marketing agency approach in mind.\n\nLorelei started her career in the luxury hospitality industry in 2009, as an F&B Intern at the Hotel de Crillon in Paris, a Rosewood Hotel. After university, she joined Emirates Palace in Abu Dhabi in 2012, as a Rooms Division Intern. Followed by roles in 5 star hotels at Le Bristol Paris as a reservation agent, at Corporate Level at Oetker Collection as a Global E-Commerce Manager piloting the digital strategy for 9 luxury hotels, and heading back to the UAE as a Marketing & Communications Manager at Rosewood Abu Dhabi and at Waldorf Astoria Ras Al Khaimah as an E-Commerce Manager.\n\nHer 360-degree experience in the luxury hospitality industry, the observed market gap and need for a staycation-focused OTA, along with the ever-innovative and dynamic GCC’s tourism landscape, inspired her the idea of StayK, with the desire to leave a positive and high-impact footprint with hoteliers, and to humanize the online booking journey for local travelers.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Bell",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjU5MTY3LFVzZXJfMTc3MTY5OCk=",
                "jobTitle": "Co-Founder",
                "lastName": "Beh",
                "photoUrl": "https://static.swapcard.com/public/images/62eab754d9c34074a16003f989e2e73d.jpeg",
                "organization": "BuzzAr",
                "biography": "Bell is the Singapore’s Top 100 Women in Tech, current Saudi Singapore Business Council, Google AI Trailblazer 2024. \n\nBell runs BuzzAR, a top Travel AI company with double HQs in Saudi Arabia and Singapore. Bell graduated with a Master's degree from UC Berkeley; majoring in Law and Technology. \n\nBuzzAR runs a Tourist Engagement Platform, BAE (Buzz AI Experience), with the world’s first AI Travel Buddy, BAE is here to help users navigate in a foreign land, especially between the APAC region and the MENA region. BuzzAR incorporated a Travel Payment arm, BuzzPay. By serving 1 million travelers to the MENA region, the team is bringing in ~SAR/AED 12 Billion (USD3.2 Billion) to the MENA region.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Nisreen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjU5MjY3LFVzZXJfMjExMjQyMDcp",
                "jobTitle": "CEO/ Cofounder",
                "lastName": "Shadad",
                "photoUrl": "https://static.swapcard.com/public/images/beed45c140484682848bf5ca203d89a8.jpeg",
                "organization": "NetGreen",
                "biography": "With 12 years of experience and dual master's degrees in Innovation and International Business, I am driven by an unwavering commitment to catalyzing industries' transformation into sustainability through innovation. \n\nI established NetGreen for Climate Action platform to empower Retailers to lead change by engaging consumers in scaling up carbon removal projects with measurable and trackable impact to compensate for their unavoidable emissions and accelerate toward NetZero.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Gwen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzY0MzI1LFVzZXJfMjExODk2NDIp",
                "jobTitle": "CEO & Founder",
                "lastName": "Wunderlich",
                "photoUrl": "https://static.swapcard.com/public/images/ad0303cf6b7f4a5e9a47d4fa4c6262d0.jpeg",
                "organization": "WKC Global",
                "biography": "As CEO of WKC Global, Gwen Wunderlich is undoubtedly a powerhouse in the public relations, communications and branding industry. With over 26 years of experience and a proven track record of working with prestigious, high-profile clients in the fashion, entertainment, beauty, luxury, wellness, and lifestyle sectors, her reputation as a maverick is well-earned. \nCombining visionary thinking, innovative strategies, and an unparalleled work ethic, Gwen excels at leveraging her extensive network of connections and prescient understanding of cultural trends to deliver creative, strategically driven solutions for her clients. Her unique mix of imagination and intuition, and her ability to tap into the ebb and flow of popular culture, are key elements in her understanding of the cultural zeitgeist, which enables her to impact her clients and shape their stories and brand narratives. \nHer client list is a testament to her professional expertise and supreme versatility, ranging from top scientists and wellness renegades, to popular fashion designers, Grammy Award-winning celebrities, hospitality venues, government entities and high-powered executives. Her brand work includes representation and partnerships with some of the world’s leading companies and influential change-makers such as Bal Harbour Shops, Triller, Netflix, Maserati, Charlotte's Web, Procter & Gamble, Naja Lingerie, Hyatt Hotels, Besame Cosmetics, New Chapter, Sundance, Farmbox Direct, Liteboxer, Mastercard, Basma Beauty, Alicia Keys, Neil Degrasse Tyson, Swizz Beatz and The Royal Commission of AlUla. \nRecently, she expanded her agency's presence in the Middle East by opening a WKC Global communications office in Riyadh, Saudi Arabia, solidifying her progressive, forward-thinking approach to the PR and communications industry. In Saudi Arabia, she has executed and collaborated on projects such as the Women to Women event with Alicia Keys, Saudi Bronx for the AlUla Camel Cup, AlUla on Wheels with Swizz Beatz, The Khaybar Volcano Camp and more. Gwen’s deep understanding of the media landscape, and mastery of experiential programming, has led to standout global campaigns and client placements in top print, digital, and broadcast outlets, resulting in monumental success for her clients.\nAs a creative mind that continually focuses on the future, Gwen and WKC Global successfully launched the first ever, female-founded, AI-assisted platform called “PR For All” which enables entrepreneurs, small businesses and start-ups to effectively create cost-effective compelling brand narratives, thereby revolutionizing the PR landscape. Additionally, in 2021, WKC Global was the first female-led PR agency to accept cryptocurrency as payment for services. \nAs the co-creator of The Enternship, a charitable initiative aimed at helping women re-enter the workforce and rebrand themselves by leveraging the power of PR and social media, Gwen has helped countless women since 2014. The program, which has been hailed as pioneering an entire “re-entry” movement, has received widespread recognition, with over three  billion media impressions including CNN, FOX Business, Time, The Glossy, Forbes, Inc, NY Post, CNBC, The London Free Press, and Money. Even famed Hollywood director Nancy Meyers, creator of the movie The Intern, tweeted out about The Enternship. \nGwen started her career in public relations in 2001, when the corporate male dominated PR world was prevalent on Madison Ave. She was part of a tiny group of relentless female, small business owners who challenged the status quo in New York City by opening boutique-style, “pop-culture driven” PR agencies. Her early client roster included  MTV, Coca Cola, Dwell, Absolut Vodka, Camp Beverly Hills, Roc-A-Fella Records and more.\nIn demand as a speaker and authority on public relations, communications and branding, Gwen has spoken at The Women’s Conference in Boston and Texas, at Florida International University, the Fashion Institute of Technology, and Bergdorf Goodman. Recently, she was a cast member on Season Five of MTV’s hit series Siesta Key. Gwen is also the co-creator and co-host of “The Pretty Electric” podcast.\nShe has been profiled in numerous media articles and interviews highlighting her achievements and contributions, including PR Week, Yahoo Finance, Ad Age, Arab News, Entrepreneur, Medium, and The Observer, and is a graduate of the Harvard Business School Executive Program. She resides in Miami with a home in New York City.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Luis Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMDU5ODAxLFVzZXJfMTE4OTk5NTQp",
                "jobTitle": "Regional Manager Innovation Education and Investment",
                "lastName": "Barrios",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3e48bf508a3f4f5a855d9b179a19b4ec.jpeg",
                "organization": "UN Tourism",
                "biography": "Luis Nicolás Barrios Medina-Montoya, Innovation Education and Investments Regional Manager for the UNWTO Regional Office in Riyadh. \n\nMaster in Project Management from Esden Business School. PMI-certified PMP. Master in Marketing and Commercial Management from IE Business School. Master in Audio-visual Production from IEEA. Degree in Audio-visual Communication from the University of Malaga. \n\nExpert in technology and innovation applied to the tourism sector. From February 2003 until June 2020, he developed his professional career in Tourism in SEGITTUR, a state-owned company integrated into the Spanish Ministry of Industry Trade and Tourism and attached to the State Secretariat for Tourism, responsible for promoting innovation (R&D) in the Spanish tourism sector, both in the public sector.      \n\nSince 2012 he was involved, in different capacities, in the development and management of the Smart Tourist Destinations program. From 2019 to 2022 he was responsible for the direction and coordination of all the Smart Tourism Destination Projects in Latin America, coordinating projects in Tequila, Medellín and Bogotá.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jessica",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjU5MjQzLFVzZXJfNjYxNTQyMCk=",
                "jobTitle": "Co-founder & CMO",
                "lastName": "Scopacasa",
                "photoUrl": "https://static.swapcard.com/public/images/757a8479de824de9887c18161b9d464c.jpeg",
                "organization": "Olive Gaea",
                "biography": "essica is the co-founder of Olive Gaea, a UAE-based climate-tech startup offering AI-driven carbon management solutions. Recognized as a top female leader in sustainability, she has been honored by BCG, Google for Startups, and Standard Chartered. With 15 years in PR, International Affairs, and Sustainability, Jessica has guided organizations in MENA on strategic communications and sustainability. She holds a B.A. in Political Science, an M.A. in International Affairs (University of Turin), an M.A. in Strategic PR (George Washington University), and certifications in Sustainability from MIT, Harvard Extension School, and Harvard Business School Online.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Rana",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzAwMTgxLFVzZXJfOTQxMzk2MCk=",
                "jobTitle": "Co-Founder & COO",
                "lastName": "Batterjee",
                "photoUrl": "https://static.swapcard.com/public/images/6d1ceccc3eb54ca49aa87f7ebf8a1754.jpeg",
                "organization": "EduPloyment",
                "biography": "Rana Batterjee is the Chief Operating Officer and Co-Founder of EduPloyment, an AI-powered recruitment platform for workers. Previously, she co-founded Momair Trading LCC, a UAE-based F&B company, exiting in 2023. From 1993 to 2013, Rana had a successful career as an Audiologist, last serving as Director of the Cochlear Implant Centre at American Hospital Dubai. She holds degrees in Hearing and Speech Sciences (University of Maryland), Audiology (George Washington University), and a Doctorate in Audiology (University of Florida). A fellow of the WIn Fellowship (2023-24), Rana is a Saudi Arabian national, fluent in Arabic and English, residing in Dubai.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Dr. Hanin",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjU5NzM0LFVzZXJfMTE3ODg3Mzcp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Alsubaie",
                "photoUrl": "https://static.swapcard.com/public/images/988268f602614ab1be24580a6b9b087a.jpeg",
                "organization": "Darent",
                "biography": "Dr. Hanin Al-Subaie is the Founder, Chairman, and CEO of Darent, an innovative company at the forefront of tourism and real estate technology. With over nine years of experience in real estate and property management, she leverages her extensive knowledge to drive the evolution of the vacation rental market. Dr. Al-Subaie earned her PhD in Environmental Biology from King Saud University, with first Honor.\n\nEarlier in her career, she gained valuable experience working for Nestlé, a global food leader, where she honed her business during her studies. Dr. Al-Subaie later established her own real estate management company focused on the tourism sector, which allowed her to expand into the emerging field of real estate technology.\n\nIn 2021, she founded Darent with license from the Ministry of Tourism, positioning the company as a key player in the daily and vacation rental space. Under her leadership, Darent has embraced technology to redefine the customer experience and foster sustainable tourism practices.\n\nDr. Al-Subaie is a recognized leader and has been invited to speak at several prominent events. Notably, she participated in the Human Capabilities  Initiative sponsored by His Royal Highness Crown Prince Mohammed bin Salman Al Saud in 2024, where she addressed ministers and leaders from across the Kingdom. Additionally, she was a key speaker at the Environment Forum for Smart Buildings in 2023, focusing on advancements in real estate technologies.\n\nHer contributions to the travel and tourism sectors were acknowledged in 2024 when Forbes magazine named Dr. Al-Subaie one of the 100 most influential Tourism leaders in the industry. Through her vision and dedication to excellence, she continues to shape the future of tourism and real estate technology in the region.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Son-Trang",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTA1NDc2LFVzZXJfMTgyODgzNjgp",
                "jobTitle": "Production Manager",
                "lastName": "Nguyen",
                "photoUrl": "https://static.swapcard.com/public/images/1e4aa41125474fa99b31b1e8170ab3a0.jpeg",
                "organization": "The Bench",
                "biography": "Being at the crossroads of Vietnamese traditions, Canadian openness and Swiss work ethics, Son-Trang offers a broad and international view to BENCH as the Conference Production Manager. Son-Trang was also the very first Vietnamese and youngest professional to moderate a CEO Panel at the Future of Hospitality Summit in Dubai at the age of 23. \n\nHaving a strong background in Hospitality since graduating from EHL, Son-Trang's main goal is to bring forward change in diversity in the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Maya",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMDQyMzgxLFVzZXJfMTMxODY3MTYp",
                "jobTitle": "Founder & CEO",
                "lastName": "Ayoub",
                "photoUrl": "https://static.swapcard.com/public/images/350451e42a844bb388b4c7f2d3833df2.jpeg",
                "organization": "District-Twelve",
                "biography": "Maya's journey began with a diverse foundation in economics and finance, nurtured in the trenches of her family's real estate development and consulting business. This early experience sparked her entrepreneurial flame, leading her to found The Private Circle, District Twelve, and Fait Par Fées.\n\nBut her ambitions extend beyond building businesses. Her experience, with over 15 years of leading professional conferences, corporate events, and communications across the Middle East, have shaped her into a seasoned professional with a passion for delivering successful outcomes.\n\nMaya's true fulfillment lies in leveraging her skills for positive impact. She is an impact entrepreneur with a fierce commitment to women's empowerment, particularly in the fast-paced world of technology. As the Saudi Arabia Chapter Ambassador for Women in Tech® Global Movement, she champion initiatives that bridge the gender and digital gap, cultivate diversity within the tech industry, and empower women to reach their full potential.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE5Mjg0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/17a7878fe072462dbdfaa73230f5d186.jpeg",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Competitions"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjAyOTkzOQ==",
        "titleTranslations": [
            {
                "value": "Your Path to Red Sea Global: Exploring Projects and Partnership Opportunities",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:00:00",
        "endsAt": "2024-09-30 15:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/46FqyW7OLOc?si=Mz7JZaaweibZ4Soe\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ben",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTM4ODE3LFVzZXJfMTg5NTEzNTAp",
                "jobTitle": "Group Head of Cost, Commercial, and Procurement",
                "lastName": "Edwards",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ad11f8c77ccf4d0dbd9386316aa311ca.jpeg",
                "organization": "Red Sea Global",
                "biography": "Ben Edwards is the Group Head of Cost, Commercial, and Procurement at Red Sea Global (RSG), the developer behind The Red Sea and Amaala, two ambitious tourism projects set along the northwestern coast of Saudi Arabia. These destinations will play key roles in the realization of Vision 2030, the Kingdom’s blueprint for economic diversification and sustainable development.\n\nBen was appointed in August 2022, thanks to over 25 years of experience gained with major contractors in the UK, Europe, the Caribbean, the Middle East, and the Far East. He has a proven record of delivering complex building and civil engineering projects across the globe prior to joining RSG.  \n\nPreviously, he was Main Board Director of Tilbury Douglas in London, UK. Ben was responsible for the development and implementation of the business’s commercial strategy to undertake a greater proportion of lower-risk projects, blending the strengths of a strong regional business with public sector building and infrastructure frameworks, fit-out and a selective presence in the commercial development market.  \n\nBen has a bachelor's degree in Quantity Surveying from Northumbria University.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1Nzg1MA==",
                                    "title": "Your Path to Red Sea Global: Exploring Projects and Partnership Opportunities",
                                    "beginsAt": "2024-04-29 13:00:00",
                                    "endsAt": "2024-04-29 15:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mohammed Al",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTM4ODIxLFVzZXJfMTg5NTEzNzYp",
                "jobTitle": "Head of Procurement",
                "lastName": "Fardan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/8a218f4b221941a8909ff30a522f2622.jpeg",
                "organization": "Red Sea Global",
                "biography": "Mohammed Al Fardan is the Head of Procurement at Red Sea Global and, through his work, is a key contributor to Vision 2030’s ambitious blueprint for the future of Saudi Arabia. \n\nHis areas of expertise include executive strategic management, strategic sourcing and procurement, program management of giga-projects, and budgets & financial controls. At Red Sea Global, he is responsible for the full process of procurement functions: development procurement, projects procurement, FF&E procurement, operations procurement, corporate procurement, and vendor procurement. \n\nMohammed has over 21 years of leadership expertise in real estate development, procurement, business management, development, supply chain, contracting, programming, and project/construction management with reputable organizations in the Middle East. \n\nHe holds a BSc in Engineering – Architectural and Planning from King Faisal University and is a member of CIPS and the Saudi Council of Engineers.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Workshop"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTQyNQ==",
        "titleTranslations": [
            {
                "value": "Welcome Remarks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:00:00",
        "endsAt": "2024-09-30 14:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/aCAjRBCy1VQ?si=UPdsZPqO0_4RxOZY\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-africa",
                "translations": [
                    {
                        "value": "Focus on Africa"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Matthew",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTI3ODUzLFVzZXJfMTU5NTQ0MjUp",
                "jobTitle": "Group Managing Director",
                "lastName": "Weihs",
                "photoUrl": "https://static.swapcard.com/public/images/66e6ed774bd94710bc44d09314173771.png",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Focus on Africa"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjA1OTMwNg==",
        "titleTranslations": [
            {
                "value": "Welcome Remarks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:00:00",
        "endsAt": "2024-09-30 14:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/5a41SQQTftU?si=aikf8aKKuYfOlI19\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-europe",
                "translations": [
                    {
                        "value": "Focus on Europe "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Marina",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE4Mzg4LFVzZXJfODk1NDg5MSk=",
                "jobTitle": "Head of Investors Relations",
                "lastName": "Franolic",
                "photoUrl": "https://static.swapcard.com/public/images/3abe13fde6ed44b3882a207e2728ca63.jpeg",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNw==",
                                    "title": "Welcome to the Future",
                                    "beginsAt": "2024-04-30 14:00:00",
                                    "endsAt": "2024-04-30 14:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Focus on Europe"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjA3OTY2Nw==",
        "titleTranslations": [
            {
                "value": "Future-Proofing Hospitality: The Evolution of People and Spaces",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:00:00",
        "endsAt": "2024-09-30 14:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ZEKlX1rvYx4?si=5AFs8nwDyqxScbIQ\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "green-construction-and-smart-cities",
                "translations": [
                    {
                        "value": "Green Construction & Smart Cities"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Alexis Marcoux",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjIwMDcyLFVzZXJfMTg0NTE5MjQp",
                "jobTitle": "Chief Consulting Officer & Partner",
                "lastName": "Varvatsoulis",
                "photoUrl": "https://static.swapcard.com/public/images/caa68d0527b648148b9cb3c1ead352a7.jpeg",
                "organization": "Livit Consulting & Design",
                "biography": "Alexis’s 20 year professional journey bridges culinary artistry and strategic innovation, driven by a passion for redefining the food and beverage landscape. As Partner and Chief Consulting Officer at Livit, Alexis aims to revolutionize development by infusing projects with hospitality’s core values. From Michelin-starred kitchens to global F&B strategies, his focus has always been on excellence, creativity, and sustainability. Alexis leads UAE & KSA as well as worldwide projects to transform F&B spaces into meaningful social environments, ensuring each project drives asset value and enriches human interactions while celebrating food, culture, and community.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Green Construction & Smart Cities",
            "Global Investments"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzczMw==",
        "titleTranslations": [
            {
                "value": "Shaping Tomorrow: What’s in the Pipeline for Africa's Booming Hospitality Market",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:05:00",
        "endsAt": "2024-09-30 14:25:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/EfqEAz7aLxc?si=hw_4RwSAc4rG3xnH\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-africa",
                "translations": [
                    {
                        "value": "Focus on Africa"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Trevor",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODc1OTkzLFVzZXJfMTQzNjcyNyk=",
                "jobTitle": "Managing Director",
                "lastName": "Ward",
                "photoUrl": "https://static.swapcard.com/public/images/94fe4da369f145cd81e9ae1d492a7167.jpeg",
                "organization": "W Hospitality Group",
                "biography": "Trevor Ward is a specialist consultant in the hospitality industry. From the late 1980s he has specialised in the provision of advisory services to clients in developing countries, and for almost 20 years has been based in Nigeria, advising clients there and throughout the whole African continent.  His international experience includes advising clients on hotel and other types of development in 40 countries in Africa, and more than 90 countries globally, in Europe, North and South America, the Caribbean and Asia.  He is regarded as one of the foremost experts on the hotel industry in Africa.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Focus on Africa"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjA1MTE4Nw==",
        "titleTranslations": [
            {
                "value": "Spotlight European Hospitality: 2024, the Turning Point for Transactional Activity",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:05:00",
        "endsAt": "2024-09-30 14:25:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/WMIDfWY1nCQ?si=7XFM5xj32iWdeRm7\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-europe",
                "translations": [
                    {
                        "value": "Focus on Europe "
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Larissa",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTI3MjkwLFVzZXJfMzIyMTQwOCk=",
                "jobTitle": "Senior Director International Transactions",
                "lastName": "Esser",
                "photoUrl": "https://static.swapcard.com/public/images/17a8fd55607b40008b6b49ac4cde22e7.jpeg",
                "organization": "Colliers",
                "biography": "Larissa Esser is a dedicated expert in hotel investment and real estate finance, whose background in hotel operations enables her to effectively integrate global capital market insights with fundamental real estate knowledge. Throughout her career, Larissa has advised on a wide range of transactions and financing assignments across the globe. She has gained extensive experience in her previous roles at leading multinational real estate investment banking and property brokerage firms, including Eastdil Secured and JLL.\n\nIn 2020, Larissa founded her own consultancy, Esser Advisory. The following year, she teamed up with senior hospitality and investment professionals to establish Hera HRI, a fully integrated hospitality operating partner and co-investor.\n\nLarissa possesses an entrepreneurial spirit and is deeply passionate about education and knowledge sharing. She actively participates in various initiatives, including the Urban Land Institute (ULI), where she co-chairs the Hotel, Resorts, and Destinations Council. Her efforts focus on inspiring positive changes for sustainable urban environments and highlighting the pivotal role the hotel- and hospitality industry can play in this process.\n\nCurrently, Larissa serves as a Senior Director and Advisor to Colliers’ International Hotels team. In this prominent role, she leads and supports complex, high-profile hospitality and real estate deals, collaborating closely with local teams to leverage global knowledge and best practices.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Focus on Europe",
            "Global Investments"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU1OA==",
        "titleTranslations": [
            {
                "value": "Master Planning for Transformative Hospitality and Destination Investments in Shifting Sands",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:10:00",
        "endsAt": "2024-09-30 14:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/JCWWOzewfws?si=TJQtVu5bJad7J26y\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Khawla Al",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMDU2OTI5LFVzZXJfMTE5NjUyMSk=",
                "jobTitle": "Chief Projects Officer",
                "lastName": "Hashimi",
                "photoUrl": "https://static.swapcard.com/public/images/3eab35b42a114829a3dd84d8ea402d5d.jpeg",
                "organization": "Sharjah Investment and Development Authority - Shurooq",
                "biography": "Khawla Al Hashimi is currently the Chief Projects Officer of development at Shurooq. She has worked there for the past 13 years, where she started as an architect and grew through the ranks. She has designed and managed the development of many projects spanning from hotels to beach promenades and libraries. Her project portfolio includes Kingfisher Retreat, Al Faya Retreat, the Chedi Al Bait Hotel, House of Wisdom, Khor Fakkan Beach to name a few. Some of these projects have won prestigious awards like: Conde Nast Traveller’s best new hotel in the ME in 2020, and Luxury Lifestyle Award for best luxury eco retreats and best luxury boutique hotel in the ME in 2020.\n\nIn essence, Khawla is a values-driven architect and a strong advocate for Sharjah’s image. She believes in sustainable projects that complement and showcase their context and history. She believes that buildings are the platform with which we get to experience a location. It is with this philosophy she is leading a team that is single-handedly transforming the face of Sharjah.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Wyatt",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyODU3ODYzLFVzZXJfMTg3MjM1NDMp",
                "jobTitle": "Head of Innovation",
                "lastName": "Roy",
                "photoUrl": "https://static.swapcard.com/public/images/d7b71cbba4634710aa4b766eb7d17958.jpeg",
                "organization": "NEOM",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Imad",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDQ5MzQ0LFVzZXJfMjA2MzEyNDUp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Barrakad",
                "photoUrl": "https://static.swapcard.com/public/images/65cd13c87a23471083e971e7c622b9f2.jpeg",
                "organization": "The Moroccan Agency for Tourism Development (SMIT)",
                "biography": "Mr. Imad BARRAKAD serves as CEO of the Moroccan Agency for Tourism Development – SMIT Since 2011. Mr. BARRAKAD has worked actively during this period on the development of the tourism product in Morocco both by raising investment capital as well as conducting strategic studies to launch several large scale tourism development projects. Mr. BARRAKAD coordinates with various stakeholders involved in these developments and attends several high profile international events dedicated to the promotion of tourism investment with the aim to boost and maintain attractiveness of Morocco. Mr. BARRAKAD also holds several positions as Director and Board Member of various development entities involved in tourism projects around the country. Prior to joining SMIT, Mr. BARRAKAD held several key positions in different government entities.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Dr. Fahad",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzk4NDM4LFVzZXJfMTYxMzcwMTMp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "bin Mushayt",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f777a708539f421bb26d3e7dfcc7daad.jpeg",
                "organization": "ASFAR",
                "biography": "Dr.  Fahad bin Mushayt is the Chief Executive Officer at ASFAR, the Saudi \ntourism investment company that is a wholly owned subsidiary of the Public \nInvestment Fund established to drive the growth of tourism investment in \npartnership with the private sector to create captivating destinations in Saudi \nArabia for visitors from all over the world in line with Saudi Vision 2030. \n\nDr. Mushayt has recently been honored as one of the Top 100 CEOs in the \nMiddle East by Forbes, a recognition that underscores his exceptional leadership \nand strategic vision at ASFAR. This accolade highlights his commitment to \ndriving innovation and excellence within the Kingdom’s tourism sector, where \nhe has successfully propelled the organization to new heights.  \nBoasting more than two decades of experience, Dr. Fahad bin Mushayt's illustrious career spans across multifaceted domains including city management, mega investments in real estate, mergers and acquisitions, strategic business development, and operations management. He has also taken on challenging roles in myriad sectors including information technology and telecommunications, as well as infrastructure development.\n \nBefore his tenure at ASFAR, Dr. Mushayt held pivotal positions in both government and semi-government entities. He spent nearly twenty years at the Saudi Telecom Group holding several other key positions including Chief Executive Officer of Mega \nStrategic Projects, Vice President for Business Development, and Vice President of Corporate Strategy and Performance. He then became the Chief Executive Officer of Saudi Telecom Specialized Company for three years. In 2021, he became Deputy \nGovernor for Investment and Business Development at the State Property General Authority, after being Chief Executive Officer of the Diplomatic Quarter General Authority (DQGA) in Riyadh for three years. \n\nHe has also served on the boards of various organizations worldwide including Maxis Communication Berhad Holding Company in Malaysia, Aircel Company in India, and Axis Company in Indonesia, to name a few. \nDr. Fahad bin Mushayt holds a PhD in Economics, Political Economy and Public Policies from the University of Southern California and a master’s degree in economics from California State Polytechnic University, Pomona. He also holds a Bachelor of Science degree in Operations Research from King Saud University, Riyadh. In July 2024, Dr. Mushayt completed the Advanced Management Development Program at Harvard University. His ongoing commitment to professional development reflects his dedication not only to personal growth but also to the advancement of the tourism sector in the Kingdom, ensuring that ASFAR remains at the forefront of innovation and excellence.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                                    "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                                    "beginsAt": "2024-04-29 16:30:00",
                                    "endsAt": "2024-04-29 17:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Zoe",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzY1OTExLFVzZXJfMjA1NzUxMTUp",
                "jobTitle": "Business Development Manager",
                "lastName": "Stanford",
                "photoUrl": "https://static.swapcard.com/public/images/126e6e90460e429898d7728c53a64da4.jpeg",
                "organization": "Compass Project Consulting",
                "biography": "Zoe is a highly experienced business development and client relationship professional with over 18 years in the property, design, and construction industries across three continents.  Her deep expertise in commercial real estate and the hospitality sector has enabled her to successfully help companies enter new markets and build strong, lasting networks.  Zoe is known for her ability to identify business opportunities and collaborate effectively with key stakeholders, playing a crucial role in the success of various high-profile hospitality and mixed-use development projects.\nWhat sets Zoe apart is her genuine approach to relationship-building.  She combines strategic insight with hands-on experience, making her a trusted partner in any business venture.  Outside of work, Zoe is committed to personal growth - whether through CrossFit, boxing, Muay Thai, or exploring new destinations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzczNg==",
        "titleTranslations": [
            {
                "value": "Insights into Africa's Dynamic Investment Landscape",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:25:00",
        "endsAt": "2024-09-30 14:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/fqRDp-13Jew?si=7Qt0N9HTVkxzMJTl\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-africa",
                "translations": [
                    {
                        "value": "Focus on Africa"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Hamza",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDE5MzMwLFVzZXJfNjM4MTMzNCk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Farooqui",
                "photoUrl": "https://static.swapcard.com/public/images/4647f1b3e985405383b25e68d832ede9.jpeg",
                "organization": "Millat Investment",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Alain",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNTU0NTM3LFVzZXJfMjA2OTgyOTYp",
                "jobTitle": "Partner – Head of Investments and Asset Management, Middle East and Africa",
                "lastName": "Debare",
                "photoUrl": "https://static.swapcard.com/public/images/11af651213334255bb3dcca860e5614a.jpeg",
                "organization": "HVS",
                "biography": "Alain brings 30 years of expertise in hotel operations and development. Driven by his sector knowledge and hands-on expertise, he has experience managing various situations and optimizing performance. At Hilton, he rose through the ranks to General Management. \nAt Action Hotels PLC, he played a key role in developing a portfolio of 15 hotels and managing its IPO on the AIM market of the London Stock Exchange. After joining Equitativa in 2018, Alain managed real estate portfolios totaling over USD 1 billion. \nAlain has broad international management experience with a strong understanding of diverse markets and cultures.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "JS",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODMzOTQ0LFVzZXJfMTQ2MzAwMDMp",
                "jobTitle": "Founder & CEO",
                "lastName": "Anand",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/0f77c61aeb96470ba1a89680e273a473.jpeg",
                "organization": "Leva Hotels",
                "biography": "Named as part of Forbes' Top Travel and Tourism Leaders in 2023 and one of the Most Powerful Leaders in Dubai by Arabian Business Magazine, with over 20 years of experience in the hospitality industry and an impeccable record of notable achievements, JS Anand is a prominent hotelier and passionate corporate leader. After earning his diploma in hotel management, he refined his hands-on management style as he advanced through senior roles in world-class hospitality companies.\n\nHe has been featured on the Power 50 - Most Influential Leaders by Hotelier Middle East, Executive Power list 2023: The Most Influential Hotel Leaders in the Middle East, Most Innovative Business Leaders Inspiring The World 2022 by The Excelligent Magazine, and Most Influential Entrepreneurs From Dubai To Watch in 2022 By The Gulf Entrepreneur Magazine.\n\nPeople-centric and future-focused, JS aims to make an impact on the hospitality industry by building on the importance of employee well-being and satisfaction, creating an unforgettable service culture that gains global recognition, and being more involved in humanitarian causes around the world.\n\nBuilding long-lasting connections play a pivotal role in his work, especially in his mission to propel LEVA across the MENA region and Europe.\n\nJS is a charismatic corporate leader with a hands-on management style. He lives by the company’s core values that are firmly focused on delivering, efficiently and effectively, what was promised to its stakeholders and clients. Now he is committed to creating the best lifestyle hotels in the Middle East and beyond, becoming one of the leading hotel management companies dedicated to clarity, transparency, and delivering on its promises to clients and stakeholders.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Khalil",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTI3ODYzLFVzZXJfMTE1OTU2ODEp",
                "jobTitle": "Partner",
                "lastName": "Manji",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/77267627507140ceaba781a84bda35ab.jpeg",
                "organization": "CHIC",
                "biography": "Khalil is an experienced and savvy entrepreneur with a successful track record of starting, growing and managing a diverse range of business ventures across multiple industries, including Real estate development, construction, hotel development, fast fashion, and branded F&B in the Democratic Republic of Congo(DRC), Angola, Portugal & Dubai",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Focus on Africa",
            "Global Investments"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjA1MTE4OA==",
        "titleTranslations": [
            {
                "value": "European Hospitality Revival: Creating Investment Opportunities in Mature Markets",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:25:00",
        "endsAt": "2024-09-30 15:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/vH3TrAagjjM?si=FA3wqh6uCwt7DSdg\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-europe",
                "translations": [
                    {
                        "value": "Focus on Europe "
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr. Marinos",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ5MjMyLFVzZXJfMjAyNTI0NTMp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Giannopoulos",
                "photoUrl": "https://static.swapcard.com/public/images/990ab432c6654c4a890c36aaff1455f2.jpeg",
                "organization": "Enterprise Greece",
                "biography": "Marinos Giannopoulos is an experienced finance and academic professional with a Doctorate in Strategic Management. For several years he lived and was active in the UK where he worked in the City of London as a banking executive and business consultant. He holds a bachelor's degree in economics from the Management School, University of Liverpool, a master's degree in international business economics from City University London, and a PhD from Brunel University London, with the thesis title: \"Divesting assets and redeploying resources as predictors of the performance of acquisitions: The case of Greece.\"\nPrior to assuming his current duties as CEO of Enterprise Greece, he worked for more than a decade in the banking industry, both in Greece and abroad. He has extensive experience in managing credit risk in investment banking portfolios and participated in the management and consolidation of credit risk portfolios at financial institutions and companies in emerging Europe.\nUpon returning to Greece, he led the team at one of Greece’s leading banks responsible for facilitating in the implementation of Greece’s National Recovery and Resilience Fund − Greece 2.0 − while also liaising with European development bodies and Greek government agencies.\nHe served as advisor to New Democracy’s Secretariat for International Relations & European Union from 2013 to 2019. He has been a member of various academic and professional committees and has been actively engaged in research and writing with numerous articles published in leading international journals, such as the Journal for Global Business Advancement and the International Journal of Business and Economic Sciences. At the same time, he also taught at Brunel University and the Hellenic Open University in the fields of Strategic Management and Business Economics.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Benjamin",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzI4Mjc4LFVzZXJfNjQ1MTMyMyk=",
                "jobTitle": "Managing Partner & Co-Founder",
                "lastName": "Habbel",
                "photoUrl": "https://static.swapcard.com/public/images/dc7d8266959f4cfcbc4ce37b4df7e832.jpeg",
                "organization": "Limestone Capital",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Tea",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMzYwMDMzLFVzZXJfMjE1NzQ4NCk=",
                "jobTitle": "Managing Director",
                "lastName": "Ros",
                "photoUrl": "https://static.swapcard.com/public/images/105c65ab7b74493cba3a8c08e4be4172.jpeg",
                "organization": "Strategic Hotel Consulting",
                "biography": "Tea is one of the leading hotel consultants globally. She is the Founder and Managing Director of Strategic Hotel Consulting, an international management consulting firm based in Switzerland, specialising in hotel investments. \n\nWith over 20 years of global consulting experience, Tea has advised prominent owners, developers and investors on hospitality projects worth in excess of USD 3 billion. Her expertise ranges from hotels and resorts to mixed-use developments and branded residences. \n\nAs a recognized industry professional, Tea is the Chair of the Board of Directors of the International Society of Hospitality Consultants (ISHC) and serves on advisory boards of numerous companies. She features #13 on the Power List - the most influential Women in Hospitality by Hotelier Middle East. \nPrior to establishing Strategic Hotel Consulting in 2010, Tea held senior consulting roles with Jones Lang LaSalle Hotels in Asia Pacific and TRI Hospitality Consulting in the Middle East. \n\nIn addition to consulting expertise, Tea has comprehensive operational background having worked with the Four Seasons, Rosewood and Starwood in various operational roles (rooms, F&B, sales and marketing and Six Sigma) across Europe, North America and the Middle East.  \n\nTea is originally from Switzerland but has a wide-ranging international background. She is a graduate from the University of Surrey in the United Kingdom.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Dr. Peter",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjk0OTAyLFVzZXJfNDQxNzQ5OCk=",
                "jobTitle": "Managing Director & Head of Hotels",
                "lastName": "Ebertz",
                "photoUrl": "https://static.swapcard.com/public/images/6cb293c31e64486bab0e003f69158d31.jpeg",
                "organization": "Art-Invest Real Estate Management",
                "biography": "Peter has more than 20 years of experience in the hotel industry. He is responsible for Art-Invest's hotel activities including investments, operations, and developments since 2012, and built up a portfolio of around 55 hotels with an investment volume of approximately €2bn. Current references include the 25h Hotel in Florence, the Hoxton in Hamburg and the Pullman Hotel in Cologne",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Focus on Europe",
            "Global Investments"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjEyMjY5NA==",
        "titleTranslations": [
            {
                "value": "Building Tomorrow: Pioneering Sustainable Hospitality Development",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:45:00",
        "endsAt": "2024-09-30 15:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Nj5-r7W3ykk?si=nwhebGuM3nBOiNcq\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Osama",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTIxNDY5LFVzZXJfMTU3NTA0OTcp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "AlOthman",
                "photoUrl": "https://static.swapcard.com/public/images/b038fa1f384840f6a33e9343296ee305.jpeg",
                "organization": "Aseer Investment Company",
                "biography": "Osama AlOthman is a seasoned executive with more than 30 years of experience, during which he has held numerous key positions in investment and finance across local, regional and global markets. \nPrior to joining Aseer Investment Company, AlOthman held the role of Head of Mergers & Acquisitions at Abu Dhabi Future Energy Company – Masdar. During his tenure, he developed the company’s investment strategy, launched the mergers & acquisition function, and deployed USD1.2 billion in capital, growing the global portfolio to generate 50%+ of the company’s total production capacity. He also established the first Masdar offices in Saudi Arabia and USA. \nAlOthman also held two key positions at First Solar International Middle East – Director of Project Finance for the Middle East & North Africa and Country Manager of Saudi Arabia. He orchestrated the disinvestment of a US$150 million project in Jordan to Diamond Energy (a Mitsubishi subsidiary) and established operations in Saudi Arabia, contributing to the efficiency of the photovoltaic industries in the Kingdom.\nDuring his career trajectory, AlOthman was the founding member and Executive Director of Evolvence Capital, a private equity firm based in the UAE. He was responsible for expanding the company’s investments into new markets and also successfully established an investment fund in India, where the company's assets amounted to USD700 million. \nAlOthman has also worked for leading firms including the Saudi British Bank (SAB), Saudi Arabian Oil Company (Aramco), and the Saudi American Bank (Samba). \nHe holds a B.S. degree in Industrial Management from King Fahd University of Petroleum & Minerals (KFUPM), as well as a certificate in Executive Leadership from Harvard University (2018).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jules",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjkzNzg3LFVzZXJfNDIyODQzNik=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Ugo",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b6731e369c8e42d18c1e81aec244adb2.jpeg",
                "organization": "LOTUS Arabia",
                "biography": "As CEO, Jules has built LOTUS to become one of the most recognised, globally renowned marketing and communications specialists in the travel, hospitality and lifestyle space.\n\nWith over 25 years' experience Jules has led global campaigns for flagship airlines, the world’s largest outbound tourism destinations and international hospitality brands.\nWith offices in New York, Singapore and headquarters in London the footprint expanded in 2023 to add hubs in Jeddah and Riyadh serving the expanding Saudi Arabian and wider GCC tourism market.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkxNDk2MQ==",
                                    "title": "TenX Leadership Talks: Insights and Learnings in the Journey of Growing Your Destination",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 10:30:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzczOA==",
        "titleTranslations": [
            {
                "value": "Guests' Quest for Unique Experiences: The African Approach to Authentic Leisure",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 14:55:00",
        "endsAt": "2024-09-30 15:20:00",
        "descriptionTranslations": [
            {
                "value": "<br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-africa",
                "translations": [
                    {
                        "value": "Focus on Africa"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Wesam",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ3NjExLFVzZXJfMTQxMjU1ODUp",
                "jobTitle": "Head of Global Development",
                "lastName": "Okasha",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/68a00e0418ad48b29ede5f0a5290d527.jpeg",
                "organization": "TUI BLUE Hotels & Resorts",
                "biography": "Wesam Okasha is a seasoned hospitality professional with an impressive track record in the industry. He currently holds the position of Managing Director and Board Member at TUI BLUE Hotels LLC in Dubai, which is part of the world’s leading tourism group TUI. TUI Group owns and operates over 400 hotels and resorts in over 30 destinations with premium brands such as RIU, TUI BLUE, TUI Suneo, TUI Magic Life, Robinson, 16 cruise ships, 5 airlines with more than 130 modern medium and long-haul aircraft, and around 1,200 travel agencies.\n\nSince 2021, Wesam has also been serving as the Head of Global Development for the TUI BLUE Hotels & Resorts brand. Before joining TUI, Wesam held various General Manager and Vice President positions at renowned hospitality brands including ITS Group, RIU Hotels, ESI Global (USA), FTI Group (SIVA Hotel Division), and Melia Hotels between 1996 and 2001. In 2002, he was appointed as Managing Director and General Manager at Neckermann/Aldiana Senegal, where he excelled in his role.\n\nWesam's career progressed with his appointment as Vice President Sales & Services at The Lufthansa Group and LSG Sky Chefs in 2011. He then worked as a Development Advisor for TUI in 2014 and later joined Mangalis Hotel Group as Head of Business Development in 2017. In 2018, he was appointed as Senior Director Development West Africa at Hilton, where he brought his vast experience and exceptional international relationships to the table.\n\nWesam is fluent in Arabic, French, English, German, Spanish, and conversant in Italian and Hebrew. He has a versatile professional background and a deep understanding of different cultural settings in the Americas, Europe, Middle East, Africa, and Asia.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jameel",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODg2NDIyLFVzZXJfMTkyMDE1OTIp",
                "jobTitle": "Founder & CEO",
                "lastName": "Verjee",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e2adba32211f40e5a5ed4440d0efb97f.jpeg",
                "organization": "CityBlue Hotels (a member of The Diar Group)",
                "biography": "Jameel was born and raised in England, where he read law at the London School of Economics. He qualified as a Solicitor of the Senior Courts of England & Wales in 2001 and practised in the firm's London and Paris offices for five years. BLP was regularly voted UK Law Firm of the Year before its merger to become Bryan Cave Leighton Paisner.\n \nJameel decided to leave the law in order to go into business and set up several start-ups in the UK and Middle East before joining hands with some of his family’s interests, now consolidated under The Diar Group. Since 2010, Jameel’s focus shifted to sub-Saharan Africa and he entrepreneurially built CityBlue Hotels from inception in 2013. \n\nOver the past decade, CityBlue has become Africa’s fastest-growing local hotel chain with properties across five African countries and more than one thousand keys in the pipeline. CityBlue Hotels is known for its focus on five-star locations, affordability, service and technology across several sub-brands which incorporate business boutique hotels, midscale hotels, aparthotels and curated experiences. \n\nCityBlue Hotels is also the hospitality partner of the National Museums of Kenya, emphasising the group’s focus on culture and giving back to the community in which it operates. \n\nBeyond East and West Africa, CityBlue Hotels has also entered into a partnership with Dream Hotels & Resorts of South Africa and Mozambique, creating a pan-African sales and marketing platform to compete with the goliaths of the industry.\n\nIn recent years, Jameel has been recognized one of the leading business “thought leaders” across the African continent and in 2023, he was awarded the “Creating Impact” award for Outstanding Contribution to Africa.  He has subsequently been invited to join the Advisory Board of the Lagos Business School’s Hospitality Initiative. \n \nJameel continues to lead CityBlue Hotels’ business with a clear plan for growth within Africa and beyond.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Trevor",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODc1OTkzLFVzZXJfMTQzNjcyNyk=",
                "jobTitle": "Managing Director",
                "lastName": "Ward",
                "photoUrl": "https://static.swapcard.com/public/images/94fe4da369f145cd81e9ae1d492a7167.jpeg",
                "organization": "W Hospitality Group",
                "biography": "Trevor Ward is a specialist consultant in the hospitality industry. From the late 1980s he has specialised in the provision of advisory services to clients in developing countries, and for almost 20 years has been based in Nigeria, advising clients there and throughout the whole African continent.  His international experience includes advising clients on hotel and other types of development in 40 countries in Africa, and more than 90 countries globally, in Europe, North and South America, the Caribbean and Asia.  He is regarded as one of the foremost experts on the hotel industry in Africa.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Focus on Africa"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU2MQ==",
        "titleTranslations": [
            {
                "value": "Decarbonisation and the Pathway to Net Zero – Start with the Data!",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 15:00:00",
        "endsAt": "2024-09-30 15:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/aMFNiDGN2_E?si=8KJaCx5yrqwxxFXg\" target=\"_blank\">Click here to watch online</a></p><p>Best practice in Data Measurement</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "green-construction-and-smart-cities",
                "translations": [
                    {
                        "value": "Green Construction & Smart Cities"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Richard",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODgwNzgyLFVzZXJfNjc4NjMwMyk=",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Williamson",
                "photoUrl": "https://static.swapcard.com/public/images/4bbae35ad27d473a9510a393ab25dfd0.jpeg",
                "organization": "Considerate Group",
                "biography": "Richard Williamson is the COO of Considerate Group, a data-driven sustainability consultancy, focused on the hospitality and tourism sectors, with offices in London and New York and a local partner in Dubai. Richard oversees Considerate’s Middle Eastern business, having previously worked for KPMG and PwC in the UAE and Oman. \n\nConsiderate Group develops tailor-made ESG frameworks and sustainability strategies for hotels and tourism companies, working with owners, operators, SWFs and asset managers around the world.  As well as transition risk mitigation, Considerate focuses on delivering the financial benefits of investment.\n\nServices include asset-level and portfolio decarbonisation and net zero strategies, hotel energy assessments, ESG due diligence, certification and accreditation. Considerate also operates a data platform, Con-Serve™ a premier ESG data-intelligence platform tailored specifically to the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                                    "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Green Construction & Smart Cities",
            "Sustainability & Innovation"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg1Ng==",
        "titleTranslations": [
            {
                "value": "Resilience Strategies: Building Anti-Fragile Hospitality Investments in Resort Destinations",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 15:00:00",
        "endsAt": "2024-09-30 15:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/mgYQndkTIhQ?si=ZNbh3QxOhPdgrR0I\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-europe",
                "translations": [
                    {
                        "value": "Focus on Europe "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "David",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTk0Njk1LFVzZXJfNDk4NTc0Nik=",
                "jobTitle": "Vice President Development, Middle East, Africa & India",
                "lastName": "Vely",
                "photoUrl": "https://static.swapcard.com/public/images/c2def37338cb4afd81b19bba1e6f162f.jpeg",
                "organization": "Club Med",
                "biography": "David brings 25 years track record in the hospitality industry with extensive experience in strategy, asset management, and development. David's strong financial and analytical background complements his cross-cultural negotiation skills acquired by closing deals across Europe, Africa, India, Turkey, and the Middle East. David has extensive experience both in Mergers and Acquisitions and organic development, from luxury to midscale and economy, from business hotels to integrated resorts and mixed-use developments, with several leading International groups (Starwood, Accor, Whitbread, MGM, and Club Med). \n\nSince 2016, David serves as Vice President Development and Asset - Middle East and Africa for Club Med, focusing on developing all-inclusive premium resorts for families and active couples. David is based in Club Med's Paris office.\n\nPrior to that position, he was based in Dubai for 12 years.\n\nDavid has a Masters in Business Administration from the J. L. Kellogg School of Management -Northwestern University, USA. He is also a graduate with a degree in Engineering from Grande Ecole D’Ingenieurs Paris-Laval (ESIEA), France.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Tea",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMzYwMDMzLFVzZXJfMjE1NzQ4NCk=",
                "jobTitle": "Managing Director",
                "lastName": "Ros",
                "photoUrl": "https://static.swapcard.com/public/images/105c65ab7b74493cba3a8c08e4be4172.jpeg",
                "organization": "Strategic Hotel Consulting",
                "biography": "Tea is one of the leading hotel consultants globally. She is the Founder and Managing Director of Strategic Hotel Consulting, an international management consulting firm based in Switzerland, specialising in hotel investments. \n\nWith over 20 years of global consulting experience, Tea has advised prominent owners, developers and investors on hospitality projects worth in excess of USD 3 billion. Her expertise ranges from hotels and resorts to mixed-use developments and branded residences. \n\nAs a recognized industry professional, Tea is the Chair of the Board of Directors of the International Society of Hospitality Consultants (ISHC) and serves on advisory boards of numerous companies. She features #13 on the Power List - the most influential Women in Hospitality by Hotelier Middle East. \nPrior to establishing Strategic Hotel Consulting in 2010, Tea held senior consulting roles with Jones Lang LaSalle Hotels in Asia Pacific and TRI Hospitality Consulting in the Middle East. \n\nIn addition to consulting expertise, Tea has comprehensive operational background having worked with the Four Seasons, Rosewood and Starwood in various operational roles (rooms, F&B, sales and marketing and Six Sigma) across Europe, North America and the Middle East.  \n\nTea is originally from Switzerland but has a wide-ranging international background. She is a graduate from the University of Surrey in the United Kingdom.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Felicity",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjE1NDUyLFVzZXJfOTM2ODA4MCk=",
                "jobTitle": "Senior Vice President Development EAME",
                "lastName": "Black-Roberts",
                "photoUrl": "https://static.swapcard.com/public/images/9b72ec6954e8456b9715373dfbac854c.jpeg",
                "organization": "Hyatt",
                "biography": "Felicity is responsible for developing Hyatt’s diverse brand portfolio across EAME, heading a diverse team of subregional development experts. Since joining in 2016, Felicity has overseen Hyatt’s market entries into 31 markets, including Barcelona, Biarritz, Dublin and Madrid, along with brand debuts in 23 markets including Amsterdam, Frankfurt, London, Paris and the French Alps. With 25 years’ experience in real estate and hospitality – spanning acquisitions, development, asset management – she understands the market from multiple industry perspectives. Prior to Hyatt, Felicity led acquisitions and developments for Starwood Hotels and Resorts in Western Europe, supported prominent brands including Forte, Le Méridien and worked with the investment fund Starman.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Focus on Europe"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU2NA==",
        "titleTranslations": [
            {
                "value": "Net Positive Hospitality: Can Hotels Achieve True Net Positive Hospitality or is it Just a Marketing Ploy",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 15:10:00",
        "endsAt": "2024-09-30 15:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/nsDDsoUy0k0?si=NObvS7fQQO10XykW\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Radhika",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjk4ODY5LFVzZXJfMTY0NjYxMTUp",
                "jobTitle": "Founder",
                "lastName": "Arapally",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/496a82994ae94dc1bfbce6ba091a03fa.jpeg",
                "organization": "Sustainability Kiosk",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Inge",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ5MTk0LFVzZXJfNDk4NTkyMik=",
                "jobTitle": "Chief Sustainability & Security Officer",
                "lastName": "Huijbrechts",
                "photoUrl": "https://static.swapcard.com/public/images/3fff1ec9abff4f11927c504ea2edd3fd.jpeg",
                "organization": "Radisson Hotel Group",
                "biography": "Inge Huijbrechts is Chief Sustainability and Security Officer for Radisson Hotel Group (RHG)– developing the Sustainability and Safety & Security programs in the group’s 1,430+ hotels in operations & development in 95 countries around the world. \n\nShe leads the group’s Net Zero transformation based on approved Science Based Targets.  \n\nIn April 2022, she was one of the key leaders involved in the definition and launch of the Hotel Sustainability Basics. The new standard is supported by the World Travel & Tourism Council and hotels groups, destinations and associations representing over 50,000 hotels. \n\nInge is Co-Chair of the ASIS Europe conference, the leading cross industry organization for security. She is a member of the ASIS Chief Security Officer Center for Leadership and Development and of the US State Department’s OSAC Hotel & Lodging Sector Committee. She is a member of the Sustainable Hospitality Alliance Board of Trustees. Inge also serves on the board of Flanders Special Venues and is a member of the EIB’s Women Climate Leader Network. \n\nIn 2024, Inge was included for the 3rd year in the global Top 100 Women in Sustainability, and has been named twice as one of the 100 Most influential people in Global Hospitality.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Pascal",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNTE0ODQ5LFVzZXJfMjAwNDMyNzQp",
                "jobTitle": "Partner",
                "lastName": "Armoudom",
                "photoUrl": "https://static.swapcard.com/public/images/7be19e1298dd4c7ca64f06f4cec210a6.jpeg",
                "organization": "Kearney",
                "biography": "During his first 18 years with Kearney, Pascal worked with clients in the tourism, luxury, and consumer industries across Europe and Asia, helping them to grow and improve their businesses, before being recruited to lead the strategy for Amaala, a luxury tourism destination on the Red Sea coast. “I was in charge of developing the experiential strategies for everything from mobility to arts and culture, as well as overseeing all of the strategic partnerships for the resort,” Pascal adds.\n\nAfter moving on to become strategy advisor to a Middle East investment fund dedicated to developing the cultural, entertainment, tourism, and sports sectors, Pascal returned to Kearney in 2023 and is now a partner in the firm’s transportation and travel practice, with a focus on tourism, leisure, and hospitality, based in Riyadh.\n\nHaving grown up on Reunion Island in the Indian Ocean, and spent time living and working in mainland France, London, and Shanghai, Pascal has a knack for bringing a global perspective to his work. As he puts it, “When you have been in consulting for a while, you start to spot familiar patterns. Every place and every firm has its own character and challenges, but I would hope that what I bring to my clients is an ability to put things in perspective, and shortcut some of the problems they face.”\nPascal graduated from Essec Business school MBA.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Sustainability & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjA1NjYzNw==",
        "titleTranslations": [
            {
                "value": "Beyond the AI Hype - An Interactive Workshop with Practical Problem Solving Demos",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 15:15:00",
        "endsAt": "2024-09-30 16:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/GhlTRKK2YgA?si=1Dqu0GxjMo-WAyuj\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Techology & AI"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ali",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE5NDM0LFVzZXJfMTA5NzY4Nzkp",
                "jobTitle": "Marketing Director",
                "lastName": "Shahid",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bd0dbdf1442141679c3df8de64b62560.jpeg",
                "organization": "The Bench",
                "biography": "Ali leads the marketing department at The Bench, where he oversees all campaigns and spearheads the adoption of new technologies, consistently inspiring his team to innovate. With 17 years of experience in international B2B marketing, Ali has a track record of delivering high ROI through the development of cutting-edge strategies. With extensive experience across 12 industries, Ali brings a deep understanding of varied business landscapes and adeptly addresses the nuanced challenges of the modern workplace.\n\nA passionate advocate for team collaboration and the unlocking of human potential, Ali adeptly recruits, trains, and inspires business professionals. He manages the complexities of today's business environment, while promoting the use and understanding of generative AI. This proactive embrace of emerging technologies ensures that The Bench remains at the forefront of industry advancements, driving key business objectives and encouraging his teams to explore new possibilities.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAyMQ==",
                                    "title": "Beyond the Hype - A Practical Insight into AI and the Future of Business",
                                    "beginsAt": "2024-05-01 10:00:00",
                                    "endsAt": "2024-05-01 11:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
                                    "title": "Fireside Chat with Desdemona The Robot",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Techology & AI"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzc0MA==",
        "titleTranslations": [
            {
                "value": "From Nepal to the World: A Journey of Strategic Investment, Development, and Asset Management",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 15:20:00",
        "endsAt": "2024-09-30 15:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/tmRgy1TA_LI?si=ioHsk6NMyFZMm7QE\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-africa",
                "translations": [
                    {
                        "value": "Focus on Africa"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Mark",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMDU2MjM5LFVzZXJfMTg3ODkyMTgp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Dunford",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/352fde424a6649bebad7f542f7827152.jpeg",
                "organization": "Knight Frank",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Rahul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTg3NTYzLFVzZXJfMjE1NzQ3OCk=",
                "jobTitle": "Managing Director & Global CEO",
                "lastName": "Chaudhary",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b721a5a2424846a6affe9a863be8608f.jpeg",
                "organization": "CG Corp & CG Hospitality Holdings",
                "biography": "Mr. Chaudhary wears his other hat as Chief Executive Officer CG Hospitality Holdings, the fast-growing hospitality vertical of CG Corp | Global that comprises of over 178 hotels & resorts in 12 countries and 116 destinations with over 11,000 keys. His forte lies in forging strategic alliances in established as well as emerging markets, which assists in the growth and development of the company. CG Hospitality’s successful joint ventures include partnership with prestigious luxury and hospitality brands and owning some of the most iconic assets globally. The list of partnering Who’s Who of leading hospitality brands include the Taj, Taj Safari, Vivanta, Jetwing, Radisson, Ekho, Fairmont brands. CG Hospitality owns The Zinc, The Fern, Summit and The Farm brands amongst others. By 2025, the portfolio is expected to grow to over 200 hotels and 12,000 keys.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Focus on Africa"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU2Nw==",
        "titleTranslations": [
            {
                "value": "Coffee Break",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 15:30:00",
        "endsAt": "2024-09-30 16:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMjE0MzMzNw==",
        "titleTranslations": [
            {
                "value": "Announcement #4",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 15:30:00",
        "endsAt": "2024-09-30 15:45:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU2OA==",
        "titleTranslations": [
            {
                "value": "Sustainable Hospitality Challenge",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 16:00:00",
        "endsAt": "2024-09-30 17:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/VnxWdf6GzRc?si=SQwiGZtBrUD27L8k\" target=\"_blank\">Click here to watch online</a></p><p>The Sustainable Hospitality Challenge (SHC), founded by Hotelschool The Hague, is the leading global student challenge that enforces true sustainable impact by means of collaboration.</p><p>Moderator: <strong>Paul Griep</strong>, Founder, Sustainable Hospitality Challenge, Director Industry Relations & Alumni, Hotelschool The Hague </p><p>Jury Members:</p><ul><li><strong>Colin Abercrombie</strong>, Strategy Director Hotel Division, NEOM</li><li><strong>Dr. Rahma Beaugrand, </strong>VP, Head of Customer Advisory MES & Sustainability Leader, SAP</li><li><strong>Michael Cheng</strong>, Dean, Chaplin School of Hospitality & Tourism Management, Florida International University</li><li><strong>Karin van den Berg</strong>, Senior Director Of Operations UAE Full Service, Hilton </li><li><strong>David Keen</strong>, Founder & CEO, QUO</li><li><strong>Marloes Knippenberg</strong>, Chief Executive Officer, Kerten Hospitality</li><li><strong>Gregory Lanter</strong>, Global Chief Development Officer, ClubMed</li><li><strong>Gustaf Lantz</strong>, SVP APAC & EMEA, GuestWorldwide</li><li><strong>Larissa Esser,</strong> Senior Director Hotels at Colliers</li><li><strong>Dimitris Manikis</strong>, President EMEA, Wyndham Hotels and Resorts</li><li><strong>Haitham Mattar</strong>, Managing Director MEA & South West Asia, IHG. Special Advisor to Secretary General UN Tourism</li><li><strong>Amit Nayak</strong>, CHA, Vice President, HAMA MEA</li><li><strong>Francesco Scullica</strong>, President Coordinator Interior and Spatial Design, Politecnico di Milano</li><li><strong>Paul Stevens</strong>, Chief Operating Officer, MEA and Turkey, Accor</li><li><strong>Wyatt Roy</strong>, Head of Innovation, NEOM</li><li><strong>Sandeep Walia</strong>, Chief Operations Officer, Middle East, Marriott International</li><li><strong>Matthijs Welle,</strong> Chief Executive Officer, MEWS</li><li><strong>Andre Wiringa</strong>, Founder & Chief Reverse Officer, StartReverse</li></ul>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3MjkwMg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "education-investment",
                "translations": [
                    {
                        "value": "Education Investment"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Sustainability & Innovation",
            "Education Investment"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjE0MzMzOA==",
        "titleTranslations": [
            {
                "value": "Announcement #5",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 16:00:00",
        "endsAt": "2024-09-30 16:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjAyOTk0MQ==",
        "titleTranslations": [
            {
                "value": "Unveiling the Invisible: Women and Implicit Bias in Leadership.",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 16:30:00",
        "endsAt": "2024-09-30 17:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3MzE2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "women-leadership",
                "translations": [
                    {
                        "value": "Women Leadership"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr. Sowon",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODUxMDM2LFVzZXJfOTk0NDc4Mik=",
                "jobTitle": "Professor",
                "lastName": "Kim",
                "photoUrl": "https://static.swapcard.com/public/images/d94470602c304c16b06f8e87c856b51b.jpeg",
                "organization": "EHL Hospitality Business School",
                "biography": "Dr. Sowon Kim, EHL professor and founder of the Women in Leadership (WIL) Initiative, has lived and worked in eight countries and boasts over 20 years of experience in academia and various industries, including consumer goods and high-tech. An expert in cultural navigation and leadership, she emphasizes interpersonal skills, multicultural team performance, and strategic cultural change in her executive education role. Holding a Ph.D. from the University of Geneva, her research focuses on personality, career strategies, and leadership diversity. Additionally, Dr. Kim co-owns World of Kids SA, serves on multiple boards, and is committed to leadership, education, and social change.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital",
            "Workshop",
            "Women Leadership"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjE0MzMzOQ==",
        "titleTranslations": [
            {
                "value": "Announcement #6",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 16:45:00",
        "endsAt": "2024-09-30 17:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjE2MzcxOA==",
        "titleTranslations": [
            {
                "value": "Invest in India",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 17:15:00",
        "endsAt": "2024-09-30 18:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr. Suruchi",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzA0NjI5LFVzZXJfMjExNTMwMTQp",
                "jobTitle": "Chief Industry Officer and Senior Vice President",
                "lastName": "Mittar",
                "photoUrl": "https://static.swapcard.com/public/images/02b261c04d354fd79eb59ec48642de8c.jpeg",
                "organization": "Invest India",
                "biography": "Dr. Suruchi Mittar is a seasoned leader with over 25 years of experience in academia, corporate governance, and policy advocacy. As Chief Industry Officer at Invest India, she drives investment in key sectors like tourism, media, and pharmaceuticals. With her Ph.D. in Philosophy, Dr. Mittar brings unique insights to her leadership. She has led initiatives to promote innovation, sustainability, and inclusive growth in India and globally.\n\nPrior to her current role, Dr. Mittar founded Sanai Changemakers, where she focused on strategic HR, leadership development, and organizational design. She has also served as a senior faculty member at the prestigious National Institute of Fashion Technology for more than 15 years.\n\nDr. Mittar has leveraged her expertise across diverse geographies, including the UK, Europe, Australia, Bangladesh, Jordan, and Ethiopia, to optimize operations and empower communities. Her leadership is characterized by a holistic approach, encompassing strategic vision, operational excellence, and a deep-seated commitment to ethical business practices.\n\nAt Invest India, Dr. Mittar has been instrumental in transforming the Tourism Team into a strategic hub that bridges the gap between government and private investment opportunities. She has developed a unified framework to align diverse stakeholders, fostering a favorable environment for increased investment in India's tourism sector.\n\nHer leadership extends to elevating India's art and craft sector, as well as developing strategic frameworks for promoting Indian industries in countries like Myanmar. Collaborating with global organizations such as the International Labour Organization (ILO) and the United Nations Environment Programme (UNEP), Dr. Mittar's work underscores her global vision, commitment to sustainable development, and passion for inclusive growth.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU2OQ==",
        "titleTranslations": [
            {
                "value": "Speed Networking",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 17:30:00",
        "endsAt": "2024-09-30 18:30:00",
        "descriptionTranslations": [
            {
                "value": "<p>Speed Networking is a great way to break the ice and ensure you go into FHS already knowing your fellow attendees. Meet over 30 new contacts before the conference has officially started! Don't forget to bring lots of business cards!  Taking place prior to the Opening Reception.</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU3MA==",
        "titleTranslations": [
            {
                "value": "Welcome Reception at Jumeirah Mina A'Salam",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-09-30 18:30:00",
        "endsAt": "2024-09-30 20:30:00",
        "descriptionTranslations": [
            {
                "value": "<p>Fresh on Table will be supporting Jumeirah’s culinary team with many ingredients from local farms and producers, minimising the carbon footprint, while guests can indulge in decadent desserts made with honey sourced from local Abu Dhabi farms—a project of the Zayed Higher Organisation that supports equity and inclusion for people of determination. Every detail has been considered, from reusable cooking stations and props to the repurposing of plants and greenery throughout the hotel after the event, ensuring a waste-free experience. In keeping with Jumeirah’s commitment to the Global Tourism Plastics Initiative, there will be no single-use plastics, and all water will be provided by our onsite Nordaq water bottling plant.</p><p>Join us in making a positive impact on our environment and community!</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Reception",
                "translations": [
                    {
                        "value": "Reception"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjEwOTc4OA==",
        "titleTranslations": [
            {
                "value": "Pilates Session at J Club Jumeirah Beach Hotel – Wellness Studio",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 07:00:00",
        "endsAt": "2024-10-01 08:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>A 60-minute Pilates class offering a blend of core strengthening, flexibility enhancement, and total body toning. This low-impact session focuses on precise movements for posture, balance, and muscle definition. Suitable for all skill levels, it's a perfect way to stretch, strengthen, and rejuvenate both body and mind.</p><p>LOCATION: J Club Jumeirah Beach Hotel – Wellness Studio (<a href=\"https://maps.app.goo.gl/kAhCXYVAymsZ5SAN9\">https://maps.app.goo.gl/kAhCXYVAymsZ5SAN9</a>)</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMjEwOTc4OQ==",
        "titleTranslations": [
            {
                "value": "HIIT Session at J Club Jumeirah Beach Hotel – High Impact Studio",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 07:00:00",
        "endsAt": "2024-10-01 08:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>A dynamic 60-minute HIIT class designed for cardio boosting, fat burning, and muscle strengthening. This session not only elevates your routine and enhances endurance but also primes you for the rest of the day at the conference. You'll leave feeling invigorated, with increased energy and mental clarity to engage more effectively in upcoming activities and discussions.</p><p>LOCATION: J Club Jumeirah Beach Hotel – High Impact Studio (<a href=\"https://maps.app.goo.gl/kAhCXYVAymsZ5SAN9\">https://maps.app.goo.gl/kAhCXYVAymsZ5SAN9</a>)</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDk1MjgwMQ==",
                "definition": {
                    "isDefault": false,
                    "name": "Experiences"
                },
                "value": "experiences",
                "translations": [
                    {
                        "value": "Experiences"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU3NA==",
        "titleTranslations": [
            {
                "value": "Registration",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 08:00:00",
        "endsAt": "2024-10-01 09:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [],
        "speakers": [],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU3NQ==",
        "titleTranslations": [
            {
                "value": "Welcome Back",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 09:00:00",
        "endsAt": "2024-10-01 09:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/1hSyqQVf9mw\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE5Mjg0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/17a7878fe072462dbdfaa73230f5d186.jpeg",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Gemma",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODk5MTgzLFVzZXJfMjMxNzIzNyk=",
                "jobTitle": "Director",
                "lastName": "Greenwood",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/28f93f5e7809429484223268fc818522.jpeg",
                "organization": "Content Inc",
                "biography": "Gemma Greenwood has more than 20 years’ experience as a journalist, editor and corporate and crisis communications consultant in the UK, Middle East and Asia. She is also an accomplished moderator, having organised and presented the Arabian Travel Market (ATM) conference programme since 2010, both live and online.\n\nOver the past 11 years, Gemma has moderated several high-profile sessions featuring major industry leaders at ATM and WTM London and launched ATM’s successful summits on hospitality, halal tourism and Saudi Arabia. She has also moderated conferences for hospitality industry giants such as InterContinental Hotels Group (IHG).\nAs an editor, she has personally overseen the launch of and managed several landmark business titles including Hotelier Middle East, Hotel News Middle East, Arabian Travel News, the highly regarded Arabian Travel Market (ATM) Yearbook series and more recently, the first World Travel Market (WTM) London annual to celebrate the event’s 40th anniversary in 2019, with a second edition to follow in 2022.\nGemma is also currently editor of Motivate Publishing title, Business Traveller Middle East and not only writes and edits the publication but plays a key role in executing the highly regarded BTME awards programme, as well as presenting webinar content for key clients.\nAs Director of Content Incorporated, she supports major hotel, tourism, hospitality and real estate companies with a wide range of corporate communications and editorial services, from content and PR to media and crisis communications training. \n\nHer clients include Dubai Tourism, the Abu Dhabi government, Ras Al Khaimah Tourism Development Authority (RAKTDA), IHG, Accor, Rotana, The First Group, Atlantis The Palm, as well as travel and hospitality industry start-ups.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU3Ng==",
        "titleTranslations": [
            {
                "value": "The Global Geopolitical Landscape and its Influence on the Hospitality Industry",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 09:15:00",
        "endsAt": "2024-10-01 09:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/oSgEH6OOiqg\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Pat",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTQyODMyLFVzZXJfNDQyNjg3Nik=",
                "jobTitle": "Editorial Director, Middle East & Africa",
                "lastName": "Thaker",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fcc1f306f0fc4f4d8645db432a444dfa.png",
                "organization": "The Economist",
                "biography": "Leading authority on the Middle East and Africa\n \nPratibha provides the intellectual leadership necessary to ensure that The EIU’s analysis and forecasts for the Middle Eastern and African markets are the most insightful available to international decision-makers. Pratibha’s deep knowledge and regional experience means she frequently chairs and speaks at conferences in Africa, the Middle East and Asia on subjects such as the business case for Africa, the impact of low oil prices for the Gulf Co-operation Council (GCC), global food security, urban sustainability and corporate social responsibility.\n \nBackground\n \nPratibha leads The EIU’s Middle East and Africa team and is also the overall manager of the other regional teams. Pratibha has many years’ experience ensuring that The EIU’s forecasts and analysis for countries’ economies are closely integrated with our global macroeconomic outlook, with the analytical skills and the regional expertise required to diagnose problems and devise viable solutions.\n \nPratibha has an MSc and a BSc in economics from the University of London. She also holds an MA in area studies from SOAS, University of London.\n \nExpertise\n \nGlobal, Middle East, Sub-Saharan Africa, UAE\n \nSpecialist subjects\n \nCorporate strategy, Development, Emerging markets, Food security, GCC, Geopolitical risk, Macroeconomics, Oil, Public policy, Risk",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Global Investments"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU4Mw==",
        "titleTranslations": [
            {
                "value": "What Are the Numbers Telling Us? A Look at Hotel Performance From a Global Perspective",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 09:45:00",
        "endsAt": "2024-10-01 10:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/CAqnFHOzDQ8\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Sarah",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjQ0NDkwLFVzZXJfMTQ2ODI3OSk=",
                "jobTitle": "Director, Client Relationships",
                "lastName": "Duignan",
                "photoUrl": "https://static.swapcard.com/public/images/d6e9b1be93184e2e860029c865367c33.jpeg",
                "organization": "STR",
                "biography": "Sarah is STR’s director of client relationships and is based in London. Prior to joining the business Sarah spent 7 years in hotel operations in Ireland and held a variety of roles including on the Front desk, in reservations, sales, and event management. She joined the HotelBenchmark team at Deloitte in 2005 as a Business Development Executive, later becoming an Account Manager responsible for a number of key international clients. Sarah regularly attends and presents at hotel operator and industry events, spreading greater awareness of STR’s benchmarking services. Sarah holds an honors degree in translation (German & Spanish) from Dublin City University (DCU)",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Global Investments"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjA0NDk4OA==",
        "titleTranslations": [
            {
                "value": "Round Table: Transforming Education for the Future of Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 10:00:00",
        "endsAt": "2024-10-01 11:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jeff",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTI1OTUzLFVzZXJfMjA5MjY5OTgp",
                "jobTitle": "AVP Business Operations",
                "lastName": "Strachan",
                "photoUrl": "https://static.swapcard.com/public/images/9be4b8c826d04099aadc8458374a3ef2.jpeg",
                "organization": "Dubai College of Tourism",
                "biography": "In September 2015, Jeff Strachan, joined the Dubai College of Tourism, a unique initiative from Dubai Department of Economy & Tourism, designed as the conduit to bring the Dubai brand to life through a number of grass-roots human capital enablement initiatives including the online self-paced learning platforms Dubai Way and Dubai Expert and the campus based curriculum including Tourism, Hospitality, Events and Culinary Arts. The platforms created by Dubai College of Tourism have now welcomed over 150,000 students, studying courses including sustainable tourism, inclusive service, autism and sensory awareness and the flagship Dubai Way course.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Workshop"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU4Nw==",
        "titleTranslations": [
            {
                "value": "Balancing Growth: Integrating Tourism in Government Policy-Making to Tackle Overtourism and Other Key Challenges",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 10:05:00",
        "endsAt": "2024-10-01 10:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Ha2cm3-IB_s\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Lenah",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNTU3MzYzLFVzZXJfMTcwMjQxNjIp",
                "jobTitle": "Editor",
                "lastName": "Hassaballah",
                "photoUrl": "https://static.swapcard.com/public/images/1ca82aa592884f7fbf0fec8e2d09949b.jpeg",
                "organization": "CNN Business Arabic",
                "biography": "Lenah Hassaballah is a television and digital journalist with 13 years of experience covering politics and business in the Arab region. Lenah started her career in the US and Egypt as a field reporter covering hard-hitting stories, then moved on to becoming a TV presenter and journalist in the UAE. She is currently leading a team of reporters to produce engaging, visual business stories.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Fatim-Zahra",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMDYxMzEyLFVzZXJfMjEwMDg0OTMp",
                "jobTitle": "Minister of Tourism, Crafts and Social and Solidarity Economy",
                "lastName": "Ammor",
                "photoUrl": "https://static.swapcard.com/public/images/2930ed33c5bd429aa1bf2fedfbbb707d.jpeg",
                "organization": "Kingdom of Morocco",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Sustainability & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjEwNzQ0NA==",
        "titleTranslations": [
            {
                "value": "A Global Perspective: UN Tourism's Role in Addressing Sustainable Growth in Travel",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 10:20:00",
        "endsAt": "2024-10-01 10:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ZKHw83T0Vh8\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Haitham",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ5NzgwLFVzZXJfNTIwODMyNyk=",
                "jobTitle": "Special Advisor, UN Tourism",
                "lastName": "Mattar",
                "photoUrl": "https://static.swapcard.com/public/images/435cebd48c194e0fb2ae286d35e8a0e0.jpeg",
                "organization": "Managing Director MEA & South West Asia, IHG Hotels & Resorts",
                "biography": "Transformational Hospitality, Travel & Tourism Leader. An agent of Change. Build high performing teams. Create strategy based organizations. Tourism Board development. Destination Development & Marketing. Tourism Product & Attractions Development. Investor Relations. Tourism Strategy. Airlift Development. Digital Marketing. Partnership Marketing",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                                    "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                                    "beginsAt": "2024-04-29 16:30:00",
                                    "endsAt": "2024-04-29 17:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Lenah",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNTU3MzYzLFVzZXJfMTcwMjQxNjIp",
                "jobTitle": "Editor",
                "lastName": "Hassaballah",
                "photoUrl": "https://static.swapcard.com/public/images/1ca82aa592884f7fbf0fec8e2d09949b.jpeg",
                "organization": "CNN Business Arabic",
                "biography": "Lenah Hassaballah is a television and digital journalist with 13 years of experience covering politics and business in the Arab region. Lenah started her career in the US and Egypt as a field reporter covering hard-hitting stories, then moved on to becoming a TV presenter and journalist in the UAE. She is currently leading a team of reporters to produce engaging, visual business stories.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Sustainability & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTQwMQ==",
        "titleTranslations": [
            {
                "value": "Saudi Vision 2030: Reimagining Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 10:35:00",
        "endsAt": "2024-10-01 10:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/sIwp9AzAMBw\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "David",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMzkzNzgzLFVzZXJfNzk3OTc2KQ==",
                "jobTitle": "CEO & Founder",
                "lastName": "Keen",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/218657551e024aaab1a1de67504600ab.jpeg",
                "organization": "QUO",
                "biography": "An evangelist for the power of experiential branding, David Keen is a successful entrepreneur and leading strategist for the travel and hospitality industries. Over the last 20 years, David has published and been interviewed in dozens of publications and has been a featured speaker at numerous conferences, tradeshows and professional events.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                                    "beginsAt": "2024-04-30 16:50:00",
                                    "endsAt": "2024-04-30 17:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjQ4MDE1LFVzZXJfMTcyMjIxMDcp",
                "jobTitle": "Managing Director – Middle East and Africa",
                "lastName": "Ansell",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/68a36c2c3cde4c0ea405fdf3c809aa46.jpeg",
                "organization": "Hyatt",
                "biography": "Stephen Ansell has recently been appointed the Managing Director for Hyatt in the Middle East and Africa regional division. Working at Hyatt for 27 years, Stephen has held several leadership positions in the company. Before his current role as Managing Director, Stephen was in a dual role as Area Vice President for Central Europe where he was responsible for Hyatt’s operations in the region, as well as the General Manager at Park Hyatt Zurich, where Stephen oversaw the running of the luxury Swiss hotel, applying his passion and expertise of the hotel industry at the property level. Stephen joined Hyatt in 1996 as Director of F&B at Hyatt Regency Riyadh and has since held General Manager positions at several Hyatt hotels including Hyatt Regency Bishkek, Hyatt Regency Kyiv, where he was central to the hotel’s opening, and Park Hyatt Moscow, where he spent nine successful years before being appointed as Area Vice President of Russia and Eastern Europe in 2014. Stephen holds a degree in Hotel and Catering Management from the University of Portsmouth.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                                    "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                                    "beginsAt": "2024-04-30 14:55:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Tatiana",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMjY3MDQ3LFVzZXJfMTU5MjM3MTEp",
                "jobTitle": "Director Innovation & Technology at Hotel Division",
                "lastName": "Labaki",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1e221c27233146fb93298f3f88259b27.jpeg",
                "organization": "NEOM",
                "biography": "Tatiana Labaki is a seasoned Biotechnologist and Bioinformatician who has coupled her scientific prowess with a decade of experience in Hospitality Management in the GCC. Prior to her current ventures, she was working for Emaar Properties in Dubai, UAE. Now serving as the Head of Hotels and Tourism Advisory for TONOMUS, she plays a pivotal role in projects within NEOM and throughout the Kingdom of Saudi Arabia. A graduate of Imperial College London, Tatiana holds both an MSc and MBA. She's a firm believer in life-long learning and the importance of introducing innovation and novelty into her chosen industries. An advocate for women in leadership roles, Tatiana is deeply committed to amplifying the voices of women in technology within the Arab World",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Focus on Saudi Arabia",
            "Sustainability & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU4OA==",
        "titleTranslations": [
            {
                "value": "Coffee Break",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 10:55:00",
        "endsAt": "2024-10-01 11:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzYwMg==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talk:  Insights of a CEO’s Journey",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 11:15:00",
        "endsAt": "2024-10-01 11:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/9feZodXPB20\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0MjI4LFVzZXJfMTU3NTcyNzUp",
                "jobTitle": "Presenter",
                "lastName": "Sackur",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
                "organization": "HARDTalk",
                "biography": "Stephen Sackur is presenter of HARDtalk, the current affairs interview on BBC World and the News Channel. His subjects have included the heads of NATO and OPEC, Shimon Peres, Gore Vidal and Richard Dawkins.\n\nFor HARDtalk he has also interviewed a number of the world’s great names, including Bill Clinton, George W Bush, Mikhail Gorbachev and Hugo Chavez. Distilling his notes for a series of articles, Stephen identiﬁed the ﬁve qualities they all seemed to share: an indestructible will, passion (almost beyond reason), outrageous optimism, a super-sized ego and a ‘rebel yell.’\n\nThese interviews have also given him an insight into how organisations can best bring about innovation: “You need to ﬁnd ways to assess individuals on their merits, and give rewards for innovative thinking rather than play-it-safe mediocrity. You should encourage insiders to get outside and bring back fresh insights. And you shouldn’t confuse seniority with creativity.”\n\nAway from set-piece interviews Stephen has served in Brussels, reporting on day-to-day stories from the major European institutions and across the continent. Before that he was Washington Correspondent, where his coverage and analysis of 9/11 won widespread acclaim.\n\nTen years earlier it was Stephen who broke the story of the mass killing on the Basra road out of Kuwait, marking the end of the Gulf War. He was then posted to Cairo and Jerusalem as Middle East Correspondent, where he reported on the emergence of the Palestinian Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sébastien",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNjE1MzIxLFVzZXJfMTYzMjc0KQ==",
                "jobTitle": "Group Chairman & CEO",
                "lastName": "Bazin",
                "photoUrl": "https://static.swapcard.com/public/images/794e920913f5478faf8b9bdb5ace41f3.jpeg",
                "organization": "Accor",
                "biography": "After five years working in several financial positions worldwide, Sébastien Bazin was appointed CEO of Hottinguer Rivaud Finances in 1990 and then CEO of L’Immobilière Hôtelière. In 1997, he moved to Colony Capital, a private real estate investment firm. \n\nHe joined Accor’s Board of Directors in 2005 and became a Paris Saint-Germain shareholder in 2006 and the club’s Chairman in 2009. In August 2013, he was appointed Chairman and CEO of AccorHotels.  \n\nHe has been Chairman of the Théâtre du Châtelet’s Board of Directors since 2015, Vice-Chairman of the Gustave Roussy Foundation’s Supervisory Board and a member of GE’s Board of Directors since 2016.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU5MQ==",
        "titleTranslations": [
            {
                "value": "Leveraging Global Opportunities in Today’s Competitive Business World",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 11:30:00",
        "endsAt": "2024-10-01 11:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/qanw9b2soaI\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0MjI4LFVzZXJfMTU3NTcyNzUp",
                "jobTitle": "Presenter",
                "lastName": "Sackur",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
                "organization": "HARDTalk",
                "biography": "Stephen Sackur is presenter of HARDtalk, the current affairs interview on BBC World and the News Channel. His subjects have included the heads of NATO and OPEC, Shimon Peres, Gore Vidal and Richard Dawkins.\n\nFor HARDtalk he has also interviewed a number of the world’s great names, including Bill Clinton, George W Bush, Mikhail Gorbachev and Hugo Chavez. Distilling his notes for a series of articles, Stephen identiﬁed the ﬁve qualities they all seemed to share: an indestructible will, passion (almost beyond reason), outrageous optimism, a super-sized ego and a ‘rebel yell.’\n\nThese interviews have also given him an insight into how organisations can best bring about innovation: “You need to ﬁnd ways to assess individuals on their merits, and give rewards for innovative thinking rather than play-it-safe mediocrity. You should encourage insiders to get outside and bring back fresh insights. And you shouldn’t confuse seniority with creativity.”\n\nAway from set-piece interviews Stephen has served in Brussels, reporting on day-to-day stories from the major European institutions and across the continent. Before that he was Washington Correspondent, where his coverage and analysis of 9/11 won widespread acclaim.\n\nTen years earlier it was Stephen who broke the story of the mass killing on the Basra road out of Kuwait, marking the end of the Gulf War. He was then posted to Cairo and Jerusalem as Middle East Correspondent, where he reported on the emergence of the Palestinian Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "His Excellency Abdulla bin Touq Al",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNzA4MDkzLFVzZXJfMjAxNzk1NjUp",
                "jobTitle": "Minister of Economy and Chairman of the Tourism Council",
                "lastName": "Marri",
                "photoUrl": "https://static.swapcard.com/public/images/42ee3cc4823e43319c9ff340311e8e79.jpeg",
                "organization": "United Arab Emirates",
                "biography": "H.E. Abdulla Bin Touq Al Marri was appointed Minister of Economy of the United Arab \nEmirates (UAE) and member of the UAE Cabinet in July 2020. \nHe is the Chairman of the General Civil Aviation Authority (GCAA), Etihad Credit Insurance (ECI), the UAE International Investors Council, the CSR UAE Fund’s Board of Trustees, and the Head of the Circular Economy Policy Committee within the UAE Circular Economy Council.  He also chairs several government committees including the Supreme Committee for Consumer Protection, the National Civil Aviation Security and \nFacilitation Committee, the Economic Integration Committee, and the Emirates Tourism Council. \nPrior to his appointment, Al Marri held various senior government positions. He was the Secretary General of the UAE Cabinet since 2017, during which he was instrumental in strengthening the interdependence between the federal and local governments. In this role, he also spearheaded many initiatives aimed at measuring public opinion and acceptability of public policies, and he developed critical partnerships with international organizations such as the World Economic Forum. \nMinister Al Marri formerly served as the Chairman of the Securities and Commodities Authority and the Director General of the Executive Office of H.H. Sheikh Mohammed bin Rashid Al Maktoum. He was part of the leading team behind the launch of “Area 2071,” the nucleus of the future envisioned in the UAE Centennial Plan 2071. He \nalso took part in the unveiling of the Hatta Economic Zone development project and the relaunching of the Mohammed Bin Rashid Center for Leadership Development. \nIn addition, as former CEO of the Dubai Future Foundation, Al Marri played a vital role in the successful launch of Dubai 10X, the Emirate’s bid to become the city of the future, and other initiatives at the local and national levels. \nMinister Al Marri is a member of the Boards of Directors of various federal entities. In these roles, he actively supports the development of priority sectors in the country such as the Golden Visa initiative, which seeks to attract talented individuals from across the world. \nMinister Al Marri holds a bachelor’s degree in civil engineering from the University of Sheffield in the United Kingdom. Moreover, he is a graduate of the UAE Government Leaders Programme and Mohammed Bin Rashid Center for Leadership Development.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "FHS Opening, Awards & Signings",
            "Global Investments"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU5OA==",
        "titleTranslations": [
            {
                "value": "Capital Talks: Global Investment and the Allure of the Hospitality Industry",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 11:50:00",
        "endsAt": "2024-10-01 12:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/SnHTv5lT3nA\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Adeeb",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjkzMTcxLFVzZXJfNTM3NDM2Nyk=",
                "jobTitle": "Managing Director",
                "lastName": "Ahamed",
                "photoUrl": "https://static.swapcard.com/public/images/f704fc6dead54ffcb162e11434543fc8.jpeg",
                "organization": "Twenty14 Holdings",
                "biography": "Adeeb Ahamed is the Managing Director of Twenty14 Holdings, an Abu Dhabi based holding company with over $650 million invested in luxury hospitality assets around the world. He is a multifaceted entrepreneur spearheading several companies in financial services, F&B and hospitality. Adeeb started his entrepreneurial journey with the founding of LuLu Financial Holdings in 2009. The honors he has been awarded include Forbes Top Travel & Tourism Leaders in the Middle East 2024 and the Forbes World’s Top Heritage Hotels with Owners from the Middle East 2020.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Lourie",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTU0Mjg3LFVzZXJfMTI2MzY0MTAp",
                "jobTitle": "Chief Financial Officer",
                "lastName": "Kruger",
                "photoUrl": "https://static.swapcard.com/public/images/3ad8ca3437f048f98b7d1778ec2dff0c.jpeg",
                "organization": "Katara Hospitality",
                "biography": "Mr. Kruger is a globally experienced investment professional executive with more than 20 years’ international experience in banking, real assets and hospitality, gained in over 35 countries, and throughout the investment lifecycle: from origination and underwriting, through active management, to disposal/exit.  \n\nHe is currently the Chief Financial Officer of Katara Hospitality, a global hotel owner, developer, and operator, based in Qatar. Prior to this he headed up the M&A and Finance functions across Africa and Middle East for Westmont Hospitality Group (WHG), one of the world’s largest private owner/operators of hotels. \n\nMr. Kruger has been based in the GCC since 2009, initially spending 10 years with Kingdom Hotel Investments (KHI), a major investment company focused primarily on mixed-use real estate and hospitality with investments in 37 operating companies across 24 countries in Africa, Asia, Europe, Middle East, and North America. During his time at Kingdom Mr. Kruger was the CFO of the company, responsible for overseeing the corporate finance activities of the company, treasury, and M&A initiatives, including leading the disposal drive that saw the company dispose of 32 portfolio companies over an 8-year period.  \n\nBefore moving to the Middle East Mr. Kruger was working for a South African investment bank where he was a founding member of the African Real Estate team within the bank. Mr. Kruger holds degrees in Computer Sciences, Financial Economics, and an MBA from London Business School.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Andreas",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODUwNzA1LFVzZXJfMTc5MTAxNSk=",
                "jobTitle": "Head of Investment Management Operational (Hotel / Retail)",
                "lastName": "Löcher",
                "photoUrl": "https://static.swapcard.com/public/images/38d68d99909c48898f4088053b8a3ee6.jpeg",
                "organization": "Union Investment Real Estate",
                "biography": "Andreas Löcher has been Head of Investment Management Hospitality at Union Investment Real Estate GmbH, Hamburg, since July 2010. As per August 2023, he is also in charge of the retail investment strategy and coordinates their Acquisitions and Sales activities within the Hamburg-based property investment company as Head of Investment Management Operational. The widespread hotel portfolio of Union Investment containing some 47 hotel operators/brands in ten country markets currently comprises 93 real estate properties with a current market value of about 7.3 billion EUR. The retail portfolio comprises 89 retail properties in 16 country markets with retail property assets of 10.0 billion EUR. Prior to joining Union Investment, Andreas Löcher was a Head of Hotel Acquisitions & Sales at Deka Immobilien GmbH, Frankfurt and a Vice President at Aareal Bank AG, Wiesbaden, responsible for real estate finance (hotel).",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Alyshia",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTMwMjEwLFVzZXJfNjk1ODA0OCk=",
                "jobTitle": "Vice President - Europe & Africa",
                "lastName": "Mangalji",
                "photoUrl": "https://static.swapcard.com/public/images/5231b842784648f6b51d01b072082232.jpeg",
                "organization": "Westmont Hospitality",
                "biography": "Alyshia Mangalji is the Vice President of Europe and Africa at Westmont Hospitality, where she oversees strategy, operations, value-add opportunities and asset management across the regions. Based in London, she plays a pivotal role in guiding the teams to identify and capitalize on new projects and investments, ensuring Westmont’s continued growth and success.\n\nWestmont Hospitality was founded by Ms Mangalji’s father and his family over 45 years ago. From a single hotel, it has become one of the largest private hotel owner/operators in the world with significant presence in North America, Europe, Asia and Africa. Although Westmont has a global reach, it remains a family-owned business, deeply rooted in its founding principles.\n\nAlyshia brings a wealth of experience across various sectors of the hospitality industry, including asset management, operations, design, and brand repositioning. Beyond her hospitality focus, she also manages several non-hotel investments for the family’s private portfolio.\n\nAs a Board member, Ms Mangalji contributes to Westmont’s global strategy by ensuring that commercial realities are effectively communicated across the organization, fostering a unified vision for growth and excellence.\n\nIn the impact space, Ms Mangalji is passionate about tangibly supporting entrepreneurship and education via University of West London’s Westmont Enterprise Hub and sits on the Board of the Westmont Institute of Tourism and Hospitality in partnership with NOVA SBE in Portugal.\n\nMs Mangalji has a bachelor’s degree from The School of Hotel Administration at Cornell University and an MBA from The University of Oxford—Saïd Business School.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "David",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTI5MjY0LFVzZXJfMTY2ODgwMSk=",
                "jobTitle": "Managing Partner & Co-CEO",
                "lastName": "Damiba",
                "photoUrl": "https://static.swapcard.com/public/images/12212ae76a56457b8d8e0c0ab44bef7c.png",
                "organization": "Kasada Capital Management",
                "biography": "David is the Managing Partner and Co-Chief Executive Officer of Kasada Capital Management, the leading independent real estate private equity platform dedicated to the hospitality sector in Africa. We are committed to generating sustainable, positive impact in the African economies and communities we invest in, while also ensuring the delivery of attractive, risk-adjusted returns for our investors. Kasada was established in 2018 with the support of Qatar Investment Authority, the sovereign wealth fund of Qatar, and Accor, a global hospitality leader. \nIn April 2019, Kasada closed its first fund, Kasada Hospitality Fund L.P. (“Kasada”), with equity commitments of more than US$ 500 million. Kasada is currently the most active investor in the hospitality industry in Sub-Saharan Africa with a current portfolio of 20 hotels representing over 3,500 keys since its first acquisition in January 2021.\n\nBefore joining Kasada in 2018, David was a Partner at Helios Investment Partners, where he co-founded and co-led the firm’s activities in African mezzanine and structured credit. In that capacity, David originated, led, structured, and executed a variety of transactions targeting equity-like returns with significant structural downside protection and an emphasis on yield and self-liquidation. \n\nPrior to joining Helios in 2012, David was a Managing Director and founder of Africa Funds at Renaissance Asset Managers (UK). David’s area of focus at Renaissance was on providing structured solutions across the capital structure to a wide range of entities. \n\nHe has more than 25 years of finance experience with an extensive African fund management, portfolio construction, and risk management track record covering all asset classes across more than 20 African countries. \n\nDavid has a BA in Economics from New York University (NYU) and an MBA from INSEAD.\n\nDavid is Burkinabé and British and speaks English and French.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Global Investments"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjE0MzM0Mw==",
        "titleTranslations": [
            {
                "value": "Announcement #7",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 12:00:00",
        "endsAt": "2024-10-01 12:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjExODIxMA==",
        "titleTranslations": [
            {
                "value": "Regenerative Tourism: Innovating High-End Hospitality for Tomorrow",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 12:30:00",
        "endsAt": "2024-10-01 12:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/AAOy7DLfd6U\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0MjI4LFVzZXJfMTU3NTcyNzUp",
                "jobTitle": "Presenter",
                "lastName": "Sackur",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
                "organization": "HARDTalk",
                "biography": "Stephen Sackur is presenter of HARDtalk, the current affairs interview on BBC World and the News Channel. His subjects have included the heads of NATO and OPEC, Shimon Peres, Gore Vidal and Richard Dawkins.\n\nFor HARDtalk he has also interviewed a number of the world’s great names, including Bill Clinton, George W Bush, Mikhail Gorbachev and Hugo Chavez. Distilling his notes for a series of articles, Stephen identiﬁed the ﬁve qualities they all seemed to share: an indestructible will, passion (almost beyond reason), outrageous optimism, a super-sized ego and a ‘rebel yell.’\n\nThese interviews have also given him an insight into how organisations can best bring about innovation: “You need to ﬁnd ways to assess individuals on their merits, and give rewards for innovative thinking rather than play-it-safe mediocrity. You should encourage insiders to get outside and bring back fresh insights. And you shouldn’t confuse seniority with creativity.”\n\nAway from set-piece interviews Stephen has served in Brussels, reporting on day-to-day stories from the major European institutions and across the continent. Before that he was Washington Correspondent, where his coverage and analysis of 9/11 won widespread acclaim.\n\nTen years earlier it was Stephen who broke the story of the mass killing on the Basra road out of Kuwait, marking the end of the Gulf War. He was then posted to Cairo and Jerusalem as Middle East Correspondent, where he reported on the emergence of the Palestinian Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjE0MzM0NQ==",
        "titleTranslations": [
            {
                "value": "Announcement #8",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 12:30:00",
        "endsAt": "2024-10-01 13:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzYxMA==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talk: People First for the Future of Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 12:45:00",
        "endsAt": "2024-10-01 13:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/nI8gst9BH3A\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Satya",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0NjcyLFVzZXJfNTYwMzI3Myk=",
                "jobTitle": "President - Europe, Middle East and Africa (EMEA)",
                "lastName": "Anand",
                "photoUrl": "https://static.swapcard.com/public/images/df441a110429418a9b99f5abd1aca892.jpeg",
                "organization": "Marriott International",
                "biography": "Satya Anand was appointed President for Europe, the Middle East & Africa in October 2020 and is accountable for developing and managing Marriott's hotel portfolio in Europe, the Middle East, and Africa, which comprises of 25 brands in 76 countries and territories.\n\nMr. Anand began his career with Marriott International in 1988 and most recently served as Chief Operations Officer, Luxury & Southern Europe and Global Design EMEA from July 2016, where he was responsible for the overall operations of the luxury portfolio in Europe and the complete portfolio of brands in Southern Europe as well as leading the Global Design team. Prior to this, Mr. Anand was Europe’s Chief Financial Officer for four years and held Area Vice President roles for Western and Central Europe respectively as well as various Cluster General Manager, operations and finance positions both on and above property.\n\nEducated primarily in Bangalore, Mr. Anand holds a bachelor’s degree in Accounting from Bangalore’s MES College of Commerce (1982-1985) and in 1988 completed his Diploma in Hotel and Tourism Management from the Institute of Tourism & Hotel Management in Semmering, Austria.\n\nMr. Anand currently resides in London and Vienna with his wife Lisa and daughter Savita.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE5Mjg0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/17a7878fe072462dbdfaa73230f5d186.jpeg",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzYwNw==",
        "titleTranslations": [
            {
                "value": "Sustainable Hospitality Challenge - The Hospitality Leaders of Tomorrow Reimagining our Industry",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 13:00:00",
        "endsAt": "2024-10-01 13:15:00",
        "descriptionTranslations": [
            {
                "value": "<p>Winner Presentation & Award Giving</p><p><a href=\"https://youtu.be/gvOMJBGr7qw\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Paul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0NzY5LFVzZXJfMTU3NTczMzAp",
                "jobTitle": "Founder, Sustainable Hospitality Challenge",
                "lastName": "Griep",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e83e40532f97441986d87e699f53d5e6.jpeg",
                "organization": "Director Industry Relations & Alumni, Hotelschool The Hague",
                "biography": "Paul is the Director of Industry & Alumni Relations as well as a Lecturer in Revenue Management and Sales & Marketing  for Hotelschool the Hague based in The Netherlands.  Paul is responsible to facilitate the alignment between Industry practices with the world- renowned curriculum of Hotelschool the Hague.  Hotelschool the Hague belongs to the top Hotelschools in the world and has won various International awards. Hotelschool the Hague has campuses in both The Hague as well as Amsterdam. \n\nThrough various programs and partnerships Paul develops and maintains a dynamic relationship with the industry and strengthens and develops the exchange of knowledge.\n\nPaul is the founder and organizer of the Sustainable Hospitality Challenge; the biggest of its kind in the world.  This Challenge is an Internationally renowned Student Challenge bringing the best students of various top schools in the world in contact with CEOs and Presidents of our Industry.  \n\nPaul has a 25 year experience in the International Hotel business working for various chains such as Marriott, Intercontinental, Hilton and Rezidor in Executive Sales & Marketing and Operations positions.  Paul has also been an entrepreneur in both The Netherlands as well as the US in the area of Real Estate development and sales.\n\nPaul, a Dutch native, was a competitive skier in his youth and is a true dog lover.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Satya",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0NjcyLFVzZXJfNTYwMzI3Myk=",
                "jobTitle": "President - Europe, Middle East and Africa (EMEA)",
                "lastName": "Anand",
                "photoUrl": "https://static.swapcard.com/public/images/df441a110429418a9b99f5abd1aca892.jpeg",
                "organization": "Marriott International",
                "biography": "Satya Anand was appointed President for Europe, the Middle East & Africa in October 2020 and is accountable for developing and managing Marriott's hotel portfolio in Europe, the Middle East, and Africa, which comprises of 25 brands in 76 countries and territories.\n\nMr. Anand began his career with Marriott International in 1988 and most recently served as Chief Operations Officer, Luxury & Southern Europe and Global Design EMEA from July 2016, where he was responsible for the overall operations of the luxury portfolio in Europe and the complete portfolio of brands in Southern Europe as well as leading the Global Design team. Prior to this, Mr. Anand was Europe’s Chief Financial Officer for four years and held Area Vice President roles for Western and Central Europe respectively as well as various Cluster General Manager, operations and finance positions both on and above property.\n\nEducated primarily in Bangalore, Mr. Anand holds a bachelor’s degree in Accounting from Bangalore’s MES College of Commerce (1982-1985) and in 1988 completed his Diploma in Hotel and Tourism Management from the Institute of Tourism & Hotel Management in Semmering, Austria.\n\nMr. Anand currently resides in London and Vienna with his wife Lisa and daughter Savita.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Marloes",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjEzOTQ0LFVzZXJfMTEyODE0MDUp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Knippenberg",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/aadc31d5ddd34fcabc0aca59a0182e30.jpeg",
                "organization": "Kerten Hospitality",
                "biography": "Marloes is a distinguished hospitality leader who has been instrumental in redefining industry benchmarks. She seamlessly integrated ESG (Environmental, Social, and Governance) into the heart of business operations, processes, and value propositions. This integration has proven transformative, elevating a singular national brand to a global lifestyle group with a portfolio spanning over 45 diversified projects.\n\nMarloes' commitment to excellence is underscored by her strategic vision. She actively pursues the expansion of the brand's lifestyle portfolio, targeting regions identified for synergistic collaborations and mutual stakeholder objectives. Her foundational expertise is anchored in her tenure at Hilton, where she was entrusted with high-impact operational and commercial management portfolios.\n\nBeyond mere strategy and execution, Marloes is deeply committed to human capital development within the industry. She consistently champions the nurturing of emerging talents, propelling industry-wide transformation, and driving organizational alignment towards sustainability-centric objectives. This approach prioritizes not just bottom-line growth but also the holistic development of individuals, communities, and guest experiences.\n\nMarloes' advocacy for a progressive hospitality sector extends beyond traditional corporate parameters. As a notable ambassador for the Global Hospitality Student Challenge, spearheaded by Hotelschool the Hague, she is at the forefront of bridging the gap between the seasoned investment community and the visionary leaders of tomorrow. This initiative stands as a testament to her commitment to fostering innovation and collaboration, cementing her role in the ongoing evolution of the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxMw==",
                                    "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                                    "beginsAt": "2024-04-29 17:20:00",
                                    "endsAt": "2024-04-29 18:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Aseel  Hussain",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMjY3MDMzLFVzZXJfMTU5MjQ5MjMp",
                "jobTitle": "Hotel Talent Development Manager",
                "lastName": "Bondagjy",
                "photoUrl": "https://static.swapcard.com/public/images/7186201b027e4b559da332e0aae95aa3.jpeg",
                "organization": "NEOM",
                "biography": "Aseel’s passion is to inspire young Saudis; to encourage, and motivate them to embrace a career in hospitality, her role at NEOM (Saudi Arabia’s visionary Giga project on the Red Sea coast) aligns perfectly with this. As part of the Hotel Development team, Aseel is responsible for driving the development and implementation of its workforce development strategy, which is aimed at creating an empowered and competent pipeline of future leaders in hospitality. \nA fluent English speaker with Arabic as her mother tongue, Aseel holds a bachelor’s degree in business administration and a master’s degree in Hospitality and Tourism Management from Ken State University where she was recognized with the International Alumni Award, which is bestowed to students who have gained global recognition in their respective fields.\n\nApart from her international credentials, Aseel also has a deep understanding of the region, having previously worked in Dubai and Abu Dhabi. She was also part of the inaugural cohort of post graduate employees at NEOM which saw only ten high potential candidates selected from more than 12,000 applicants.\n\nAseel began her career at NEOM within its tourism department, making significant contributions towards its tourism strategy by developing a variety of marketing collateral including compelling audio and visual campaigns. She is now a ‘Rising Star’ in NEOM’s Hotel Development business unit having recently been awarded as such at the inaugural ‘Leaders in Hospitality Awards KSA’ held by Hotel & Catering News Middle East.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzYxMQ==",
        "titleTranslations": [
            {
                "value": "Lunch",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 13:00:00",
        "endsAt": "2024-10-01 14:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg5Nw==",
        "titleTranslations": [
            {
                "value": "Sustainable Cook Off",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 13:00:00",
        "endsAt": "2024-10-01 14:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><strong>Judges:</strong></p><ul><li><strong>Atul Chopra</strong>, Founder & CEO, Fresh on Table</li><li><strong>Bhatt Dwarika</strong>, Dubai Chairman, Emirates Culinary Guild</li><li><strong>Amit Nayak, CHA</strong>, Vice President, HAMA MEA</li><li><strong>Majed Al Sabagh</strong>, Manager / Owner Chef Training and Consultancy</li><li><strong>Atim Suyatim</strong>, Vice President Public Relations, Emirates Culinary Guild</li><li><strong>Jonathan Worsley</strong>, Chairman & CEO, The Bench</li></ul>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "competitions",
                "translations": [
                    {
                        "value": "Competitions"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Competitions"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjA4ODI4Nw==",
        "titleTranslations": [
            {
                "value": "Welcome Back",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 13:55:00",
        "endsAt": "2024-10-01 14:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Marco",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjk0NzA4LFVzZXJfMjA1MzU1MzEp",
                "jobTitle": "Young Leader",
                "lastName": "Palamara",
                "photoUrl": "https://static.swapcard.com/public/images/ea0bcb74624846ed900173a908c50f4a.jpeg",
                "organization": null,
                "biography": "Born in Milan, in my early twenties I moved to London to explore the world and broaden my horizons. My career began in the hospitality industry, where I worked in Michelin-starred restaurants and prestigious Forbes 5-star properties. This immersion into the luxury field allowed me to gain invaluable experience and a deep understanding of excellence in service, as well as to recognize societal needs and gaps. My journey continued with a degree in management, providing a solid foundation to better address global concerns, particularly those related to sustainability in our sector. \n\nThroughout my academic and professional journey, I actively participated in extracurricular activities, consistently seeking out innovative and challenging environments. My passion for growth and learning drives me to invest my time and energy in projects that push boundaries. I believe that in a rapidly changing world, youth leaders are essential to inspire the next generation and ensure a promising future. \n\nEvery day is a new beginning for me, a step towards a brighter future, where I can leverage my skills and experiences to make a meaningful impact. I am excited about the opportunities ahead and committed to contributing positively to our ever-evolving world. With my enthusiasm for exploring disruptive concepts, adventure is always on the horizon!",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjA4ODUyNw==",
        "titleTranslations": [
            {
                "value": "Welcome Back",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 13:55:00",
        "endsAt": "2024-10-01 14:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Francine",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzM1MjEwLFVzZXJfMjA1NTkyODYp",
                "jobTitle": "Young Leader",
                "lastName": "Aclan",
                "photoUrl": "https://static.swapcard.com/public/images/fa75f1e3e1864c9793d0eb2142ebe26a.jpeg",
                "organization": null,
                "biography": "As an HR professional in hospitality, Francine Aclan is deeply passionate about social sustainability—specifically, analyzing how business decisions impact employee wellbeing. She is excited to participate as a finalist in the Sustainable Hospitality Challenge and is eager to learn more about other aspects of sustainability.\n\nAclan’s professional background includes HR analytics, diversity & inclusion, and learning & development. She has worked at hospitality companies such as Hilton, Walt Disney World, and Cornell University.\n\nAclan is currently pursuing a Master of Management in Hospitality (MMH) from Cornell University, and currently holds a Bachelor of Science in Global Business Administration at California Lutheran University.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjA4ODYyOA==",
        "titleTranslations": [
            {
                "value": "Welcome Back",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 13:55:00",
        "endsAt": "2024-10-01 14:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Rahul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjkyNjA5LFVzZXJfMjA1MzQyMTMp",
                "jobTitle": "Young Leader",
                "lastName": "Dahiya",
                "photoUrl": "https://static.swapcard.com/public/images/bb97d875a4e6448291767655d39ff95f.jpeg",
                "organization": null,
                "biography": "I am a passionate advocate for sustainability, with roots in India and a rich history of involvement in impactful projects. At the age of 16, I had the privilege of working on United Nations sustainability initiatives, which ignited my lifelong commitment to this critical cause. This early experience fueled my drive to explore and contribute to sustainable solutions on a global scale.\n\nMy professional journey includes a significant role as a project manager for the Ministry of Education Italy during Expo 2020 Dubai. This opportunity deepened my understanding of the UN’s Sustainable Development Goals and expanded my network within the industry. Midway through my bachelor’s in hospitality management, I relocated to London to continue my education at the University of West London, where I am currently in my final year. \n\nDuring my first year, I connected with like-minded individuals, Marco and Andrei, who shared my vision for a sustainable future. Our collective determination to effect positive change has been a cornerstone of my journey. After completing an enriching internship at a Forbes property in the United States, I was invited to participate in the Sustainable Hospitality Challenge. This opportunity has allowed me to further my knowledge and contribute to innovative solutions in sustainable hospitality.\n\nI look forward to sharing my insights and experiences, and to collaborating with fellow enthusiasts to create a more sustainable world.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzY0OQ==",
        "titleTranslations": [
            {
                "value": "Leading with Purpose: Commitment to People, Planet and Profit",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:00:00",
        "endsAt": "2024-10-01 14:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/mT340MJNyeg\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Maha",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNTgyNTU3LFVzZXJfMTg1NTUyNzMp",
                "jobTitle": "Vice-President of Business Advocacy",
                "lastName": "Al Gargawi",
                "photoUrl": "https://static.swapcard.com/public/images/89bb768bd62c4c82b92f9c237ccc3f23.jpeg",
                "organization": "Dubai Chambers",
                "biography": "Maha Al Gargawi is the Vice President of Business Advocacy at Dubai Chambers. In this role, she drives proactive and reactive business and legislative advocacy recommendations and engagement with the government. \nPrior to joining Dubai Chambers, Maha was the Senior Vice President of Political Affairs at Expo 2020 Dubai and she also held the role of Vice President of International Participants at Expo 2020.\nPrior to Expo 2020, Maha was the Deputy General Counsel at Emirates Nuclear Energy Corporation.\nMaha also sits on the board of the German-Emirati Joint Council for Industry and Commerce. \nShe began her career working for Clifford Chance, a law firm based in London.\nShe holds a master’s and a bachelor’s degree in international commercial law from universities in the UK.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Dr John",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMTI0Mjk5LFVzZXJfNTE4OTU5KQ==",
                "jobTitle": "Author - Force for Good",
                "lastName": "Blakey",
                "photoUrl": "https://static.swapcard.com/public/images/3ff173de5e804881833e7614a3bbaa92.jpeg",
                "organization": "John Blakey Ltd",
                "biography": "Dr John Blakey is the UK's leading executive coach for purpose-driven CEOs and the founder of The Trusted Executive. An authority on purpose-driven leadership, his expertise is sought-after by ambitious leaders aiming to be a force for good and achieve the triple bottom line - profit, people and planet. With a unique track record as a pioneering coach, global thought leader and former FTSE 100 international managing director, John has worked with over 130 CEOs around the globe, including the leaders of gold-medal-winning Team GB Olympic squads, title-winning premiership football clubs and England cricket.\nAs an executive coach and board advisor, John has worked with over 130 CEOs from 22 countries, including the leaders of FTSE 100 PLCs, high-profile public servants and some of the UK’s most successful entrepreneurs. John has also coached the leaders of gold-medal winning Team GB Olympic squads, title-winning premiership football clubs and England cricket.\n\nAs a thought leader, John is a regular keynote speaker at international business conferences on the three coaching models featured in his books: Force for Good – How to thrive as a purpose-driven leader (Kogan Page, publication August 2024); The Trusted Executive – Nine leadership habits that inspire results, relationships and reputation (shortlisted as the CMI Book of the Year), and Challenging Coaching (UK bestseller co-authored with Ian Day).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Guy",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNzA4MTE3LFVzZXJfMTg5NTE1NjQp",
                "jobTitle": "President, Middle East & Africa",
                "lastName": "Hutchinson",
                "photoUrl": "https://static.swapcard.com/public/images/7b69152893044de9bd64e3bd51d49861.jpeg",
                "organization": "Hilton",
                "biography": "Guy Hutchinson is President, Middle East & Africa (MEA) for Hilton and is a member of Hilton’s Europe, Middle East & Africa (EMEA) Executive Committee.\n\nBased at Hilton’s Regional Office in Dubai, Hutchinson oversees 137 operating properties across 11 brands in the MEA region, with more than 182 hotels in the pipeline. Together with the team, Hutchinson focuses on providing friendly and reliable stays for guests and above-market returns for owners.\n\nHutchinson brings with him an impressive track record in the hospitality industry, including 15 years working previously with Hilton, holding several managerial positions in Dubai, Japan, China, Australia before serving as Vice President – Operations in India. Most recently, he was CEO of Abu Dhabi based Rotana. During his tenure, Hutchinson led the company’s global expansion plans and launched a new franchise model for the group.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                                    "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                                    "beginsAt": "2024-04-29 16:30:00",
                                    "endsAt": "2024-04-29 17:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Duncan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTUyNDMzLFVzZXJfNDk4NTU2MCk=",
                "jobTitle": "Chief Executive Officer, Middle East, Africa & Asia Pacific - Premium, Midscale & Economy",
                "lastName": "O’Rourke",
                "photoUrl": "https://static.swapcard.com/public/images/1c3e3941e7364f5499e61c5ed5068869.jpeg",
                "organization": "Accor",
                "biography": "Duncan O’Rourke holds a degree from César Ritz Colleges in Switzerland and a MBA from Reims Management School.\n\nWith more than 30 years’ experience within the industry, he held several executive positions in Europe, the US and the Middle East. From 2004, he served as General Manager for Kempinski in various destinations before being promoted to the position of Regional Director overseeing the Operations of the properties in the Middle East. In 2008, he was appointed Chief Operating Officer of Kempinski Hotels and became part of the Management Board at the same time.\n\nDuncan joined Accor in 2016 as COO Europe for the Luxury and Premium segment before taking over as COO Central Europe. In that capacity, he was responsible for more than 470 hotels and 13 brands within Germany, Austria and Switzerland. In October 2020, Duncan was appointed CEO Northern Europe, overseeing more than 1,100 hotels and 40,000 team members across 32 countries, and joins Accor’s Executive Committee.\n\nIn January 2023, Duncan joined Accor’s Premium, Midscale & Economy Executive Committee as the division’s CEO Middle East, Africa, Turkey & Asia Pacific.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Artur",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ3NjAwLFVzZXJfMTkzMjA1Mjkp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Gerber",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/0f23ecf59ba442a396d3bcf6966bbcfe.png",
                "organization": "TUI BLUE Hotels & Resorts",
                "biography": "Artur Gerber joined TUI Group in 2015 as Managing Director TUI BLUE and has developed the new brand to become the fastest-growing hotel brand in the history of TUI. He leads the business and pursues the growth strategy. Artur's responsibilities include Operations, Business Development, and Brand Partnership for TUI BLUE.\n\nArtur has many years of experience in the hotel industry. He began his career in tourism in 1986 with an apprenticeship as a hotel specialist at Dorint Hotels & Resorts and became General Manager within a few years. He is based in Germany.\n\nFurther professional stations were Center Parcs Deutschland GmbH as General Manager and Development Manager. For Aldiana GmbH, he was first responsible as Director of Operations and later as Managing Director. Before joining TUI, he was the CEO of HMS Hotel Management Services GmbH, which operates and develops new international hotels for the Maritim Hotel Group.\n\nOutside of work, Artur likes to go golfing.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Philip",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0MjQxLFVzZXJfMTkxMzQ5MzIp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Barnes",
                "photoUrl": "https://static.swapcard.com/public/images/246b45805ccc406aa094b53884a16d4f.jpeg",
                "organization": "Rotana",
                "biography": "Philip Barnes is the Chief Executive Officer (CEO) of Rotana, one of the leading hotel management companies in the region with hotels across the Middle East, Africa, Eastern Europe, and Türkiye. In his current role, Barnes oversees all aspects of Rotana’s growth and operations, from directing long-term strategies to improving day-to-day efficiencies. With a focus on robust expansion in the region and beyond, Barnes plays a pivotal role in propelling Rotana to new heights and driving the company’s ongoing success. \n\nWith over 40 years of experience spanning five continents, Barnes specialises in hotel and resort openings, turnarounds, and asset re-positioning. His successful stints in Asia, Canada, the United Kingdom, and the United States of America underscore the breadth of his expertise and global impact on the industry.\n\nCareer highlights for the British national include 25 years at Fairmont Hotel & Resorts, where he held several senior leadership positions worldwide. In the Middle East, he served as Fairmont Hotels & Resorts’ Regional Vice President of the United Arab Emirates where he oversaw the operations and pre-opening for several properties. He also held the position of Vice President of the Middle East for the group, leading the developments and planned openings in South Africa, the Kingdom of Saudi Arabia, Egypt, the United Arab Emirates, and Oman. Prior to joining Fairmont Hotel & Resorts, Barnes held positions at Four Seasons Hotels & Resorts and Shangri La Hotels & Resorts among other leading international brands.\n\nAt Rotana, Barnes works closely with the wider team to grow Rotana’s legacy and firmly position it as one of the leading hospitality players in the region. He remains dedicated to redefining the hospitality experience, creating Treasured Time for guests and setting new benchmarks for the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Sustainability & Innovation"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzc0Mw==",
        "titleTranslations": [
            {
                "value": "Beyond Borders: Strategic Fund Structuring for Cross-Border Investments to transform the Global Hospitality Landscape",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:00:00",
        "endsAt": "2024-10-01 14:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/PA_C-q-i7oA\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "hotelisation-of-traditional-assets",
                "translations": [
                    {
                        "value": "Hotelisation of Traditional Assets"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Paula",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzk5MjkyLFVzZXJfMjA1OTc2NTEp",
                "jobTitle": "Senior Reporter",
                "lastName": "Naoufal",
                "photoUrl": "https://static.swapcard.com/public/images/2ad63627a3fa49c3ab5897a30da76d54.jpeg",
                "organization": "CNN Business Arabic",
                "biography": "Paula Naoufal is an award-wining journalist who is currently a Senior Reporter at CNN Business Arabic with over a decade of experience in media and communications. She has conducted interviews with heads of state, government officials, and CEOs including the President of Iraq, the CEO of Aramco, the Indian Minister of Petroleum, the executive director of the IEA, the Ukrainian Minister of Economy, GCC ministers, among others. Additionally, Paula has moderated several panels across the region, and she has won international journalism awards.\n\nPaula's expertise includes live reporting and broadcasting, covering business news, conducting special interviews, and presenting shows and segments. She has also covered numerous on-ground events such as the OPEC+ meetings in Vienna and the World Economic Forum at Davos.\n\nPrior to joining CNN BA, Paula worked at an array of institutions such as Asharq News with Bloomberg and the UN HQ in New York. She is currently pursuing a PhD in Media and Communication at Leicester University and holds a master's degree in Risk Analysis from King's College London.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Siegfried",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTAxMDEyLFVzZXJfMTkwOTUxNzQp",
                "jobTitle": "Vice President/Head of Development Middle East, India, Africa",
                "lastName": "Nierhaus",
                "photoUrl": "https://static.swapcard.com/public/images/64ba4b14b8904209bfae35c6518ce156.jpeg",
                "organization": "H World International",
                "biography": "Siegfried Nierhaus is a well-respected name in the Middle Eastern hospitality industry, \nknown for his passion and dedication towards his work and team. Born and raised in a \nfamily of restaurateurs and hoteliers in Germany and Austria, Siegfried inherited the love for hospitality from his family and has entertained guests at his family business since the age of 4. \nHis more then 30-year career in the industry has been dominated by 15 years spent in \nFrance and 16 years based in Dubai with responsibilities throughout the Middle East, India, Asia, and Africa. \nIn the Middle East, Siegfried has held strategic and leading operational positions, and board of director positions while working for different international hotel operators, hotel owners, and hospitality consultants. He is the only German in the hospitality industry who has beenrecognised as one of the Top 50 hoteliers in the Middle East since 2011. \nSiegfried holds the position of Vice President and Head of Business Development for H \nWorld International covering the Middle East, India, and Africa (MEIA) region with over 32 \nhotels, 8344 keys to date. With a strategic vision and a passion for delivering exceptional \nguest experiences, Siegfried has led numerous high-profile projects, enhanced operational excellence and driven business growth across diverse markets. Siegfried’s deep understanding of the unique cultural and business dynamic within the MEIA region, has positioned him as a key influencer in the hospitality sector and inspire and empower teams to achieve new heights of success, fostering a culture of collaboration and excellence throughout the organisation. \nSiegfried’s motto is to empower his team by fostering an inclusive and collaborative \nenvironment where every voice is valued by encouraging open communication, providing \nopportunities for continuous learning and professional development with skills needed to succeed in a fast-paced industry. He promotes a culture of accountability and trust, \nempowering the team to take ownership of their roles and make decisions that drive the \nbusiness forward. The leadership style is rooted in mentorship, actively guiding and inspiring his team to reach their full potential.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Mohannad",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjkxOTkwLFVzZXJfMTU2ODY5NjUp",
                "jobTitle": "Vice President",
                "lastName": "Mosly",
                "photoUrl": "https://static.swapcard.com/public/images/1590b41cb66545e59f333831286eddb2.jpeg",
                "organization": "SEDCO Capital",
                "biography": "Mohannad is a Vice President in SEDCO Capital’s Regional Real Estate team, overseeing a SAR 15 billion real estate and hospitality portfolio that includes 21 income generating properties and 12 development funds across Saudi Arabia. \nWith over 10 years of experience, he previously served as a Senior Manager at EY’s Strategy and Transactions practice, focusing on real estate and hospitality projects, and worked as an Acquisition Analyst for a REIT in New York City. Mohannad holds a bachelor’s in hospitality and Tourism Management from Royal Roads University and a master’s in real estate development from Georgetown University.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Thomas",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDQzNTI4LFVzZXJfMTU5ODI2OTAp",
                "jobTitle": "Chief Operating Officer and interim Chief Executive Officer",
                "lastName": "B. Meier",
                "photoUrl": "https://static.swapcard.com/public/images/4740f0521fa54a2d8ad70defcfec57a1.jpeg",
                "organization": "Jumeirah",
                "biography": "Thomas B. Meier joined Jumeirah Group as Chief Operating Officer in October 2021 and is currently the interim Chief Executive Officer.\n\nHaving studied at the Ecole Hotelière de Lausanne, Thomas started his career in general hotel management roles in Asia and rose through the ranks to lead operations for Raffles globally. He then spent several years leading new openings and integrations globally for the Fairmont, Swissotel and Raffles brands, ahead of joining Minor Hotels as Senior Vice President, Operations (Asia) in 2016.\n\nThomas brings extensive operations experience gained across multiple markets. His global responsibilities have spanned business performance, acquisitions, owner relations and transformation across all aspects of hotel operations, development, and systems integration.\n\nAs Chief Operating Officer and interim Chief Executive Officer, Thomas plays a key role in driving Jumeirah Group’s vision of becoming one of the top five luxury hospitality companies worldwide, prioritising operational excellence and innovative transformation across its global portfolio.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Hotelisation of Traditional Assets",
            "Global Investments"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
        "titleTranslations": [
            {
                "value": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:00:00",
        "endsAt": "2024-10-01 15:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Techology & AI"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nurhan M.",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzQ2MDcxLFVzZXJfMjExNzc0ODQp",
                "jobTitle": "Growth Manager & Cofounder",
                "lastName": "Rani",
                "photoUrl": "https://static.swapcard.com/public/images/87ebf2aec85e47ee908966247eb16eef.jpeg",
                "organization": "ITHAKA",
                "biography": "Nurhan has over 5 years of experience in writing and reporting EU Commission-funded projects, along with extensive expertise in startup operations and sales. Nurhan has successfully supported initiatives that align with sustainability and innovation goals in hospitality. Drawing from a deep understanding of startup ecosystems, she helps bridge the gap between securing funding and scaling operations effectively.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Nouran",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzQ1NjE1LFVzZXJfMjExNzcxOTIp",
                "jobTitle": "Cofounder",
                "lastName": "Farouk",
                "photoUrl": "https://static.swapcard.com/public/images/d35ebb3450504c59a4a64ab6b37ae6e8.jpeg",
                "organization": "Dosy Bikes",
                "biography": "Nouran Farouk is the Cofounder of Dosy\nShe is a trained physician , social enterpreneur and social media & marketing specialist, with an interest in healthcare and lifestyle. She is an active volunteer within the startup environment supporting ventures focused on health, wellbeing, and food.She has has more than 7 years of experience in well-being and nutrition which also helps in convincing our customers of riding healthy means of transport like bicycles and scooters. \nShe has also worked on other projects like Healthyia & many other startups",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Gwen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzY0MzI1LFVzZXJfMjExODk2NDIp",
                "jobTitle": "CEO & Founder",
                "lastName": "Wunderlich",
                "photoUrl": "https://static.swapcard.com/public/images/ad0303cf6b7f4a5e9a47d4fa4c6262d0.jpeg",
                "organization": "WKC Global",
                "biography": "As CEO of WKC Global, Gwen Wunderlich is undoubtedly a powerhouse in the public relations, communications and branding industry. With over 26 years of experience and a proven track record of working with prestigious, high-profile clients in the fashion, entertainment, beauty, luxury, wellness, and lifestyle sectors, her reputation as a maverick is well-earned. \nCombining visionary thinking, innovative strategies, and an unparalleled work ethic, Gwen excels at leveraging her extensive network of connections and prescient understanding of cultural trends to deliver creative, strategically driven solutions for her clients. Her unique mix of imagination and intuition, and her ability to tap into the ebb and flow of popular culture, are key elements in her understanding of the cultural zeitgeist, which enables her to impact her clients and shape their stories and brand narratives. \nHer client list is a testament to her professional expertise and supreme versatility, ranging from top scientists and wellness renegades, to popular fashion designers, Grammy Award-winning celebrities, hospitality venues, government entities and high-powered executives. Her brand work includes representation and partnerships with some of the world’s leading companies and influential change-makers such as Bal Harbour Shops, Triller, Netflix, Maserati, Charlotte's Web, Procter & Gamble, Naja Lingerie, Hyatt Hotels, Besame Cosmetics, New Chapter, Sundance, Farmbox Direct, Liteboxer, Mastercard, Basma Beauty, Alicia Keys, Neil Degrasse Tyson, Swizz Beatz and The Royal Commission of AlUla. \nRecently, she expanded her agency's presence in the Middle East by opening a WKC Global communications office in Riyadh, Saudi Arabia, solidifying her progressive, forward-thinking approach to the PR and communications industry. In Saudi Arabia, she has executed and collaborated on projects such as the Women to Women event with Alicia Keys, Saudi Bronx for the AlUla Camel Cup, AlUla on Wheels with Swizz Beatz, The Khaybar Volcano Camp and more. Gwen’s deep understanding of the media landscape, and mastery of experiential programming, has led to standout global campaigns and client placements in top print, digital, and broadcast outlets, resulting in monumental success for her clients.\nAs a creative mind that continually focuses on the future, Gwen and WKC Global successfully launched the first ever, female-founded, AI-assisted platform called “PR For All” which enables entrepreneurs, small businesses and start-ups to effectively create cost-effective compelling brand narratives, thereby revolutionizing the PR landscape. Additionally, in 2021, WKC Global was the first female-led PR agency to accept cryptocurrency as payment for services. \nAs the co-creator of The Enternship, a charitable initiative aimed at helping women re-enter the workforce and rebrand themselves by leveraging the power of PR and social media, Gwen has helped countless women since 2014. The program, which has been hailed as pioneering an entire “re-entry” movement, has received widespread recognition, with over three  billion media impressions including CNN, FOX Business, Time, The Glossy, Forbes, Inc, NY Post, CNBC, The London Free Press, and Money. Even famed Hollywood director Nancy Meyers, creator of the movie The Intern, tweeted out about The Enternship. \nGwen started her career in public relations in 2001, when the corporate male dominated PR world was prevalent on Madison Ave. She was part of a tiny group of relentless female, small business owners who challenged the status quo in New York City by opening boutique-style, “pop-culture driven” PR agencies. Her early client roster included  MTV, Coca Cola, Dwell, Absolut Vodka, Camp Beverly Hills, Roc-A-Fella Records and more.\nIn demand as a speaker and authority on public relations, communications and branding, Gwen has spoken at The Women’s Conference in Boston and Texas, at Florida International University, the Fashion Institute of Technology, and Bergdorf Goodman. Recently, she was a cast member on Season Five of MTV’s hit series Siesta Key. Gwen is also the co-creator and co-host of “The Pretty Electric” podcast.\nShe has been profiled in numerous media articles and interviews highlighting her achievements and contributions, including PR Week, Yahoo Finance, Ad Age, Arab News, Entrepreneur, Medium, and The Observer, and is a graduate of the Harvard Business School Executive Program. She resides in Miami with a home in New York City.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Doaa Abdel",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzQ2MTAxLFVzZXJfMTI5NjgxMzMp",
                "jobTitle": "Cofounder & CBO",
                "lastName": "Hameed",
                "photoUrl": "https://static.swapcard.com/public/images/038d2290446948ae811b5997193cb68f.jpeg",
                "organization": "Bonbell",
                "biography": "Doaa is a seasoned senior-level leader renowned for her strategic prowess and innovative mindset. With over 19 years of experience spanning diverse industries including manufacturing, retail, financial services, and technology, she has excelled in roles across established businesses and startups alike. Her professional journey includes impactful contributions to renowned organizations such as Delivery Hero (Otlob & talabat) and Lezzoo in Kurdistan, where she played pivotal roles in the food-tech sector.\n\nComplementing her extensive practical expertise, Doaa is committed to academic growth, holding degrees and an MBA from prestigious institutions including The American and German universities in Egypt. Her dedication to lifelong learning underscores her pursuit of personal and professional excellence.\n\nCentral to Doaa's core beliefs is the belief in the transformative power of knowledge sharing and continuous learning. She champions collaboration and ongoing improvement within her teams and organizations, fostering inclusive environments that prioritize mentorship and human-centric leadership. Renowned for her exceptional communication skills, Doaa is adept at building enduring relationships with stakeholders.\n\nBeyond her professional endeavors, Doaa finds purpose and motivation in her role as a mother to two remarkable children: a 17-year-old young gentleman and a 10-year-old princess. Their presence fuels her determination to lead a life marked by success and fulfillment.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Duaa",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzQ1NTU0LFVzZXJfNTk2MzE0NSk=",
                "jobTitle": "Founder",
                "lastName": "Suliman",
                "photoUrl": "https://static.swapcard.com/public/images/933e5254029d480a854cd21ffea0b7fb.jpeg",
                "organization": "Rifgaa",
                "biography": "Duaa Mohamed is a global health activist, and health policy researcher committed to making a positive impact on global health through research, innovation, and advocacy. Beyond her academic and research pursuits, Duaa is the founder of Rifqaa , an online community that aims to empower Arabic women to explore the world confidently, with the support of a like-minded community.Riqaa aims to transform the travel experience for Arabic women, making it more accessible, enjoyable, and secure.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Maya",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMDQyMzgxLFVzZXJfMTMxODY3MTYp",
                "jobTitle": "Founder & CEO",
                "lastName": "Ayoub",
                "photoUrl": "https://static.swapcard.com/public/images/350451e42a844bb388b4c7f2d3833df2.jpeg",
                "organization": "District-Twelve",
                "biography": "Maya's journey began with a diverse foundation in economics and finance, nurtured in the trenches of her family's real estate development and consulting business. This early experience sparked her entrepreneurial flame, leading her to found The Private Circle, District Twelve, and Fait Par Fées.\n\nBut her ambitions extend beyond building businesses. Her experience, with over 15 years of leading professional conferences, corporate events, and communications across the Middle East, have shaped her into a seasoned professional with a passion for delivering successful outcomes.\n\nMaya's true fulfillment lies in leveraging her skills for positive impact. She is an impact entrepreneur with a fierce commitment to women's empowerment, particularly in the fast-paced world of technology. As the Saudi Arabia Chapter Ambassador for Women in Tech® Global Movement, she champion initiatives that bridge the gender and digital gap, cultivate diversity within the tech industry, and empower women to reach their full potential.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Saria",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNjE1NzczLFVzZXJfMTMxNzEyNTkp",
                "jobTitle": "Founder",
                "lastName": "Alderhali",
                "photoUrl": "https://static.swapcard.com/public/images/c6bac05ca76e4d4a9cd6ebed0cfcfef9.jpeg",
                "organization": "Bondai",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Zeinab",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNDgwNDk2LFVzZXJfMjEyNjQ3MDcp",
                "jobTitle": "Founder",
                "lastName": "Zohny",
                "photoUrl": "https://static.swapcard.com/public/images/7f1a8fa0bd6e4310bb1d55d458357157.jpeg",
                "organization": "Zenn-AI",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Son-Trang",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTA1NDc2LFVzZXJfMTgyODgzNjgp",
                "jobTitle": "Production Manager",
                "lastName": "Nguyen",
                "photoUrl": "https://static.swapcard.com/public/images/1e4aa41125474fa99b31b1e8170ab3a0.jpeg",
                "organization": "The Bench",
                "biography": "Being at the crossroads of Vietnamese traditions, Canadian openness and Swiss work ethics, Son-Trang offers a broad and international view to BENCH as the Conference Production Manager. Son-Trang was also the very first Vietnamese and youngest professional to moderate a CEO Panel at the Future of Hospitality Summit in Dubai at the age of 23. \n\nHaving a strong background in Hospitality since graduating from EHL, Son-Trang's main goal is to bring forward change in diversity in the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Luis Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMDU5ODAxLFVzZXJfMTE4OTk5NTQp",
                "jobTitle": "Regional Manager Innovation Education and Investment",
                "lastName": "Barrios",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3e48bf508a3f4f5a855d9b179a19b4ec.jpeg",
                "organization": "UN Tourism",
                "biography": "Luis Nicolás Barrios Medina-Montoya, Innovation Education and Investments Regional Manager for the UNWTO Regional Office in Riyadh. \n\nMaster in Project Management from Esden Business School. PMI-certified PMP. Master in Marketing and Commercial Management from IE Business School. Master in Audio-visual Production from IEEA. Degree in Audio-visual Communication from the University of Malaga. \n\nExpert in technology and innovation applied to the tourism sector. From February 2003 until June 2020, he developed his professional career in Tourism in SEGITTUR, a state-owned company integrated into the Spanish Ministry of Industry Trade and Tourism and attached to the State Secretariat for Tourism, responsible for promoting innovation (R&D) in the Spanish tourism sector, both in the public sector.      \n\nSince 2012 he was involved, in different capacities, in the development and management of the Smart Tourist Destinations program. From 2019 to 2022 he was responsible for the direction and coordination of all the Smart Tourism Destination Projects in Latin America, coordinating projects in Tequila, Medellín and Bogotá.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Techology & AI"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjA4ODI4NA==",
        "titleTranslations": [
            {
                "value": "Consumer – what are the demands and preferences of the next generation traveler?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:00:00",
        "endsAt": "2024-10-01 14:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/fCmZ2jDN2G0\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Pascal",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNTE0ODQ5LFVzZXJfMjAwNDMyNzQp",
                "jobTitle": "Partner",
                "lastName": "Armoudom",
                "photoUrl": "https://static.swapcard.com/public/images/7be19e1298dd4c7ca64f06f4cec210a6.jpeg",
                "organization": "Kearney",
                "biography": "During his first 18 years with Kearney, Pascal worked with clients in the tourism, luxury, and consumer industries across Europe and Asia, helping them to grow and improve their businesses, before being recruited to lead the strategy for Amaala, a luxury tourism destination on the Red Sea coast. “I was in charge of developing the experiential strategies for everything from mobility to arts and culture, as well as overseeing all of the strategic partnerships for the resort,” Pascal adds.\n\nAfter moving on to become strategy advisor to a Middle East investment fund dedicated to developing the cultural, entertainment, tourism, and sports sectors, Pascal returned to Kearney in 2023 and is now a partner in the firm’s transportation and travel practice, with a focus on tourism, leisure, and hospitality, based in Riyadh.\n\nHaving grown up on Reunion Island in the Indian Ocean, and spent time living and working in mainland France, London, and Shanghai, Pascal has a knack for bringing a global perspective to his work. As he puts it, “When you have been in consulting for a while, you start to spot familiar patterns. Every place and every firm has its own character and challenges, but I would hope that what I bring to my clients is an ability to put things in perspective, and shortcut some of the problems they face.”\nPascal graduated from Essec Business school MBA.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg1OA==",
        "titleTranslations": [
            {
                "value": "Tourism 2.0: Transforming Destination Investment into an Unmatched Opportunity",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:15:00",
        "endsAt": "2024-10-01 14:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Elduig5zbcc\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jules",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjkzNzg3LFVzZXJfNDIyODQzNik=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Ugo",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b6731e369c8e42d18c1e81aec244adb2.jpeg",
                "organization": "LOTUS Arabia",
                "biography": "As CEO, Jules has built LOTUS to become one of the most recognised, globally renowned marketing and communications specialists in the travel, hospitality and lifestyle space.\n\nWith over 25 years' experience Jules has led global campaigns for flagship airlines, the world’s largest outbound tourism destinations and international hospitality brands.\nWith offices in New York, Singapore and headquarters in London the footprint expanded in 2023 to add hubs in Jeddah and Riyadh serving the expanding Saudi Arabian and wider GCC tourism market.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkxNDk2MQ==",
                                    "title": "TenX Leadership Talks: Insights and Learnings in the Journey of Growing Your Destination",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 10:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Bhagya",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNzY5NTU4LFVzZXJfMTkxMzQ5NDQp",
                "jobTitle": "Deputy Director - Investor Relations Unit",
                "lastName": "Mahavithanage",
                "photoUrl": "https://static.swapcard.com/public/images/72218a6445cf4a02bc6578850f6d4083.jpeg",
                "organization": "Sri Lanka Tourism Development Authority",
                "biography": "Bhagya is the Head of the Investor Relations Unit (IRU) of SLTDA, the centralized facilitation centre for tourism investments in Sri Lanka. She led the streamlining process of IRU together with all government agencies partnering tourism development in the country creating a hassle-free investor experience. She has 12 years’ experience in the tourism sector in successful implementation of diverse tourism projects, contributed in sustainability initiatives in tourism. Currently, she’s spearheading SLTDA-IRU’s campaign in laying the foundations to source and secure high-quality, values-aligned investments into Sri Lanka's tourism sector with a publicly-accessible tourism investment land bank of properties across Sri Lanka.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Global Investments"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjAyOTk0Mg==",
        "titleTranslations": [
            {
                "value": "Unveiling Global Affairs: An Open Conversation With Pat Thaker, Editorial Director MEA, the Economist Intelligence Unit",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:15:00",
        "endsAt": "2024-10-01 15:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Pat",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTQyODMyLFVzZXJfNDQyNjg3Nik=",
                "jobTitle": "Editorial Director, Middle East & Africa",
                "lastName": "Thaker",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fcc1f306f0fc4f4d8645db432a444dfa.png",
                "organization": "The Economist",
                "biography": "Leading authority on the Middle East and Africa\n \nPratibha provides the intellectual leadership necessary to ensure that The EIU’s analysis and forecasts for the Middle Eastern and African markets are the most insightful available to international decision-makers. Pratibha’s deep knowledge and regional experience means she frequently chairs and speaks at conferences in Africa, the Middle East and Asia on subjects such as the business case for Africa, the impact of low oil prices for the Gulf Co-operation Council (GCC), global food security, urban sustainability and corporate social responsibility.\n \nBackground\n \nPratibha leads The EIU’s Middle East and Africa team and is also the overall manager of the other regional teams. Pratibha has many years’ experience ensuring that The EIU’s forecasts and analysis for countries’ economies are closely integrated with our global macroeconomic outlook, with the analytical skills and the regional expertise required to diagnose problems and devise viable solutions.\n \nPratibha has an MSc and a BSc in economics from the University of London. She also holds an MA in area studies from SOAS, University of London.\n \nExpertise\n \nGlobal, Middle East, Sub-Saharan Africa, UAE\n \nSpecialist subjects\n \nCorporate strategy, Development, Emerging markets, Food security, GCC, Geopolitical risk, Macroeconomics, Oil, Public policy, Risk",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Workshop"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMjA2ODg2OQ==",
        "titleTranslations": [
            {
                "value": "Who’s Really in Charge? The Hidden Power of Third Party Management in Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:30:00",
        "endsAt": "2024-10-01 14:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/P0YTtzBNtXI\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "hotelisation-of-traditional-assets",
                "translations": [
                    {
                        "value": "Hotelisation of Traditional Assets"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Eng. Rawaf I.",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzAwMjI2LFVzZXJfMjA1Mzg3Njkp",
                "jobTitle": "Vice Chairman",
                "lastName": "Bourisli",
                "photoUrl": "https://static.swapcard.com/public/images/7b49b585cf1c4124bc60515aab6a68d8.jpeg",
                "organization": "Action Hotels",
                "biography": "With many years of professional experience in Architecture design, Project Management, and development, Mr. Bourisli is known as an expert in the field of mixed use / mid class developments of real estate and Hotels.Rawaf Bourisli was appointed as a General Manager in June 2007. Action Real Estate Company (AREC) was established in 2004 and then transformed into a Kuwaiti shareholding closed company in 2005 with a capital of KD 18 million. In 2015 he took over additionally the position of General Manager of the newly established Action Drilling and Well Maintenance Company (ADCO) where he oversaw the creation of the company business in Drilling and oil services (Coil Tubing, Cementing and Mud Engineering).In addition to real estate sector under AREC, and oil services under ADCO, Mr. Bourisli is serving as a Executive Director of Action Hotels Company, and chairman of Ebla Computer Consultancy, a pioneer Information Technology provider in the state of Kuwait and Qatar.Mr. Boursili lives in Kuwait and he enjoys Arts (baroque in particular) and History.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Greg",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNTUzMDUyLFVzZXJfMTgzMjg5MDYp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "O'Stean",
                "photoUrl": "https://static.swapcard.com/public/images/4894f20e103f42a992e91d8d1667f532.jpeg",
                "organization": "United Hospitality Management",
                "biography": "Greg O’Stean, who has joined in February 2024 as the CEO of United Hospitality Management, brings a wealth of experience and strategic prowess to the forefront of the hospitality industry. Formerly the Global Chief Development Officer at Aimbridge Hospitality, Greg's leadership contributed to the successful merger of Interstate Hotels & Resorts into Aimbridge Hospitality in October 2019, creating the world’s largest third-party management company with approximately 1,500 hotels across more than 20 countries.\nWith a distinguished career spanning more than 30 years, Greg has held key positions in renowned organizations including GE Capital Real Estate, Starwood Hotels, IHG, Loews Hotels, Carlson Rezidor, and Ernst & Young. Notably, his role as the Chief Investor Relations Officer for the Investment Management division of GE Capital Real Estate showcased his exceptional leadership during the global financial crisis, where he led a global capital markets team that raised billions of dollars to reposition a $90 billion commercial real estate portfolio across Europe, Asia, and North America.\nGreg's extensive experience in hotel acquisitions, development, investment, lending, franchising, asset management, joint ventures, and management contracts has consistently positioned him as a luminary in the hospitality sector. His proven track record and strategic vision make him an invaluable leader for United Hospitality Management, driving the company towards unparalleled success.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDg3MTk1LFVzZXJfMjA2NTU5NTYp",
                "jobTitle": "Global Tourism and Hospitality Industry Leader",
                "lastName": "Mayer",
                "photoUrl": "https://static.swapcard.com/public/images/9dabe03ef1ae4c8eb532ba3788623229.jpeg",
                "organization": "PwC",
                "biography": "Nicolas leads PwC's global tourism and hospitality consulting practice. His areas of expertise are in the domain of tourism & hospitality strategy and destination development, strategic execution of large scale tourism & hospitality projects.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Hotelisation of Traditional Assets",
            "Global Investments"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjE0NDE1NQ==",
        "titleTranslations": [
            {
                "value": "Next-Gen Lifestyle Brands: Leveraging International Branding to Integrate Local Art, Culture, and Destination Experiences",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:30:00",
        "endsAt": "2024-10-01 14:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/GvJ0YpG70yI\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Gaurav",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjkzNzk5LFVzZXJfMTQzNjUzMSk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Sinha",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/90fc35e1480c41078f9fcdb37669236e.jpeg",
                "organization": "Insignia Worldwide",
                "biography": "Gaurav is the CEO and Chief Strategist of Insignia Worldwide, a category-defining design, development, and experience company specializing in nation-building initiatives. \nWith over 30 years of global experience, Gaurav has steered strategy and design projects across different sectors including luxury hospitality, tourism, arts and culture, leisure, retail and entertainment, and real estate development.\n\nGaurav has provided his services to some of the world’s most revered hospitality companies and shaped the narrative for globally renowned brands across 20 countries. His company is also engaged by NEOM, Ministry  of Culture, Red Sea Global, DGDA, Soudah Development Company and numerous other organisations in the Kingdom of Saudi Arabia. \n\nHe is the author of ‘Compassion Inc.’ a critically acclaimed book published by Penguin Randomhouse UK.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MTg0MQ==",
                                    "title": "Empowering Hospitality: Leading the Way in Crafting a Diverse, Inclusive Lifestyle Brand and Transforming Human Experience",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU1MQ==",
        "titleTranslations": [
            {
                "value": "Emerging Lifestyle Brands: Bridging Luxury and Midscale Markets with Locally Inspired Experiences in New and Established Destinations",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:45:00",
        "endsAt": "2024-10-01 15:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/r3oUb1selgs\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3MzE3Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branding-strategies",
                "translations": [
                    {
                        "value": "Branding Strategies"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Katerina",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjk5MDA5LFVzZXJfMjA1Mzc5Njgp",
                "jobTitle": "Partner, Real Estate, Hospitality and Leisure",
                "lastName": "Argyrou",
                "photoUrl": "https://static.swapcard.com/public/images/954e64763eed4fa2a6a5524a9158d563.jpeg",
                "organization": "PwC",
                "biography": "Katerina is a Partner in PwC’s Deals service line, specializing in Real Estate, Hospitality, and Leisure. She brings over 18 years of industry experience, gained in consulting firms and international hotel operators. \nSince 2006, Katerina has been based in the region, contributing to real estate projects throughout the Middle East and Africa. Her expertise spans mega real estate developments and all phases of the project development lifecycle, from strategy formulation and business planning to design project management and operational implementation. Katerina's skills include strategy development, product mix optimization, business planning, development management, operating model design, hospitality management oversight, and guest experience.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Elie",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzk2OTc3LFVzZXJfMTQ1Mzg3MCk=",
                "jobTitle": "Vice President Development",
                "lastName": "Milky",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3e57faf6b16b416ba6dece262ac74733.jpeg",
                "organization": "Radisson Hotel Group",
                "biography": "Elie heads expansion opportunities and leads Radisson Hotel Group’s strategic growth and hotel portfolio in the Middle East region as well as Pakistan, Cyprus and Greece. His responsibility is to grow the Group’s regional portfolio to 150 hotels and 30,000 keys by 2030 across each of Radisson Hotel Group’s core brands: Radisson Collection, Radisson BLU, Radisson, Radisson RED, Park Inn by Radisson, Radisson Individuals, art’otel and prizeotel.\n\nA Lebanese national, Elie has 15 years’ experience in development and asset management with international hospitality consultants, as well as a global hotel operator. He was formerly part of the HVS team based in London and in Dubai, where his focus was on conducting feasibility studies, valuations, ROI analyses and strategic advice. He joined Radisson Hotel Group in 2010 as Development Manager quickly rising to his current VP role within the organisation. His ability to forge enduring cross-cultural relationships has proven to be a key attribute in a career that has included mandates for Europe, the Middle East and Africa.\n\nElie’s strengths lie in his ability to execute strategic agreements for new-build and conversion opportunities while forging strong relationships with new and existing owners. He is adept at assessing market conditions and gathering intelligence, turning single asset and portfolio opportunities into business.\n\nElie has an MBA in International Hospitality Management specialising in Hotel Real Estate and Finance from the renowned IMHI – ESSEC Business School in Paris and a BA in Hospitality Management & Tourism from Notre Dame University in Lebanon.\n\nA passionate hotelier, Elie began his career 25 years ago in hotel operations immersing himself in all facets of hotel management before specialising in hotel real estate, finance and development.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                                    "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Charbel",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ5NzY3LFVzZXJfMTU3NTczMjMp",
                "jobTitle": "VP Development MEA",
                "lastName": "Boutros",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/60072b9b11384997844faa8e0428849d.jpeg",
                "organization": "IHG Hotels & Resorts",
                "biography": "Charbel Boutros is Vice President of Development for Middle East & Africa region at IHG®, one of the world’s leading hotel companies. He is responsible for leading and driving the strategic growth and distribution of IHG brands, focusing on priority markets within MEA.\n\nCharbel brings in-depth experience in the region across major hospitality chains and expertise in the completion of major deals and transactions. Prior to joining IHG, he was with Roya International for 17 years, holding various roles covering development strategy, hotel development, hotel portfolio strategy, asset management, M&A, tourism, master planning, F&B services and franchising. He was most recently Senior Director of Hospitality and Development Strategy, where he contributed to growth and expansion of Roya’s services to become the leading hospitality consultancy practice in the region. He was also responsible for business development related to hospitality strategy and transactions, leading business sales, deal negotiations and closure of business practice assignments. During his tenure, he completed the development of several hotels such as St. Regis, Shangri-La Hotel Abu-Dhabi, W Doha and developed local brands such as Media One and Studio One hotels as a client representative and hospitality advisor. He also worked with renowned architects such as Jean Nouvel, Zaha Hadid, Oppenheim, PEI, Arquitectonica on landmark hospitality and mixed-use projects.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                                    "beginsAt": "2024-04-30 16:50:00",
                                    "endsAt": "2024-04-30 17:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Carlos",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNzA4MzAzLFVzZXJfMjMxNzI4Mik=",
                "jobTitle": "Vice President Development Middle East & Africa",
                "lastName": "Khneisser",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fd2d5fa65f704f1896360c6fd505e0ab.jpeg",
                "organization": "Hilton",
                "biography": "Based at Hilton’s regional office in Dubai, Carlos is charged with spearheading the growth of the Hilton portfolio across the Middle East & Africa, which features more than 300 hotels trading or under development across 11 brands.\n\nUnder Carlos’s leadership, Hilton has enjoyed year-on-year, organic growth in the region.\n\nCarlos started his career in the hospitality industry in 1998, gaining broad experience across the sector, before focusing on finance and asset management positions over a nine-year period.\n\nCarlos joined Hilton in 2009, overseeing the company’s growth within the Middle East & North Africa region. In 2020 he began overseeing Hilton’s development operations in Sub-Saharan Africa.\n\nHe holds a BA in Business Administration and Finance from Notre Dame University, Lebanon and is a Certified Public Accountant (CPA). A native of Lebanon, Carlos is fluent in Arabic, English and French.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Branding Strategies"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjEyOTQ5Mg==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talk: Mastering Growth with an Asset-Light Strategy",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:45:00",
        "endsAt": "2024-10-01 15:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/TdWRvCsS9fc\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Kevin",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTIwMzk3LFVzZXJfMjA0MzA5MDYp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Goh",
                "photoUrl": "https://static.swapcard.com/public/images/c605ef87a3bb480e97ce2b91a2946d3f.jpeg",
                "organization": "The Ascott Limited",
                "biography": "Kevin Goh is the Chief Executive Officer of Lodging at CapitaLand Investment (CLI), and The Ascott Limited (Ascott), responsible for directing the growth strategy of Ascott to deliver strong fee-related earnings to CLI’s lodging business. \n\nUnder his leadership, Ascott has grown to be one of the world’s leading international lodging owner-operators with a portfolio that spans more than 230 cities across over 40 countries. In December 2019, Mr Goh played an instrumental role in merging the Ascott Residence Trust, now known as CapitaLand Ascott Trust, with the Ascendas Hospitality Trust, creating the largest hospitality trust in Asia-Pacific. In July 2022, he led the group in the acquisition of Oakwood Worldwide, which fast-tracked Ascott’s growth and cemented its position as one of the world’s largest extended-stay serviced residence providers. As of end 2023, Oakwood became one of Ascott’s fastest growing global brands, with an expanded portfolio of more than 20% since the acquisition.       \n\nMr Goh first joined Ascott in 2007 and was based in China for over 10 years, where he served as Regional General Manager for South & East China, Vice President for Asset Management and Vice President for Corporate Services, before moving to assume the role of Ascott’s Managing Director for North Asia in 2013, where he spearheaded Ascott’s investments and operations in China, Japan and Korea.\n\nMr Goh holds a Bachelor of Mechanical Engineering (Honours) from the National University of Singapore and is a Chartered Financial Analyst charterholder. He was awarded the prestigious Medal of Commendation at the National Trades Union Congress (NTUC) Singapore May Day Awards 2020 for his strong advocacy for productivity improvement and upgrading of employees’ capabilities to ensure a dynamic and digitally savvy workforce.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Anthony",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNTUxNTk4LFVzZXJfMjAwNjk0ODQp",
                "jobTitle": "Director - Asset Management , Hotels & Tourism Middle East Region",
                "lastName": "Lagrabette",
                "photoUrl": "https://static.swapcard.com/public/images/3668446eb4cb45ed8ea61d67851b2eb5.jpeg",
                "organization": "CBRE",
                "biography": "Anthony leads the Hotels Asset Management Team at CBRE MENA. ​\nFollowing years in hotel operation heading the Revenue Management department across multiple markets, his transition to strategic Asset Management in capacity of owner representative and then third-party Asset Manager led to successful Asset Performance improvements.  From individual properties to large hotel portfolios, Anthony insight on complex operational matters is the foundation to asset value creation. With over 15,000  keys Asset Managed through Ongoing Operational Asset Management mandates and various Asset plans, Annual Business plan, HMAs and CAPEX Reviews, his expertise covers hotels Asset entire life cycle.​",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzc0MQ==",
        "titleTranslations": [
            {
                "value": "The Future of Hospitality Management: From White Label Operators, Franchising, to Traditional Management Agreements",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 14:50:00",
        "endsAt": "2024-10-01 15:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ttmDCwW0sZc\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "hotelisation-of-traditional-assets",
                "translations": [
                    {
                        "value": "Hotelisation of Traditional Assets"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Amith",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNTA3MTUwLFVzZXJfMTU3NzU1OTcp",
                "jobTitle": "Head of Franchise, IMEA",
                "lastName": "Khanna",
                "photoUrl": "https://static.swapcard.com/public/images/86c17c7f261c44cb8239d4f273866fa5.jpeg",
                "organization": "IHG Hotels & Resorts",
                "biography": "Amith Khanna is a seasoned international hospitality executive, with over 20+ years of experience in the industry working in India, Middle East, Africa, Singapore, Bangkok and several assignments across Europe and US. He is currently based in Dubai working with the InterContinental Hotels Group leading the Franchise division overseeing 50 plus operating hotels and over 80 hotels in pipeline.Having led numerous International hotel assets as a General Manager and multiple corporate roles leading Franchise Business, Operations Excellence ,Quality ,Guest Experience, Strategic Projects, Hotel Openings, Hotel development, Brand Management, member of InterContinental Hotel Group (IHG)’s Global Operations Excellence council he is able to provide a well-rounded experience and perspective on the hospitality business. He has an invaluable owner relations expertise and has provided inspirational leadership to cross functional senior leaders that has driven exceptional results in the multiple roles that he has either led or supported. Some of his expertise are: - Executive Leadership | Hotel Operations | Franchise Business | Operations Excellence | Quality Assurance | Guest Experience Management | P& L Management | Budget Planning | Performance Analysis | Customer and Employee Relationship Management | New Business Development | Policy Execution | Online Reputation Management | Program Development | Strategic Planning | Forecasting and Planning | Recruiting and Training | Change management at an organizational level\nAmith successfully completed CHA from American Hotel and Motel association, Michigan, USA and has numerous certificates from Cornell University in USA.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Marco",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjU0NzkyLFVzZXJfMjMxNzE5Nik=",
                "jobTitle": "Partner, Global Consulting Hospitality & Tourism Center of Excellence",
                "lastName": "Rentsch",
                "photoUrl": "https://static.swapcard.com/public/images/027b0439248a48c9bdb22259f039b73a.jpeg",
                "organization": "PwC",
                "biography": "Marco is a Partner in PwC's Global Consulting Hospitality & Tourism Center of Excellence, based in Dubai and Riyadh. He is leading the hospitality consulting service offering, focusing on investor and operator services, delivering strategy to activation and transformation work. Building on his 20 year consulting track record across EMEA, he is currently mostly working with leading KSA government entities in the tourism and hospitality industry, supporting them in formulating reimagined and differentiated strategies, and cascading them through to full activation.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Panos",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMjk0MzM4LFVzZXJfMTQzNjUyMCk=",
                "jobTitle": "Market Managing Director Türkiye, Middle East & Africa",
                "lastName": "Loupasis",
                "photoUrl": "https://static.swapcard.com/public/images/cfcc35a1b06f4109ad5cecfc02afba5a.jpeg",
                "organization": "Wyndham Hotels & Resorts",
                "biography": "Panos Loupasis is the Market Managing Director for Türkiye, Middle East & Africa for Wyndham Hotels & Resorts. In his role, he is at the helm of driving brand operations, business development, as well as owner relations and commercial leadership across the region. Since joining the company in 2011 as Senior Director of Development for Middle East & Africa, his remit has further expanded to steer Wyndham Hotels & Resorts’ growth strategy in the Middle East, Eurasia & Africa region. \n\nPrior to joining Wyndham Hotels & Resorts, he has held various development and asset management positions, including roles at the Rezidor Hotel Group and Accor Hotels. He was also instrumental in the introduction of the Holiday Inn Express brand in the GCC. Panos has over 20 years of experience in the hospitality industry, also including operational roles in properties in Europe, the Americas and the Middle East. \n\nPanos is a native Greek and holds a Bachelor’s Degree in Economics from the Aristotelian University in Greece and an MBA in International Hospitality Management from IMHI, a program established by Cornell University in the US. He is based in Wyndham Hotels & Resorts’ Dubai office.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Bani",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTM4ODE0LFVzZXJfMjE5MDU1NSk=",
                "jobTitle": "Founder & Managing Director",
                "lastName": "Haddad",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4a639b6d658c48fd9b806f450f012908.jpeg",
                "organization": "Aleph Hospitality",
                "biography": "In 2015 Bani Haddad founded Aleph Hospitality to provide hotel owners in the Middle East and Africa with a customized, results-driven alternative to traditional hotel management models. Bani has 30 years’ experience in the hospitality industry whereas 19 years have been focused on the Middle East and Africa. Consistently ranked as one of the most powerful hoteliers in the Middle East, Bani won “Business Leader of the Year” in the 2022 MEED SME Awards, and in 2023 and 2024, Bani made it onto the prestigious Forbes Middle East list of Top 100 Travel & Tourism Leaders.\n\nUnder Bani’s visionary leadership, Aleph Hospitality has grown to become the largest independent hotel management company in the region, and in 2020 the company was valued at USD 20 million by a large European institutional investor who subsequently became a shareholder.\n\nBani holds an MBA from IMHI, a joint programme established by Cornell University’s School of Hotel Administration and ESSEC.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Adil",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNTUzMzc0LFVzZXJfMTg0NTE3Njkp",
                "jobTitle": "Development Director MENA",
                "lastName": "Jabrayilov",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e8db8e58573c4e0ba752101aa67f06b4.jpeg",
                "organization": "Louvre Hotels Group",
                "biography": "My name is Adil Jabrayilov, and I am 26 years old. Originally Azerbaijani, I am a graduate of Glion Institute of Higher Education with a major degree in International Hotel Development and Real Estate Finance. I have also completed few eCornell courses, namely Hotel Real Estate Investments and Hotel Planning and Design and I have been acknowledged as a Certified Hotel Valuer by International Association of Hotel Appraisers.\n\nI have started my career in Hilton Worldwide as part of a Feasibility & Investment Analysis team for Middle East and Africa region. Following few years in Dubai office, I have joined Hilton’s Development team for Central and Eastern Europe region and have been covering Turkish and Azerbaijani markets. After a successful time in Hilton’s Istanbul corporate office being involved in multiple deal signings, I have come back to the Middle East and joined Royal Group as the Development Manager Hospitality. I have led the development process for multiple projects across the EMEA embarking multiple milestones, including but not limited 2 luxury hotel developments in Seychelles, 1 in Greece, and few in the Middle East Region. The one that I particularly would like to call off is Mallside Hotel & Residences Dubai Hills, Curio Collection by Hilton. The following property consists both of hotel and branded residences parts and it is noteworthy that the residences have sold out already during the pre-launch period.\n\nI am currently Development Director for MENA region for Louvre Hotels Group and develop such esteemed brands as Royal Tulip, Golden Tulip, Tulip Hotels & Residences, Campanile, Kyriad, Tempting Places and Hotels & Preference. The following brands have huge potential to grow their presence further in the MENA market and add incredible value to the properties from both return on investment and guest experience. With 1’700 hotels globally across 60 countries, Louvre Hotels Group currently licenses or operates 55 hotels across the MENA region and we aim to reach 100 hotels within the next few years.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Hotelisation of Traditional Assets",
            "Global Investments"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzYxMg==",
        "titleTranslations": [
            {
                "value": "Global Insights: Aligning Growth Strategies for Asset Owner Success",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 15:00:00",
        "endsAt": "2024-10-01 15:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/UrU232AysZ4\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Vijay",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTM0OTUxLFVzZXJfMTExNTEzNik=",
                "jobTitle": "Director",
                "lastName": "Raghavan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/01c5c010481942ebbc02e594873303ba.jpeg",
                "organization": "Arenco",
                "biography": "Vijay Raghavan, is a Chartered Accountant and a Company Secretary from India, with more than 35 years of professional experience in India, Turkey and the UAE.\n\nHe started his career in 1986 with Ashok Leyland, the second largest commercial vehicle manufacturer in India and a subsidiary of British Leyland.  \n\nAfter 6 years of working experience with Leyland, he moved to Istanbul, Turkey, where he worked for Leggett and Platt and Panasonic.\n\nVijay joined the ARENCO Group in 1996 as Group Finance Manager and is currently the Group Finance Director.  In this capacity he sits on the board of many Group companies in the Arenco Group and he is also a board member of a listed entity in Oman.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Anthony",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNTUxNTk4LFVzZXJfMjAwNjk0ODQp",
                "jobTitle": "Director - Asset Management , Hotels & Tourism Middle East Region",
                "lastName": "Lagrabette",
                "photoUrl": "https://static.swapcard.com/public/images/3668446eb4cb45ed8ea61d67851b2eb5.jpeg",
                "organization": "CBRE",
                "biography": "Anthony leads the Hotels Asset Management Team at CBRE MENA. ​\nFollowing years in hotel operation heading the Revenue Management department across multiple markets, his transition to strategic Asset Management in capacity of owner representative and then third-party Asset Manager led to successful Asset Performance improvements.  From individual properties to large hotel portfolios, Anthony insight on complex operational matters is the foundation to asset value creation. With over 15,000  keys Asset Managed through Ongoing Operational Asset Management mandates and various Asset plans, Annual Business plan, HMAs and CAPEX Reviews, his expertise covers hotels Asset entire life cycle.​",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Coley",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzc0Njk0LFVzZXJfMTY1Nzk5Nyk=",
                "jobTitle": "Partner & Head of Europe",
                "lastName": "Brenan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/912f9161493048bfb746abf77baac9cd.jpeg",
                "organization": "KSL Capital Partners",
                "biography": "Coley Brenan, Partner, KSL Capital Partners, runs the KSL European office, based in London. KSL is a leading private equity firm with approximately $8.0 billion of equity capital commitments raised since 2005 and a 20-year track record of making investments exclusively in travel and leisure businesses. Through its investment vehicles, KSL has owned, operated and franchised some of the largest and most renowned hotel and resort properties in the United States and Europe, including approximately 62,000 hotel rooms, 1,100 restaurants, 575 retail stores, 1,100 spas, 700 leisure clubs and 300 golf courses with 1,100,000 members, 30,000 skiable acres with 260 ski lifts and 12 aviation FBOs. In Europe, KSL currently own, The Pig Hotels, a collection of award-winning rural boutique hotels located throughout southern England, Beaumier, a collection of 12 boutique hotels located in France, Spain, and Switzerland; Cameron House Hotel, a golf resort on the shores of Loch Lomond, Scotland; Third Space, a collection of 10 premium fitness clubs located across London and Le Sereno Hotels, multi-award-winning ultra-luxury hotel chain comprising: Il Sereno located on the shores of Lake Como, Italy, and Le Sereno on the beach at Grand Cul de Sac on the island of St. Barthelemy.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMg==",
                                    "title": "Diversifying the Economy: Strategies for Attracting Foreign Direct Investment and Achieving Vision 2030 Objectives through Innovative Funding Mechanisms",
                                    "beginsAt": "2024-04-30 10:40:00",
                                    "endsAt": "2024-04-30 11:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Global Investments"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyOTk0Mw==",
        "titleTranslations": [
            {
                "value": "Forming Culture to Build Brands",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 15:15:00",
        "endsAt": "2024-10-01 16:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "David",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMzkzNzgzLFVzZXJfNzk3OTc2KQ==",
                "jobTitle": "CEO & Founder",
                "lastName": "Keen",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/218657551e024aaab1a1de67504600ab.jpeg",
                "organization": "QUO",
                "biography": "An evangelist for the power of experiential branding, David Keen is a successful entrepreneur and leading strategist for the travel and hospitality industries. Over the last 20 years, David has published and been interviewed in dozens of publications and has been a featured speaker at numerous conferences, tradeshows and professional events.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                                    "beginsAt": "2024-04-30 16:50:00",
                                    "endsAt": "2024-04-30 17:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Workshop"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMjA2OTM1NQ==",
        "titleTranslations": [
            {
                "value": "Global Expertise, Local Talent: Hospitality's Balancing Act",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 15:15:00",
        "endsAt": "2024-10-01 15:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/0oruNcFjm4s\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3MjkwMg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "education-investment",
                "translations": [
                    {
                        "value": "Education Investment"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Werner",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzMwMzYwLFVzZXJfMzg4MzMyMik=",
                "jobTitle": "General Manager & Area Vice President, Operations",
                "lastName": "Anzinger",
                "photoUrl": "https://static.swapcard.com/public/images/ee7ac5e66a0a484fba76650fa1893b7e.jpeg",
                "organization": "Mandarin Oriental Jumeira, Dubai",
                "biography": "Werner Anzinger is a seasoned hospitality leader with over 25 years of exemplary experience. As General Manager & Vice President, Operations of Mandarin Oriental Jumeira, Dubai, he plays a pivotal role in shaping the luxury hotel landscape in the Middle East. Over his 21-year tenure with the Mandarin Oriental Hotel Group, Werner has expanded his influence to oversee four landmark properties, including Mandarin Oriental Jumeira, the soon-to-open second Mandarin Oriental in Dubai, Mandarin Oriental, Doha, and the highly anticipated Mandarin Oriental, Cairo.\n\nWerner’s career with Mandarin Oriental began in 1997 at the prestigious Mandarin Oriental Hyde Park, London, where his leadership potential was quickly recognized, leading to his promotion to Assistant Food and Beverage Manager by 2000. His trajectory continued with key appointments, including Executive Assistant Manager at Mandarin Oriental, Munich in 2004, and later, The Excelsior, Hong Kong in 2006, where he managed high-profile operations. Werner returned to Mandarin Oriental Hyde Park, London in 2007, where he successfully managed operations with a turnover of £50 million and took on the role of Acting General Manager in 2008.\n\nFurther solidifying his expertise, Werner earned a Master of Business Administration from the Royal Melbourne Institute of Technology in 2010. From 2011 to 2017, he served as General Manager of Mandarin Oriental, Prague, where he led the hotel to record profitability and received prestigious accolades for service excellence.\n\nFluent in both English and German, Werner is a passionate traveler, avid golfer, and skier. Currently, he is expanding his linguistic skills by studying Spanish, bringing a global perspective to both his professional and personal life.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Shaikha Al",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTI4MTA2LFVzZXJfMTYzNjA4NDMp",
                "jobTitle": "Corporate Vice President - Owner Relationship Management",
                "lastName": "Nowais",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/021971f022ac456db0218fde09ed3808.jpeg",
                "organization": "Rotana",
                "biography": "Shaikha Al Nowais is Corporate Vice President of Owner Relationship Management at Rotana, one of the leading hotel management companies in the region with hotels across the Middle East, Africa, Eastern Europe, and Turkey. \n\nReporting directly to the Chief Executive Officer, Al Nowais is responsible for strengthening the close working relationships between Rotana and hotel owners by overseeing the effective communication of all the latest developments and initiatives implemented at their properties.\n\nAl Nowais joined Rotana as Director of Internal Audit in May 2011, where she leveraged her considerable knowledge and expertise to maintain consistently high standards and drive improved efficiencies throughout its operations. During her time in this role, she successfully led the internal audit team to ensure that all properties were in full compliance with Rotana’s company policies and procedures, as well as external regulations outlined by UAE Federal Law, the Abu Dhabi Food Control Authority, and the Abu Dhabi Tourism Authority.\n\nPrior to joining Rotana, Al Nowais honed her financial and analytical skills during a two-and-a-half-year tenure at KPMG, where she was responsible for performing audits of financial statements, developing robust audit plans and strategies, and examining internal controls to assess the efficiency of procedures.\n\nShaikha Al Nowais is a graduate of Dubai’s Zayed University, where she attained a Bachelor of Science degree in Business Sciences – Finance in 2006.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMA==",
                                    "title": "Breaking Barriers, Shaping the Future: Women in Tourism & Hospitality Leadership",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Georgette",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNzczNjIwLFVzZXJfMjA4MzQ4NDMp",
                "jobTitle": "Managing Director",
                "lastName": "Davey",
                "photoUrl": "https://static.swapcard.com/public/images/1cbee61643fe41a0bb825740f1d57e57.jpeg",
                "organization": "Abu Dhabi Hospitality Academy Les Roches",
                "biography": "Georgette Davey has over 30 years of experience in the hospitality and education sectors and is renowned for her innovative approach and dedication to developing future industry leaders. She has held leadership roles at Les Roches - Switzerland, Ecole Hôtelière de Lausanne and Glion Institute of Higher Education where she was Global Managing Director. Her leadership experience extends to accrediting hospitality management schools, solidifying her reputation as a global leader in hospitality education. As Managing Director of Abu Dhabi Hospitality Academy Les Roches she looks forward to sharing her passion for Hospitality Education.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Aseem",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNzM3MDk4LFVzZXJfMjA4MTE4ODcp",
                "jobTitle": "Founder & Chief Executive",
                "lastName": "Kapoor",
                "photoUrl": "https://static.swapcard.com/public/images/e21e2fc552dd494db5adfb664df799cd.jpeg",
                "organization": "ARK People Solutions",
                "biography": "Aseem Kapoor is Founder & Chief Executive of ARK People Solutions, a consultancy specializing in bringing brands to life through people.  He leads a team of hospitality, talent and brand experience professionals who are passionate about creating impact to re-define success for those they work with. \n\nWith a diverse set of leadership experiences, Aseem specialises in crafting agile and innovative business-driven talent and culture functions.  Under his leadership, ARK has rapidly grown by creating talent strategies covering all aspects of the people experience, including developing brand culture, and standards, and designing learning content. ARK also excels in crafting customer journey maps, enabling businesses to deliver a consistent brand experience across all touchpoints.  ARK also manages mystery shopping, compliance audits and continuous improvement processes to ensure operational excellence.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Education Investment"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjExOTk5Mg==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talk: Leading with Purpose for Sustainable Success",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 15:20:00",
        "endsAt": "2024-10-01 15:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/d9ItmI7QnpA\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Elie",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNzIxMTI4LFVzZXJfNDk4NTU4Mik=",
                "jobTitle": "Executive Vice President & Global Chief Development Officer",
                "lastName": "Younes",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d1152a46d0c3455b9e8e29b6c2a9a52c.jpeg",
                "organization": "Radisson Hotel Group",
                "biography": "Elie Younes leads Radisson Hotel Group’s organic growth and M&A expansions with an international team based across the world.\n\nYounes has re-engineered Radisson Hotel Group’s development strategy to focus on an asset-right growth and relevant mature and new business concepts in a fast-changing environment. His experience spread to almost 1,000 hotel transactions across all business models globally, and he cemented Radisson Blu as the largest upper upscale brand in the industry across Europe for 12 consecutive years.\n\nA Lebanese national and British citizen, Younes began his career in managerial roles in his home country, before joining HVS in London in 2001. He progressed quickly to the position of Director and a Designate MD with HVS within 5 years. He also authored a number of publications on hotel performance assessments and investments. In 2007, he joined Starwood in London as Senior Director of Acquisitions and Development. His next move took him to Hilton Hotels Worldwide as Vice President Development, based in Dubai, before joining Radisson Hotel Group (formerly The Rezidor Hotel Group) in 2010, as Vice President of Business Development for the Middle East and Africa.\n\nElie is fluent in English, French and Arabic. He has graduate and post graduate education in Beirut, Paris, New York and London, at universities like Notre Dame, IMHI/Essec, Insead, Cornell University, Johnson Graduate Business School and City University.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0MjI4LFVzZXJfMTU3NTcyNzUp",
                "jobTitle": "Presenter",
                "lastName": "Sackur",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
                "organization": "HARDTalk",
                "biography": "Stephen Sackur is presenter of HARDtalk, the current affairs interview on BBC World and the News Channel. His subjects have included the heads of NATO and OPEC, Shimon Peres, Gore Vidal and Richard Dawkins.\n\nFor HARDtalk he has also interviewed a number of the world’s great names, including Bill Clinton, George W Bush, Mikhail Gorbachev and Hugo Chavez. Distilling his notes for a series of articles, Stephen identiﬁed the ﬁve qualities they all seemed to share: an indestructible will, passion (almost beyond reason), outrageous optimism, a super-sized ego and a ‘rebel yell.’\n\nThese interviews have also given him an insight into how organisations can best bring about innovation: “You need to ﬁnd ways to assess individuals on their merits, and give rewards for innovative thinking rather than play-it-safe mediocrity. You should encourage insiders to get outside and bring back fresh insights. And you shouldn’t confuse seniority with creativity.”\n\nAway from set-piece interviews Stephen has served in Brussels, reporting on day-to-day stories from the major European institutions and across the continent. Before that he was Washington Correspondent, where his coverage and analysis of 9/11 won widespread acclaim.\n\nTen years earlier it was Stephen who broke the story of the mass killing on the Basra road out of Kuwait, marking the end of the Gulf War. He was then posted to Cairo and Jerusalem as Middle East Correspondent, where he reported on the emergence of the Palestinian Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzY1MA==",
        "titleTranslations": [
            {
                "value": "Ongoig Coffee Break",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 15:30:00",
        "endsAt": "2024-10-01 16:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzc0Mg==",
        "titleTranslations": [
            {
                "value": "Commercially Driven Asset Management in Hospitality: Strategies for Maximizing Returns",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 15:30:00",
        "endsAt": "2024-10-01 16:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/2S9Q3-3EPls\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "hotelisation-of-traditional-assets",
                "translations": [
                    {
                        "value": "Hotelisation of Traditional Assets"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Aboudi",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNjM1MTEzLFVzZXJfMTQyMTQ2MjYp",
                "jobTitle": "Executive Vice President, Head of Hotels Advisory MENA",
                "lastName": "Asali",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/6bec2df7ac174d53baeb9dbf8656e21c.jpeg",
                "organization": "JLL",
                "biography": "Aboudi brings over 25 years of regional experience in operations, asset management and hotel development. He has worked at several international operators including Jumeirah Group, Marriott International, Four Seasons, Hilton and IHG, as well as being a hospitality consultant at Andersen in Bahrain and London.\n\nHis last role prior to joining JLL was as Chief Executive Officer of Hospitality Management Holding (HMH) where he was responsible for the operations and strategic expansion of the group which operated 14 hotels across the Middle East and Africa. His extensive operational experience on both the operator’s and the owner’s sides enables him to identify practical value-add opportunities.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Dr. Naim",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTMwMjM1LFVzZXJfMTQzNjQ1NCk=",
                "jobTitle": "CEO & Founder",
                "lastName": "Maadad",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/0a0e1122465040f4a3bced2640d97c9a.jpeg",
                "organization": "Gates Hospitality",
                "biography": "With almost 30 years’ experience in the hospitality industry in Australia, Asia and the Middle East, Naim is the Chief Executive and Founder of Gates Hospitality, a home-grown hospitality group based in the UAE, with award-winning concepts such as folly, Bistro Des Arts and Reform Social & Grill.\n \nHaving led a wide spectrum of both operational and senior positions throughout his career, Naim was Managing Director for both Six Senses and Minor Hotels prior to setting up Gates Hospitality in 2010; two roles (amongst many others) that allowed him to gain significant operational and commercial experience as a leader, as well as nurture significant owner and stakeholder relationships. \n\nNaim has been based in the Middle East for more than twenty years, and so has witnessed tremendous industry growth and gained a deep cultural understanding of the ways of the region, allowing him to support businesses and owners, and be a credible and respected voice of authority for the industry.\n \nAs well as his day-to-day role, Naim is on the boards of various hospitality businesses such as The Middle East Food Forum, Dubai Restaurants Group, Almont Global, Australian Business Council and others.\n \nA visionary and yet clear and direct leader, Naim is passionate about nurturing local and regional talent, and is known to have to supported and guided many hoteliers, chefs and restauranters as a mentor throughout his career.\n \nNow, leading a team of 700 colleagues across Gates Hospitality, he is considered one of industry’s most respected spokespeople and a ‘Godfather’ figure, nurturing the careers of many new faces of the future.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Judith",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDc2Mzg2LFVzZXJfOTgzOTkzNik=",
                "jobTitle": "Founder & Managing Director",
                "lastName": "Cartwright",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/efa02cf95da1468d9d912a2d6314cb69.jpeg",
                "organization": "Black Coral Consulting",
                "biography": "With over two decades of experience in the hospitality industry, Judith has worked with top executives and leading hospitality companies including Boutique Group, Four Seasons, Wynn, CoolInc, Azmont Investments, Grupo Vidanta, and Global Hotel Alliance to name a few.\n\nHer global career in hospitality culminated in her role as Global Senior Vice President of Revenue Management & Distribution at Kerzner. As head of revenue for the Atlantis, One&Only, and Mazagan brands, she led teams to achieve double-digit growth by optimizing operations and identifying new revenue sources. Judith brings this expertise to her current consulting work, helping clients improve their revenue strategies.\n\nSince launching Black Coral Consulting, Judith has received numerous awards for her consultancy work, including becoming a proud Member of ISHC, the leading source of global hospitality expertise, Chair of the Revenue Optimization Advisory Board for HSMAI, and a member of the Hotelier's Guild Academy of Hospitality Arts. Her success has made her a sought-after speaker, and she is frequently invited to participate in panels and conferences. \n\nAdditionally, Judith is the author of the acclaimed book \"Asset Management with a Commercial Lens\" which has been widely praised by industry professionals for its insightful analysis and practical advice.\n\nBased in Dubai and drawing on her extensive regional and global experience, Judith is deeply committed to helping her clients thrive and succeed.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MTM5Nw==",
                                    "title": "TenX Leadership Talks: Emergence of Third-Party Operators in Saudi Arabia's Dynamic Market and The Prospects for Growth in Saudi Arabia?",
                                    "beginsAt": "2024-05-01 10:05:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Suma",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyODY2MTAwLFVzZXJfMTU3NTczMDMp",
                "jobTitle": "Executive Vice President - Real Estate & Development",
                "lastName": "Venkatesh",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ab0f7a5ca0ac4be2a3e2f1d4b1154738.jpeg",
                "organization": "The Indian Hotels Company Limited",
                "biography": "Ms. Suma is an Engineer and an MBA in Marketing & Finance. She brings over 30 years of varied experience across engineering, financial services, real estate and hospitality sectors. She has worked across different functions ranging advisory services, financial structuring and lending for infrastructure projects and contract negotiations, planning and development of real estate and hotel projects. As Executive Vice President – Real Estate & Development, she heads IHCL’s Development, Projects & Technical Services and Asset Management functions. She leads the company’s growth and expansion initiatives and has delivered a fourfold growth of the company’s portfolio during the course of her remarkable journey of two decades with the company. She is a director on the board of PIEM Hotels and few others.\nShe has won many awards and accolades during her career and has most recently\nbeen recognized for her outstanding contributions to Inclusion and Diversity in the tourism sector by IIPT (International Institute for Peace through Tourism) at the 7th \"Celebrating Her Awards\" at ITB, Berlin last week.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkyMA==",
                                    "title": "Transforming Palaces: Embracing Heritage and Showcasing New Luxury",
                                    "beginsAt": "2024-04-30 15:50:00",
                                    "endsAt": "2024-04-30 16:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Hotelisation of Traditional Assets"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTU1Mg==",
        "titleTranslations": [
            {
                "value": "Invest in Italy:  Showcasing Unique Hospitality Projects",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 15:30:00",
        "endsAt": "2024-10-01 16:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/fzGkk6pcofM\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-europe",
                "translations": [
                    {
                        "value": "Focus on Europe "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Pier",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzE5NDYxLFVzZXJfMjExNjIxNjQp",
                "jobTitle": "General Manager, Tour Operating",
                "lastName": "Ezhaya",
                "photoUrl": "https://static.swapcard.com/public/images/1e15bf15c4254b19a477f8a8290a68f6.jpeg",
                "organization": "Alpitour World",
                "biography": "Dopo varie esperienze nel settore del turismo Pier Ezhaya approda nel 2002 in Alpitour World come Managing Director di Viaggidea. Nel 2012 diventa Direttore Commerciale del Tour Operating e nel 2015 Direttore del Tour Operating di Alpitour Spa. Nel novembre 2020 assume l’incarico di Direttore Generale Tour Operating. Con la sua guida, la Divisione Tour Operating ha realizzato importanti traguardi di fatturato, strategici e di posizionamento. È membro dei Consigli di Amministrazione di Welcome Travel Group Spa e di Away Hotels SA. Da settembre 2020 è Presidente di ASTOI e membro del Board di Presidenza di Federturismo in Confindustria.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jules",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjkzNzg3LFVzZXJfNDIyODQzNik=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Ugo",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b6731e369c8e42d18c1e81aec244adb2.jpeg",
                "organization": "LOTUS Arabia",
                "biography": "As CEO, Jules has built LOTUS to become one of the most recognised, globally renowned marketing and communications specialists in the travel, hospitality and lifestyle space.\n\nWith over 25 years' experience Jules has led global campaigns for flagship airlines, the world’s largest outbound tourism destinations and international hospitality brands.\nWith offices in New York, Singapore and headquarters in London the footprint expanded in 2023 to add hubs in Jeddah and Riyadh serving the expanding Saudi Arabian and wider GCC tourism market.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkxNDk2MQ==",
                                    "title": "TenX Leadership Talks: Insights and Learnings in the Journey of Growing Your Destination",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 10:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Andrea",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTM4NjQzLFVzZXJfOTQ1MDY0Myk=",
                "jobTitle": "Founder & CEO",
                "lastName": "Delfini",
                "photoUrl": "https://static.swapcard.com/public/images/3833becbe7314934b891b5dcb70b2cab.jpeg",
                "organization": "Blastness",
                "biography": "Andrea Delfini is the founder and CEO of Blastness, a leading Italian travel technology company specialising in increasing direct bookings and hotel revenues. Since 1995 he has been an entrepreneur in the Internet and multimedia production and integrated communication sector using innovative technologies. At the end of the 90's he ventured into the hotel tourism industry, to which he later dedicated himself.\n\nFounded in 2004, Blastness S.p.A. has been the leading operator of 5-star hotels in Italy for over 12 years and was selected for Google's EMEA Strategic Partner programme in 2017. At the beginning of 2024, the company received the international Microsoft Advertising Partner Growth Award. In January 2024, the Forbes Small Giants magazine, dedicated to high potential Italian small- and medium-sized enterprises, featured the company on its cover.\n\nIn 2012, Andrea Delfini founded NERO Lifestyle SRL. This brand focuses on the marketing and positioning of hotels, products and services aimed at the HNWI segment.\n\nIn 2019, he established Fox Technologies SRL, an innovative start-up of the Blastness Group focused on the development of business intelligence and artificial intelligence platforms for the hotel sector.\n\nAndrea has been Vice-President of NIAF Italy since 2015, has been a member of the Board of Directors of NIAF USA since October 2022, a member of the Friends of Aspen group – Aspen Institute Italia since December 2022, and Ambassador in Italy for the Columbus Citizens Foundation USA since August 2023.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Paolo",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMDExMzY1LFVzZXJfMTQ2MTkxNTUp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Barletta",
                "photoUrl": "https://static.swapcard.com/public/images/61770aec30614dc1a1c0d6d79e6229fe.jpeg",
                "organization": "Arsenale Spa",
                "biography": "Paolo Barletta is a 37-year-old Italian serial entrepreneur, investor, and philanthropist. Over the past decade, he has successfully founded several companies in technology, real estate, luxury hospitality, fashion, and cinema. \nIn September 2020, Paolo Barletta and Annabel Holding strengthened their partnership by creating a new industrial project in the hospitality Made in Italy segment. Thus, Arsenale S.p.a. company is born, whose main objective is to enhance the Italian tourism sector by investing in real estate and managing several Italian trophies. Arsenale is a significant player in the Italian market with structured agreements with the most important luxury brands, such as Soho House and Orient Express. Arsenale created its second division (Arsenale Express), focused on the development of sustainable tourism project by rail with a luxury offer, in partnership with the most renewed luxury brand in the world. The division includes the Orient Express La Dolce Vita project in partnership with the Orient Express of Accor Group, Trenitalia-Gruppo Ferrovie dello Stato and Fondazione FS Italiane, a fleet of six trains that will travel in Italy at the end of 2024.\nArsenale is developing a new concept of luxury rail cruising capable of expanding worldwide relying on Made in Italy know-how and manufacturing. The next trains will be Dream of the Desert (KSA); Spirit of the Union (UAE), Samarkanda Express (Uzbekistan) and The guardina of the Nile (Egypt).",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Chiara",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTQ2MzE2LFVzZXJfMTY3MTIxMjMp",
                "jobTitle": "Director National Tourism Fund",
                "lastName": "Caruso",
                "photoUrl": "https://static.swapcard.com/public/images/8cef1228e35d4f8fb3a2e58d7c6ffbc8.jpeg",
                "organization": "CDP Real Asset SGR SpA",
                "biography": "From May 2022 Chiara is director of the National Tourism Fund in CDP Real Asset SGR, an entity controlled by CDP SpA, the Italian promotional bank, with the aim to support the growth and consolidation of the hospitality sector in Italy. With a degree in Economics from University of Rome “LUISS – Guido Carli” and a Master in Finance from London Business School, Chiara began her professional experience in investment banking and private equity with Merrill Lynch, then moving to the real estate sector in GE Commercial Finance, Beni Stabili SGR and InvestiRE SGR.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Projects & Destinations",
            "Focus on Europe"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjE2MTEwMA==",
        "titleTranslations": [
            {
                "value": "Visionary Leadership: Driving Abu Dhabi’s Leisure and Entertainment Growth through Immersive Destinations",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 15:35:00",
        "endsAt": "2024-10-01 15:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/FJCd5cW9ido\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Mohamed",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNjIxNTY3LFVzZXJfMTIyNzg3NjEp",
                "jobTitle": "Group Chief Executive Officer",
                "lastName": "Abdalla Al Zaabi",
                "photoUrl": "https://static.swapcard.com/public/images/5c4360f526ca4929820c9cf6c6f60fea.jpeg",
                "organization": "Miral",
                "biography": "Mohamed Abdalla Al Zaabi, the visionary leader and the Group Chief Executive Officer of Miral, has been a driving force in transforming the company into a powerhouse within the leisure, entertainment and tourism sector. Joining Miral in 2015, Al Zaabi’s strategic insight and unwavering dedication have propelled Miral to the forefront of the industry.\n\nUnder his leadership, Yas Island, Abu Dhabi, has thrived into a global renowned entertainment, leisure, and business destination, while accelerating the realization of the Emirate’s economic diversification. \n\nAl Zaabi’s leadership played a key role in shaping Yas Island’s destination strategy that has contributed to the emirate’s consistent growth. By introducing new attractions and experiences, Yas Island has seen a constant growth in visitation. Building on Yas Island’s successful destination management, Miral was appointed to oversee destination management for Saadiyat Island in 2022 and has since then elevated the destination’s awareness. \n\nAs one of the most influential people in his industry, he was recognized in the top ten of Forbes Middle East’s Top 100 Travel & Tourism Leaders for 2024.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Amit",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMDkxNDIxLFVzZXJfMTYyMTI2NSk=",
                "jobTitle": "Vice President",
                "lastName": "Nayak, CHA",
                "photoUrl": "https://static.swapcard.com/public/images/1de1fe42566f4d0dbdb24885e0724c4b.jpeg",
                "organization": "HAMA MEA",
                "biography": "Amit Nayak is a seasoned Senior Asset Management Specialist with expertise in Property Development, Private Equity, and Family Office operations. Until recently, he served as Vice President of Asset Management at Dubai Holding, overseeing & supporting the strategic management of over 50 global properties. Currently, Amit is a member of the Hospitality Advisory Committee under the UAE Ministry of Economy, contributing to the growth and competitiveness of the UAE's tourism sector. His career began at One & Only Royal Mirage, and he holds advanced qualifications from Harvard and Cornell. Amit is also actively involved in mentoring and industry associations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzY0Nw==",
        "titleTranslations": [
            {
                "value": "Emergence of Real Estate Investment Trusts in the Middle East",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:00:00",
        "endsAt": "2024-10-01 16:25:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/uYN9QMalAIE\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Asad",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTM0NzkyLFVzZXJfNzIxNDU5NSk=",
                "jobTitle": "Senior Director",
                "lastName": "Rahman",
                "photoUrl": "https://static.swapcard.com/public/images/19e8f85ab7374239bdbfdfbe224e7278.png",
                "organization": "Mashreq Bank",
                "biography": "Asad has over 25 years’ experience in corporate banking, asset restructuring, mergers and acquisitions (M&A) and strategic advisory in New York, Toronto and Dubai. He joined Mashreq in 2006 where his focus has primarily been in the real estate space, corporate banking and investment banking. \n\nAsad manages a large portfolio of real estate corporate clients across GREs, private developers, and family groups. He has structured and financed transactions across diversified real estate asset classes including residential, commercial, retail, hospitality and industrial sectors in the GCC, US and UK.\n\nAsad has a bachelor’s degree in Economics and History from Brandeis University. He also has a Masters in International Affairs from Columbia University and a MBA from Columbia Business School.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Paula",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzk5MjkyLFVzZXJfMjA1OTc2NTEp",
                "jobTitle": "Senior Reporter",
                "lastName": "Naoufal",
                "photoUrl": "https://static.swapcard.com/public/images/2ad63627a3fa49c3ab5897a30da76d54.jpeg",
                "organization": "CNN Business Arabic",
                "biography": "Paula Naoufal is an award-wining journalist who is currently a Senior Reporter at CNN Business Arabic with over a decade of experience in media and communications. She has conducted interviews with heads of state, government officials, and CEOs including the President of Iraq, the CEO of Aramco, the Indian Minister of Petroleum, the executive director of the IEA, the Ukrainian Minister of Economy, GCC ministers, among others. Additionally, Paula has moderated several panels across the region, and she has won international journalism awards.\n\nPaula's expertise includes live reporting and broadcasting, covering business news, conducting special interviews, and presenting shows and segments. She has also covered numerous on-ground events such as the OPEC+ meetings in Vienna and the World Economic Forum at Davos.\n\nPrior to joining CNN BA, Paula worked at an array of institutions such as Asharq News with Bloomberg and the UN HQ in New York. She is currently pursuing a PhD in Media and Communication at Leicester University and holds a master's degree in Risk Analysis from King's College London.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jamie",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTI4OTE0LFVzZXJfMjA0MzYzOTcp",
                "jobTitle": "Director, Real Estate Advisory",
                "lastName": "Odgers",
                "photoUrl": "https://static.swapcard.com/public/images/128eddcf137a45a9820b210b5f7cf14c.jpeg",
                "organization": "Standard Chartered Bank",
                "biography": "Jamie has more than 8 years of experience in corporate finance space, specializing in originating and executing M&A deals in the real estate sector. Jamie has worked directly on a number of high profile advisory mandates\n\nfor leading clients such as ICD, Brookfield, Blackstone, Emaar, Aldar Properties, DP World, and Arada Developments.\n\n \n\nJamie has a Bachelor of Science Degree in Business Administration from Boston University, USA and a passion for a broad range of competing in and watching sports including rugby, rowing, NFL and the NBA.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Amr",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNjM1MTA5LFVzZXJfMTM1MDUwOTEp",
                "jobTitle": "Head of Hotels & Hospitality MEA and Managing Director, Global Hotel Desk",
                "lastName": "El Nady",
                "photoUrl": "https://static.swapcard.com/public/images/982df6695622462cb476e3a7cc2650db.jpeg",
                "organization": "JLL",
                "biography": "Amr leads the Hotels Advisory and Transactions business for JLL in the Middle East and Africa. He also advises Middle Eastern investors in defining and executing their international hotel investment strategies through JLL’s Global Hotels Desk platform. As the Head of Hotels & Hospitality, Amr has overall responsibility for the strategic direction and growth of JLL’s hotel business in the Middle East and Africa. He is also an integral part of the Global Hotel Desk team and is currently involved in a wide range of hotel advisory and investment sale instructions for single asset and portfolio transactions, with a focus on cross-border investment activities primarily from the Middle East. In addition, he also provides hotel investment services to private and institutional investors across the Middle East region.\n\nAmr has over 15 years’ experience within the hospitality industry. He has been involved in numerous assignments including Transaction Advisory services, Development Consulting, Operator Search and Selection, Strategic Portfolio Advice and Investment Sale Instructions. Amr also worked in JLL’s Hotels & Hospitality team and Northern European Investment Sales team based in London, UK, where he was heavily involved in acquisition and sale mandates for several iconic trophy hotels, as well as asset portfolios across the UK and Northern Europe.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMg==",
                                    "title": "Diversifying the Economy: Strategies for Attracting Foreign Direct Investment and Achieving Vision 2030 Objectives through Innovative Funding Mechanisms",
                                    "beginsAt": "2024-04-30 10:40:00",
                                    "endsAt": "2024-04-30 11:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Global Investments"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjE0MzM0Ng==",
        "titleTranslations": [
            {
                "value": "Announcement #9",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:00:00",
        "endsAt": "2024-10-01 16:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjE2MjUxOQ==",
        "titleTranslations": [
            {
                "value": "Signings & Announcements",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:00:00",
        "endsAt": "2024-10-01 16:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzkwOQ==",
        "titleTranslations": [
            {
                "value": "Tech-Driven Tranquility: Enhancing Wellness Through Robotics",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:10:00",
        "endsAt": "2024-10-01 16:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/g6zRZNzs8AA\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "competitions",
                "translations": [
                    {
                        "value": "Competitions"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dennis",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMDE4NjI0LFVzZXJfMTM1Nzc3NTgp",
                "jobTitle": "Chief Executive Office",
                "lastName": "Ledenkof",
                "photoUrl": "https://static.swapcard.com/public/images/878687228c8c450884137e199fb1f49d.jpeg",
                "organization": "RoboSculptor",
                "biography": "Denis Ledenkov is the CEO of roboSculptor, an automated robotic system for aesthetic body contouring.\nAs an entrepreneur and inventor, he first stepped into the aesthetic hardware industry about a decade ago. His journey began with an aesthetic contouring product, which completely revolutionized the approach to body treatment. The company managed to maintain high sales levels by focusing on the good quality of the products and continually enhancing them based on customer feedback and desires.\nIn 2022, Denis made the decision to move to the UAE where he shares more insights into the revolutionary roboSculptor innovation and the unique opportunities it presents.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Competitions"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyOTk0NA==",
        "titleTranslations": [
            {
                "value": "Purpose-Driven Leadership: Practical Tools and Models for Thriving in a Purpose-Driven Agenda",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:15:00",
        "endsAt": "2024-10-01 17:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr John",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMTI0Mjk5LFVzZXJfNTE4OTU5KQ==",
                "jobTitle": "Author - Force for Good",
                "lastName": "Blakey",
                "photoUrl": "https://static.swapcard.com/public/images/3ff173de5e804881833e7614a3bbaa92.jpeg",
                "organization": "John Blakey Ltd",
                "biography": "Dr John Blakey is the UK's leading executive coach for purpose-driven CEOs and the founder of The Trusted Executive. An authority on purpose-driven leadership, his expertise is sought-after by ambitious leaders aiming to be a force for good and achieve the triple bottom line - profit, people and planet. With a unique track record as a pioneering coach, global thought leader and former FTSE 100 international managing director, John has worked with over 130 CEOs around the globe, including the leaders of gold-medal-winning Team GB Olympic squads, title-winning premiership football clubs and England cricket.\nAs an executive coach and board advisor, John has worked with over 130 CEOs from 22 countries, including the leaders of FTSE 100 PLCs, high-profile public servants and some of the UK’s most successful entrepreneurs. John has also coached the leaders of gold-medal winning Team GB Olympic squads, title-winning premiership football clubs and England cricket.\n\nAs a thought leader, John is a regular keynote speaker at international business conferences on the three coaching models featured in his books: Force for Good – How to thrive as a purpose-driven leader (Kogan Page, publication August 2024); The Trusted Executive – Nine leadership habits that inspire results, relationships and reputation (shortlisted as the CMI Book of the Year), and Challenging Coaching (UK bestseller co-authored with Ian Day).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital",
            "Workshop"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMjA1MTE5Nw==",
        "titleTranslations": [
            {
                "value": "The Hotel of the Future",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:15:00",
        "endsAt": "2024-10-01 16:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/uEll62okDnU\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Turab",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODUwOTI5LFVzZXJfMTU3NTczMzIp",
                "jobTitle": "Partner - Hospitality,Tourism & Leisure Advisory Services  - MENA",
                "lastName": "Saleem",
                "photoUrl": "https://static.swapcard.com/public/images/2997ea6051bc4a76af56a4500fbc22be.jpeg",
                "organization": "Knight Frank",
                "biography": "An accomplished and meticulous professional with 22 years of proven success record in various aspects of the hospitality industry including Asset Management, Hotel Development, Tourism Development, Restaurant Development/Management, Hotel Management and Project Management. With Master’s in hospitality from NYU and Bachelor’s in Hotel Management from Swiss Hotel Institute, his consulting experience includes projects with a value of approximately USD 64  Billion. He has worked in various continents including Europe, US and the Middle East holding senior positions. He has been involved in consulting some of the successful Hospitality projects globally including :-   Paris, Miami, New York, London, Hong Kong, Dubai, Riyadh, Doha particularly with major hotel and consultancy groups.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0Ng==",
                                    "title": "Digital Talks: The Hotel of the Future",
                                    "beginsAt": "2024-04-30 09:50:00",
                                    "endsAt": "2024-04-30 10:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc4ODc4Nw==",
                                    "title": "The Key to Successful Hospitality Project Development in Saudi Arabia",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:55:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Sustainability & Innovation",
            "Global Investments"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjE2MDI3NA==",
        "titleTranslations": [
            {
                "value": "Data-Driven Sustainability: Transforming Hospitality with AI",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:20:00",
        "endsAt": "2024-10-01 16:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/hEIhmQWO6kE\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jitesh",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNjE1ODA3LFVzZXJfMjEzNDcyNDUp",
                "jobTitle": "CEO/Founder",
                "lastName": "Shetty",
                "photoUrl": "https://static.swapcard.com/public/images/a943c226aaa94af2a78d706d1e8d0a24.jpeg",
                "organization": "Credibl ESG Innovations",
                "biography": "Jitesh Shetty is Founder/CEO of Credibl ESG Innovations - a San Francisco headquartered leading Sustainability technology company. Credibl is a leader in decarbonization in the hospitality space with deep deployment with companies like IHCL. Prior to Credibl, Jitesh Founder Qwiklabs in Boston which was an early innovator in the cloud computing space. Qwiklabs was acquired by Google in 2016. He is an investor in 17 deep tech companies and sits on the board of many companies like MRAccess in New York and TravelX in Palo Alto. He has a MS in Computer Science from USC in Los Angeles and is a lead inventor in two core cloud computing patents.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTU0Nw==",
        "titleTranslations": [
            {
                "value": "Greening Hospitality: When ESG Law Compliance Impacts Your Hotel Real Estate Value",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:25:00",
        "endsAt": "2024-10-01 16:45:00",
        "descriptionTranslations": [
            {
                "value": "<p>Moderator: <strong>Giuliano Gasparini</strong>, FRICS, CRE, HAMA, IoH, CHIA – Head of Hospitality Asset Management, WASL Group</p><p><a href=\"https://youtu.be/05U9dtlxg0A\" target=\"_blank\">Click here to watch online.</a></p><br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "green-construction-and-smart-cities",
                "translations": [
                    {
                        "value": "Green Construction & Smart Cities"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Gergely",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTczNTk4LFVzZXJfMjA0NjYxMjgp",
                "jobTitle": "Associate Partner, Specialist Valuation",
                "lastName": "Balint, MRICS RV",
                "photoUrl": "https://static.swapcard.com/public/images/e277b930f4a6417586f41613c5a530dd.jpeg",
                "organization": "Cavendish Maxwell",
                "biography": "Gergely has 15 years of valuation experience in real assets positioned in specialist sectors including hotels, large scale mixed-use projects, hospitality and leisure facilities, across Europe.\n\nGergely recently joined Cavendish Maxwell as an Associate Partner from CBRE Munich, Germany. He holds a Bachelor degree in hospitality management from the University of West London as well as completed an executive program in Hotel Real Estate Investment and Asset Management with Cornell University. He is a professional member of the Royal Institution of Chartered Surveyors (MRICS) as well as a RICS registered valuer.\n\nGergely has experience in providing valuation and related advisory for financial reporting, secured lending, asset disposals and business restructuring purposes. His experience covers more than 100 notable valuation assignments spread across Europe.\n\nGergely currently assists on overseeing Cavendish Maxwell’s commercial valuation operation in their Dubai office.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Giuliano",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODk5MTc0LFVzZXJfMTI2MzY3MzQp",
                "jobTitle": "Head of Hospitality Asset Management",
                "lastName": "Gasparini, FRICS, CRE, HAMA, IoH, CHIA",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1185b82f30fb4c59b01dd92aafdcf851.jpeg",
                "organization": "WASL Group",
                "biography": "Giuliano Gasparini is Head of Hospitality Asset Management at wasl / Dubai Real Estate Corporation being directly involved in the asset management of the hotel and leisure portfolio of the firm. Prior to that he covered several executive positions in the hospitality asset management teams of leading Middle Eastern developers (Associate Director of Hospitality Asset Management for Aldar Properties PJSC) and in specialized consulting firms having been Head of Consulting at PKF in Dubai, Senior Vice-President of JLL Hotels in Madrid and Senior Associate at HVS in Madrid amongst others. \nGiuliano Gasparini is one of the board members of HAMA MEA (Hotel Asset Managers Association) and a full-time professor at both Paris Sorbonne Abu Dhabi and IE Business School in Madrid. He holds affiliation at the Royal Institution of Chartered Surveyors (FRICS), Counsellor of Real Estate (CRE©) and Institute of Hospitality (FIH).\nGiuliano graduated in Economics at Bocconi University in Italy and hold two master degrees: in Urban Economics (by Erasmus University Rotterdam in the Nederland’s) and in Tourism Economics (by Bocconi University in Italy). He also completed a post-graduate certificate on Hotel Asset Management from Cornell University (USA).",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkzMg==",
                                    "title": "USALI 11th Edition – Tips and Tricks",
                                    "beginsAt": "2024-04-29 11:30:00",
                                    "endsAt": "2024-04-29 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Dale Qi",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMDk4NjA5LFVzZXJfMTU3NTczMzEp",
                "jobTitle": "Vice President, Director - Real Estate Structuring & Advisory",
                "lastName": "Shen, MRICS",
                "photoUrl": "https://static.swapcard.com/public/images/cade34b84234410ca850597be8b11d09.jpeg",
                "organization": "Mashreq Bank",
                "biography": "Dale is a real estate banking professional who has extensive experiences in hospitality and real estate market in UAE and wider GCC over the last two decades.  \n\nWith Mashreq, she has structured and advised on high-profile real estate transactions both conventional as well as be-spoke structure.  \n\n \n\nPrior to that, Dale had various ranges of roles in real estate field focused on hospitality assets. She managed a portfolio of hospitality and leisure assets valued over AED 2 billion, and supported acquisition and disposal of hospitality / leisure assets with value exceeding AED 1 billion.  \n\nDale is also an RICS qualified valuer, she carried out real estate consultancy works on valuations, feasibility studies, advise on acquisition and strategy of real estate assets during her time in CBRE, Knight Frank and Colliers.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Green Construction & Smart Cities",
            "Sustainability & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg4Nw==",
        "titleTranslations": [
            {
                "value": "The BIG Project Pitch: International Hospitality Projects Revealed",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:30:00",
        "endsAt": "2024-10-01 17:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/nDicNBnrY3E\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Marta",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjg2MTUzLFVzZXJfMTk4MTc2MTgp",
                "jobTitle": "Co-founder and Business Development Director",
                "lastName": "Garcia De Alcaraz",
                "photoUrl": "https://static.swapcard.com/public/images/1d864b4c0eca4a70b4572e794fcb97bc.jpeg",
                "organization": "Salasia Group",
                "biography": "Marta Garcia de Alcaraz is the co-founder of Salasia Group, leading a transformative project to revitalize one of Madrid’s most historic properties, located just 35 minutes from the city. This visionary endeavor will create a world-class wellness retreat, drawing on the globally renowned healing waters of Carabaña, celebrated for their therapeutic powers for over a century. With Dagny Pétursdóttir, former General Manager of Blue Lagoon Iceland, as a key advisor, Salasia is poised to become one of Europe’s top wellness destinations. Investors are invited to seize this high-growth, high-profit opportunity in Madrid’s booming tourism sector.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Delegate",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Louis",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMDM1NTE4LFVzZXJfMzc3NTc3OCk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Thompson",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/8258815cc5304a04a04d76903e376971.jpeg",
                "organization": "Nomadic Resorts",
                "biography": "Louis is the founder and CEO of Nomadic Resorts an award-winning architectural and landscape design office that delivers innovative, experiential hospitality projects across the planet since 2011.\n\nAmong their most recent work is Madi Hiyaa overwater restaurant at Banyan Tree Vabinfaru, Playa Viva treehouses in Mexico (which won the Global Ahead Award 2023 for Cabins, lodges and tented camps) and Wild Coast Tented Lodge in Sri Lanka which was voted Global Gamechanger at the 2020 Ahead Awards.\n\nThe team has designed bespoke green building projects, treehouses and tented camps for various luxury hotel groups including Shangri-La, Domes Resorts, Banyan Tree, Six Senses, Playa Viva, Red Sea Global, Neom and Resplendent Ceylon.\n\nLouis recently launched Nomadic Escapes, a new outdoor lodging management company creating, a series of biophilic, low carbon tented camps with a strong focus on personal wellbeing and outdoor adventure sports. The first mixed use camp is under construction near the Morne in south-west Mauritius and several additional camps are under development in the Indian Ocean.\n\nPrior to launching Nomadic, Louis worked at Six Senses Resorts and Spas from 2004- 2012 as group Director of Green Building and Sustainable Landscaping, a role in which he helped develop the group’s ground-breaking sustainability practices.\n\nThroughout his career he has worked at the cutting edge of experiential travel focussing on pioneering projects including ‘Fresh in the Garden’ the Farm to Fork treetop restaurant at Soneva Fushi, the Treetop Dining Pod at Soneva Kiri and the innovative bamboo restaurant at Banyan Tree, Vabinfaru.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Delegate",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Philipp",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTE5MjEwLFVzZXJfMjM5MDAyOCk=",
                "jobTitle": "Senior Vice President",
                "lastName": "Klohr",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/70925a87800142b28e7c1d6c23f6ded0.jpeg",
                "organization": "Mubadala",
                "biography": "Philipp Klohr leads Mubadala’s hospitality portfolio including its asset management, investment and divestment functions.  Mubadala is an Abu Dhabi based diversified global investment firm with over US$280bn assets under management, and holds investments in international hotel real estate and hospitality operating companies.  Prior to joining Mubadala, Philipp worked for London-based hotel investment firm Cedar Capital Partners where he was involved in the firm’s acquisitions and asset management functions, focusing on hospitality related value-add and turnaround opportunities.  Before that, Philipp worked for the London-based hotel brokerage and investment advisory firm HVS Hodges Ward Elliott.  Philipp graduated from the École Hôtelière de Lausanne in Switzerland.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Ottar",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTM1MDU2LFVzZXJfMjEwNTAxODYp",
                "jobTitle": "CEO & Founder",
                "lastName": "Zahl Jonassen",
                "photoUrl": "https://static.swapcard.com/public/images/219b03e499b54830b2ddcb62e74fbcc1.jpeg",
                "organization": "Marelius AS",
                "biography": "Ottar Zahl Jonassen is an entrepreneur living at the top of Europe. Fueled by positive energy, passion, and creativity, Ottar is deeply connected to his Arctic heritage. With this strong sense of purpose, he is on a mission to transform the region into a world-class destination in the far north.\n\nOttar invites you on an extraordinary journey to the easternmost tip of Norway. Here, Marelius plans to develop an Arctic village with resorts, holiday homes, and a small marina. This wild, untouched landscape, bathed in the midnight sun and winter's Northern Lights, offers rich wildlife, bird cliffs, and dramatic headlands. Experience rivers full of fish, the Arctic Ocean with exotic king crabs, whales, old fishing villages, and vibrant cultures — a world where nature and traditions collide.\n\nOur region, Varanger, has everything — breathtaking nature, colorful horizons, rich cultural heritage, unique experiences, and warm-hearted communities. \n\nWhat we lack is the necessary capital to fully realize the potential of these hidden gems. This gives innovative investors a rare opportunity to join us on an exciting journey, where the rewards extend beyond financial returns to shaping the future of Arctic tourism.\n\nWhile we’ve seen large investments in places like Iceland, Lofoten, and Tromsø, the industry’s presence in this region is still very modest. This is where the \"real deal\" lies — untouched, undiscovered, and waiting for pioneers like you.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Delegate",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Coley",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzc0Njk0LFVzZXJfMTY1Nzk5Nyk=",
                "jobTitle": "Partner & Head of Europe",
                "lastName": "Brenan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/912f9161493048bfb746abf77baac9cd.jpeg",
                "organization": "KSL Capital Partners",
                "biography": "Coley Brenan, Partner, KSL Capital Partners, runs the KSL European office, based in London. KSL is a leading private equity firm with approximately $8.0 billion of equity capital commitments raised since 2005 and a 20-year track record of making investments exclusively in travel and leisure businesses. Through its investment vehicles, KSL has owned, operated and franchised some of the largest and most renowned hotel and resort properties in the United States and Europe, including approximately 62,000 hotel rooms, 1,100 restaurants, 575 retail stores, 1,100 spas, 700 leisure clubs and 300 golf courses with 1,100,000 members, 30,000 skiable acres with 260 ski lifts and 12 aviation FBOs. In Europe, KSL currently own, The Pig Hotels, a collection of award-winning rural boutique hotels located throughout southern England, Beaumier, a collection of 12 boutique hotels located in France, Spain, and Switzerland; Cameron House Hotel, a golf resort on the shores of Loch Lomond, Scotland; Third Space, a collection of 10 premium fitness clubs located across London and Le Sereno Hotels, multi-award-winning ultra-luxury hotel chain comprising: Il Sereno located on the shores of Lake Como, Italy, and Le Sereno on the beach at Grand Cul de Sac on the island of St. Barthelemy.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMg==",
                                    "title": "Diversifying the Economy: Strategies for Attracting Foreign Direct Investment and Achieving Vision 2030 Objectives through Innovative Funding Mechanisms",
                                    "beginsAt": "2024-04-30 10:40:00",
                                    "endsAt": "2024-04-30 11:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "David",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjgyMzc2LFVzZXJfMTYyMjI0MTkp",
                "jobTitle": "Founder",
                "lastName": "Singleton",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/a4234bad263246c3ba7ed24c70df0aa2.jpeg",
                "organization": "Oraculi",
                "biography": "David has led organisations worldwide with some of the world’s best-loved brands. In 2022, he founded Oraculi, an advisory practice specializing in leadership, transformation, and strategic advisory. From Dubai, he serves as a retained strategic advisor and NED across hospitality, F&B, tech, and related sectors globally from Dubai. His hospitality career started in the UK, leading F&B brands, then transitioned to roles in Russia and the UAE, including Vice President at Al Tayer and Hard Rock Cafe.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Ines",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTAwNDAzLFVzZXJfMTU4ODQwMzcp",
                "jobTitle": "CEO & Founder",
                "lastName": "Abel",
                "photoUrl": "https://static.swapcard.com/public/images/54f9e6d234fa4a3aa47abd89d4d70914.jpeg",
                "organization": "Luxury Hospitality",
                "biography": "Founder & CEO of Luxury Hospitality agency,  a private international boutique focused on  3 lines of business \n\n- REAL ESTATE PROJECT DEVELOPMENT & INVESTMENT\n- HOTEL PROJECT  \n- F&B  BRAND FRANCHISE \n\nAfter a master's MBA specializing in Hospitality Management & Tourism, I worked for different hotel groups like Mariott, HIG, and Kempinsky and then I moved to QATAR to join the Convention Center( to develop the tourism HUB in the region)   \n\nI also gained experience as Business Director Development for Agence Publics in Qatar, specializing in public, political, and institutional communication. It offers customized solutions to its French and international clients: states, governments, international organizations, foundations, and major companies.\n\nWith unmatched global expertise, Agence Publics supports its clients in strategic communication, image, and e-reputation. The agency organizes the most outstanding international conferences and major public events. It has organized the inauguration of the new Suez Canal, and COP22 - Conference on Climate Change - in Marrakech, as well as the Francophonie Summit in Madagascar in 2016.\n\nMy whole background is a perfect mix of  various expertise : Hotels, Real Estate, Corporate, Tourism, development, project, and brand marketing. \n\nAs of today, my ambition is to be recognized and collaborate with top groups and aim to help them to achieve their projects/goals.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Delegate",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Rabih",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjg2NDM5LFVzZXJfMTYzOTU2ODUp",
                "jobTitle": "Board Member",
                "lastName": "Feghali",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bde0f2da88104f85b7b4d69ce0181547.jpeg",
                "organization": "HAMA",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjA3MzYxMQ==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talk: Harmony in Health - Integrating Wellness, Medical Innovations, and Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:30:00",
        "endsAt": "2024-10-01 16:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/tu6tYgpZONw\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "wellness-and-medical-tourism",
                "translations": [
                    {
                        "value": "Wellness & Medical Tourism"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Kathryn",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTI3ODg4LFVzZXJfMjE5MTIwOCk=",
                "jobTitle": "Managing Director",
                "lastName": "Moore",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2d11f660bf5f4f36b540573b290c1068.jpeg",
                "organization": "Spa Connectors",
                "biography": "Kathryn Moore has been a leading expert in the global spa & wellness industry for over 15 years with extensive knowledge of all aspects of the business.  Her successes include negotiating complex commercial arrangements, conception and implementation of new operational frameworks, plus development of standards and training programmes.  Recognised for creativity and ‘out of the box’ thinking when developing bespoke, high-end spa and wellness concepts for a broad spectrum of clients, Kathryn is a highly sought-after collaborator in the market today. \n\nDuring her time with MSPA, overseeing more than 60 spas for Minor Hotels, Kathryn identified noticeable gaps in the industry.  Her solution was to form Spa Connectors in 2015, offering business consultancy, exclusive training programmes as well as recruitment solutions.  \n\nKathryn had always wanted to create an awards program to recognize individuals in the industry and Covid provided the ideal time to launch the Hall of Wellness Awards. A platform to showcase the stories of the individuals who make our industry great.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Simone",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjk1MjUyLFVzZXJfMjA1MzU4OTQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Gibertoni",
                "photoUrl": "https://static.swapcard.com/public/images/ebe6692dfb6f4c8eb8faa4accbdaaac1.jpeg",
                "organization": "Clinique La Prairie & Co-founder CLP Holistic Health",
                "biography": "Simone Gibertoni is the CEO of Clinique La Prairie, and co-founder of Holistic Health by Clinique La Prairie (longevity supplements). Clinique La Prairie is the world's most exclusive clinic and one of the most iconic Swiss brands. Simone is driving the international development of Clinique La Prairie and its diversification strategy, with the mission of creating a global player able to help people live a longer, healthier, and better life. Simone is a renowned keynote speaker, presenting at leading conferences, and universities. He frequently shares insights on wellness, longevity, business, and luxury strategies, with his thoughts on business and longevity featured in top international journals.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Wellness & Medical Tourism"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjExODMzMw==",
        "titleTranslations": [
            {
                "value": "Journey to a Sustainable Tourism Future: Paving the Way for Eco-Friendly Travel",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:30:00",
        "endsAt": "2024-10-01 16:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/GA6ZyhOnaGc\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0ODk4Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "intelligence-talks",
                "translations": [
                    {
                        "value": "Intelligence Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Engy",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDQ5MzEzLFVzZXJfOTEyOTAyMyk=",
                "jobTitle": "Senior Engagement Manager - Tourism",
                "lastName": "Naguib",
                "photoUrl": "https://static.swapcard.com/public/images/f34b7d497d9f46ba9c4ea5969a858757.jpeg",
                "organization": "Euromonitor International",
                "biography": "Engy is a seasoned expert with 20 years of experience specializing in scientifically grounded, research-driven consulting services for the tourism sector. Leveraging strategic frameworks, marketing research, and statistical analysis, she has successfully guided Destination Management Companies (DMCs) and tourism authorities globally, crafting customized strategies to address sector-specific challenges. Engy’s expertise spans the entire journey—from building awareness and defining target segments to developing branding messages and measuring economic impact. She has led initiatives that improve business environments through strategic partnerships with government entities and multinational corporations, driving sustainable growth in the tourism industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Intelligence Talks",
            "Sustainability & Innovation"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzk2MQ==",
        "titleTranslations": [
            {
                "value": "The Future of Wellness: Brand Challenges and Opportunities",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:45:00",
        "endsAt": "2024-10-01 17:25:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ZpSwHaMLvL4\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "wellness-and-medical-tourism",
                "translations": [
                    {
                        "value": "Wellness & Medical Tourism"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Catherine",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTQ4MDEyLFVzZXJfNzgzNTgxKQ==",
                "jobTitle": "Chief Strategy Officer",
                "lastName": "Edwards",
                "photoUrl": "https://static.swapcard.com/public/images/798d8cf33f9346bfa0699b7d1b5f1d6c.jpeg",
                "organization": "QUO",
                "biography": "Innately curious, with a passion for cultural narratives and human behaviour, Catherine supports QUO’s multidisciplinary teams as they form distinctive brands for our diverse base of clients. \n\nCatherine joined QUO in 2011, initially as content director, before moving into brand strategy, building and establishing brand cultural definition as a core component of QUO’s offering. \n\nShe has worked with many of QUO’s key clients, conceptualizing and re-imagining brands from small independent hotels to global hospitality groups, across numerous cultures and destinations within Asia Pacific,�the Middle East and Europe. \n\nA graduate of University College London (UCL), Catherine previously worked as a journalist, writing and editing for a variety of lifestyle and business publications in London and Bangkok.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                                    "beginsAt": "2024-04-30 16:35:00",
                                    "endsAt": "2024-04-30 16:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Sammy",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTg4MjEwLFVzZXJfMjEwNzcxMzkp",
                "jobTitle": "CEO / Founder",
                "lastName": "Gharieni",
                "photoUrl": "https://static.swapcard.com/public/images/3384df8a5e7e4747991cc04402d79916.jpeg",
                "organization": "Gharieni Group",
                "biography": "Wellness Industry Pioneer\nKnown for his visionary industry leadership & pioneering spirit, Sammy has built an extraordinary Wellness brand based on a DNA of innovation- the Gharieni Group. \nSammy travels the globe for inspiration to create new ideas, business opportunities & improve existing processes. His client-focused mindset always looks to improve service, curate experiences, & refine processes that deliver exceptional value and delight guests with unique Wellness experiences.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Lindsay",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTMxNDMzLFVzZXJfMjA0Mzc5MDAp",
                "jobTitle": "Senior Director - Wellness Strategy",
                "lastName": "Madden-Nadeau",
                "photoUrl": "https://static.swapcard.com/public/images/2806c5dbdfad47938d50c6aad96c7f24.jpeg",
                "organization": "Red Sea Global",
                "biography": "Lindsay Madden-Nadeau is the Sr. Director, Wellness Strategy at Red Sea Global (RSG) and leads the wellness strategy for both The Red Sea and AMAALA, two exceptional, regenerative tourism destinations that aim to set new standards in sustainable development and put Saudi Arabia on the global tourism map for health and wellbeing. She is responsible for actively steering the Wellness Strategy supporting the Development team across the entire portfolio to identify and analyze industry insights, converting these into an actionable strategic roadmap that delivers on RSG’s ambitions for wellness in the region.  Lindsay has over 23 years of experience in the hospitality industry, working across the globe for prestigious hospitality leaders.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Amanda",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTI4MDQxLFVzZXJfMjA0MzYyMzYp",
                "jobTitle": "Senior Director of Spa and Wellness",
                "lastName": "Schmiege",
                "photoUrl": "https://static.swapcard.com/public/images/d9434718dced4231a1dfcc3eda2ea234.jpeg",
                "organization": "Four Seasons",
                "biography": "Graduating from the University of Michigan with a focus in Organizational Behavior, Amanda also completed further studies at University College London, holding a Nutrition Certification from the National Academy of Sports Management (NASM) and previously served as the President of the Hawaii Spa Association.\n\nFrom starting her career at a local spa business in Michigan, to leadership positions with renowned & international iconic hospitality brands including Elizabeth Arden, Starwood, WTS International and Marriott, Amanda has become a well-respected figure in the global spa & wellness industry.\n\nHaving previously played a pivotal role in launching the spa, pool & recreation areas of the St Regis, W Hotel & Westin complex at Habtoor City in Dubai, Amanda was also the Marriott Spa Regional Leader, marking her achievement of opening an illustrious 8 properties to date and supporting an additional 15 spas across the UAE.\n\nAmanda has been an integral part of the Four Seasons spa team for the past 6 years, not only as Senior Spa Director at Four Seasons Hualalai, but also overseeing spa operations at Four Seasons Oahu, Lanai, Bora Bora, St. Louis, and most notably, the opening of Four Seasons Cartagena, Columbia.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sara",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTEzOTMwLFVzZXJfMjA0MjUwNjMp",
                "jobTitle": "Area Director Spa & Wellness",
                "lastName": "Codner",
                "photoUrl": "https://static.swapcard.com/public/images/a06c02fcad8742e99e49c940ee7511d4.jpeg",
                "organization": "Mandarin Oriental Hotel Group",
                "biography": "Sara Codner, Area Director of Spa & Wellness, Middle East at Mandarin Oriental Downtown, Dubai has over 28 years’ experience in the Spa and Wellness Industry. She began her wellness journey as a spa therapist and then moved into consultancy, working on developmental projects throughout the world, Ms. Codner brings both business acumen as well as a passion for and deep insight into the spa industry to her role.\n\nAs Area Director of Spa & Wellness at Mandarin Oriental Downtown, Dubai Sara is responsible for the preopening, setting, and implementing the spa’s business strategy, developing signature spa and wellness programmes as well as tailored nutrition and healing therapies, eventually overseeing the spa operations and ensuring successful performance. \n\nSara joined the latest Dubai team from her role as Area Director of Spa & Wellness at Mandarin Oriental Jumeira, Dubai leading it to become the flagship Spa & Wellness property within the group and the number one Spa in the region. \nThis is Ms. Codner’s fifth role within the Mandarin Oriental Hotel Group. Prior to that, she joined us from another flagship property in Tokyo and was previously part of the pre-opening team for Mandarin Oriental Guangzhou, the group’s first urban hotel in China and in the earlier stages of her career she worked as Spa Manager for The Spa at Mandarin Oriental Hyde Park, London.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Wellness & Medical Tourism"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjA1MTE5OQ==",
        "titleTranslations": [
            {
                "value": "New Horizons Ahead: Trends and Developments in Tomorrow’s Designs",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:45:00",
        "endsAt": "2024-10-01 17:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/2jIblSZVGsA\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "green-construction-and-smart-cities",
                "translations": [
                    {
                        "value": "Green Construction & Smart Cities"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Yosor",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjEwODI4LFVzZXJfMTIwOTgyNTMp",
                "jobTitle": "Principal & Head of Business Development",
                "lastName": "Al Suhaili",
                "photoUrl": "https://static.swapcard.com/public/images/334f805667c24f969b2d1def4102b686.jpeg",
                "organization": "Andart Global",
                "biography": "Yosor is a seasoned strategist with a focus on developing the design, culture, and tourism industries in the GCC with Andart Global. With two decades of experience, she has significantly contributed to shaping the region’s business landscape. She has worked with the Dubai government on industry development initiatives and helped build creative ecosystems in the UAE. Yosor also led the region's largest tech, media, and design startup incubator, fostering innovation and economic growth. Her deep understanding of the region’s culture and business environment uniquely positions her to guide clients through complex challenges and opportunities.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Tony",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjEwNzAyLFVzZXJfODc3ODYyMCk=",
                "jobTitle": "Partner",
                "lastName": "Miki",
                "photoUrl": "https://static.swapcard.com/public/images/c4507dfe7e6f47218b9f1ef46bda730c.jpeg",
                "organization": "Foster & Partners",
                "biography": "Tony studied architecture at the Wentworth Institute of Technology in Boston. Upon graduation in 1999 he joined Foster + Partners and worked on the Petronas University of Technology in Malaysia. Since then, he has been involved in a wide range of international projects including the design of a fleet of ten yachts for YachtPlus, The Waterfront, Japan; Gaafaru Masterplan in the Maldives and multiple projects in Saudi Arabia including Haramain High-Speed Rail, Jeddah Metro and King Salman International Airport. Tony was promoted to partner in 2014.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Elyza",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNTg4NDkwLFVzZXJfNjgyNTQ5NSk=",
                "jobTitle": "Vice President - Architecture, Design & Construction ME & SSA",
                "lastName": "Falzon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/9a5c3f84af374083ba66f43de4cddaac.jpeg",
                "organization": "Hilton",
                "biography": "Elyza Falzon is the Head of Architecture, Design & Construction for Hilton in the Middle East and Africa. She leads a dynamic, multi-disciplinary team that partners with Owners and Developers to deliver world-class hotels, resorts, and residences across the region.\n\nWith two decades of extensive experience in international hospitality design, Elyza has developed a deep expertise in creating innovative, culturally attuned spaces. She relocated to Dubai fifteen years ago, where she has honed her knowledge of both global and regional industry standards. Before moving to Dubai, Elyza began her career in Milan, where she worked as a design consultant on a diverse portfolio of internationally branded hotels and resorts across Europe and the Middle East.\n\nA passionate advocate for Women in Leadership, Elyza is committed to nurturing the next generation of industry leaders through mentoring and active involvement in leadership development initiatives.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5OQ==",
                                    "title": "Building Tomorrow: The Impact of Sustainable Construction on Evolving Demand Trends",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ana Lobo",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNzA4MTk2LFVzZXJfMTkyNzk4Nzkp",
                "jobTitle": "Director, Interior Design",
                "lastName": "Martins",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/dd57025983104c75946e38dee4bbbd46.jpeg",
                "organization": "ARC International Design Consultants",
                "biography": "She has extensive experience in various areas, and always looks for a creative approach when developing projects, being a firm believer in teamwork.\n\nHer main focus has been on Retail and Hospitality, including Architecture and especially Interior Design. She has worked on many projects, both national and international, and is always looking for new challenges and opportunities for learning and growth.\n\nIn the hospitality world, she has had the opportunity to work with the big operator brands in various locations all over the world.\n\nWith a focus on Interior design, her main concern is always to find the best solutions, considering the Brand statements, the local culture and the creation of unique sustainable destinations that become exquisite guest experiences.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Green Construction & Smart Cities",
            "Sustainability & Innovation"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjExNTUzOA==",
        "titleTranslations": [
            {
                "value": "India 2047: The Future of Travel and Hospitality in India​",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 16:45:00",
        "endsAt": "2024-10-01 17:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/aJDyvbrV2ZM\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Puneet",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTA3NTk2LFVzZXJfMjA5MTc2ODAp",
                "jobTitle": "Managing Director & CEO",
                "lastName": "Chhatwal",
                "photoUrl": "https://static.swapcard.com/public/images/a317878f51c94beeb2687d2b0e88f8b8.jpeg",
                "organization": "Indian Hotels Company Limited",
                "biography": "Mr. Puneet Chhatwal joined The Indian Hotels Company Limited (IHCL) as the Managing Director and Chief Executive Officer on November 6, 2017. He is a global professional with close to four decades of leadership experience at highly acclaimed international  hotel groups in Europe and North America. \n\nUnder his leadership, IHCL has been on a journey of re-imagination to achieve \nsustainable profitable growth. Mr. Chhatwal also serves as the leading voice of the industry in India in his capacity as the Chairman of the National Committee of Tourism and Hospitality, CII, and Chairman of Federation of Associations in Indian Tourism & Hospitality (FAITH).\n\nPrior to this, Mr. Chhatwal was the Chief Executive Officer and Member of the Executive Board of Steigenberger Hotels AG – Deutsche Hospitality based out of Frankfurt, Germany. He was also the Chief Development Officer of The Rezidor Hotel Group – Carlson Hotels Worldwide based out of Brussels, Belgium. Mr. Chhatwal is a graduate of both, Delhi University and Institute of Hotel Management, Delhi. He has completed an MBA in Hospitality from ESSEC, Paris and an Advanced Management Program from INSEAD.\n\nAcross his global leadership career in hospitality, Mr. Chhatwal has received several acclaimed industry awards. He was honoured with the Carlson Fellowship in 2012 and he was also the First Alumnus included in the ESSEC-IMHI Hall of Honor 2014.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0MjI4LFVzZXJfMTU3NTcyNzUp",
                "jobTitle": "Presenter",
                "lastName": "Sackur",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
                "organization": "HARDTalk",
                "biography": "Stephen Sackur is presenter of HARDtalk, the current affairs interview on BBC World and the News Channel. His subjects have included the heads of NATO and OPEC, Shimon Peres, Gore Vidal and Richard Dawkins.\n\nFor HARDtalk he has also interviewed a number of the world’s great names, including Bill Clinton, George W Bush, Mikhail Gorbachev and Hugo Chavez. Distilling his notes for a series of articles, Stephen identiﬁed the ﬁve qualities they all seemed to share: an indestructible will, passion (almost beyond reason), outrageous optimism, a super-sized ego and a ‘rebel yell.’\n\nThese interviews have also given him an insight into how organisations can best bring about innovation: “You need to ﬁnd ways to assess individuals on their merits, and give rewards for innovative thinking rather than play-it-safe mediocrity. You should encourage insiders to get outside and bring back fresh insights. And you shouldn’t confuse seniority with creativity.”\n\nAway from set-piece interviews Stephen has served in Brussels, reporting on day-to-day stories from the major European institutions and across the continent. Before that he was Washington Correspondent, where his coverage and analysis of 9/11 won widespread acclaim.\n\nTen years earlier it was Stephen who broke the story of the mass killing on the Basra road out of Kuwait, marking the end of the Gulf War. He was then posted to Cairo and Jerusalem as Middle East Correspondent, where he reported on the emergence of the Palestinian Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzcxNw==",
        "titleTranslations": [
            {
                "value": "Trailblazing Careers in Hospitality: Leading the Way",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 17:00:00",
        "endsAt": "2024-10-01 17:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/_kphcfcho_g\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Lenah",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNTU3MzYzLFVzZXJfMTcwMjQxNjIp",
                "jobTitle": "Editor",
                "lastName": "Hassaballah",
                "photoUrl": "https://static.swapcard.com/public/images/1ca82aa592884f7fbf0fec8e2d09949b.jpeg",
                "organization": "CNN Business Arabic",
                "biography": "Lenah Hassaballah is a television and digital journalist with 13 years of experience covering politics and business in the Arab region. Lenah started her career in the US and Egypt as a field reporter covering hard-hitting stories, then moved on to becoming a TV presenter and journalist in the UAE. She is currently leading a team of reporters to produce engaging, visual business stories.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Hala Matar",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNDI5NzU3LFVzZXJfMTQzNjUyMyk=",
                "jobTitle": "President, Middle East & Africa",
                "lastName": "Choufany",
                "photoUrl": "https://static.swapcard.com/public/images/ff1bc2942014471ca482413fc686ecb4.jpeg",
                "organization": "HVS",
                "biography": "Hala Matar Choufany is the President for HVS -Middle East & Africa -the only global consulting company focused solely on the hospitality industry. Hala is recognized as one of the most experienced and influential leaders in the hospitality industry, notably in the Middle East and Africa region.\n \nHala has advised on more than 5,000 hospitality and mixed-use projects in the last 20 years across Europe, the Middle East, Africa and Asia in areas such as Valuations, Acquisitions, Asset Management, Strategic investments and development, Contract Negotiations, and general Real Estate Strategic Advisory. \n \nHala has authored more than 60 publications and speaks frequently at investment and hospitality related conferences on a range of topics including asset valuation, investments, management issues and women leadership.\n \nIn addition to being a Board Member of HVS Global, Hala is regularly invited to Boards as a subject matter expert in the industry and frequently invited to discuss hotel and tourism trends on major news channel including Alarabiya, Bloomberg, Abu Dhabi TV, Forbes, Breaking Travel News and CNN.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                                    "beginsAt": "2024-04-30 16:35:00",
                                    "endsAt": "2024-04-30 16:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzcyMA==",
        "titleTranslations": [
            {
                "value": "Company Culture and Relationships as a Competitive Advantage",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 17:15:00",
        "endsAt": "2024-10-01 17:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/NIG-SHXn6bk\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Eddy",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjg5NDcxLFVzZXJfMTU5NTQzNzIp",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Tannous",
                "photoUrl": "https://static.swapcard.com/public/images/0ea10113e8f64d0795d891c9d1769812.jpeg",
                "organization": "Rotana",
                "biography": "Eddy Tannous is the Chief Operating Officer (COO) of Rotana, one of the leading hotel management companies in the region with hotels across the Middle East, Africa, Eastern Europe and Türkiye. In his current position, Tannous is driving the growth and expansion of Rotana and his responsibilities include the successful opening of our new properties and creating synergy among Rotana properties in all aspects of our operations.\nTannous commenced his journey with Rotana in August 2023, bringing with him an extensive background of over 20 years in effectively overseeing hotel\noperations within large hotel groups. His career path has covered significant\npositions within the Middle East's hospitality sector, collaborating with\nwell-known global brands. Most recently, he held the position of Senior Vice\nPresident, Operations, where he supervised operational performance across\nFairmont's Middle East and Asian properties. Prior to that role, Tannous served\nas Vice President, Operations for the Kingdom of Saudi Arabia at Accor, where he managed the country's entire portfolio, comprising over 40 operating hotels and 40 pipeline projects.\nTannous possesses a proven track record of delivering success in various facets of the hospitality industry, encompassing operations, customer satisfaction, strategic expansion, marketing, and more, for some of the region's most renowned hospitality brands.\nAt Rotana, Tannous will continue to strengthen the Rotana brand's presence in\nglobal markets. He remains committed to advancing the group's global footprint while ensuring robust and consistent financial performance, all with the ultimate goal of creating shareholder value.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Paul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzM4NjczLFVzZXJfNzgzNTY3KQ==",
                "jobTitle": "Director of Project Management",
                "lastName": "Keen",
                "photoUrl": "https://static.swapcard.com/public/images/4bd6dbb118df460395817d2ffb74d8ff.jpeg",
                "organization": "QUO",
                "biography": "Paul places relationships at the heart of our dynamic project management processes, fostering strong connections and enabling teams to tackle complex brand challenges. With a recent Master’s in Innovation, Paul brings a fresh perspective to branding hospitality, pushing beyond boundaries while maintaining a strong focus on people and culture. His leadership drives a collaborative environment where creativity thrives, delivering results that are both innovative and human. By integrating strategic vision with a commitment to relationships, Paul is committed to creating a future for hospitality centred on social connection.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Aseel  Hussain",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMjY3MDMzLFVzZXJfMTU5MjQ5MjMp",
                "jobTitle": "Hotel Talent Development Manager",
                "lastName": "Bondagjy",
                "photoUrl": "https://static.swapcard.com/public/images/7186201b027e4b559da332e0aae95aa3.jpeg",
                "organization": "NEOM",
                "biography": "Aseel’s passion is to inspire young Saudis; to encourage, and motivate them to embrace a career in hospitality, her role at NEOM (Saudi Arabia’s visionary Giga project on the Red Sea coast) aligns perfectly with this. As part of the Hotel Development team, Aseel is responsible for driving the development and implementation of its workforce development strategy, which is aimed at creating an empowered and competent pipeline of future leaders in hospitality. \nA fluent English speaker with Arabic as her mother tongue, Aseel holds a bachelor’s degree in business administration and a master’s degree in Hospitality and Tourism Management from Ken State University where she was recognized with the International Alumni Award, which is bestowed to students who have gained global recognition in their respective fields.\n\nApart from her international credentials, Aseel also has a deep understanding of the region, having previously worked in Dubai and Abu Dhabi. She was also part of the inaugural cohort of post graduate employees at NEOM which saw only ten high potential candidates selected from more than 12,000 applicants.\n\nAseel began her career at NEOM within its tourism department, making significant contributions towards its tourism strategy by developing a variety of marketing collateral including compelling audio and visual campaigns. She is now a ‘Rising Star’ in NEOM’s Hotel Development business unit having recently been awarded as such at the inaugural ‘Leaders in Hospitality Awards KSA’ held by Hotel & Catering News Middle East.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Dr. Bertrand",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODUxMDA0LFVzZXJfMjAyNTMzNzkp",
                "jobTitle": "Professor",
                "lastName": "Audrin",
                "photoUrl": "https://static.swapcard.com/public/images/297ae5e757984e778f1c8eb9c88d5be1.jpeg",
                "organization": "EHL Hospitality Business School",
                "biography": "Dr. Bertrand Audrin is assistant professor in Human Resource Management and Organizational Behavior at EHL Business School. His research focuses on digital transformation and its impact on organizations, human resource management, and employment relationships. His current projects tackle questions on digital skills and emotional intelligence, new ways of working and AI for recruitment.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "William-Harley",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTUwMzA0LFVzZXJfMTU3NjE3ODMp",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Fleming",
                "photoUrl": "https://static.swapcard.com/public/images/8b79f370a3ba406aa9bb58de1634306a.jpeg",
                "organization": "Millennium Hotels & Resorts Middle East & Africa",
                "biography": "William Harley-Fleming is the Chief Operating Officer of Millennium Hotels and Resorts Middle East and Africa (MEA), overseeing the group’s growth across the region, whilst spearheading operational excellence and brand standards across the portfolio.\n\nWilliam joined Millennium Hotels and Resorts family in August 2023, initially as Senior Vice President of Operations Middle East and Africa, however through his passion and drive for excellence was soon promoted to the role of Chief Operating Officer Millennium Hotels and Resorts MEA, in April 2024.\n\nDescribed as a dynamic and results-oriented hospitality professional, with more than 28 years of experience. William has an impressive and diverse background working in various countries and regions, including the Middle East, Asia, and Europe. His most recent journey to the region was upon his appointment as Corporate Food and Beverage Concept Director, with JA Resorts & Hotels, back in September 2007. However, through his determination and ambition, he ascended through the ranks, achieving his first General Manager role in 2009, and later becoming Vice President of Operations for the JA group.\n\nWilliam’s career trajectory includes holding various senior management roles with Starwood, Rezidor, JA Resorts & Hotels, and more recently with Millennium Hotels & Resorts, overseeing a diverse portfolio of more than 61 hotels, across 11 different countries, with over 16,000 colleagues with-in the region.\n\nThroughout William’s career, he has always had a strong passion in identifying, nourishing, and developing hospitality professionals, guiding and supporting their career progression, whilst fostering an environment in which our colleagues are integral to the business objectives and achievements.\n\nWiliam also holds a Bachelor of Science in Hospitality Management from Manchester University, and a Diploma in Food Hygiene and Safety from The Royal Institute of Public Health and Hygiene UK.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjE0NzcxNg==",
        "titleTranslations": [
            {
                "value": "The World's First AI-Created Restaurant In Action",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 17:45:00",
        "endsAt": "2024-10-01 18:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/mdwVrNf6blI\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Investment"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "James",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTM4ODA4LFVzZXJfMTYyNTA1MDkp",
                "jobTitle": "Founding Partner",
                "lastName": "Hacon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
                "organization": "Think Hospitality",
                "biography": "James is one of the leading names in hospitality growth, marketing & brand strategy, he has been an executive, board member, Attendees and consultant in the hospitality brand and technology sector for the past twenty years, having worked with more than 80 hospitality brands in 22 countries, from independent Michelin starred restaurants to leading restaurant brands, international hotel companies & contract caterers. \n\nHis brand experience includes Accor, IHG, Sodexo, Compass Group, Krispy Kreme, Costa Coffee, Diageo, AMREST, Jamie Oliver Group, Wagamama, Gleneagles & Pret. \n\nHe is regularly called upon as a commentator, writer, speaker & facilitator, giving him a unique insight into global trends and the very best brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                                    "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                                    "beginsAt": "2024-04-30 09:45:00",
                                    "endsAt": "2024-04-30 10:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                                    "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                                    "beginsAt": "2024-04-30 15:10:00",
                                    "endsAt": "2024-04-30 15:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Investment"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzcyMg==",
        "titleTranslations": [
            {
                "value": "Evening Reception at Taj Dubai - Hosted by IHCL",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-01 19:00:00",
        "endsAt": "2024-10-01 21:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>Hosted by IHCL, the evening reception will be held at Miss Tess and Treehouse, offering guests the chance to experience two distinct yet equally captivating dining venues. Miss Tess, nestled on the third floor of the Taj Dubai, transports guests on a vibrant culinary journey through Asian flavors, from contemporary Chinese to traditional Japanese and Thai cuisine, with each dish presenting a modern interpretation of time-honored recipes. Meanwhile, Treehouse, located in the serene back garden of the Burj Khalifa, invites guests to a chic urban hideaway, where Mediterranean-inspired bites and soulful house tunes create an ambiance of relaxed sophistication. Together, these venues epitomize the fusion of culinary artistry and experiential dining, each promising unforgettable moments in Dubai's vibrant dining scene.</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Reception",
                "translations": [
                    {
                        "value": "Reception"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjEwOTgwNg==",
        "titleTranslations": [
            {
                "value": "Yoga Session at J Club Jumeirah Beach Hotel – Wellness Studio",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 07:00:00",
        "endsAt": "2024-10-02 08:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>Start your day with this 60 minutes yoga flow designed for all levels. Shake off sleepy vibes, wake up your muscles, and bring movement to your body. In this class, you’ll open your hips, legs, back, and shoulders and at the end, you’ll feel physically and mentally refreshed, ready to enjoy the day ahead.</p><p>LOCATION: J Club Jumeirah Beach Hotel – Wellness Studio (<a href=\"https://maps.app.goo.gl/kAhCXYVAymsZ5SAN9\">https://maps.app.goo.gl/kAhCXYVAymsZ5SAN9</a>)</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDk1MjgwMQ==",
                "definition": {
                    "isDefault": false,
                    "name": "Experiences"
                },
                "value": "experiences",
                "translations": [
                    {
                        "value": "Experiences"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMjEwOTgwOQ==",
        "titleTranslations": [
            {
                "value": "Spinning Class at J Club Jumeirah Beach Hotel – Spinning Studio",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 07:00:00",
        "endsAt": "2024-10-02 08:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>High-energy spinning class focused on improving cardio, burning calories, and strengthening legs. Ideal for all fitness levels, it boosts stamina and tones muscles. Post-class, you'll feel energized and focused, ready to tackle conference activities with renewed enthusiasm.</p><p>LOCATION: J Club Jumeirah Beach Hotel – Spinning Studio (<a href=\"https://maps.app.goo.gl/kAhCXYVAymsZ5SAN9\">https://maps.app.goo.gl/kAhCXYVAymsZ5SAN9</a>)</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzcyMw==",
        "titleTranslations": [
            {
                "value": "Welcome Back",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 09:00:00",
        "endsAt": "2024-10-02 09:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/0aoeqZ0f2xY\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ries",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjkyNTE0LFVzZXJfMjA1MzQxNTgp",
                "jobTitle": "Young Leader",
                "lastName": "Anderson",
                "photoUrl": "https://static.swapcard.com/public/images/e7bdb9ec66504e6ca3efb33aa4d4b724.jpeg",
                "organization": null,
                "biography": "Ries Anderson is an experienced speaker who has given guest lectures and seminars at multiple universities worldwide. He specializes in topics such as creativity, entrepreneurship, and sustainability.\n\nRies was awarded Student Entrepreneur of the Year 2024 and was named a \"Global Changemaker\" by CMWUN. Along with his team, he reached the finals of the Sustainable Hospitality Challenge with Ecoqanat, an eco-friendly cooling solution that promises to revolutionize the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzYwNg==",
        "titleTranslations": [
            {
                "value": "Hospitality in Saudi Arabia: Aligning with Vision 2030 for a Sustainable Future",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 09:15:00",
        "endsAt": "2024-10-02 09:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/btn8eoJek1Y\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Eng. Sultan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyODI3MzIyLFVzZXJfMTYwOTc5NjEp",
                "jobTitle": "Chief of Investment",
                "lastName": "Alshehri",
                "photoUrl": "https://static.swapcard.com/public/images/a0aa1e8ec7034070983f61d7616eebde.jpeg",
                "organization": "Aseer Development Authority",
                "biography": "Sultan Alshehri is a seasoned executive with over 18 years of experience in investment, finance, and strategic development across Saudi Arabia and the GCC. Currently, as the Chief of Investment for Aseer Development Authority, Sultan drives initiatives to stimulate economic growth in the region. Previously, he served as the Investment Development & Attraction Director for the Water Segment at the Ministry of Investment and held key roles at Johnson Controls and the Saudi Arabian Olympic Committee. Known for delivering exceptional results and fostering strong professional relationships, Sultan is dedicated to advancing sustainable growth and investment opportunities.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Yousef",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTU4MzE1LFVzZXJfMjAyNzE3Njgp",
                "jobTitle": "Anchor and Entrepreneur",
                "lastName": "Gamal El-Din",
                "photoUrl": "https://static.swapcard.com/public/images/5b02a1deed2244c784ae60c9ea7b925e.jpeg",
                "organization": "Stagespring",
                "biography": "Yousef Gamal El-Din is the founder of Stagespring. He hosts high-profile figures including heads-of-state, ministers, CEOs and billionaires. Notably, his interview with the SNB Chairman in 2023 shook up the financial world, leading to the sale of Credit Suisse.\n\nIn over 15 years of live TV, he has secured exclusive conversations with many celebrated leaders, among them Christine Lagarde. Some 1,500 top decision-makers have joined him so far. He speaks regularly at the Future Investment Initiative and other key global events.\n\nGamal El-Din's journey covers eight years as an anchor with Bloomberg Television and previously at CNBC. The shows looked at the most important business and economic issues shaping markets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Amir",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjkzNzI2LFVzZXJfMTQzNjUxOSk=",
                "jobTitle": "Managing Director Development MENA",
                "lastName": "Lababedi",
                "photoUrl": "https://static.swapcard.com/public/images/c7d9ecf2b59d433fadc4d12a20418066.jpeg",
                "organization": "Hilton",
                "biography": "Amir is responsible for driving growth throughout the MENA region for the company’s suite of industry-leading brands.\n\nWith almost 20 years’ experience, Amir has previously held senior development roles for both owners and operators throughout EMEA, and has acted for private and institutional hotel investors in an advisory capacity.\n\nAmir holds a BSc in Hotel Management from the University of Surrey and an MSc in Global Banking and Finance at the London European Business School.\n\nA UK national of Arabic-English descent, Amir is married and has two daughters. He’s also a keen sportsman with a passion for combat and motor sports, tennis and skiing.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Samy",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjkzMDQyLFVzZXJfMTYwNDg1MjEp",
                "jobTitle": "Vice President",
                "lastName": "Boukhaled",
                "photoUrl": "https://static.swapcard.com/public/images/f1dfb83ca8cf4ec29d4e9a86ef49a8bf.jpeg",
                "organization": "Elaf Hotels",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Hassan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzIwMzcxLFVzZXJfMTQzNjQ4NSk=",
                "jobTitle": "Chief Hospitality Operations Officer",
                "lastName": "Ahdab",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/29735f117d6442c9a838312bceeeee9e.jpeg",
                "organization": "Taiba Investments",
                "biography": "Hospitality Leader and Expert\nMr. Ahdab is the Chief Hospitality Operations Officer for Taiba Investments company and formerly President of Hotels Operations for Dur Hospitality, the leading hospitality company in the Kingdom of Saudi Arabia.\n\nMr. Ahab oversees all hotel operations, aligning the company's vision to grow its portfolio across the Kingdom. Currently, he manages 15 Hotels or +5000 Hotel’s Rooms in various cities with Makarem Hotels brand in Makkah and Madinah and international brands such as Marriott, Crowne Plaza and Holiday Inn in other cities.\n\nWith over 35 years of experience in hospitality, Mr. Ahdab has established himself as one of the industry's most progressive and energetic leaders. Renowned for his unwavering commitment to stringent quality standards and his groundbreaking financial innovations, he has consistently driven success in every market he has touched. \nA champion for Saudi talent, Mr. Ahdab recognizes their potential to shape the Kingdom's hospitality future. He actively supports programs that unlock their skills and empower them for success.\n\nLeveraging his experience and network, Mr. Ahdab unlocks new business opportunities in every market. Recent successes include opening China tourism channels for the Kingdom with Cvent and STA.\n\nMr. Ahdab navigated numerous mergers and acquisitions, ensuring stability and successful integrations by building teams focused on maximizing strengths and delivering value to stakeholders. He was also acted as Hospitality expert for many arbitrations between owners and operators.\n\nMr. Ahdab began his hospitality career in 1977 with Le Méridien (then an Air France subsidiary), holding senior finance and operations roles across Europe, the Middle East, Africa, GCC, Indian Ocean, and the Caribbean. In 2017, he became CEO of Retaj Group (Qatar) before joining Dur Hospitality. His prior experience includes CEO at Retaj Hospitality Group (Doha), Vice President for Africa & Indian Ocean for Starwood Hotels & Resorts, and various leadership positions and worldly GM roles.\n\nFrench citizen, born in Syria, Mr. Ahdab holds a bachelor’s degree in economics and commerce with a major in Accounting from Damascus University. He furthered his education through various diplomas from INSEAD, Cornell University (Ithaca, NY) and Essec – Leoron Development Institute, including Min- MBA, Advanced Finance, Resorts Marketing, and Human Resources. In 2000, he received the honorary title of Executive Doctor for International Relations from CEHMI (Geneva).\n\nMr. Ahdab’ s achievements extend beyond his extensive experience. In 2023, he was awarded for The World's Leading Travel Personality at the 2022 World Travel Awards event in Muscat, Oman. He was also ranked 16th and 21st, respectively, in the Hotelier Middle East Power 50 List in 2020 and 2019. Since 2020, he is serving on Future Hospitality Advisory Board- FHS.\n\nBeyond his leadership role at Taiba Investments, Mr. Ahdab actively shapes the industry. In January 2024, he was elected Chairman of the IHG Owners Association for IMEA (India, Middle East, Africa). His dedication extends further back, having founded and led hospitality associations like the Seychelles Hotels Association (1986-1991) and St. Martin Hotels Association (1993-1995). He also co-founded the Association des Professionnels du Tourisme du Gabon – AHSM (1996-1998).",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwOA==",
                                    "title": "ENSURING THE LONG-TERM VIABILITY OF RELIGIOUS TOURISM",
                                    "beginsAt": "2024-05-01 12:50:00",
                                    "endsAt": "2024-05-01 13:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Focus on Saudi Arabia",
            "Sustainability & Innovation"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyOTk0MA==",
        "titleTranslations": [
            {
                "value": "HAMA Workshop & Annual Debriefing",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 09:15:00",
        "endsAt": "2024-10-02 10:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Amit",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMDkxNDIxLFVzZXJfMTYyMTI2NSk=",
                "jobTitle": "Vice President",
                "lastName": "Nayak, CHA",
                "photoUrl": "https://static.swapcard.com/public/images/1de1fe42566f4d0dbdb24885e0724c4b.jpeg",
                "organization": "HAMA MEA",
                "biography": "Amit Nayak is a seasoned Senior Asset Management Specialist with expertise in Property Development, Private Equity, and Family Office operations. Until recently, he served as Vice President of Asset Management at Dubai Holding, overseeing & supporting the strategic management of over 50 global properties. Currently, Amit is a member of the Hospitality Advisory Committee under the UAE Ministry of Economy, contributing to the growth and competitiveness of the UAE's tourism sector. His career began at One & Only Royal Mirage, and he holds advanced qualifications from Harvard and Cornell. Amit is also actively involved in mentoring and industry associations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Simon",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzMzMDQ1LFVzZXJfMTYzNzQ3MDEp",
                "jobTitle": "Vice President Asset Management Hospitality",
                "lastName": "Hasdell",
                "photoUrl": "https://static.swapcard.com/public/images/81a36f2c97104729adb15b0005e61e09.jpeg",
                "organization": "IFA Hotels & Resorts",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Workshop"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMjA4ODI4OA==",
        "titleTranslations": [
            {
                "value": "Welcome Back",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 09:15:00",
        "endsAt": "2024-10-02 09:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/C8Pq_ByBKHM\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Emma",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjkyNTY0LFVzZXJfMjA1MzQxODcp",
                "jobTitle": "Young Leader",
                "lastName": "Doherty",
                "photoUrl": "https://static.swapcard.com/public/images/df1773ecca2f4650bd973dc435ddef25.jpeg",
                "organization": null,
                "biography": "Emma Doherty, Co-Founder and CEO of PYRO, is a finalist in the Sustainable Hospitality Challenge. With 6 years of food and beverage experience, Emma has managed restaurants including Joe’s Seafood, Prime Steak & Stone Crab at Caesars Palace in Las Vegas and other prestigious establishments. She's currently pursuing a Master of Management in Hospitality from Cornell University and holds a Bachelor of Science in Hospitality Management from the University of Nevada, Las Vegas, where she graduated Magna Cum Laude. Emma also holds a Level 2 Award in Wines & Spirits with Distinction from the Wine & Spirits Education Trust.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjA4ODY0Nw==",
        "titleTranslations": [
            {
                "value": "Welcome Back",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 09:15:00",
        "endsAt": "2024-10-02 09:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/dwdgaX8pWUg\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Katrina",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjkyNTQzLFVzZXJfMjA1MzQxNzcp",
                "jobTitle": "Young Leader",
                "lastName": "Chin",
                "photoUrl": "https://static.swapcard.com/public/images/ef6893b85ae34c5dacfc56d8788e0eed.jpeg",
                "organization": null,
                "biography": "Hailing from the vibrant land of Jamaica, home to legends like Bob Marley and Usain Bolt, I’ve grown up with a passion for dreaming big. As an incoming President of the University of the West Indies Tourism Society and a second-year student, my journey in tourism has been marked by significant milestones, including becoming a finalist in the Sustainable Hospitality Challenge. My dedication to youth policy advocacy as a Youth Parliamentarian and Junior Counsellor, combined with my academic success—ranking third nationally in the Caribbean Advanced Proficiency Examination—reflects my commitment to leadership and excellence.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgwNw==",
        "titleTranslations": [
            {
                "value": "Back to Basics: Addressing Key Bottlenecks in Hospitality Innovation Before Advancing to Advanced Technologies",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 09:35:00",
        "endsAt": "2024-10-02 10:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/oYNH6OFh5-k\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Techology & AI"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Gavin",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNTY5MDA0LFVzZXJfMjA3MDc0NTMp",
                "jobTitle": "Regional Director",
                "lastName": "Weaver",
                "photoUrl": "https://static.swapcard.com/public/images/7c95a4ed367e40a4b33fe03dc3cc35bc.jpeg",
                "organization": "AtkinsRéalis",
                "biography": "Gavin has over 30 years’ experience as a contractor and consultant PM/QS in ten different countries and four continents. He has worked on prestigious projects throughout his career, with a specific focus on hotels, residential and mixed-use schemes. As well as iconic projects such as Burj Al Arab, Atlantis the Royal and Red Sea Project, Gavin has worked on over 30 hotels from economy to ultra luxury, from city to island.\nHe has gained an immense amount of cultural, contractual and construction procurement experience, managing at Director level in four of those countries. Gavin has also lectured part-time for a UK QS degree, matching his experience with insightful and clear presentation skills.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Tjalling van den",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTk5MTY4LFVzZXJfMTE2MDY4MDIp",
                "jobTitle": "Vice President Enterprise Sales",
                "lastName": "Burger",
                "photoUrl": "https://static.swapcard.com/public/images/462e480c06d3416682a24758e9143c71.jpeg",
                "organization": "Adyen",
                "biography": "As a self-proclaimed F&B “nerd”, Tjalling started his career working in (Michelin-starred) restaurants in The Netherlands before graduating with a BSc. Business Administration from Hotelschool The Hague.\n\nAfter having worked at HelloFresh in Amsterdam and finishing Apple’s leadership program in London he joined food waste technology startup Winnow in the UAE to lead their commercial activities in the MEA region.\n\nHe then moved on to become the General Manager for the UAE at Foodics, one of the leading food-tech startups in the region.\n\nCurrently, Tjalling holds the position of VP Enterprise Sales at Adyen, a global financial technology platform. At Adyen, Tjalling looks after the Entertainment and F&B verticals, helping businesses become more efficient and unlock unique guest experiences through payments.\n\nWith a passion for the F&B and technology industry, Tjalling is tasked with growing Adyen's footprint in the UAE and supporting restaurant owners and operators in their journey towards digital innovation.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Mohammed",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzIxMzcwLFVzZXJfMjA1NTM0ODUp",
                "jobTitle": "Board Member",
                "lastName": "Altajir",
                "photoUrl": "https://static.swapcard.com/public/images/7960c604c50a4cd18a40258fe87b7303.jpeg",
                "organization": "Tratok Holding",
                "biography": "Mohammed Altajir is a visionary disruptor and pioneer in the hospitality industry, renowned for over a decade of expertise in leveraging disruptive technology to transform user experiences. His innovative approach has enabled service providers to optimize operations while maximizing economic benefits for clients. Mohammed's passion for technology and commitment to excellence have positioned him as a sought-after speaker, sharing insights on the future of hospitality. With a track record of successful implementations and a keen understanding of market trends, he inspires audiences to embrace change and harness technology to elevate the guest experience.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Fritz",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE4OTc5LFVzZXJfMTU3NTczMjcp",
                "jobTitle": "Managing Director",
                "lastName": "Dickamp",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2036c6d15c0647e4ad00d055e433e9be.jpeg",
                "organization": "Studio 49",
                "biography": "Fritz Dickamp is the Managing Director of “Studio 49”, an award-winning online marketing agency for the hospitality industry, as well as the initiator and host of the podcast & edutainment platform “SMACK Hospitality”. SMACK tells the stories of the industry’s most well-known decision-makers in engaging conversations and other various formats.\n\nFritz has specialized in digital marketing with an enthusiastic approach to e-commerce and digitization of the hospitality and tourism sector after graduating from Ecole Hôtelière de Lausanne in 2013. Besides managing one of the leading online marketing agencies in hospitality in Europe, Fritz is engaged in advisory boards, lecturing at several European hospitality management schools and acts as a keynote speaker with previous records of speaking at TedX, hospitality conventions such as ITB, IHIF, WTM, ATM and tourism fares around the world. He is a member of the “Premium Speakers” network and regularly entertains audiences with his knowledgeable and fun presentations that create plenty of food for thought.\n\nHis favorite topics are such as:\n\n• Start-Up & Entrepreneurship in Hospitality & beyond\n\n• Digital Marketing & E-Commerce – how to win the game!\n\n• Hospitality Service – what other industries can learn from the hospitality world!\n\n• It's a question of attitude – and generation!\n\n• Tell me why! A journey through generations and what they expect online\n\n\nFritz Dickamp belongs to a generation of thought leaders in the hospitality industry that combines enthusiasm for the industry with an understanding of modern business models in the digital age.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0NA==",
                                    "title": "Welcome to the Data Talks",
                                    "beginsAt": "2024-04-29 13:30:00",
                                    "endsAt": "2024-04-29 13:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk1Nw==",
                                    "title": "Welcome to the Digital Talks",
                                    "beginsAt": "2024-04-30 09:00:00",
                                    "endsAt": "2024-04-30 09:05:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Techology & AI"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg3OQ==",
        "titleTranslations": [
            {
                "value": "Driving strategic decisions making for hotels through bespoke F&B data",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 09:35:00",
        "endsAt": "2024-10-02 09:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/WxW3cybtnM4\" target=\"_blank\">Click here to watch online.</a></p><br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Investment"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Gustavo De",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODUwMzE3LFVzZXJfMTU3NTcyOTMp",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Hostos",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/7f3d496d1fa84a62b29c020bff30bed5.jpeg",
                "organization": "Forsite Creative",
                "biography": "Gustavo is the Founder and Managing Partner of Forsite Creative. He has worked on approximately 200 projects across Europe, the Middle East, and Africa over the past 12 years of which 10 years in the region.\n\nWith a strategic mind, operational background, and an eye for design; he manages several in-house multi-disciplinary teams (including Research, Data Analytics, Concept Developers, Interior Designers, Branding and Kitchen Designers) for coordinated end-results.\n\nToday Gustavo and his team work together with leading restaurant groups, hotel groups, but also work with real estate developers and government initiatives.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1Ng==",
                                    "title": "GRIF Data Report - Using Data to Competition Proof your Business and Invest in the Right Places",
                                    "beginsAt": "2024-04-29 10:50:00",
                                    "endsAt": "2024-04-29 11:05:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Investment"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg4NA==",
        "titleTranslations": [
            {
                "value": "Unlocking F&B Success: Boosting Hotel Real Estate Value with Effective Third-Party Outlet Agreements",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 09:45:00",
        "endsAt": "2024-10-02 10:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/-_pvXqYRvis\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Investment"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Miguel",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjE2MDg5LFVzZXJfMTYwNzk0NzMp",
                "jobTitle": "Director of AI & Design",
                "lastName": "Chillerón",
                "photoUrl": "https://static.swapcard.com/public/images/b86b7662334f4231a3445b50d1e9426c.jpeg",
                "organization": "Livit Consulting & Design",
                "biography": "With over 15 years of expertise in architecture and a distinguished tenure exceeding seven years at Livit, Miguel serves as the Design Director and AI specialist. His leadership and creative vision have been pivotal in the design and development of various retail, entertainment, and F&B ventures on a global scale. Miguel's passion for innovation and technology drives him to integrate AI seamlessly into the process of conceptualizing and evolving F&B brands. Comfortable and inspiring on stage, he regularly shares his insights and experiences with audiences, offering valuable perspectives on design and technology.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sam",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNDE4MTQ5LFVzZXJfMTkwODMyNjYp",
                "jobTitle": "Global Chief Executive Officer",
                "lastName": "Bakhshandehpour",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/46a16339843641dfae39ca89faaf369d.jpeg",
                "organization": "José Andrés Group",
                "biography": "Sam Bakhshandehpour is the President and Board Member of José Andrés Group (JAG), a restaurant and media company. Driven by the mission of “Changing the world through the power of food,\" JAG's platform spans 38+ restaurants across 9 markets globally and multiple cuisines, including the 2-Michelin starred minibar by José Andrés, and numerous Michelin Bib Gourmand restaurants. Mr. Bakhshandehpour also runs José Andrés Media division (JAM) which produces food-related cultural content across scripted, unscripted - film and television, books (including The New York Times Best Seller Zaytinya), podcasts, and digital content. JAG also houses numerous global partnerships and a consumer products platform.\n\nThrough his hospitality investment platform, The Silverstone Companies, Mr. Bakhshandehpour has made numerous investments including The Electric Jane (membership community and live music lounge / restaurant), Cultivate Hospitality (F&B programming), Bazaar by José Andrés, and select other hotel, restaurant and lifestyle properties.\n\nNamed one of the “Most Important People in Hospitality” on the Observer’s 2023 Dining and Nightlife Power List, Mr. Bakhshandehpour previously served as President, Chief Executive Officer and Board Member of sbe Entertainment, a private-equity backed hotel, restaurant and nightlife company with over 80 properties globally.\n\nMr. Bakhshandehpour started his career on Wall Street with J.P. Morgan Securities running the Global Casino and West Coast Real Estate & Lodging Investment Banking practice focused on mergers & acquisitions and capital raising.\n\nMr. Bakhshandehpour holds a Bachelor of Science degree in Business Administration from Georgetown University’s McDonough School of Business. He serves on the board of Shift4 (NYSE: FOUR) and as a member of Fiserv Inc’s (NYSE: FI) Restaurant Advisory Board, including the Audit and Compensation Committees for both companies, as well as an Advisor for Bilt Technologies, Inc. Previously, Sam served on the boards of The New Home Company (NYSE: NWHM), including the Audit and Compensation Committees, and Georgetown University McDonough School of Business’ Board of Advisors as a Board Member and Capital Campaigns Committee Member. He is a trustee of Federal City Council (FC2), a founding member of the Georgetown Wall Street Alliance West, and a Senior Advisor to Montminy & Co., FINRA-registered (series 7, 24, 63). Mr. Bakhshandehpour is also an active member and former Chair of the Bel Air Chapter of the Young Presidents Organization.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ2NQ==",
                                    "title": "Case study: What is your North Star? Profit with Purpose - From Restaurants to Global Media Powerhouse & Force for Good, learning from The José Andrés Group’s transformation",
                                    "beginsAt": "2024-04-29 12:15:00",
                                    "endsAt": "2024-04-29 12:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Anil",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjkzMjU0LFVzZXJfMjM3NDMyMCk=",
                "jobTitle": "Director",
                "lastName": "Bhardwaj",
                "photoUrl": "https://static.swapcard.com/public/images/bc38b0de8a1741849b422b1cf80d5f48.jpeg",
                "organization": "The Arenco Group",
                "biography": "Anil Bhardwaj, a Chartered Accountant by profession, is a Director with A.A. AlMoosa Enterprises LLC, Dubai (The Arenco Group) for several years. The Group is a diversified conglomerate with interests in real estate, hotels, manufacturing, services and trade. As one of the largest landlords of Dubai, it has, inter alia, 21 hotel and hotel apartment ownerships, with the hotels being primarily managed by internationally renowned operators, and in-house, under the Golden Sands brand. The Group pioneered the hotel apartment concept in Dubai almost 37 years ago. Anil sits on the board of various group companies, including that which regularly interacts with the hotel operators and their management.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jennifer",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjc2NDU4LFVzZXJfMTgyMTg1NTEp",
                "jobTitle": "Co-Founder, Global Restaurant Investment Forum, Partner,",
                "lastName": "Pettinger",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f309f54478254e93bbb14b9f13313b8a.jpeg",
                "organization": "THINK Hospitality",
                "biography": "Jennifer has built a career on fostering meaningful hospitality industry connections\nacross the globe providing her with a unique international perspective on the F&B and\nhotel investment landscapes and its key players.\nHaving called Dubai home for the past 15 years, Jennifer has become an integral part of\nthe local and international hospitality community. She is a Partner at Think Hospitality,\nwhere she helps accelerate restaurant brand growth and maximizes F&B opportunities\nfor investors, retailers, hoteliers, and property developers.\nJennifer is also the owner and driving force behind the Global Restaurant Investment\nForum, a series of events and an international community focused on facilitating\nknowledge, connections, and growth for the industry’s leaders. In addition, she serves\nas a strategic advisor to The Bench, where she was previously Managing Director for the\nMiddle East leading their business in the region.\nAdditionally, she is an advisor to the UAE Restaurants Group Board, reflecting her\ncommitment to supporting the industry she loves.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkxMQ==",
                                    "title": "Global Restaurant Investment Forum - Welcome",
                                    "beginsAt": "2024-04-29 09:00:00",
                                    "endsAt": "2024-04-29 09:10:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNQ==",
                                    "title": "Case Study: Continuing the Conversation - Real Facts, Figures and Take Aways that Prove Sustainability can be a Commercial Success",
                                    "beginsAt": "2024-04-30 10:00:00",
                                    "endsAt": "2024-04-30 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OA==",
                                    "title": "Bringing Riyadh’s culinary heritage back to life",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Rizwan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMDI4Njc4LFVzZXJfMTU5NTQ0Mjcp",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Kassim",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bfd98485cb0646bfba84fdb2f7c29cfd.jpeg",
                "organization": "RIKAS Hospitality Group",
                "biography": "Rizwan Kassim is a testament to the UAE's spirit of entrepreneurship. Having started with the long-established La Cantine du Faubourg in Paris over ten years ago, the young Parisian saw a vision for the brand in Dubai and has since gone on to create the RIKAS Group, which is now one of the leading creators and operators in the Middle East dining scene.\n\nIn just nine years, he has opened a staggering 16 restaurant and Beach Club concepts in Dubai and have a total of 19 operations at the moment, many of which are now gracing the pages of the inaugural Michelin Guide and Gault Millau. With expansion underway to countries including Saudi Arabia, Greece, Europe, US and India, the ambitious young entrepreneur is no stopping as he takes the RIKAS Group - home to top-name dining destinations.\n\nAside from the 16 concepts, five more are under development which will hit the UAE market in 2024.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                                    "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                                    "beginsAt": "2024-04-30 16:10:00",
                                    "endsAt": "2024-04-30 16:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Investment"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjA3MTcyMQ==",
        "titleTranslations": [
            {
                "value": "Iconic Developments: Navigating the Next Wave of Urban Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 09:50:00",
        "endsAt": "2024-10-02 10:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/9ME3VS72N54\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Michael",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTI0MDIwLFVzZXJfMjA5MjU4MDgp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Dyke",
                "photoUrl": "https://static.swapcard.com/public/images/505a6f5795b04e1e992f654406deb3db.jpeg",
                "organization": "New Murabba Development Company",
                "biography": "Michael Dyke is the Chief Executive Officer of New Murabba Development Company, a wholly-owned subsidiary of Saudi Arabia’s Public Investment Fund.\nNew Murabba has been designed to significantly contribute to Riyadh’s future development and its transformation into a global, modern metropolis.\nMichael brings over 37 years of experience leading large-scale business enterprises and projects across multiple sectors and geographies. \nMichael's breadth of experience encompasses diverse sectors, where he has consistently delivered complex projects that shape infrastructure, energy, construction and real estate landscapes.\nHis previous role was CEO for Major Projects at Balfour Beatty.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0MjI4LFVzZXJfMTU3NTcyNzUp",
                "jobTitle": "Presenter",
                "lastName": "Sackur",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
                "organization": "HARDTalk",
                "biography": "Stephen Sackur is presenter of HARDtalk, the current affairs interview on BBC World and the News Channel. His subjects have included the heads of NATO and OPEC, Shimon Peres, Gore Vidal and Richard Dawkins.\n\nFor HARDtalk he has also interviewed a number of the world’s great names, including Bill Clinton, George W Bush, Mikhail Gorbachev and Hugo Chavez. Distilling his notes for a series of articles, Stephen identiﬁed the ﬁve qualities they all seemed to share: an indestructible will, passion (almost beyond reason), outrageous optimism, a super-sized ego and a ‘rebel yell.’\n\nThese interviews have also given him an insight into how organisations can best bring about innovation: “You need to ﬁnd ways to assess individuals on their merits, and give rewards for innovative thinking rather than play-it-safe mediocrity. You should encourage insiders to get outside and bring back fresh insights. And you shouldn’t confuse seniority with creativity.”\n\nAway from set-piece interviews Stephen has served in Brussels, reporting on day-to-day stories from the major European institutions and across the continent. Before that he was Washington Correspondent, where his coverage and analysis of 9/11 won widespread acclaim.\n\nTen years earlier it was Stephen who broke the story of the mass killing on the Basra road out of Kuwait, marking the end of the Gulf War. He was then posted to Cairo and Jerusalem as Middle East Correspondent, where he reported on the emergence of the Palestinian Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjA3MzU5MQ==",
        "titleTranslations": [
            {
                "value": "The Rise of Luxury Hospitality: Trends and Differentiators Shaping the Future of High-End Tourism",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 10:05:00",
        "endsAt": "2024-10-02 10:40:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nicholas",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjMwMzYxLFVzZXJfMTY0Njg0ODQp",
                "jobTitle": "Partner",
                "lastName": "Nahas",
                "photoUrl": "https://static.swapcard.com/public/images/0e7bf6a861424a608302179b6d96dea6.jpeg",
                "organization": "Arthur D. Little",
                "biography": "Nicholas Nahas is a Partner with Arthur D. Little and leader of the firm’s Global Hospitality and Tourism Competence Center.  Nahas brings over 15+ years of management consulting experience working with clients in hospitality, tourism, real estate, infrastructure, leisure, entertainment, and sports on projects related to strategy and innovation.\nAs the firm’s Global Hospitality and Tourism Competence Center lead, Nahas supports the coordination and knowledge sharing of the firm’s global experience in hospitality and tourism from ADL’s 138+ years of experience in management consulting.  Moreover, he is a leader in Arthur D. Little’s Middle East’s Travel & Transport practice, playing a critical role in leading projects, team building, and building partnerships with clients and senior experts.  \nNahas’s project experience spans the United States, Europe, and the GCC.  Since moving to Abu Dhabi in 2015, Nahas has led a range of tourism and hospitality projects across the GCC region, from developing tourism strategies at national and regional levels to overseeing the design of a new luxury hospitality brand to developing innovation strategies for real estate development companies.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Mark",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTM1MjgxLFVzZXJfNDI4MTcxMik=",
                "jobTitle": "Chief Operating Officer - Head of Hospitality",
                "lastName": "Kirby",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/92712602ac7047da9f4ff961583cb932.jpeg",
                "organization": "Emaar Hospitality Group",
                "biography": "•A veteran hospitality professional with over two decades of international experience.\n\n•In 2007, Mark moved to Dubai joining two of Dubai’s most respected hotels – Grosvenor House Dubai and Le Royal Meridien Beach Resort & Spa, before joining Emaar Hospitality Group in 2014 as Hotel Manager of Armani Hotel Dubai. He was subsequently promoted to General Manager.\n\n•Under his leadership, Armani Hotel Dubai achieved several global recognitions including 27 service-related accolades in 2018.\n\n•Mark has also managed the iconic flagship hotel, Address Downtown, as well as other Emaar Downtown Hotels such as Address Fountain Views, Address Sky Views, Palace Downtown and Vida Residences.\n\n•Mark was promoted to his current role as Head of Hospitality in January 2021.\n\n•Holds a BA (Hons) in Hospitality Management from the University of Central England in Birmingham, UK. Mark worked at some of London’s most prestigious hotels where he spent 15 years developing his experience and career. And attended several professional development programmes.\n\n•Actively involved in charity work and fundraising through his love for endurance sports, including marathon running. Mark is also the President of Dubai Lankans Rugby Sports Club, an avid diver, and is actively involved in developing young talent in the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Gregory",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNjE2MjE2LFVzZXJfNTk4NjAxMyk=",
                "jobTitle": "CEO Global Development Construction Property",
                "lastName": "Lanter",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bd21592bd99c45d3afe4fb5b2ccc5f1c.jpeg",
                "organization": "Club Med - All-Inclusive Beach and Mountain Resorts",
                "biography": "Gregory Lanter graduated from the Paris HEC Business School. He joined Club Med Group and its development teams in 2004, especially in charge of Africa and Middle East. He was appointed Vice President Global Development in 2009, which was later extended to Construction matters. His teams are positioned in Miami, Paris, Singapore and Shanghai. He is a member of the Group Executive Board.\n\nThe Development Construction and Property team is a strong contributor to the success of Club Med’s strategy, aiming at being the most desirable holiday lifestyle brand.\n\nClub Med is settled on almost 70 of the most extra-ordinary sites on Earth, where Club Med was most of the time the first ever international resort operator (Cancun, Punta Cana, Maldives, Mauritius, Bali…). Its development has strongly accelerated, with projects over 4 continents, with a very specific focus on contributing to sustainable tourism, specifically by promoting sustainable certifications in construction.\n\nClub Med offers a unique combination of an expert premium resort manager (over 60 years of experience) and a unique Tour Operating company, recognized and directly physically distributed in 35 different markets in the world.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk5MA==",
                                    "title": "Splashes of Success: Saudi Arabia's Thriving Leisure Landscape for the Changing Demographics",
                                    "beginsAt": "2024-04-30 17:10:00",
                                    "endsAt": "2024-04-30 17:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Agnès",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyODIyNzkyLFVzZXJfMTYzMjM4KQ==",
                "jobTitle": "Global Chief Development Officer Luxury & Lifestyle",
                "lastName": "Roquefort",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b11bfb415f7942958d0cd947ffd68b3c.jpeg",
                "organization": "Accor",
                "biography": "Agnès Roquefort holds a MBA from ESSEC Business School in Paris, with a specialty in Corporate Finance.\n\nAgnès is a seasoned professional with more than 15 years’ experience in hospitality, travel and tourism with different positions in Strategy, Business Development, M&A, Marketing, Digital, Revenue Management and Data. On top of these expertises, Agnès is an enthusiastic team leader with a strong dedication to talent development.\n\nAgnès started her career in the Private Equity Fund Turenne Capital. In 2002, she joined Bain & Company, the major strategic consulting firm where she mainly worked on due diligence projects for multiple industries. From 2004 to 2010, she pursued strategic consulting at Advancy as Principal, working on strategic projects mainly in the Tourism, Travel, F&B and Hospitality sectors. \n\nAgnès joined Accor in 2010 and was successively Chief of Staff for the Global COO, Global Head of Revenue Management & Pricing, Global Head of MGallery and SVP Digital Strategy, Integrations & Data and Group Chief Development Officer.\n\nIn January 2023, Agnès joined Accor’s Luxury & Lifestyle Executive Committee, as the division’s Chief Development Officer.\n\nAgnès is the mother of 2 daughters , and is a strong advocate of gender equality at work. She contributes to RiiSE, the Accor diversity network and pays a particular attention to   talents’ mentoring.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                                    "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                                    "beginsAt": "2024-04-30 14:55:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Amir",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzc4NzkzLFVzZXJfMTU3NjE3NTAp",
                "jobTitle": "Senior Vice President - Middle East, Africa & India",
                "lastName": "Golbarg",
                "photoUrl": "https://static.swapcard.com/public/images/64fe1d3671004a90af6c98e5cf255640.jpeg",
                "organization": "Minor Hotels",
                "biography": "Amir first joined Minor Hotels in 2012 as Director of Operations & Hotel Openings based in the Bangkok corporate office. He then furthered his career with Minor Hotels with several international postings and became Hotel Manager at Souq Waqif Hotel Doha, Qatar in 2015. Amir then moved to Al Rayyan Hospitality and Katara Hospitality where he held the strategic position of Chief Operating Officer and Corporate Director in Qatar.\n\nSince Amir joined Minor Hotels back in March 2019 as Vice President Operations - Middle East, his proactive and strategic leadership focused on improving processes and growing our footprint has proven successful in operational efficiency and addition of numerous new hotels despite the global pandemic. In September 2021, he was promoted to Senior Vice President Operations, Middle East & Africa to continue overseeing the Middle East region as well as manage all operations and the company’s performance in Africa.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg4Mg==",
        "titleTranslations": [
            {
                "value": "The World's First AI-Created Restaurant Revealed",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 10:20:00",
        "endsAt": "2024-10-02 10:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/wSCkbQUnKiE\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Investment"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "James",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTM4ODA4LFVzZXJfMTYyNTA1MDkp",
                "jobTitle": "Founding Partner",
                "lastName": "Hacon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
                "organization": "Think Hospitality",
                "biography": "James is one of the leading names in hospitality growth, marketing & brand strategy, he has been an executive, board member, Attendees and consultant in the hospitality brand and technology sector for the past twenty years, having worked with more than 80 hospitality brands in 22 countries, from independent Michelin starred restaurants to leading restaurant brands, international hotel companies & contract caterers. \n\nHis brand experience includes Accor, IHG, Sodexo, Compass Group, Krispy Kreme, Costa Coffee, Diageo, AMREST, Jamie Oliver Group, Wagamama, Gleneagles & Pret. \n\nHe is regularly called upon as a commentator, writer, speaker & facilitator, giving him a unique insight into global trends and the very best brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                                    "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                                    "beginsAt": "2024-04-30 09:45:00",
                                    "endsAt": "2024-04-30 10:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                                    "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                                    "beginsAt": "2024-04-30 15:10:00",
                                    "endsAt": "2024-04-30 15:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Investment"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTQxOA==",
        "titleTranslations": [
            {
                "value": "Cyber Resilience in Hospitality: Future-proofing your Data",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 10:20:00",
        "endsAt": "2024-10-02 10:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/gcSSCf92Wrg\" target=\"_blank\">Click here to watch online.</a></p><br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Techology & AI"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Shamsh",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTUyODM4LFVzZXJfMzUzOTM1OSk=",
                "jobTitle": "Founder & CEO",
                "lastName": "Hadi",
                "photoUrl": "https://static.swapcard.com/public/images/6540f5750dfe498d9c52e6d65cdf58ab.jpeg",
                "organization": "ZorroSign",
                "biography": "Shamsh Hadi is a distinguished innovator in data privacy and security. As the founder and CEO of ZorroSign, he has driven the development of revolutionary solutions built on blockchain, providing unparalleled security, privacy, and transparency. A global citizen, Shamsh’s academic and professional journey has spanned geographies worldwide. As a member of the rigorous Harvard Presidents’ Program, he believes in lifelong learning. A seasoned professional and a recipient of numerous awards, his passion for technological innovation makes him a leading voice in an ever-evolving industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Fritz",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE4OTc5LFVzZXJfMTU3NTczMjcp",
                "jobTitle": "Managing Director",
                "lastName": "Dickamp",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2036c6d15c0647e4ad00d055e433e9be.jpeg",
                "organization": "Studio 49",
                "biography": "Fritz Dickamp is the Managing Director of “Studio 49”, an award-winning online marketing agency for the hospitality industry, as well as the initiator and host of the podcast & edutainment platform “SMACK Hospitality”. SMACK tells the stories of the industry’s most well-known decision-makers in engaging conversations and other various formats.\n\nFritz has specialized in digital marketing with an enthusiastic approach to e-commerce and digitization of the hospitality and tourism sector after graduating from Ecole Hôtelière de Lausanne in 2013. Besides managing one of the leading online marketing agencies in hospitality in Europe, Fritz is engaged in advisory boards, lecturing at several European hospitality management schools and acts as a keynote speaker with previous records of speaking at TedX, hospitality conventions such as ITB, IHIF, WTM, ATM and tourism fares around the world. He is a member of the “Premium Speakers” network and regularly entertains audiences with his knowledgeable and fun presentations that create plenty of food for thought.\n\nHis favorite topics are such as:\n\n• Start-Up & Entrepreneurship in Hospitality & beyond\n\n• Digital Marketing & E-Commerce – how to win the game!\n\n• Hospitality Service – what other industries can learn from the hospitality world!\n\n• It's a question of attitude – and generation!\n\n• Tell me why! A journey through generations and what they expect online\n\n\nFritz Dickamp belongs to a generation of thought leaders in the hospitality industry that combines enthusiasm for the industry with an understanding of modern business models in the digital age.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0NA==",
                                    "title": "Welcome to the Data Talks",
                                    "beginsAt": "2024-04-29 13:30:00",
                                    "endsAt": "2024-04-29 13:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk1Nw==",
                                    "title": "Welcome to the Digital Talks",
                                    "beginsAt": "2024-04-30 09:00:00",
                                    "endsAt": "2024-04-30 09:05:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Techology & AI"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjA0NDk4Nw==",
        "titleTranslations": [
            {
                "value": "The New USALI 12th Edition: What To Expect",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 10:30:00",
        "endsAt": "2024-10-02 11:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/pGrFfvhPYeU\" target=\"_blank\">Click here to watch online.</a></p><br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Giuliano",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODk5MTc0LFVzZXJfMTI2MzY3MzQp",
                "jobTitle": "Head of Hospitality Asset Management",
                "lastName": "Gasparini, FRICS, CRE, HAMA, IoH, CHIA",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1185b82f30fb4c59b01dd92aafdcf851.jpeg",
                "organization": "WASL Group",
                "biography": "Giuliano Gasparini is Head of Hospitality Asset Management at wasl / Dubai Real Estate Corporation being directly involved in the asset management of the hotel and leisure portfolio of the firm. Prior to that he covered several executive positions in the hospitality asset management teams of leading Middle Eastern developers (Associate Director of Hospitality Asset Management for Aldar Properties PJSC) and in specialized consulting firms having been Head of Consulting at PKF in Dubai, Senior Vice-President of JLL Hotels in Madrid and Senior Associate at HVS in Madrid amongst others. \nGiuliano Gasparini is one of the board members of HAMA MEA (Hotel Asset Managers Association) and a full-time professor at both Paris Sorbonne Abu Dhabi and IE Business School in Madrid. He holds affiliation at the Royal Institution of Chartered Surveyors (FRICS), Counsellor of Real Estate (CRE©) and Institute of Hospitality (FIH).\nGiuliano graduated in Economics at Bocconi University in Italy and hold two master degrees: in Urban Economics (by Erasmus University Rotterdam in the Nederland’s) and in Tourism Economics (by Bocconi University in Italy). He also completed a post-graduate certificate on Hotel Asset Management from Cornell University (USA).",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkzMg==",
                                    "title": "USALI 11th Edition – Tips and Tricks",
                                    "beginsAt": "2024-04-29 11:30:00",
                                    "endsAt": "2024-04-29 13:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Workshop"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTU2NQ==",
        "titleTranslations": [
            {
                "value": "Signings & Announcements",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 10:30:00",
        "endsAt": "2024-10-02 11:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 3
    },
    {
        "id": "UGxhbm5pbmdfMjA4ODY3OQ==",
        "titleTranslations": [
            {
                "value": "From Search to Stay: Enhancing Booking Tech for a Seamless Guest Journey",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 10:35:00",
        "endsAt": "2024-10-02 11:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/TBZjFoPjckQ\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Techology & AI"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Tariq",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjkyMDI2LFVzZXJfMTE5NDAyNSk=",
                "jobTitle": "Senior Vice President - Global Support Services",
                "lastName": "Valani",
                "photoUrl": "https://static.swapcard.com/public/images/836b0380358548d783d78e501cd084c3.jpeg",
                "organization": "Accor",
                "biography": "With over 20 years of experience, Tariq is currently a Senior Vice President at Accor, where he leads the Global Support Services team that provides technology, sales, distribution, and loyalty support for over 5,400 hotels across 43 brands in 117 countries. \n\nThroughout his career, Tariq has successfully led and delivered multiple large-scale and complex projects, such as building the global support services framework for Accor, integrating M&A brands, and transforming digital platforms. \n\nHe also contributes to the industry's advancement by serving as a member of the Hospitality Financial and Technology Professionals (HFTP) Board of Directors.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Gemma",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODk5MTgzLFVzZXJfMjMxNzIzNyk=",
                "jobTitle": "Director",
                "lastName": "Greenwood",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/28f93f5e7809429484223268fc818522.jpeg",
                "organization": "Content Inc",
                "biography": "Gemma Greenwood has more than 20 years’ experience as a journalist, editor and corporate and crisis communications consultant in the UK, Middle East and Asia. She is also an accomplished moderator, having organised and presented the Arabian Travel Market (ATM) conference programme since 2010, both live and online.\n\nOver the past 11 years, Gemma has moderated several high-profile sessions featuring major industry leaders at ATM and WTM London and launched ATM’s successful summits on hospitality, halal tourism and Saudi Arabia. She has also moderated conferences for hospitality industry giants such as InterContinental Hotels Group (IHG).\nAs an editor, she has personally overseen the launch of and managed several landmark business titles including Hotelier Middle East, Hotel News Middle East, Arabian Travel News, the highly regarded Arabian Travel Market (ATM) Yearbook series and more recently, the first World Travel Market (WTM) London annual to celebrate the event’s 40th anniversary in 2019, with a second edition to follow in 2022.\nGemma is also currently editor of Motivate Publishing title, Business Traveller Middle East and not only writes and edits the publication but plays a key role in executing the highly regarded BTME awards programme, as well as presenting webinar content for key clients.\nAs Director of Content Incorporated, she supports major hotel, tourism, hospitality and real estate companies with a wide range of corporate communications and editorial services, from content and PR to media and crisis communications training. \n\nHer clients include Dubai Tourism, the Abu Dhabi government, Ras Al Khaimah Tourism Development Authority (RAKTDA), IHG, Accor, Rotana, The First Group, Atlantis The Palm, as well as travel and hospitality industry start-ups.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Fouad",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNzk0MzY3LFVzZXJfMjAyMjg5MzEp",
                "jobTitle": "Regional Manager Middle East & Africa",
                "lastName": "Talaat",
                "photoUrl": "https://static.swapcard.com/public/images/08008a8ab5a8401a8a4aed9cc5a7be31.jpeg",
                "organization": "Booking.com",
                "biography": "As the Regional Manager for the Middle East and Africa, Fouad leads the Regional Commercial Team's mission to create a robust relationship with accommodation partners and stakeholders within the travel ecosystem. With an extensive background spanning 18 years in the travel and hospitality industry, including the past 12 years with Booking.com, Fouad brings a wealth of expertise.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Piergiorgio",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTM4NjQ5LFVzZXJfMjAzMDgxOTMp",
                "jobTitle": "Executive Vice President",
                "lastName": "Schirru",
                "photoUrl": "https://static.swapcard.com/public/images/a06d22a0a9b1476eb024ee304c8ac0e1.jpeg",
                "organization": "Blastness",
                "biography": "Piergiorgio Schirru is the Executive Vice President of Blastness, a leading Italian Travel Tech company focused in increasing direct bookings and hotel revenues. In his role, Piergiorgio is responsible for all aspects of Blastness' operations and leads the company's research and development projects, with an emphasis on the evolution of its software and platform solutions.\n\nWith a degree in Economics, a Master's in Big Data, and an MBA, Piergiorgio's professional journey includes extensive experience in Airline Revenue Management acquired during his tenure at Alitalia/Skyteam. Over the past 20 years, he has cultivated extensive knowledge of the hospitality industry, with a focus on boosting revenue and direct bookings. He is skilled in developing automated processes to collect data, analyse them, and transform them into actionable strategies. \n\nPiergiorgio is a technology enthusiast, an avid user of Excel and PowerBI, and a strong advocate of Artificial Intelligence and data-driven solutions. He also shares his expertise and enthusiasm as a Professor of Revenue Management and Digital Marketing at the prestigious Luiss Business School.\n\nRecognized as one of Italy's foremost experts in revenue management, he demonstrates an exceptional aptitude for leveraging new technologies and converting them into pioneering business solutions.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Techology & AI"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAzNTg1Mw==",
        "titleTranslations": [
            {
                "value": "FHS Awards 2024",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 10:40:00",
        "endsAt": "2024-10-02 11:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><strong>FHS Lifetime Achievement Award - Winner Presentation & Award Giving:</strong> Selim El Zyr, Vice Chairman and Co-Founder, Rotana</p><p><strong>FHS Leadership Award (in partnership with Hospitality News Middle East) - Winner Presentation & Award Giving:</strong> Rizwan Kassim, Founder & Managing Partner, RIKAS Hospitality Group</p><p><strong>Future Leader Award (in partnership with EHL Hospitality Business School) - Winner Presentation & Award Giving:</strong> Errikos Christodoulou, Hotel Operations Manager, MarBella Collection</p><p><a href=\"https://youtu.be/7WY6g_way-s\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE5Mjg0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/17a7878fe072462dbdfaa73230f5d186.jpeg",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Selim",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMDI3NjU4LFVzZXJfMjA5ODc0NTYp",
                "jobTitle": "Vice Chairman and Co-Founder",
                "lastName": "El Zyr",
                "photoUrl": "https://static.swapcard.com/public/images/58ac505ed69149eeb238a070969bb41a.jpeg",
                "organization": "Rotana",
                "biography": "Selim El Zyr is the Vice Chairman of Rotana Hotel Management Group (Rotana). In 1992, El Zyr co-founded Rotana, the first Middle Eastern hotel management company, and served as its President and CEO until December 2013. \nAs Vice Chairman, El Zyr looks after the company’s strategic development and is part of the Executive Committee. His ambitious managerial direction is credited with building Rotana’s extensive portfolio of over 100 hotels across the Middle East, Africa, Eastern Europe, and Türkiye.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Rizwan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMDI4Njc4LFVzZXJfMTU5NTQ0Mjcp",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Kassim",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bfd98485cb0646bfba84fdb2f7c29cfd.jpeg",
                "organization": "RIKAS Hospitality Group",
                "biography": "Rizwan Kassim is a testament to the UAE's spirit of entrepreneurship. Having started with the long-established La Cantine du Faubourg in Paris over ten years ago, the young Parisian saw a vision for the brand in Dubai and has since gone on to create the RIKAS Group, which is now one of the leading creators and operators in the Middle East dining scene.\n\nIn just nine years, he has opened a staggering 16 restaurant and Beach Club concepts in Dubai and have a total of 19 operations at the moment, many of which are now gracing the pages of the inaugural Michelin Guide and Gault Millau. With expansion underway to countries including Saudi Arabia, Greece, Europe, US and India, the ambitious young entrepreneur is no stopping as he takes the RIKAS Group - home to top-name dining destinations.\n\nAside from the 16 concepts, five more are under development which will hit the UAE market in 2024.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                                    "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                                    "beginsAt": "2024-04-30 16:10:00",
                                    "endsAt": "2024-04-30 16:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Errikos",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTkwNTM3LFVzZXJfMjEwNzg1NjEp",
                "jobTitle": "Hotel Operations Manager",
                "lastName": "Christodoulou",
                "photoUrl": "https://static.swapcard.com/public/images/16c7a7e85656472399326fde022e1935.jpeg",
                "organization": "MarBella Collection",
                "biography": "Errikos Christodoulou is a highly experienced Hotel Operations Manager with over 14 years in the hospitality industry. Educated in Switzerland, he holds a Bachelor of Arts in Hotel Management from BHMS, Lucerne. His expertise in strategic planning, team leadership, and service innovation has significantly enhanced guest experiences across multiple luxury properties. Currently leading operations at MarBella, Corfu, he manages a diverse team of 350 employees and oversees a 362-room hotel with 12 F&B outlets. During his tenure, he has been instrumental in redesigning the hotel's F&B product, launching new dining concepts, and implementing cutting-edge operational systems.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzcyOA==",
        "titleTranslations": [
            {
                "value": "Coffee Break",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 11:00:00",
        "endsAt": "2024-10-02 11:20:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg4MQ==",
        "titleTranslations": [
            {
                "value": "Beyond the Plate: Culinary Experiences as a Pillar of Destination Tourism",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 11:00:00",
        "endsAt": "2024-10-02 11:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/MxnUQKdUviE\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Investment"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Neha",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzAwMjAyLFVzZXJfMjExNTAyNDQp",
                "jobTitle": "Founder",
                "lastName": "Mishra",
                "photoUrl": "https://static.swapcard.com/public/images/627664087f0145a6adb612f1ccb33dfe.jpeg",
                "organization": "Kinoya Restaurant Dubai - Michelin Bib Gourmand",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sahar Parham Al",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzAwMDA1LFVzZXJfOTQxNjMwMyk=",
                "jobTitle": "Pastry Chef",
                "lastName": "Awadhi",
                "photoUrl": "https://static.swapcard.com/public/images/19742ce33e094e79ab3ed975811d4773.jpeg",
                "organization": "",
                "biography": "After graduating from high school, Sahar studied Communications & Design Management at the American University of Sharjah which was followed by a role in Marketing & PR at Zayed University. \n\nChef Sahar started her culinary career at La Serre Bistro & Boulangerie in 2014. Her ability and hard work was recognized and rewarded when her head chef, Chef Izu Ani, sent her to Paris to perfect the art of bread making from his own mentor.\n\nChef Sahar Parham Al Awadhi joined the Pastry Kitchen at Burj Al Arab in 2016, and in doing so became the first Emirati Chef to work at the iconic hotel. In 2019, she took at the helm of the kitchen as the Head Pastry Chef where she managed and worked alongside a team of 34 pastry chefs in a kitchen that operates 24 hours a day. She is an advocate of sustainability, sourcing locally, and loves creating experiences through her creations.\n\nOver the course of her career, Chef Sahar has had the honor to cook with respected chefs in the industry including Pierre Gaigner, Niko Romito, Frederic Bau, Himanshu Saini creating harmonious and memorable menus together.\n\nIn 2022, Chef Sahar was awarded the Best Pastry Chef in the Middle East and North Africa at the inaugural World’s 50 Best Award MENA Ceremony held in Abu Dhabi and led the pre-opening team of Laduree Gordes in the south of France. She is currently the chef consultant of the much-anticipated restaurant Gerbou, opening in 2024.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Panchali",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjAxNTg0LFVzZXJfMTczOTA1MTMp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Mahendra",
                "photoUrl": "https://static.swapcard.com/public/images/83256e8bc5924829b3ceea5eaa24a983.jpeg",
                "organization": "Atelier House Hospitality",
                "biography": "Panchali Mahendra, recognized by Forbes Middle East as one of the “Leaders Behind Luxury Dining in the Middle East,” is the CEO of Atelier House Hospitality. Under her leadership, brands such as 11 Woodfire have achieved prestigious accolades, including a Michelin star and ranking #14 on MENA’s 50 Best list. With over two decades in the industry, Panchali has developed 80+ global restaurant concepts. She was named Restaurateur of the Year by Caterer Middle East in 2023, and is a strong advocate for women’s empowerment, being the first woman in hospitality to receive the UAE Golden Visa.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Seymone",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjIxMDMxLFVzZXJfODE5OTYyMyk=",
                "jobTitle": "Editor In Chief",
                "lastName": "Moodley",
                "photoUrl": "https://static.swapcard.com/public/images/6ce9b17453ef46528b9a82c8404c0524.jpeg",
                "organization": "Hotel & Catering News Middle East",
                "biography": "Seymone Moodley is a journalist, strategist, speaker and guest lecturer on the subjects of content. Before her current role as the Editor in Chief of Hotel & Catering magazine in Dubai, she worked for years as a South African journalist at the BBC, CNBC Africa, Forbes Africa, and Forbes Woman Africa magazine.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Investment"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTQxOQ==",
        "titleTranslations": [
            {
                "value": "Serviced Residences Reimagined:  A New Era of Accommodation",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 11:20:00",
        "endsAt": "2024-10-02 11:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/xmv8oMJQG-Y\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Serena",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMzkzOTIxLFVzZXJfMTQxNjU3Njgp",
                "jobTitle": "Chief Growth Officer",
                "lastName": "Lim",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/001a18f724f34456972674b28bbe07a1.jpeg",
                "organization": "The Ascott Limited",
                "biography": "Serena is Chief Growth Officer at The Ascott Limited (Ascott), leading its global business development team to steer and manage the company’s growth in management and franchise contracts globally . Supporting the group’s development ambitions through an asset light strategy to deliver strong recurring fee income, Serena and her team drives continued opportunities to extend Ascott’s geographic reach across key growth markets.\n\nShe joined Ascott in January 2023 and brings over two decades of experience in hotel development, strategic planning and feasibility.\n\nMost recently in the role of Vice President, Development, Southeast Asia and Korea at the InterContinental Hotels Group (IHG), Serena was responsible for leading IHG’s development strategy and extended growth teams in the region. Serena played an integral role in implementing initiatives to align culture with strategy and processes as a key member of the leadership team. \n\nPrior to joining IHG, Serena was responsible for development efforts in Southeast Asia at Marriott International, where she held the role of Regional Vice President. She spent early parts of her career with Starwood Hotels and Resorts, where she led the company’s expansion across Southeast Asia, while overseeing feasibility and strategic planning efforts in Asia Pacific. \n\nSerena graduated on the Dean’s List with a Bachelor of Science (Distinction) in Hotel Administration and Major in Finance at Cornell University, School of Hotel Administration.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Global Investments"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzU1MA==",
        "titleTranslations": [
            {
                "value": "RevoluationAIsing Tourism",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 11:30:00",
        "endsAt": "2024-10-02 11:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/lwLuGJdz4b4\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Techology & AI"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0ODk4Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "intelligence-talks",
                "translations": [
                    {
                        "value": "Intelligence Talks"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Naiara",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMDQyMzQwLFVzZXJfMTYzMjk4Mjgp",
                "jobTitle": "Tourism Advisory Lead",
                "lastName": "Lopez Giner",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c06a42b2a6874de0bb036958e605041b.jpeg",
                "organization": "Colliers MENA",
                "biography": "Naiara has lead and collaborate in the development of +10 destination strategies at national and regional level, across 4 continents, with a stronger presence in the Middle East, prior to joining Colliers.\nShe has worked in destination management and strategy development, destination marketing and promotion, tourism investment, and product development, making her a multidisciplinary tourism professional.\nNaiara has a deep understanding of the tourism ecosystem, as well as the impact of different initiatives on it. \nShe brings to Colliers team this specific and holistic tourism knowledge and expertise.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Techology & AI",
            "Intelligence Talks"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzcyNw==",
        "titleTranslations": [
            {
                "value": "Capitalizing on the Alternative Accommodation Boom: Unveiling Realities and Global Trends",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 11:30:00",
        "endsAt": "2024-10-02 11:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/JV5gTveP6Tw\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-and-urban-development",
                "translations": [
                    {
                        "value": "Projects & Destinations"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Amit",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDIzNDgwLFVzZXJfMjA2MTQyODgp",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Arora",
                "photoUrl": "https://static.swapcard.com/public/images/cb22de0ff76c48e080aa1ad8b770b936.jpeg",
                "organization": "Arada",
                "biography": "Amit Arora leads Arada’s new Hospitality and Entertainment division, spanning wellness, hospitality, F&B, events, and non-residential ventures. As CSMO at Emaar Hospitality Group, Amit spearheaded the development and launch of The Address Hotels and Resorts, Armani Hotels and Resorts, and Vida Hotels. He was instrumental in bringing École Ducasse to Abu Dhabi, as well as establishing FIVE Holding’s hotel division as CEO, Hospitality. While COO of Erth Abu Dhabi, he led strategic direction for Hotels, Recreation Clubs, Catering, Hospitality, and Restaurants. Amit’s distinguished 30-year career includes The Ritz-Carlton, where he managed assets in Boston, Berlin, Dubai, and Ras Al Khaimah.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Adeline",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODUwOTkwLFVzZXJfMTY5ODc4MTAp",
                "jobTitle": "Managing Lyf Partner",
                "lastName": "Phua",
                "photoUrl": "https://static.swapcard.com/public/images/dade4e07b5e3468986d2892903f86f84.jpeg",
                "organization": "The Ascott Limited",
                "biography": "Adeline Phua is Managing lyf Partner at The Ascott Limited (Ascott). She also helms a dual role as Vice President for Business Development at Ascott.  \n\nIn her role as Managing lyf Partner, Adeline champions the development and growth of the lyf (pronounced ‘life’) brand, an experience-led social living concept designed for the next-generation traveller to ‘live your freedom’. As overall guardian of the brand, Adeline leads the strategic growth of the lyf brand globally. She spearheads brand development and management, collaborations and partnerships for lyf, and drives commercial and operational excellence of the properties.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Projects & Destinations",
            "Global Investments"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjA2OTM1OA==",
        "titleTranslations": [
            {
                "value": "Bridging the Gap: Integrating SDGs into Core Business Strategies for Sustainable Success",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 11:30:00",
        "endsAt": "2024-10-02 12:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/atYmip2m85A\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Investment"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Kelly",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTMyMzQ2LFVzZXJfMTQxNjY4NTIp",
                "jobTitle": "Executive Director, Sustainability & Marine Animal Operations",
                "lastName": "Timmins",
                "photoUrl": "https://static.swapcard.com/public/images/02eff018fa2b45b284c73b529302d22e.png",
                "organization": "Atlantis Dubai",
                "biography": "Kelly Timmins, Executive Director, Sustainability & Marine Animal Operations, Atlantis Dubai, has more than 13 years of international experience as a Zoological and Sustainability professional. With a BSc in Marine Science and an MSc in Marine Environmental Protection, in her current role, Kelly is responsible for implementing an environmental and social sustainability strategy and management system, to drive measurable change across the destination. \n\nKelly has worked in the United Kingdom, Singapore and now Dubai, gathering a range of skills across a number of different areas, including animal husbandry, conservation, education, events and sustainability. On joining Atlantis Dubai in July 2019, Kelly’s successfully lead the team to achieve AZA Accreditation for Atlantis Dubai – the international gold standard for animal care and welfare – after which, she worked with all departments to help the resort achieve Bronze Certification from EarthCheck in 2019, the world’s leading scientific benchmarking, certification and advisory group for travel and tourism. This was followed by EarthCheck Silver Certification in 2020, standards which are evaluated and monitored year on year both by the business and EarthCheck.\n\nIn just five years, Kelly has developed and enhanced educational programme offerings at Atlantis Dubai for both guests and colleagues. She has established a funding process to give support to local and international partnerships working on marine conservation and sustainability projects. Most recently, as part of Atlantis Dubai’s journey towards becoming a more responsible, sustainable tourism destination, Kelly has been the driving force behind Atlantis Atlas Project, the cornerstone of the destination’s overall commitment to sustainability-focused around the key pillars of Responsible Operations, Marine Conservation & Animal Welfare, Education & Awareness, and Corporate Social Responsibility.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Parisa",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjk1Mjg0LFVzZXJfMTc0NTI2NTAp",
                "jobTitle": "Head of Sustainability Communications",
                "lastName": "Chum",
                "photoUrl": "https://static.swapcard.com/public/images/3b3ec41c938d467586e3e81c7e49d2af.jpeg",
                "organization": "Flint Culture",
                "biography": "Sustainability and hospitality expert, Parisa has worked in strategic communications, corporate affairs, and reputation management for over eighteen years with diverse experience across agency, corporate, and government sectors in both regional and international markets. \n\nParisa currently leads on Flint Culture's sustainable and cultural tourism clients, advising them on sustainability-related communications frameworks and crisis management including The Royal Commission of AlUla, BEEAH Group, Ithra, and Kerten Hospitality.\n\nIn her previous tenure at IHG Hotels & Resorts, she led the company’s communications and corporate responsibility agenda, embedding sustainability practices (including carbon reduction, energy efficiency, water conservation, food waste and removal of single-use plastics) across India, the Middle East and Africa. As a member of the regional leadership team, Parisa led the communications for market and brand debuts and navigated the company's COVID-19 pandemic response for the region. She was also a member of the IMEA D, E &I Board where she contributed significantly to IHG’s employability and national talent development initiatives in Saudi Arabia and the UAE.\n\nPrior to this, she led the corporate, consumer, financial and healthcare practices at Memac Ogilvy PR leading communications advisory services across high-profile global and regional clients such as Hilton Luxury Brands, Siemens, DIFC, Tetra Pak and Aujan Industries.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Atul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjc2NDYyLFVzZXJfMTU0ODM5OSk=",
                "jobTitle": "Founder & CEO",
                "lastName": "Chopra",
                "photoUrl": "https://static.swapcard.com/public/images/ef0e284064384703ba06a3f9028e05d6.jpeg",
                "organization": "FreshOnTable",
                "biography": "Atul is a serial entrepreneur, a Chartered Accountant, and a Lawyer by training, he spent the first part of his professional journey in Investment Banking. He started his career with one of India’s largest private I Bank as a Bond and Equity Trader, eventually moving and later heading their Project Finance practice. He subsequently set up a boutique Corporate Finance Investment Bank with the backing of International Investors. As an MD of this venture, he has to his credit some of the path breaking International M & A deals in the core sector, representing some of the top names in the Telecom vertical.\nHe became a Tech entrepreneur in early 2000 by acquiring a small IT product company in Bangalore, the Silicon capital of India. In a short span of a decade, he scaled the business to over 700 engineers, with a leading footprint across emerging markets. In 2009, it attracted IFC, the private sector arm of the World Bank, to acquire a minority interest.\nPost exiting from this business in 2012, he has been an active investor in select startups, where he could also add value.\nHis journey with FreshOnTable, an Agri tech platform, started in 2018, initially in France followed by a ‘POC’ in the State of Maryland, USA. In 2019, attracted and encouraged by UAE’s food security and sustainability missions, he started focusing in this region.\nFreshOnTable is a preferred sustainability partner for over 290 fine dining and hotel chains, including The Atlantis, Hilton, Hyatt, Rotana, IHG, and Accor. It also collaborates with more than 90 small and medium farms across the northern emirates and partners with SILAL for HORECA services. \nAtul’s professional achievements have won many accolades including\n•\t“Best Sustainable Agri-Food CEO 2020 in the UAE”\n•\tNo. 1 F&B Game changer in the MENA Region by Caterer Magazine for 2021\n•\tSustainable UAE Eating Award by Gulfood, 2021\n•\tFirst catalyst for Local farms in UAE\n•\tFirst C02 emissions saver meter by supporting Local Produce",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Bryanne",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDQzODg5LFVzZXJfMTc0NTIyNTQp",
                "jobTitle": "Group Senior Director Sustainability",
                "lastName": "Tait",
                "photoUrl": "https://static.swapcard.com/public/images/e353cc9489a846b191e25d8e1253c738.png",
                "organization": "Jumeirah",
                "biography": "Bryanne joined Jumeirah early 2023 as Group Senior Director of Sustainability, bringing with her over 25 years of experience in sustainability, clean energy, and climate change. She has held leadership roles at Shell, E.ON, Masdar, and the World Bank Group, as well as state-owned entities like Petronas and Eskom. Her work spans industries including renewable energy, oil and gas, textiles, and waste management, with projects in over 30 countries. Bryanne spent much of the last decade in Pakistan and Afghanistan, developing clean energy solutions for rural communities. Closer to home, she held the position of Chief Development Officer at Dubai-based Blue Forest, focusing on blue carbon projects. At Jumeirah, Bryanne leads the group’s sustainability strategy and governance, focusing on the decarbonisation of operations, reducing energy and water consumption, reducing the production of waste in particular food wate, eliminating single-use plastics and protecting biodiversity.\n\nBryanne joined Jumeirah early 2023 as Group Senior Director of Sustainability, bringing with her over 25 years of experience in sustainability, clean energy, and climate change. She has held leadership roles at Shell, E.ON, Masdar, and the World Bank Group, as well as state-owned entities like Petronas and Eskom. Her work spans industries including renewable energy, oil and gas, textiles, and waste management, with projects in over 30 countries. Bryanne spent much of the last decade in Pakistan and Afghanistan, developing clean energy solutions for rural communities. Closer to home, she held the position of Chief Development Officer at Dubai-based Blue Forest, focusing on blue carbon projects. At Jumeirah, Bryanne leads the group’s sustainability strategy and governance, focusing on the decarbonisation of operations, reducing energy and water consumption, reducing the production of waste in particular food wate, eliminating single-use plastics and protecting biodiversity.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Edward",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjE1NTc0LFVzZXJfMTE3NTY4Nzkp",
                "jobTitle": "Founder & CEO",
                "lastName": "Hamod",
                "photoUrl": "https://static.swapcard.com/public/images/2ddf4bfae3c24f37a38fa316887a1758.jpeg",
                "organization": "Switch Foods",
                "biography": "Edward Hamod is the CEO and Founder of Switch Foods, a FoodTech start-up revolutionizing the culinary landscape with its innovative plant-based meat alternatives.\nWith a wealth of experience and a successful track record in leading esteemed food manufacturing and production organizations across the Middle East, Edward identified a pressing need in the region for healthy, nutritious, sustainable, and locally sourced food options. This realisation fuelled his passion for contributing to national food security, promoting source diversity, and creating alternative-meat varieties that cater specifically to Middle Eastern palates. Edward's commitment to sustainability and his unwavering belief in the potential of nutritional plant-based diets are not only driving forces behind Switch Foods, but also reflect his strong conviction that FoodTech plays a pivotal role in the region's aspirations for enhanced food security.\nEdward's impressive professional journey showcases his adeptness and self-motivation as a leader in various business sectors. He possesses a deep understanding of financial, organizational, and operational strategies, positioning him as a forward-thinking, adaptable, and enterprising catalyst for change. Edward has consistently demonstrated an innate ability to navigate complex structures and foster the growth of new enterprises.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Investment",
            "Sustainability & Innovation"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgxMQ==",
        "titleTranslations": [
            {
                "value": "Disrupting the Market: How AI in the Hospitality Industry Is Changing the Game?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 11:45:00",
        "endsAt": "2024-10-02 12:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/71hCH4wUW-o\" target=\"_blank\">Click here to watch online.</a></p><br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Techology & AI"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Peter",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTEwOTg1LFVzZXJfMTkyNzE0MTAp",
                "jobTitle": "Futurist and Founder of AI & Communications agency",
                "lastName": "Heneghan",
                "photoUrl": "https://static.swapcard.com/public/images/536c882dc333446f810758bd092173ef.webp",
                "organization": "The Future Communicator",
                "biography": "Peter Heneghan, Founder of The Future Communicator, is an award-winning AI and communications expert with experience at BBC News, Channel 4, BuzzFeed, and 10 Downing Street. As the UK Government's Chief Digital Communicator, he modernized its strategy. His agency delivers AI-driven strategies for high-end clients, including the UN, Arts Council England, a Formula One team, and luxury brands. Peter helps luxury businesses stay ahead of trends, enhancing customer experiences and efficiency. With expertise in AI adoption, he ensures smooth integration of both technology and staff. He’s a Cannes Lions Grand Prix winner and guest lecturer at London Business School.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMDQyMzQyLFVzZXJfMTYyMTUyMTkp",
                "jobTitle": "Director - Head of Hotel Advisory",
                "lastName": "Nasra",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2107edc501364b20835b2031eb656fc5.jpeg",
                "organization": "Colliers MENA",
                "biography": "Nicolas oversees the execution of greenfield and brownfield hospitality and tourism feasibility studies, operator search and selection, and strategic development advisory projects in MENA. Nicolas holds an MBA and a Master's in Business Analytics and has developed broad expertise in commercial real estate advisory, covering hotels, serviced apartments, residential, spa & wellness, golf, marina and yachting, retail, arts & culture, and leisure assets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                                    "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 15:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jens",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjc3MDc1LFVzZXJfMjA1MjQyNTEp",
                "jobTitle": "CEO & Member of the Executive Board",
                "lastName": "Schramm",
                "photoUrl": "https://static.swapcard.com/public/images/a1e009c4a89745cc83695f789b2a2708.jpeg",
                "organization": "Robosculptor",
                "biography": "Jens is a seasoned leader in the medical device industry with an extensive career spanning three decades. His expertise encompasses a broad range of specialties, including Ophthalmology, Urology, Dentistry, Dermatology, and the aesthetic market. \nHis exceptional ability to foster strong relationships with clients and stakeholders is matched by a solid record of executing sales plans and surpassing targets. His role involved managing complex business transformation and executing high-level corporate strategy initiatives. A visionary in the medical device field, Jens’ professional journey is a testament to his strategic insight, operational excellence, and the ability to drive success in dynamic and competitive markets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Klaus",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMzIxMjcwLFVzZXJfMjA0MjI4Mik=",
                "jobTitle": "Chief Evangelist & Development Officer",
                "lastName": "Kohlmayr",
                "photoUrl": "https://static.swapcard.com/public/images/429bdd98c67442cca42af343d7180d55.png",
                "organization": "IDeaS Revenue Solutions",
                "biography": "As Chief Evangelist and Development Officer for IDeaS, Klaus’s role is to challenge existing thought processes, create stimulating conversations, and help bring to live the future of Revenue Management and Pricing in hospitality and travel. Klaus is a frequently sought out thought leader and contributor for some of the major industry forums, including Phocuswire, Skift, ITB, HITEC & ROC, and others.\n\nHe is currently responsible for global thought leadership, working closely with the industry and teams at IDeaS to accelerate innovation. Additionally, he is also leading the team responsible for mapping out IDeaS long term strategy and is heading up the Global Alliances and Partnership group as well as the newly formed IDeaS.Lab innovation team. \n\nKlaus has been working to challenge the status quo for the last 20+ years. He has worked in global hospitality roles for many years both in Operations as well as leading revenue management and pricing departments in Europe and Asia. \n\nAn advocate of lifelong learning, Klaus holds a Bachelor of Science in Hotel Management, has studied business at Henley Management College, real estate investment and asset management at Cornell University’s School of Hotel Administration; and finance and strategy at the Singapore Management University.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Techology & AI"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTQyMA==",
        "titleTranslations": [
            {
                "value": "Luxury Fashion Brands in Real Estate: Crafting Spaces of Elegance",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 11:45:00",
        "endsAt": "2024-10-02 12:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Dsdv5NC6hOw\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0MjI4LFVzZXJfMTU3NTcyNzUp",
                "jobTitle": "Presenter",
                "lastName": "Sackur",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
                "organization": "HARDTalk",
                "biography": "Stephen Sackur is presenter of HARDtalk, the current affairs interview on BBC World and the News Channel. His subjects have included the heads of NATO and OPEC, Shimon Peres, Gore Vidal and Richard Dawkins.\n\nFor HARDtalk he has also interviewed a number of the world’s great names, including Bill Clinton, George W Bush, Mikhail Gorbachev and Hugo Chavez. Distilling his notes for a series of articles, Stephen identiﬁed the ﬁve qualities they all seemed to share: an indestructible will, passion (almost beyond reason), outrageous optimism, a super-sized ego and a ‘rebel yell.’\n\nThese interviews have also given him an insight into how organisations can best bring about innovation: “You need to ﬁnd ways to assess individuals on their merits, and give rewards for innovative thinking rather than play-it-safe mediocrity. You should encourage insiders to get outside and bring back fresh insights. And you shouldn’t confuse seniority with creativity.”\n\nAway from set-piece interviews Stephen has served in Brussels, reporting on day-to-day stories from the major European institutions and across the continent. Before that he was Washington Correspondent, where his coverage and analysis of 9/11 won widespread acclaim.\n\nTen years earlier it was Stephen who broke the story of the mass killing on the Basra road out of Kuwait, marking the end of the Gulf War. He was then posted to Cairo and Jerusalem as Middle East Correspondent, where he reported on the emergence of the Palestinian Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Pier Paolo",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ5OTM4LFVzZXJfMjAyNTI3Nzcp",
                "jobTitle": "CEO & President",
                "lastName": "Righi",
                "photoUrl": "https://static.swapcard.com/public/images/79c118f294c24c3b90c2504e9ba9b93b.jpeg",
                "organization": "Karl Lagerfeld",
                "biography": "Pier Paolo Righi, CEO & President of KARL LAGERFELD, is half-Italian and half-German, and has over 30 years of experience in the international fashion, sports and lifestyle industries.\n\nSince joining KARL LAGERFELD in 2011, Righi spearheaded the launch of the KARL LAGERFELD brand and helped grow its consumer sales to more than $1.5 billion to date. For many years, he worked in tandem and close collaboration with the late design icon Karl Lagerfeld, the former creative director of his namesake House, as well as Chanel and Fendi.\n\nUnder Righi’s leadership, the House has expanded globally and successfully ventured into new categories beyond fashion, including residential projects and hospitality. This includes the first KARL LAGERFELD branded luxury hotel in Macau, plus luxury residential developments in Spain, Portugal, the UAE and Southeast Asia.\n\nPrior to joining KARL LAGERFELD, Righi worked for nearly a decade at Nike, including seven years as General Manager CEMEA. He has also held various senior management positions within international groups including Tommy Hilfiger and Pentland Brands Limited. Righi has lived in Amsterdam, Frankfurt, Munich, Milan and Paris. He currently serves in several non-executive boards across various industries.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences",
            "Global Investments"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjA1NjYyOQ==",
        "titleTranslations": [
            {
                "value": "Unveiling Market Trends: Insights into Branded Residences",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 12:00:00",
        "endsAt": "2024-10-02 12:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/9V3T17gWB8o\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Zhann",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTIwNDI5LFVzZXJfMjA0MzA5Mjkp",
                "jobTitle": "Director of Market Intelligence and Research",
                "lastName": "Jochinke",
                "photoUrl": "https://static.swapcard.com/public/images/502ab6f6b0c0414091d1e772b1b0c4d0.jpeg",
                "organization": "Cavendish Maxwell",
                "biography": "“Zhann Jochinke is the Director of Market Intelligence and Research of Cavendish Maxwell – and has over 15 years’ experience in the real estate, data analytics, and PropTech sectors covering both the United States and United Arab Emirates. Widely known for his accurate assessments of the real estate market and the publication of the Property Monitor Monthly Market Report, which was the first to call the bottom of the Dubai property market in November 2020, Zhann is a sought-after expert on the housing sector. He has been featured in major local and international publications including: the New York Times, Reuters, Bloomberg, Maison Global, The National, Gulf News, and Arabian Business.  Zhann has also served as the President of the Manhattan Association of REALTORS®, President of the Manhattan MLS, and as a board member of home owners’ associations in the New York City market”.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg4MA==",
        "titleTranslations": [
            {
                "value": "Hoteliers Are From Mars, Restauranters Are From Venus: Why Hoteliers Can’t Run Restaurants?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 12:10:00",
        "endsAt": "2024-10-02 12:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/5ATmXZb1Kmo\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Investment"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Christian",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzIwNTI2LFVzZXJfMTU5NTQ0MzMp",
                "jobTitle": "VP Business Development",
                "lastName": "Gradnitzer",
                "photoUrl": "https://static.swapcard.com/public/images/129c79dea51147c9b9a791b3ab5dee4d.jpeg",
                "organization": "RIKAS Hospitality Group",
                "biography": "Christian Gradnitzer is Vice President of Development at RIKAS Hospitality Group, leading its expansion locally and globally. With over 30 years of experience across Europe, the US, and the Middle East, he has worked at The Dorchester, Jumeirah Group, Doğuş Group / D.ream, and Hilton. He was pivotal in developing Jumeirah Group’s restaurant division before joining Doğuş and Hilton. Since 2022, Christian has been instrumental in RIKAS Group’s growth, including award-winning concepts like La Cantine du Faubourg, Ninive, Mimi Kakushi, Twiggy by La Cantine, and others",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Josh",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTg4MTY5LFVzZXJfMTQ1MDc4MzIp",
                "jobTitle": "Group Director Marketing",
                "lastName": "Craddock",
                "photoUrl": "https://static.swapcard.com/public/images/3c4433650b97428f9b9b17857559a442.jpeg",
                "organization": "EatX",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "James",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTM4ODA4LFVzZXJfMTYyNTA1MDkp",
                "jobTitle": "Founding Partner",
                "lastName": "Hacon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
                "organization": "Think Hospitality",
                "biography": "James is one of the leading names in hospitality growth, marketing & brand strategy, he has been an executive, board member, Attendees and consultant in the hospitality brand and technology sector for the past twenty years, having worked with more than 80 hospitality brands in 22 countries, from independent Michelin starred restaurants to leading restaurant brands, international hotel companies & contract caterers. \n\nHis brand experience includes Accor, IHG, Sodexo, Compass Group, Krispy Kreme, Costa Coffee, Diageo, AMREST, Jamie Oliver Group, Wagamama, Gleneagles & Pret. \n\nHe is regularly called upon as a commentator, writer, speaker & facilitator, giving him a unique insight into global trends and the very best brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                                    "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                                    "beginsAt": "2024-04-30 09:45:00",
                                    "endsAt": "2024-04-30 10:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                                    "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                                    "beginsAt": "2024-04-30 15:10:00",
                                    "endsAt": "2024-04-30 15:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Investment"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjA0OTQxNQ==",
        "titleTranslations": [
            {
                "value": "Branded Residences: A New Era in Real Estate Investment",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 12:10:00",
        "endsAt": "2024-10-02 12:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/nIIHOzxbWHM\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "global-investments",
                "translations": [
                    {
                        "value": "Global Investments"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTg3ODI2LFVzZXJfMjEwNzY5MDUp",
                "jobTitle": "Director Development",
                "lastName": "Rossouw",
                "photoUrl": "https://static.swapcard.com/public/images/f0f81072af1e4c2c94bef5b9af555e52.jpeg",
                "organization": "New Murabba Development Company",
                "biography": "As a member of the development leadership team of the New Murabba Development Company, Stephen oversees mixed-use and hospitality real estate assets within Riyadh’s new iconic Mukaab. Prior to his role with New Murabba, Stephen has led major development and infrastructure projects across Europe and Australasia.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Andrew",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMjY0OTM3LFVzZXJfMTU5MzI5OCk=",
                "jobTitle": "Editorial Director and Owner",
                "lastName": "Sangster",
                "photoUrl": "https://static.swapcard.com/public/images/179cbe47c45644beaa6f1c683cbc1880.jpeg",
                "organization": "Hotel Analyst",
                "biography": "Andrew Sangster launched Hotel Analyst more than 20 years ago. It has grown into a publishing business encompassing a paid subscription service for hotel investors, a reports division and events. \nMore information on these services can be found at www.hotelanalyst.co.uk and see www.op-re.com for the latest event for investors across the operational real estate sector, the Operational Real Estate Festival.\nAndrew has been a journalist his entire career, starting on trade press titles before joining the national press and a brief spell at the BBC. He launched his own business focused on providing high-level information on a subscription basis after despairing at the quality of what the old business model of selling advertising space was producing.\nAndrew holds a BSc in economics and an MA in journalism. He lives in Cambridge with his wife and three children.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Paul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNzk4MDIwLFVzZXJfMTg2NzQ3NSk=",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Bridger",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c3ee50cc462e49ac86d1a8a097a15de2.jpeg",
                "organization": "Rove Hotels",
                "biography": "A proven hospitality leader with more than 20 years of experience across the Middle East, Asia, the UK & Ireland, Paul Bridger is the Chief Operating Officer of Rove Hotels, the smart, value hospitality brand created as a joint venture between Emaar Properties PJSC and Meraas Holding.\n\nPaul heads Rove Hotels and is responsible for overseeing the initiation, planning, and achievement of strategic brand objectives, ensuring a successful and consistent rollout of this new mid-scale lifestyle offering. His role also includes providing leadership and management focus on the business operations to achieve maximum financial performance, and team and customer satisfaction. \n \nBefore joining Rove Hotels, Paul worked with one of the UK’s largest hotel, restaurant, and café operators where he held the position of General Manager for eight years, before taking on larger responsibilities as Regional Director of Operations – Southeast Asia. \n\nPaul has diverse experience in markets such as the UK, UAE, Singapore, Thailand, Indonesia, and Malaysia with a focus on hospitality leadership.\n\nPaul holds an MBA in Hospitality from Ecole hôtelière de Lausanne (EHL), Switzerland.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ali",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjIxOTE2LFVzZXJfMjA0OTY5ODMp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Ghaleb Jaber",
                "photoUrl": "https://static.swapcard.com/public/images/826c4c2e952441b49e7c2545558de69a.jpeg",
                "organization": "GJ Properties Investments LLC",
                "biography": "Mr. Ali Ghaleb Jaber is an accomplished executive with over 24 years of experience in the Real Estate Industry. As the CEO of GJ Properties Investments LLC, He has driven significant growth and innovation, as a leader in the real estate sector in the northern emirates of the UAE by establishing GJ Properties Investments LLC in the year 2014 and increasing its developments to AED 4.4 Billion in the past 10 years and delivered over 6,000 apartments, his strategic vision and leadership have been instrumental in achieving his achievements or milestones.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Eezan Shahul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTI3OTI3LFVzZXJfMTkxMzQ5MDMp",
                "jobTitle": "Chief Commercial Officer",
                "lastName": "Hameed",
                "photoUrl": "https://static.swapcard.com/public/images/277c33646dca4feea257ed48adeb7371.jpeg",
                "organization": "Maldives Fund Management Corporation",
                "biography": "Eezan Shahul Hameed, Chief Commercial Officer at Maldives Fund Management Corporation (MFMC), a Maldivian state-owned fund, investment, and asset management corporation, is currently developing unique hospitality projects in the Maldives. In his current role, Eezan manages the growth and operations of MFMC’s entire commercial portfolio. He has been instrumental in accelerating MFMC’s groundbreaking initiatives, setting unprecedented benchmarks across the Maldivian economy.\nPrior to being appointed as the CCO at MFMC, Eezan served as a Trade & Investment Consultant to the Ministry of Economic Development in the Maldives, where he focused on implementing the government’s trade and investment policies. His efforts were particularly notable in large-scale projects such as the new gateway port in Male’ and the international airport in northern Maldives. His key achievements include launching the country’s first unemployment benefit scheme, which positively impacted the local economy during the COVID-19 pandemic.\nEezan is also well-accomplished in the hospitality field, a sector he is passionate about. He has advised new investors on property acquisitions and provided project management services for resort developments. Moreover, he has led negotiations securing contracts with renowned hotel brands.\nAs the CCO of MFMC, Eezan is a driving force behind groundbreaking integrated tourism projects being introduced for the first time in the Maldives. His ability to identify and capitalize on new business opportunities and foster relationships with key stakeholders has been a hallmark of his career, enabling MFMC to secure long-term partnerships with elite corporations across various industries.\nEezan’s track record of successfully leading high-profile projects, combined with his supportive and approachable leadership style, makes him stand out in his field. His expertise and strategic insights continue to drive impactful results for MFMC and the broader Maldivian economy.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences",
            "Global Investments"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgxMg==",
        "titleTranslations": [
            {
                "value": "Digital Transformation - The Future of Design and Customer Experience",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 12:20:00",
        "endsAt": "2024-10-02 13:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/kv7E3VRcH-w\" target=\"_blank\">Click here to watch online.</a></p><br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Techology & AI"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Markus",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNDg0ODM3LFVzZXJfMTYxNjMyNTYp",
                "jobTitle": "Chairman",
                "lastName": "Schreyer",
                "photoUrl": "https://static.swapcard.com/public/images/37bd745766e64fc69bfef0b26ba9e3a0.jpeg",
                "organization": "META Foundation",
                "biography": "Markus Schreyer is a global hospitality executive at the forefront of business & brand development, innovation, experience design, and STEM. His career encompasses roles across 40 countries and 20 luxury brands in global hotel chains like Hilton Hotels & Resorts and Starwood Hotels & Resorts. He has also held leadership positions in lifestyle brands, including Senior Vice President of Global Innovation at Design Hotels, a Marriott brand, and Chief Development Officer at Proper Hospitality.\n\nHis passion for fostering growth, mentoring global teams, and developing new revenue streams—such as retail, experiences, and membership models for lifestyle brands through strategic innovation and human-touch points across multiple digital platforms—has earned him recognition across industries. \n\nAs the co-founder and chairman of the META Foundation, a visionary hospitality innovation lab established in 2020, he accelerates global projects in cultural, social, and sustainable development. The foundation collaborates with developers, brands, and technologists across industries, introducing impactful business models in living, travel, and community building enabled through AI, web3, and spatial computing, fostering project longevity.\n\nMarkus Schreyer holds an MBA and a PhD in Innovation Strategy from the University of Dresden, Germany. He teaches competitive strategy and venture development at New York University (NYU) and brand, marketing, and PR at Parsons School of Design.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                                    "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                                    "beginsAt": "2024-04-30 15:20:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Joe",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNDg0ODUzLFVzZXJfODI0ODc4NCk=",
                "jobTitle": "Founder & Managing Director",
                "lastName": "Tabet",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/92f3ad3bab5d49eebb2b626ffb308ba2.jpeg",
                "organization": "JT+Partners",
                "biography": "Joe Tabet is an innovative visionary architect wearing different hats, with +20 years of professional experience in worldwide architecture and construction industry.\nJoe founded JT&Partners in 2015, starting with a handful of staff in a +100sqm office in Business Bay, Dubai. The company became an “overnight success”, earning recognition as an acclaimed international multidisciplinary consultant with imAttendeesive projects located in global destinations.\nHe creates buildings and communities that transcend design and encompass social and environmental issues. Joe, JT&Partners and its projects received awards and recognitions from Cityscape, MEA, Arabian Property, UAE Business Awards, UAP Dubai. Recent completed projects include hotels in RAK, Seychelles and Egypt. Ongoing and upcoming projects include residential towers and villas, hotels, resorts, golf course, waterpark and hospital in Abu Dhabi, Dubai, RAK, Sharjah, Egypt, Greece and KSA.\nAlways alert to the latest trends and with eyes towards the future, he pushes his staff into looking at innovation, Internet of Things, digital twin, 3D printing, modeller construction and invests in the newest multi-media technology and up-to-date state-of-the-art tools.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                                    "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                                    "beginsAt": "2024-04-30 15:20:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Sissi",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjEwMTM4LFVzZXJfMjEwOTIzNDAp",
                "jobTitle": "President",
                "lastName": "Johnson",
                "photoUrl": "https://static.swapcard.com/public/images/f4c4a1eca30d4a26ae9c9cf323b7e0b6.jpeg",
                "organization": "Berlin Fashion Film Festival",
                "biography": "Sissi serves as President of the Berlin Fashion Film Festival, showcasing motion pictures from luxury powerhouses like Bvlgari, Prada, and Hermès since 2012. These legacy brands are now exploring new territory in the hospitality industry by blending fashion, lifestyle, and travel.\n\nSissi's award-winning career highlights range from teaching her proprietary Luxury Brand Management MBA curriculum at the world's top fashion and business schools, to designing experiences, products, and spaces that enhance how we live, learn, work, and play. \n\nShe joined Airbnb at its inception, advised Maison Chaumet (LVMH) on their largest travel-inspired high jewellery collection since 1780, hosted a global virtual retreat with the Marriott group, spearheaded the launch of a critically acclaimed farm-to-table culinary lab, and collaborated with the United Nations World Tourism Organization.\n\nBerlin fashion Film Festival's next edition will take place November 13-15, 2024 under the esteemed patronage of the European Union, the city of Berlin, and in partnership with Design Hotels.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Laurent",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNTU3NDcwLFVzZXJfMTYyMjM2OTAp",
                "jobTitle": "Chief Research & Development Officer",
                "lastName": "Cartier",
                "photoUrl": "https://static.swapcard.com/public/images/a5a437ad4c61416a997150cbc982ef44.jpeg",
                "organization": "Amsa Hospitality",
                "biography": "With over 30 years of experience in the hospitality industry, Laurent is passionate about creating and delivering exceptional products and services that meet the needs and expectations of diverse and discerning customers. As the Chief Research and Development Officer at Amsa Hospitality, he leads the development and execution of new hospitality projects, concepts, and designs that reflect the hallmark of Arabian hospitality and culture.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Techology & AI"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjA1NjYzMA==",
        "titleTranslations": [
            {
                "value": "Closing Remarks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 12:50:00",
        "endsAt": "2024-10-02 13:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/AVvWnyW9Ejo\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE5Mjg0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/17a7878fe072462dbdfaa73230f5d186.jpeg",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0MjI4LFVzZXJfMTU3NTcyNzUp",
                "jobTitle": "Presenter",
                "lastName": "Sackur",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
                "organization": "HARDTalk",
                "biography": "Stephen Sackur is presenter of HARDtalk, the current affairs interview on BBC World and the News Channel. His subjects have included the heads of NATO and OPEC, Shimon Peres, Gore Vidal and Richard Dawkins.\n\nFor HARDtalk he has also interviewed a number of the world’s great names, including Bill Clinton, George W Bush, Mikhail Gorbachev and Hugo Chavez. Distilling his notes for a series of articles, Stephen identiﬁed the ﬁve qualities they all seemed to share: an indestructible will, passion (almost beyond reason), outrageous optimism, a super-sized ego and a ‘rebel yell.’\n\nThese interviews have also given him an insight into how organisations can best bring about innovation: “You need to ﬁnd ways to assess individuals on their merits, and give rewards for innovative thinking rather than play-it-safe mediocrity. You should encourage insiders to get outside and bring back fresh insights. And you shouldn’t confuse seniority with creativity.”\n\nAway from set-piece interviews Stephen has served in Brussels, reporting on day-to-day stories from the major European institutions and across the continent. Before that he was Washington Correspondent, where his coverage and analysis of 9/11 won widespread acclaim.\n\nTen years earlier it was Stephen who broke the story of the mass killing on the Basra road out of Kuwait, marking the end of the Gulf War. He was then posted to Cairo and Jerusalem as Middle East Correspondent, where he reported on the emergence of the Palestinian Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAzMDE5NA==",
        "titleTranslations": [
            {
                "value": "Welcome to the Branded Residences Forum",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 13:30:00",
        "endsAt": "2024-10-02 13:35:00",
        "descriptionTranslations": [
            {
                "value": "<br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTE5Mjg0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/17a7878fe072462dbdfaa73230f5d186.jpeg",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgxNQ==",
        "titleTranslations": [
            {
                "value": "Setting the Stage - Introduction to the Branded Residences Forum, Industry Overview, Key Insights, Concepts & Trends",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 13:35:00",
        "endsAt": "2024-10-02 13:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/o0Ou2V2E1dE\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jeff",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNjkxOTI3LFVzZXJfMTc4MTEwNSk=",
                "jobTitle": "Chief Business Officer, Accor One Living",
                "lastName": "Tisdall",
                "photoUrl": "https://static.swapcard.com/public/images/93e21228749a4f0480a74e05cd7f65e4.jpeg",
                "organization": "Global Head of Mixed-Use, Accor",
                "biography": "Jeff Tisdall is Chief Business Officer, Accor One Living and Global Head of Mixed-Use. Accor One Living is an industry first mixed-use platform, focussed on the development and operation of branded residences. Leveraging Accor’s two decades of residential experience pioneered under iconic brands like Fairmont and Raffles, the Group is now developing trend setting residential solutions across luxury, lifestyle, premium and midscale segments.  \n\nPrior to joining Accor in 2013 (via FRHI Hotels and Resorts), Tisdall was the Managing Director of Singapore-based LIFT, where he served as branded residential advisor to FRHI and the Jumeirah Group. Previously, Tisdall worked with Wyndham Worldwide in Dubai, as Managing Director with responsibility for the company’s RCI and Registry Collection brands in the Middle East and North Africa region. He was also Vice President of Real Estate at Kingdom Hotel Investments, where he managed the company’s residential and commercial real estate portfolio. Earlier in his career, Tisdall spent 13 years with Intrawest, leaving as a Senior Vice President at the company’s premium vacation ownership division.  \n\nTisdall holds a degree from McGill University in Canada and lives in Dubai with his family.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgxNg==",
        "titleTranslations": [
            {
                "value": "Unpacking the Benefits of Branded Residences for Investors",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 13:50:00",
        "endsAt": "2024-10-02 14:25:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Q-pNc5KF8Kk\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "George",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjE1MzgzLFVzZXJfMjA0OTI4MjUp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Azar",
                "photoUrl": "https://static.swapcard.com/public/images/cf7f682b06ab4e8cb7855d6121a0a3ae.jpeg",
                "organization": "Sotheby's International Realty",
                "biography": "George Azar is the Chairman & CEO of United Kingdom Sotheby's International Realty, Dubai Sotheby's International Realty and Saudi Arabia Sotheby's International Realty. George started his career as a Financial Consultant at Merrill Lynch Pierce Fenner & Smith (Middle East) where he expanded the company's clientele and created numerous opportunities.\n\nIn 1995, he joined the Swiss Bank Corporation as Agent - Middle East and excelled in servicing and advising clients on various investment strategies. In 1998, George was appointed as a General Manager by Banque SCS Alliance Groupe (Beirut) where he systematised the marketing and business development in the Middle East until 2001.\n\nIn September of the same year, Union Bancaire Privée appointed him as Director of its Dubai Representative Office and, following a series of successful initiatives, as Managing Director in 2004. Two years later, George launched UBP Qatar LLC and led the company as its Chief Executive Officer. He furthered his ventures by serving Dubai Sotheby's International Realty as Chairman & CEO since 2013, acquired the Saudi Arabia business in 2015, and the United Kingdom business in 2023.\n\nGeorge strongly believes in the positive side of things. This leadership perspective yields to his success as one of the top-notch entrepreneurs who played a key role in elevating the status of Dubai on the global level.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Husni Al",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjkxNjEwLFVzZXJfMjA1MzM1OTUp",
                "jobTitle": "Chairman & Founder",
                "lastName": "Bayari",
                "photoUrl": "https://static.swapcard.com/public/images/473d1a48df0a4c8dbfc163ac5e82f405.jpeg",
                "organization": "Bayari Investments",
                "biography": "Husni Al Bayari is the visionary Chairman and Founder of Bayari Investments, a leading conglomerate in the UAE. With over 20 years of experience in the UK and MENA real estate markets, Husni has carved a strong presence in the UAE's real estate industry. In 2023, he launched Evolutions, an innovative real estate intelligence hub offering exclusive developments, consultancy, and a global network of experts. Under his leadership, Bayari Investments also includes D&B Properties, Homes & Beyond, and more. Husni is a key shareholder in houza and has received RERA's prestigious 4 Star Real Estate Brokers Award.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Louis",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNzQwMzM2LFVzZXJfMTU3NTczMTAp",
                "jobTitle": "Chief Development Officer, Deputy Head MEAT & Global Head F&B Development",
                "lastName": "Abboud",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fc5fda656ea943b2ac6c1d865715584a.jpeg",
                "organization": "Ennismore",
                "biography": "Louis is the Chief Development Officer and Deputy Head for the Middle East, Africa, India and Turkey at Ennismore, where he oversees all facets of hotel development and operations, from partnership inception, deal-making, owner relations, to property design and pre-opening activities. He also serves as the Global Head of F&B Development, leading Ennismore's investment strategy in its F&B platforms, including Rikas and Paris Society. Louis is focused on accelerating the growth of Ennismore’s hotels, residences, and F&B brands.\nBefore joining Ennismore, Louis held the role of VP of Development, Middle East and Africa at Accor. His career began in hotel operations at Starwood Hotels and Resorts in California, followed by roles in asset management with the Saudi BinLadin Group in Jeddah and Majid Al Futtaim in Dubai. Louis also gained valuable experience in hospitality consultancy with HVS in Dubai, specializing in consulting and valuations",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                                    "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                                    "beginsAt": "2024-04-30 16:10:00",
                                    "endsAt": "2024-04-30 16:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Charlie",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTY2MjUzLFVzZXJfMjA0NjEzNzAp",
                "jobTitle": "Head of Sales & Marketing",
                "lastName": "Walsh",
                "photoUrl": "https://static.swapcard.com/public/images/a2589b4788664df7bf2c6cf5adcc0de8.jpeg",
                "organization": "The OWO Residences by Raffles",
                "biography": "Having spent 20 years working in Prime London Real Estate, I have been fortunate enough to have worked on some truly landmark developments across the capital and in varying degrees of use classes.\n\nI have spent much of my career overseas, focussing on the Asian markets, but also living and working in the UAE and Saudi Arabia.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sudhin",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTYwMjcwLFVzZXJfMjA0NTcwODUp",
                "jobTitle": "Chief Asset Management Officer",
                "lastName": "Siva",
                "photoUrl": "https://static.swapcard.com/public/images/e6af2a91ddad4cf9bdec80cb33cf8a3a.jpeg",
                "organization": "Shamal Holding",
                "biography": "Sudhin is an experienced Asset Management & Operations professional brining 20 years of experience in portfolio development, asset management, operations and commercial oversight of diverse portfolios in the real estate, hospitality, food and beverage, leisure, recreation and maritime sectors.\n\nHis core areas of focus are multi-sector asset management, feasibility & investment assessments, strategic planning, portfolio growth, performance and operations management.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
        "titleTranslations": [
            {
                "value": "EAHM Leadership Series: CEO for the Day",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 14:00:00",
        "endsAt": "2024-10-02 16:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/BBh8Xfxv7bU\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "JS",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODMzOTQ0LFVzZXJfMTQ2MzAwMDMp",
                "jobTitle": "Founder & CEO",
                "lastName": "Anand",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/0f77c61aeb96470ba1a89680e273a473.jpeg",
                "organization": "Leva Hotels",
                "biography": "Named as part of Forbes' Top Travel and Tourism Leaders in 2023 and one of the Most Powerful Leaders in Dubai by Arabian Business Magazine, with over 20 years of experience in the hospitality industry and an impeccable record of notable achievements, JS Anand is a prominent hotelier and passionate corporate leader. After earning his diploma in hotel management, he refined his hands-on management style as he advanced through senior roles in world-class hospitality companies.\n\nHe has been featured on the Power 50 - Most Influential Leaders by Hotelier Middle East, Executive Power list 2023: The Most Influential Hotel Leaders in the Middle East, Most Innovative Business Leaders Inspiring The World 2022 by The Excelligent Magazine, and Most Influential Entrepreneurs From Dubai To Watch in 2022 By The Gulf Entrepreneur Magazine.\n\nPeople-centric and future-focused, JS aims to make an impact on the hospitality industry by building on the importance of employee well-being and satisfaction, creating an unforgettable service culture that gains global recognition, and being more involved in humanitarian causes around the world.\n\nBuilding long-lasting connections play a pivotal role in his work, especially in his mission to propel LEVA across the MENA region and Europe.\n\nJS is a charismatic corporate leader with a hands-on management style. He lives by the company’s core values that are firmly focused on delivering, efficiently and effectively, what was promised to its stakeholders and clients. Now he is committed to creating the best lifestyle hotels in the Middle East and beyond, becoming one of the leading hotel management companies dedicated to clarity, transparency, and delivering on its promises to clients and stakeholders.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Khushi",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNDYyMTU2LFVzZXJfMjEyNTQwNjcp",
                "jobTitle": "Students",
                "lastName": "Kumar",
                "photoUrl": "https://static.swapcard.com/public/images/cf5c2c7378fb492abc89a90ae41abd40.jpeg",
                "organization": "Emirates Academy of Hospitality Management",
                "biography": "Currently a second year BBA student at the emirates academy of hospitality management. I’m 19 years old and originally from India . I recently completed an internship as an events sales intern at Sofitel Dubai the palm , where I gained invaluable experience in the hospitality industry. Hospitality has always been a huge passion of mine , and I am excited to continue learning and growing in this field as I work towards a successful career.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Raghuveer",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzQ1ODk4LFVzZXJfMTY0NzQ0MDQp",
                "jobTitle": "Student",
                "lastName": "Swamy",
                "photoUrl": "https://static.swapcard.com/public/images/3d7d149bb2fe47d9b41c719cd85b3662.png",
                "organization": "Emirates Academy of Hospitality Management",
                "biography": "Was born in Hyderabad and raised in the vibrant city of Surat, Gujarat. I completed a bachelor's degree from the prestigious Welcome group Graduate School of Hotel Administration (WGSHA) in Manipal and am currently pursuing my master's degree at the Emirates Academy of Hospitality Management (EAHM), where I am expanding my expertise in the hotel industry.\n\nApart from academics, I'm a passionate drummer and hold a brown belt in karate, which showcases my dedication to both music and martial arts. As an optimist with a relentless thirst for knowledge and experience, I aim to make my mark in the hospitality sector. My long-term goal is to leverage the experience acquired to launch my venture in the future, combining the entrepreneurial spirit with my love for the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jeff",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTI1OTUzLFVzZXJfMjA5MjY5OTgp",
                "jobTitle": "AVP Business Operations",
                "lastName": "Strachan",
                "photoUrl": "https://static.swapcard.com/public/images/9be4b8c826d04099aadc8458374a3ef2.jpeg",
                "organization": "Dubai College of Tourism",
                "biography": "In September 2015, Jeff Strachan, joined the Dubai College of Tourism, a unique initiative from Dubai Department of Economy & Tourism, designed as the conduit to bring the Dubai brand to life through a number of grass-roots human capital enablement initiatives including the online self-paced learning platforms Dubai Way and Dubai Expert and the campus based curriculum including Tourism, Hospitality, Events and Culinary Arts. The platforms created by Dubai College of Tourism have now welcomed over 150,000 students, studying courses including sustainable tourism, inclusive service, autism and sensory awareness and the flagship Dubai Way course.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Naureen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTQ4MDc3LFVzZXJfMjA0NDkzODIp",
                "jobTitle": "Founder",
                "lastName": "Ahmed",
                "photoUrl": "https://static.swapcard.com/public/images/80178a5951204f6190802570f888975e.jpeg",
                "organization": "Inspiring Women in Hospitality",
                "biography": "Naureen Ahmed is a seasoned hospitality professional, a fervent community builder, an engaging storyteller, and the visionary founder of ‘Inspiring Women in Hospitality’. \nRecognising the underrepresentation of women in hospitality, Naureen launched the ‘Inspiring Women in Hospitality’ podcast to amplify female voices and inspire change within the industry. Her efforts expanded in September 2023 with the creation of the Inspire Community, a platform designed to foster support among women through mentorship and career development discussions globally.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Bani",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxOTM4ODE0LFVzZXJfMjE5MDU1NSk=",
                "jobTitle": "Founder & Managing Director",
                "lastName": "Haddad",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4a639b6d658c48fd9b806f450f012908.jpeg",
                "organization": "Aleph Hospitality",
                "biography": "In 2015 Bani Haddad founded Aleph Hospitality to provide hotel owners in the Middle East and Africa with a customized, results-driven alternative to traditional hotel management models. Bani has 30 years’ experience in the hospitality industry whereas 19 years have been focused on the Middle East and Africa. Consistently ranked as one of the most powerful hoteliers in the Middle East, Bani won “Business Leader of the Year” in the 2022 MEED SME Awards, and in 2023 and 2024, Bani made it onto the prestigious Forbes Middle East list of Top 100 Travel & Tourism Leaders.\n\nUnder Bani’s visionary leadership, Aleph Hospitality has grown to become the largest independent hotel management company in the region, and in 2020 the company was valued at USD 20 million by a large European institutional investor who subsequently became a shareholder.\n\nBani holds an MBA from IMHI, a joint programme established by Cornell University’s School of Hotel Administration and ESSEC.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Eddy",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjg5NDcxLFVzZXJfMTU5NTQzNzIp",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Tannous",
                "photoUrl": "https://static.swapcard.com/public/images/0ea10113e8f64d0795d891c9d1769812.jpeg",
                "organization": "Rotana",
                "biography": "Eddy Tannous is the Chief Operating Officer (COO) of Rotana, one of the leading hotel management companies in the region with hotels across the Middle East, Africa, Eastern Europe and Türkiye. In his current position, Tannous is driving the growth and expansion of Rotana and his responsibilities include the successful opening of our new properties and creating synergy among Rotana properties in all aspects of our operations.\nTannous commenced his journey with Rotana in August 2023, bringing with him an extensive background of over 20 years in effectively overseeing hotel\noperations within large hotel groups. His career path has covered significant\npositions within the Middle East's hospitality sector, collaborating with\nwell-known global brands. Most recently, he held the position of Senior Vice\nPresident, Operations, where he supervised operational performance across\nFairmont's Middle East and Asian properties. Prior to that role, Tannous served\nas Vice President, Operations for the Kingdom of Saudi Arabia at Accor, where he managed the country's entire portfolio, comprising over 40 operating hotels and 40 pipeline projects.\nTannous possesses a proven track record of delivering success in various facets of the hospitality industry, encompassing operations, customer satisfaction, strategic expansion, marketing, and more, for some of the region's most renowned hospitality brands.\nAt Rotana, Tannous will continue to strengthen the Rotana brand's presence in\nglobal markets. He remains committed to advancing the group's global footprint while ensuring robust and consistent financial performance, all with the ultimate goal of creating shareholder value.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Markus",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNDg0ODM3LFVzZXJfMTYxNjMyNTYp",
                "jobTitle": "Chairman",
                "lastName": "Schreyer",
                "photoUrl": "https://static.swapcard.com/public/images/37bd745766e64fc69bfef0b26ba9e3a0.jpeg",
                "organization": "META Foundation",
                "biography": "Markus Schreyer is a global hospitality executive at the forefront of business & brand development, innovation, experience design, and STEM. His career encompasses roles across 40 countries and 20 luxury brands in global hotel chains like Hilton Hotels & Resorts and Starwood Hotels & Resorts. He has also held leadership positions in lifestyle brands, including Senior Vice President of Global Innovation at Design Hotels, a Marriott brand, and Chief Development Officer at Proper Hospitality.\n\nHis passion for fostering growth, mentoring global teams, and developing new revenue streams—such as retail, experiences, and membership models for lifestyle brands through strategic innovation and human-touch points across multiple digital platforms—has earned him recognition across industries. \n\nAs the co-founder and chairman of the META Foundation, a visionary hospitality innovation lab established in 2020, he accelerates global projects in cultural, social, and sustainable development. The foundation collaborates with developers, brands, and technologists across industries, introducing impactful business models in living, travel, and community building enabled through AI, web3, and spatial computing, fostering project longevity.\n\nMarkus Schreyer holds an MBA and a PhD in Innovation Strategy from the University of Dresden, Germany. He teaches competitive strategy and venture development at New York University (NYU) and brand, marketing, and PR at Parsons School of Design.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                                    "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                                    "beginsAt": "2024-04-30 15:20:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Marloes",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMjEzOTQ0LFVzZXJfMTEyODE0MDUp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Knippenberg",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/aadc31d5ddd34fcabc0aca59a0182e30.jpeg",
                "organization": "Kerten Hospitality",
                "biography": "Marloes is a distinguished hospitality leader who has been instrumental in redefining industry benchmarks. She seamlessly integrated ESG (Environmental, Social, and Governance) into the heart of business operations, processes, and value propositions. This integration has proven transformative, elevating a singular national brand to a global lifestyle group with a portfolio spanning over 45 diversified projects.\n\nMarloes' commitment to excellence is underscored by her strategic vision. She actively pursues the expansion of the brand's lifestyle portfolio, targeting regions identified for synergistic collaborations and mutual stakeholder objectives. Her foundational expertise is anchored in her tenure at Hilton, where she was entrusted with high-impact operational and commercial management portfolios.\n\nBeyond mere strategy and execution, Marloes is deeply committed to human capital development within the industry. She consistently champions the nurturing of emerging talents, propelling industry-wide transformation, and driving organizational alignment towards sustainability-centric objectives. This approach prioritizes not just bottom-line growth but also the holistic development of individuals, communities, and guest experiences.\n\nMarloes' advocacy for a progressive hospitality sector extends beyond traditional corporate parameters. As a notable ambassador for the Global Hospitality Student Challenge, spearheaded by Hotelschool the Hague, she is at the forefront of bridging the gap between the seasoned investment community and the visionary leaders of tomorrow. This initiative stands as a testament to her commitment to fostering innovation and collaboration, cementing her role in the ongoing evolution of the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxMw==",
                                    "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                                    "beginsAt": "2024-04-29 17:20:00",
                                    "endsAt": "2024-04-29 18:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Hala Matar",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNDI5NzU3LFVzZXJfMTQzNjUyMyk=",
                "jobTitle": "President, Middle East & Africa",
                "lastName": "Choufany",
                "photoUrl": "https://static.swapcard.com/public/images/ff1bc2942014471ca482413fc686ecb4.jpeg",
                "organization": "HVS",
                "biography": "Hala Matar Choufany is the President for HVS -Middle East & Africa -the only global consulting company focused solely on the hospitality industry. Hala is recognized as one of the most experienced and influential leaders in the hospitality industry, notably in the Middle East and Africa region.\n \nHala has advised on more than 5,000 hospitality and mixed-use projects in the last 20 years across Europe, the Middle East, Africa and Asia in areas such as Valuations, Acquisitions, Asset Management, Strategic investments and development, Contract Negotiations, and general Real Estate Strategic Advisory. \n \nHala has authored more than 60 publications and speaks frequently at investment and hospitality related conferences on a range of topics including asset valuation, investments, management issues and women leadership.\n \nIn addition to being a Board Member of HVS Global, Hala is regularly invited to Boards as a subject matter expert in the industry and frequently invited to discuss hotel and tourism trends on major news channel including Alarabiya, Bloomberg, Abu Dhabi TV, Forbes, Breaking Travel News and CNN.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                                    "beginsAt": "2024-04-30 16:35:00",
                                    "endsAt": "2024-04-30 16:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Tiffany",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNzczMzA0LFVzZXJfMjA4MzQ2Njcp",
                "jobTitle": "Director Sustainable Hospitality",
                "lastName": "McGrath",
                "photoUrl": "https://static.swapcard.com/public/images/8b834ea0ae974f30955e53478af70fc9.jpeg",
                "organization": "Sustainability Kiosk",
                "biography": "As Director of Sustainable Hospitality at Sustainability Kiosk, my passion thrives at the intersection of hospitality and sustainability. For over six years, I've dedicated myself to empowering hotels on their journeys to net-zero, leveraging my 20+ years of experience in Hospitality and Tourism. \nHolding a Business Degree focussed on Tourism; and as a Sustainability Management graduate of the Institute for Sustainability Leadership at the University of Cambridge along with being certified with the Global Sustainable Tourism Council (GSTC), I bring a balance of theoretical knowledge, and actionable solutions. I've witnessed the transformative power of partnerships firsthand, collaborating with hotels and local partners to achieve sustainability goals.  Crafting impactful sustainability programs, genuine reductions and pave the way for knowledge sharing on a larger scale.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "David",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxMzkzNzgzLFVzZXJfNzk3OTc2KQ==",
                "jobTitle": "CEO & Founder",
                "lastName": "Keen",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/218657551e024aaab1a1de67504600ab.jpeg",
                "organization": "QUO",
                "biography": "An evangelist for the power of experiential branding, David Keen is a successful entrepreneur and leading strategist for the travel and hospitality industries. Over the last 20 years, David has published and been interviewed in dozens of publications and has been a featured speaker at numerous conferences, tradeshows and professional events.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                                    "beginsAt": "2024-04-30 16:50:00",
                                    "endsAt": "2024-04-30 17:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMjEwOTg1NA==",
        "titleTranslations": [
            {
                "value": "Site Tours",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 14:00:00",
        "endsAt": "2024-10-02 18:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><strong>Smart Grow Farms</strong></p><p>Smart Grow Farms is a technology-driven, ISO-certified indoor vertical farm in Dubai, founded by agri-tech entrepreneur and former banker Ganthi Palvannasundaram. With a mission to revolutionize food production and distribution, the farm uses soilless agriculture methods and advanced automation to monitor and control the growing environment for salad greens, herbs, and vegetables. This innovative approach enhances productivity, improves crop quality, and reduces the need for harmful pesticides, ensuring that the produce is free from bacteria like E.coli, Salmonella, and Legionella. Ganthi’s passion for gardening, nurtured since childhood, led her to leave a successful 14-year banking career to establish Smart Grow Farms, where fresh, local harvests are now a reality. We are delighted to welcome you to our indoor vertical farm to witness the future of agriculture.</p><p><strong>Museum of the Future</strong></p><p>The Museum of the Future in Dubai is an architectural and engineering marvel. It confidently straddles the past and the future, applying advanced technology to traditional artforms. The museum ‘speaks Arabic’: its facade is a canvas for the poetry of His Highness Sheikh Mohammed Bin Rashid Al Maktoum rendered in the calligraphy of Mattar bin Lahej. The Museum of the Future welcomes people of all ages to see, touch, and shape our shared future. Go on a journey through possible futures and bring hope and knowledge back to the present.</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDk1MjgwMQ==",
                "definition": {
                    "isDefault": false,
                    "name": "Experiences"
                },
                "value": "experiences",
                "translations": [
                    {
                        "value": "Experiences"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMjE2MDE2OA==",
        "titleTranslations": [
            {
                "value": "From London to Dubai - Perspectives from a Pioneering Developer on the Future of Branded Living in the World's most Dynamic Market for Branded Real Estate",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 14:25:00",
        "endsAt": "2024-10-02 14:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/3t9xN2Y-WBw\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nick",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNjE0MjM4LFVzZXJfMjEzNDYyOTYp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Candy",
                "photoUrl": "https://static.swapcard.com/public/images/a273c291d2894997a22b0a9250c95e4e.jpeg",
                "organization": "Candy Capital",
                "biography": "Nick Candy is a British luxury real estate developer and co-founder of world-leading interior design and development management firm Candy & Candy (now Candy London). His groundbreaking project – the globally celebrated One Hyde Park – revolutionised the property market worldwide, breaking industry records and setting unparalleled new standards in luxury design and living. \n\nNick operates a private family office overseeing a diverse group of companies spanning real estate, design, development, and a portfolio of multi-stage investments in tech, digital media, consumer and sports, biotech, sustainability, and natural resources.\n\nWith a long-standing affiliation with the Middle East, Candy is actively engaged in a number of significant real estate and hospitality projects across the region through joint venture partnerships at the highest level.\n\nRecognised as a distinguished figure and innovator within the real estate community, Nick is a regular commentator in the media on industry topics and trends, and his visionary insights have earned him widespread acclaim and recognition.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMwOTY0MjI4LFVzZXJfMTU3NTcyNzUp",
                "jobTitle": "Presenter",
                "lastName": "Sackur",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
                "organization": "HARDTalk",
                "biography": "Stephen Sackur is presenter of HARDtalk, the current affairs interview on BBC World and the News Channel. His subjects have included the heads of NATO and OPEC, Shimon Peres, Gore Vidal and Richard Dawkins.\n\nFor HARDtalk he has also interviewed a number of the world’s great names, including Bill Clinton, George W Bush, Mikhail Gorbachev and Hugo Chavez. Distilling his notes for a series of articles, Stephen identiﬁed the ﬁve qualities they all seemed to share: an indestructible will, passion (almost beyond reason), outrageous optimism, a super-sized ego and a ‘rebel yell.’\n\nThese interviews have also given him an insight into how organisations can best bring about innovation: “You need to ﬁnd ways to assess individuals on their merits, and give rewards for innovative thinking rather than play-it-safe mediocrity. You should encourage insiders to get outside and bring back fresh insights. And you shouldn’t confuse seniority with creativity.”\n\nAway from set-piece interviews Stephen has served in Brussels, reporting on day-to-day stories from the major European institutions and across the continent. Before that he was Washington Correspondent, where his coverage and analysis of 9/11 won widespread acclaim.\n\nTen years earlier it was Stephen who broke the story of the mass killing on the Basra road out of Kuwait, marking the end of the Gulf War. He was then posted to Cairo and Jerusalem as Middle East Correspondent, where he reported on the emergence of the Palestinian Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgxNw==",
        "titleTranslations": [
            {
                "value": "Operator Perspective - A Look at How Leading Operators of Branded Residences View their Relationship With Development Partners and Homeowner Communities",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 14:40:00",
        "endsAt": "2024-10-02 15:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/urK2RsykC0w\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Barry",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNjY2MzU0LFVzZXJfMTI0MTE1ODIp",
                "jobTitle": "Principal",
                "lastName": "Landsberg",
                "photoUrl": null,
                "organization": "Landsberg Residential Consulting Inc.",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Adelina",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzM1NTk4LFVzZXJfMTk3MjQyNDIp",
                "jobTitle": "Global Head of Residential Marketing",
                "lastName": "Wong Ettelson",
                "photoUrl": "https://static.swapcard.com/public/images/d99bf302a81248ae953388076d11e2a9.jpeg",
                "organization": "Mandarin Oriental Hotel Group",
                "biography": "Adelina Wong Ettelson leads the marketing division for The Residences at Mandarin Oriental. She has been pivotal in establishing the legendary hospitality brand as a global leader in branded residences, launching properties in diverse locales such as London, Bodrum, and Bangkok. As a sought after thought leader on branded residences, she employs her diverse background in luxury fashion, retail, real estate, and hospitality to connect and engage with audiences and stakeholders across domestic and international markets. Prior to joining Mandarin Oriental, she was the Executive Vice President of Marketing at Corcoran Sunshine Marketing Group.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTkwMDA4LFVzZXJfMTQxMDA0ODQp",
                "jobTitle": "Global Head and SVP Private Homes and Branded Residential",
                "lastName": "Tomlinson",
                "photoUrl": "https://static.swapcard.com/public/images/db51b6ba212e49cdac8b72619b33cee5.jpeg",
                "organization": "Kerzner International",
                "biography": "Jonathan Tomlinson is the Global Head and Senior Vice President of Branded Residential and Private Homes at Kerzner International, responsible for the operational and strategic development of the entirety of Kerzner's residential offering and leads the curation of the ultimate homeowner experience. He spearheads the promotion, development, and management of Kerzner International’s residential component globally, including business development, real estate sales and marketing strategy, design planning assistance, and executive management of all residential projects including Atlantis, The Royal Residences, One&Only Private Homes, SIRO Residences and Rare Finds.\n\nPrior to joining Kerzner International in 2021, Jonathan held leadership roles with Four Seasons as Vice President Residential based in Singapore, IMG, and leading real estate developer Indochina Capital as Managing Director of the hospitality portfolio which included Branded Residential developments with Hyatt, Six Senses, GHM and independent serviced apartments, mixed use developments and golf properties.\n\nJonathan holds an MBA from RMIT University Melbourne, Australia and a CPM from the Institute of Real Estate Management and resides in Dubai with his family.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Ali",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ5MTgzLFVzZXJfMTU3NTczMzUp",
                "jobTitle": "Senior Director Head of Hospitality, Hotels & Tourism",
                "lastName": "Manzoor",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ee75f5da2004484ebe7a16782b1cd54b.jpeg",
                "organization": "CBRE MENA",
                "biography": "Ali is Head of Hotels & Tourism at CBRE in the Middle East, dedicated to providing creative, hands-on hospitality expertise across the region.\n \nHaving been in the industry for over 15 years, Ali is a well-established hospitality specialist with experience in hotel advisory, valuations and operations. During his time in the Middle East, Ali has worked with developers, Attendeess and governmental institutions on feasibility studies, hotel valuations, pricing strategies, asset reviews and optimum site use for both large-scale multi-use projects and stand-alone assets. He has also led several owner-operator Hotel Management Agreement negotiations across a number of jurisdictions.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                                    "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                                    "beginsAt": "2024-04-30 14:55:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Daniel von",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNjc4NjM2LFVzZXJfOTc0MTM4OSk=",
                "jobTitle": "Regional Vice President, Accor One Living",
                "lastName": "Barloewen",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/5cf473e2ddec40608d2edc80e017428d.jpeg",
                "organization": "Head of Mixed-Use (EMEA), Global Development Lead, Accor",
                "biography": "Daniel von Barloewen is the Regional Vice President of Accor One Living and Head of Mixed-Use for Accor for Europe, Middle East, Africa and India. His remit covers development, brand advisory & marketing support for development partners, as well as operations for branded residences, golf, private members’ clubs, and co-working.\n\nBoasting 42 brands, over 6,500 open and pipeline hotels with c.1,000,000 rooms, Accor is the world's 2nd largest branded residential operator (with over 150 open and pipeline residence projects, approximately 25,000 Residences, with more than USD $15bn of value of real estate licensed under 25 of its brands in the Accor and Ennismore portfolio). In 2023 more than $2.2Bn of residential real estate was sold under Accor brands.\n\nAccor offers world class residential expertise, bringing iconic brands and legendary hospitality service to private home ownership. Located in prime urban locations and the sought after resort destinations, our residential properties are a natural extensions of our iconic hotel brands. Providing development partners with a tremendous value creation opportunity, our branded private residences offer the potential to generate significant brand premiums and enhanced hotel economics as a result of co-location strategy, which help drive supplementary revenue (F&B, Spa) to the hotel.\n\nPrior to joining Accor, Daniel von Barloewen founded a real estate consultancy business, Strategic Development Advisors Ltd, which provided a range of development advisory services as well as hotel operator searches and contract negotiation to both institutional and private Attendeess. Before that, he was head of Mixed-Use Development Europe at Marriott International, and previously spent 11 years at Savills where he created and ran the Global Residential Development Consultancy department.\n\nOriginally a development surveyor, Daniel brings an over 18-year track record on the advisory side and hotel operator side of residential, mixed-use and integrated resort development projects, in over 40 countries, with particular expertise on branded residences and co-located hotel and residential development. He is skilled at working with a wide range of Attendees and developer profiles, with the ability to focus strategically on opportunity analysis, value generation, risk reduction, exit strategy, ROI and development strategy evaluation.\n\nDaniel speaks 4 languages, is also a Major in the British Army Reserves, and has served with distinction in Afghanistan. He holds a Bachelors Degree from the University of Durham, a Masters Degree from CASS Business School and is a Member of the Chartered Management Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgxOA==",
        "titleTranslations": [
            {
                "value": "Coffee Break",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 15:10:00",
        "endsAt": "2024-10-02 15:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Branded Residences Forum"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgxOQ==",
        "titleTranslations": [
            {
                "value": "Marketing Case Studies - Short Presentations by Leading Marketing Professionals Who Have Helped Drive the Success of Branded Residence Projects",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 15:15:00",
        "endsAt": "2024-10-02 16:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/G7A6UUSh6bY\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Adelina",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzM1NTk4LFVzZXJfMTk3MjQyNDIp",
                "jobTitle": "Global Head of Residential Marketing",
                "lastName": "Wong Ettelson",
                "photoUrl": "https://static.swapcard.com/public/images/d99bf302a81248ae953388076d11e2a9.jpeg",
                "organization": "Mandarin Oriental Hotel Group",
                "biography": "Adelina Wong Ettelson leads the marketing division for The Residences at Mandarin Oriental. She has been pivotal in establishing the legendary hospitality brand as a global leader in branded residences, launching properties in diverse locales such as London, Bodrum, and Bangkok. As a sought after thought leader on branded residences, she employs her diverse background in luxury fashion, retail, real estate, and hospitality to connect and engage with audiences and stakeholders across domestic and international markets. Prior to joining Mandarin Oriental, she was the Executive Vice President of Marketing at Corcoran Sunshine Marketing Group.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Curtis",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTg1NzAyLFVzZXJfMjA5NjMyMzQp",
                "jobTitle": "CEO & Founder",
                "lastName": "Tischler",
                "photoUrl": "https://static.swapcard.com/public/images/c197a76203a843a897a4353f3abe442e.png",
                "organization": "SagePoint Real Estate Company, INC.",
                "biography": "Curtis L. Tischler is a seasoned leader in resort and urban real estate development with over 20 years of experience specializing in sales, marketing, and consulting for branded hospitality properties and luxury estates. As the CEO and Corporate Broker of SagePoint Real Estate Company, Curtis oversees a boutique firm renowned for its strategic, high-touch approach to both urban and resort markets across the United States and internationally.\n\nCurtis’s career spans a variety of roles across real estate development, private equity, and financial services, driving hundreds of millions in sales revenue. His expertise encompasses pre-development planning, brand strategy, go-to-market execution, multi-channel marketing, brokerage management, DRE compliance, and sales team leadership.\n\nBefore entering real estate, Curtis was an accomplished athlete, spending eight years on the United States and World Championship Ski Team. He holds a Bachelor of Science in Business Management and Finance from the University of Nevada, Reno, and is a licensed broker in California, Nevada, Utah, and Arizona. Curtis’s diverse background and results-driven approach make him a premier authority in the luxury real estate market, adept at fostering connections and driving business growth.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sally",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNzMyNzE4LFVzZXJfMjA4MDk1MTMp",
                "jobTitle": "Founder & Managing Director",
                "lastName": "Maier-Yip",
                "photoUrl": "https://static.swapcard.com/public/images/e167271ea40e48a09196616faa91965f.jpeg",
                "organization": "11K Consulting",
                "biography": "Sally is a trusted cross-cultural communications advisor with a simple mission to help ambitious companies to grow in the complex China market, domestically and abroad.\n\nOver the past two decades, Sally has built a successful career on delivering award-winning multi-stakeholder communications strategies for multi-national and local companies.\n\nIn 2015, Sally founded 11K Consulting - a London-based China-specialist communications consultancy that unlocks the market potential of Chinese high-net-worth-individuals and investors through sharing unique insights, tailored communications strategies and providing unparalleled access. \n\nWith teams in London and Shanghai and affiliate networks in Singapore, Hong Kong, UAE, the USA, and globally, 11K are a team of modern, multi-lingual trusted advisors who are culturally astute, connected and who understand your business priorities as well as the needs and aspirations of these valuable customer groups.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Adrian",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ5MDAzLFVzZXJfMjAyNTIzMDEp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Strittmatter",
                "photoUrl": "https://static.swapcard.com/public/images/e85beecfcc9645db9b251cb36856562f.png",
                "organization": "Saentys",
                "biography": "Adrian Strittmatter is the CEO and founder of Saentys Communication Ltd., the international creative consultancy specializing in the real estate and hospitality sectors since 2008. Under Adrian’s leadership Saentys has grown to over 50 employees, 6 studios and active in over 35 countries. \n\n Adrian is a passionate entrepreneur, leader and public speaker who has in depth and long-standing expertise in the fields of business development, brand strategy, branding, real estate sales and marketing. \n\nHe holds Masters in both Political Science and Media and Communications.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sudhin",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTYwMjcwLFVzZXJfMjA0NTcwODUp",
                "jobTitle": "Chief Asset Management Officer",
                "lastName": "Siva",
                "photoUrl": "https://static.swapcard.com/public/images/e6af2a91ddad4cf9bdec80cb33cf8a3a.jpeg",
                "organization": "Shamal Holding",
                "biography": "Sudhin is an experienced Asset Management & Operations professional brining 20 years of experience in portfolio development, asset management, operations and commercial oversight of diverse portfolios in the real estate, hospitality, food and beverage, leisure, recreation and maritime sectors.\n\nHis core areas of focus are multi-sector asset management, feasibility & investment assessments, strategic planning, portfolio growth, performance and operations management.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Richard",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTY1Mjk2LFVzZXJfMjA0NjA1NzAp",
                "jobTitle": "Group Chief Executive Officer",
                "lastName": "Stevens",
                "photoUrl": "https://static.swapcard.com/public/images/b9975db8f5b840c89803ea7a02ec590c.jpeg",
                "organization": "Sectorlight",
                "biography": "Richard Stevens, Group CEO of brand agency Sectorlight, specialists in luxury property marketing.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgyNA==",
        "titleTranslations": [
            {
                "value": "Legal Structures: Protecting Interests of Investors, Purchasers & Brands",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 15:15:00",
        "endsAt": "2024-10-02 15:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/JfGmMXli3Xw\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Khaled A.",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNjkzNTIyLFVzZXJfODIwMzA5OCk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Kaawar",
                "photoUrl": "https://static.swapcard.com/public/images/2eda337d8e8b4cbbb2ffada160125b4d.jpeg",
                "organization": "Strata Global Holdings",
                "biography": "Khaled Kaawar, an MBA graduate, assumes the role of Chief Executive Officer at Strata Global Holdings. Boasting an illustrious career spanning 31 years in Hotel Management across the UAE and USA, Khaled has garnered extensive experience in various capacities within branded and boutique projects in San Diego, San Francisco, and Los Angeles, establishing himself as a consummate hotelier.\n\nHis visionary leadership has been instrumental in seamlessly integrating hospitality elements into our managed portfolio, elevating the standards of service and quality across all sectors. Khaled leads a team of seasoned professionals, comprising of community managers, customer happiness executives, facility management experts, and procurement specialists, ensuring the delivery of exceptional results and unparalleled client satisfaction.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Lara Y.",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODU3MjM4LFVzZXJfMTQxMDA0NjYp",
                "jobTitle": "Senior Vice President Legal - Luxury & Lifestyle, Special Projects & Global Legal Lead for Accor One Living",
                "lastName": "Barrett",
                "photoUrl": "https://static.swapcard.com/public/images/620ae55a06b64822af6ba7d9b8dc5a7e.jpeg",
                "organization": "Accor",
                "biography": "Lara Barrett has extensive experience in real estate and hospitality transactions, having worked over 25 years for top tier international law firms and hospitality companies. She is responsible for the oversight of the legal transactional and operational issues for hotel and mixed-use properties for Accor and the legal transactional aspects of the M&A special projects for Accor's Luxury & Lifestyle division.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Scott",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODU4OTU2LFVzZXJfMjMzNjI1MSk=",
                "jobTitle": "Founder & Owner",
                "lastName": "Antel",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/750373591fb945a3b6ee3e909a226df6.jpeg",
                "organization": "Scotts FZ LLE",
                "biography": "Scott Antel is a highly respected emerging markets hotels & hospitality lawyer with 25+ years’ experience advising both owners/developers and, less frequently, international operators in the Middle East, Africa, Russia/CIS countries, Turkey, Southern & Eastern Europe and the Caribbean on hotel & resort, branded residential and mixed-use developments.\n\nA former senior partner in DLA Piper and BCLP, Scott regularly advises clients on all aspects of hotel & resort development, with a specific focus on branded residential and mixed-use development, as well as advising on related operational matters, including disputes and litigation.\n\nHe has acted on hundreds of hotel projects including numerous landmark projects such as Sochi 2014, Grand Hotel Europe and Astoria Hotel in St Petersburg, the Ritz Carlton and Mandarin Oriental in Moscow, Four Seasons, Mandarin Oriental and Chedi hotels in Oman, JW Marriott and W Yas Island in the UAE, Sofitel and Hyatt hotel and residence projects in Cyprus and many others projects in numerous locations, including Moscow, St Petersburg, Sochi, Almaty, Istanbul, Bodrum, London, Muscat, Zanzibar, Dubai, Abu Dhabi, Jeddah, Makkah, Riyadh, Tehran, Muscat, Limassol, Crete, Montenegro, Vietnam and more than 15 African countries.\n\nHe also works in the franchise sector advising hotels, restaurants and retail clients and on the structuring and set up of inbound franchise investment and operation, including franchise conversions of managed hotels.\n\nScott is recommended as a \"Leading Adviser\" and \"go to\" hospitality lawyer by Chambers Europe and Legal 500 legal directories and listed in Best Lawyers. He serves on the Advisory Boards of the Arabian, African, Southern European snd Russian Hotel Investment Conferences and is a regular outspoken speaker at these events, as well at the Berlin (IHIF) and ALIS (US) hotel conferences. Scott is a regularly published thought leader and frequently quoted on hospitality related legal and commercial matters.\n\nScott was recipient of the Russia/CIS Hotel Investment Forum's 2012 “Lifetime Achievement Award” for his contribution in developing the hotel industry in these emerging markets, the only lawyer or consultant to ever receive this prestigious award. In 2011 he was elected a member of the International Society of Hospitality Consultants (ISHC). A UK citizen, Scott variously resides in Dubai, London and Moscow.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Richard",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTU1NjgyLFVzZXJfMTc4MTAyMyk=",
                "jobTitle": "Partner",
                "lastName": "Bursby",
                "photoUrl": "https://static.swapcard.com/public/images/be8666ef6d5f4b7f9e05a941090c5aae.png",
                "organization": "Taylor Wessing LLP",
                "biography": "Richard is a partner at Taylor Wessing and leads the Hotels & Hospitality Group.  He has over 20 years' experience of advising Owners, Investors, Developers, Funders and Operators on numerous hotel related projects around the world.  Richard is a recognized expert in Hotel Management and Franchise Agreements and Branded Residences. \n\nHe is top ranked in Chambers and Legal 500 which stated \"Richard Bursby is one of the top experts in our industry and instantly commands respect from other firms we are up against in our contract negotiations. I find this adds huge value to our position from the off.\"",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Moustafa",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTUyMjY0LFVzZXJfMTYwOTUzNzIp",
                "jobTitle": "Founding Partner",
                "lastName": "Said",
                "photoUrl": "https://static.swapcard.com/public/images/18bdf4b7d36e46a4909308223311f493.jpeg",
                "organization": "Wisefields",
                "biography": "Moustafa is a founding partner specialising in real estate, hotels, and tourism. He has extensive experience in real estate, particularly in hotel and branded residence developments. \n\nWith considerable experience in the United Arab Emirates, Saudi Arabia, and other jurisdictions in the region, Moustafa represent numerous prominent master developers, sub-developers, and hotel owners and operators in the region, earning recognition for his sophisticated development practice. \n\nHe has been recognised as a leading real estate lawyer by Chambers Global from 2014 through 2022, and by Legal 500 EMEA for 2014, 2016 through to 2023.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                                    "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzk1NQ==",
        "titleTranslations": [
            {
                "value": "The Leading Edge of Global Residential Markets - Examining The Role of Innovation, Architecture and Design in Branded Residence Projects",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 15:15:00",
        "endsAt": "2024-10-02 15:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/a6u43Fq7RBw\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Philip S.",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNzI3NTkxLFVzZXJfMjA4MDc2NDcp",
                "jobTitle": "Managing Director",
                "lastName": "Gillard",
                "photoUrl": "https://static.swapcard.com/public/images/c6f0306a44ed40459dd68e4ac2a00115.jpeg",
                "organization": "Arquitectonica",
                "biography": "Since commencing his career in the Middle East in 2001, Philip S. Gillard has dedicated over two decades to transforming the regional landscape. He currently spearheads the newest office of the global architectural powerhouse, Arquitectonica, marking its 11th worldwide. The firm’s reach extends across more than 50 countries, where the team develops ultra-luxury branded designs across various sectors, including residential, mixed-use, hospitality, and more. With each project in their portfolio, characterised by efficient plans wrapped in a series of cutting-edge and environmentally stringent designs, they are every corner of the globe.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Federica",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNzYzNjY2LFVzZXJfMTMwMDc4ODUp",
                "jobTitle": "Associate",
                "lastName": "Grignolo",
                "photoUrl": "https://static.swapcard.com/public/images/db9d44432901412dba410405c5020750.jpeg",
                "organization": "Studio Carter",
                "biography": "Italian-French nationality, born in Turin (Italy).\nGraduated in Architecture at the Polytechnic University in Turin (Italy) and ETSAM - Polytechnic University in Madrid (Spain).\n2013-2018: Worked in high end residential interior architecture projects at Tomèf Design (London - UK) as interior designer and local architect for prestigious French interior decorators. Projects for private Clients spanning across London's boroughs of Mayfair, Knightsbridge, South Kensington, Chelsea, Westminster.\n2018-2022: Moved to hospitality projects at Rockwell Group Madrid (Spain). Working with brands such as JW Marriott, The Edition, Ritz-Carlton, W, Hard Rock, Royal Caribbean and Norwegian Cruise Line. Interior Design, project managing and overviewing materials and FF&E specifications. \n2022-ongoing: joined Studio Carter as Senior Designer then Associate, deepening and elevating the knowledge in the hospitality sector. Brands and projects to date include SLS, Six Senses, One&Only, resorts in Red Sea (KSA), residential developments in Dubai.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Wissal",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNTQ3MTI4LFVzZXJfMjEzMDM4NTIp",
                "jobTitle": "Interior Designer",
                "lastName": "Jarjour",
                "photoUrl": "https://static.swapcard.com/public/images/148774464bc143e5a399abe7639af512.jpeg",
                "organization": "Dubai Holding Investments",
                "biography": "Wissal is an accomplished interior architect with over 22 years of experience in the fields of hospitality, residential, and commercial projects. She began her career in FF&E (Furniture, Fixtures, and Equipment) design and gradually transitioned into a role as a client representative. Throughout her career, Wissal has developed a deep passion for design space planning and has honed her skills in creating detailed and meticulous designs.\nWith her experience and expertise, Wissal has been entrusted with leadership roles where she oversees and coordinates with various consultants to ensure successful project execution. She excels in identifying and addressing site-specific challenges and is adept at finding innovative solutions. Wissal's meticulous attention to detail allows her to effectively manage complex design projects while maintaining a high standard of quality.\nIn her role as an interior architect, Wissal has worked on a diverse range of projects, such as hotels, resorts, luxury residences, office spaces, retail stores, and more. Her comprehensive knowledge of different sectors within the industry enables her to adapt her skills and design approach to suit the specific requirements of each project.\nOverall, Wissal's experience, passion for design, and strong mindfulness make her a valuable asset in the field of interior architecture, allowing her to deliver exceptional project.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Mark",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDAyNTIzLFVzZXJfMjA1OTk3ODcp",
                "jobTitle": "Global VP Design",
                "lastName": "Eacott",
                "photoUrl": "https://static.swapcard.com/public/images/054c0fb6144a4ce5b7674e82c4f827b1.jpeg",
                "organization": "Ennismore",
                "biography": "Mark joined Ennismore in 2018 from Los Angeles as part of the Accor acquisition of the SBE Lifestyle Brands. Bringing with it his in-depth knowledge of the SLS, Mondrian, HYDE, and Delano legacy brands, Mark was part of a small team based out of Singapore, instrumental in the growth of Ennismore in Asia-Pacific.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Andy",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNTQ5MzEwLFVzZXJfMTA4NDE4Mzkp",
                "jobTitle": "Head of Global Residential Development Sales",
                "lastName": "Hawkins",
                "photoUrl": "https://static.swapcard.com/public/images/bd01a52490254818a0aeb8a2ffc5954a.jpeg",
                "organization": "Savills",
                "biography": "Andy is responsible for teams specialising in the global sale of residential development projects for Savills UK.  He has been in the industry for over 15 years and has worked a number of high profile projects in the UK, Europe, the US and Middle East.\n\nAndy has in depth experience of advising on and delivering strategic campaigns for branded residences both in the UK and around the World, as well as large scale multi-phase projects.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgyMw==",
        "titleTranslations": [
            {
                "value": "Structuring Rentals Programs to Appeal to Buyers, While Protecting the Interests of Hotel Owners & Developers",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 15:45:00",
        "endsAt": "2024-10-02 16:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Barry",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNjY2MzU0LFVzZXJfMTI0MTE1ODIp",
                "jobTitle": "Principal",
                "lastName": "Landsberg",
                "photoUrl": null,
                "organization": "Landsberg Residential Consulting Inc.",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Carlos",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMzIwMjcyLFVzZXJfNDQxNzA3MCk=",
                "jobTitle": "Executive Chairman and Board Member",
                "lastName": "Leal",
                "photoUrl": "https://static.swapcard.com/public/images/ba4bdf48913f453abc302161a6447d06.jpeg",
                "organization": "United Hospitality Management (UHM)",
                "biography": "Carlos Leal serves as both the CEO at United Investments Portugal (UIP) and the Executive Chairman at United Hospitality Management (UHM). Under his strategic leadership, he has propelled the company to attain a prominent market position in Portugal's development, construction, and management of mixed-use tourist development projects. Additionally, Carlos holds the position of Head of Asset Management at IFA Hotels & Resorts (Kuwait) and is a member of the Advisory Committee at the Fund FCR C2 R&D Growth IV (Portugal).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Rico",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODUwMjkyLFVzZXJfMTU3MTMyNDkp",
                "jobTitle": "Head of Global Residential Development Consultancy",
                "lastName": "Picenoni",
                "photoUrl": "https://static.swapcard.com/public/images/b0a1c9d0c3b24b52b91cb27bd540cb8c.jpeg",
                "organization": "Savills",
                "biography": "Rico is head of global residential development consultancy with Savills UK, with a background in hotel and branded residential strategy including programming, mixed-use integration & standalone branding models, as well as best practices in legal & contractual structuring within the greater hospitality context.\n\nRico works in international markets including North America, Europe, the Middle East and APAC. His experience involves project feasibility, contract negotiations & commercial structuring, as well as operational structuring and mixed-use integration.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Daniel von",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNjc4NjM2LFVzZXJfOTc0MTM4OSk=",
                "jobTitle": "Regional Vice President, Accor One Living",
                "lastName": "Barloewen",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/5cf473e2ddec40608d2edc80e017428d.jpeg",
                "organization": "Head of Mixed-Use (EMEA), Global Development Lead, Accor",
                "biography": "Daniel von Barloewen is the Regional Vice President of Accor One Living and Head of Mixed-Use for Accor for Europe, Middle East, Africa and India. His remit covers development, brand advisory & marketing support for development partners, as well as operations for branded residences, golf, private members’ clubs, and co-working.\n\nBoasting 42 brands, over 6,500 open and pipeline hotels with c.1,000,000 rooms, Accor is the world's 2nd largest branded residential operator (with over 150 open and pipeline residence projects, approximately 25,000 Residences, with more than USD $15bn of value of real estate licensed under 25 of its brands in the Accor and Ennismore portfolio). In 2023 more than $2.2Bn of residential real estate was sold under Accor brands.\n\nAccor offers world class residential expertise, bringing iconic brands and legendary hospitality service to private home ownership. Located in prime urban locations and the sought after resort destinations, our residential properties are a natural extensions of our iconic hotel brands. Providing development partners with a tremendous value creation opportunity, our branded private residences offer the potential to generate significant brand premiums and enhanced hotel economics as a result of co-location strategy, which help drive supplementary revenue (F&B, Spa) to the hotel.\n\nPrior to joining Accor, Daniel von Barloewen founded a real estate consultancy business, Strategic Development Advisors Ltd, which provided a range of development advisory services as well as hotel operator searches and contract negotiation to both institutional and private Attendeess. Before that, he was head of Mixed-Use Development Europe at Marriott International, and previously spent 11 years at Savills where he created and ran the Global Residential Development Consultancy department.\n\nOriginally a development surveyor, Daniel brings an over 18-year track record on the advisory side and hotel operator side of residential, mixed-use and integrated resort development projects, in over 40 countries, with particular expertise on branded residences and co-located hotel and residential development. He is skilled at working with a wide range of Attendees and developer profiles, with the ability to focus strategically on opportunity analysis, value generation, risk reduction, exit strategy, ROI and development strategy evaluation.\n\nDaniel speaks 4 languages, is also a Major in the British Army Reserves, and has served with distinction in Afghanistan. He holds a Bachelors Degree from the University of Durham, a Masters Degree from CASS Business School and is a Member of the Chartered Management Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzk1Ng==",
        "titleTranslations": [
            {
                "value": "Strategies to Drive the Development and Operation of Sustainable Homeowner Communities that Deliver on Health and Wellbeing Objectives",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 15:45:00",
        "endsAt": "2024-10-02 16:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/uN06G-C_myY\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "inspiration-workshop-room",
                "translations": [
                    {
                        "value": "Workshops (Murjaan)"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzNTQ1MjkwLFVzZXJfMjEzMDI2NTQp",
                "jobTitle": "Founder and CEO",
                "lastName": "Roux",
                "photoUrl": "https://static.swapcard.com/public/images/b2857ac9a89e433cb44417ed8e864e1c.png",
                "organization": "Rive Gauche London",
                "biography": "Founder and CEO Nicolas Roux brings over 20 years’ international experience with globally renowned studios, including Candy & Candy and Terence Conran. \n\nHis experience covers a broad range, from luxury private residences and residential developments, to fashion retailers and boutique hotel. Past projects include: One Hyde Park, London, a €90M residence in Monaco, The Four Seasons Residences in Astana, a high-rise luxury development in Kuala Lumpur and the Marc Jacobs retail store in London. \n\nIn 2024 Nicolas owns and is the CEO of Rive Gauche London - an established, multi-award winning, world-class team of designers, architects and technical specialists who cover the end-to-end range of skills needed to deliver exceptional design and build projects.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Ashley",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjg5NDI2LFVzZXJfMTE2NDE3NjMp",
                "jobTitle": "Global Practice Principal, Planning + Landscape",
                "lastName": "Scott",
                "photoUrl": "https://static.swapcard.com/public/images/3f4fe06196d24fd18ff32bbcf1c7f193.jpeg",
                "organization": "WATG",
                "biography": "Ashley Scott is a Master Planner and Landscape Architect with more than twenty-five years of experience in design management and thought leadership. His portfolio of work represents a wide range of resort project types and scales, and spans Europe, the Middle East, Asia and Latin America.\n\nPrior to joining WATG in late 2019, Ashley was the Global Lead for the Resort Master Planning and Landscape Architecture sector of AECOM, where he managed a cohesive and experienced team of over seventy-five Master Planners and Landscape Architects in London and across the UK.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Ricardo",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjIxMzIyLFVzZXJfMzc3NTY2OSk=",
                "jobTitle": "Managing Director",
                "lastName": "Moreira",
                "photoUrl": "https://static.swapcard.com/public/images/6e8b77a231714caa8c090a646b664940.jpeg",
                "organization": "XCO2",
                "biography": "A leading expert in sustainability in the hospitality industry for nearly 20 years, Ricardo Moreira is founder and managing director of XCO2, a Sustainability and Engineering consultancy based in London and Singapore. He is responsible for the company’s overall management and leads some of its key decarbonisation projects around the world, supporting owners, investors and operators in achieving their sustainability ambitions. \n\nWith both architectural and engineering backgrounds, he brings a technical focus to discussions, and a design integration approach to deliver robust sustainability solutions. The company is currently involved in hospitality projects in Europe, Americas, Middle East and Asia.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Emlyn",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTcyMjY3LFVzZXJfMTYzNTM5NDAp",
                "jobTitle": "Senior Vice President - Well-Being",
                "lastName": "Brown",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/8d523bcf11cf4589bfebfdfc3c2f5251.jpeg",
                "organization": "Accor",
                "biography": "Emlyn throughout his 22-year career, he has occupied various pivotal leadership roles in Wellness, traversing the globe from Europe to the Middle East, Asia and China helming group operations for a number of luxury spa and fitness companies\n\nPrior to joining Accor, he was a senior lead at Resense Spas as Global Design Director and MD of Asia, accountable for the growth of the Resense portfolio in China and Southeast Asia.\n\nEmlyn was also wellness director at award-winning consultancy, GOCO Hospitality and has held senior positions at Six Senses Resorts & Spas where he was the regional director for Europe and later operations director for Asia.\n\nToday he is responsible for driving the strategic development and design strategy for wellness at Accor, seamlessly integrating the ethos of wellbeing into every facet of the customer journey.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Paul",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODUwNTQ0LFVzZXJfMjAyNTMxMTYp",
                "jobTitle": "Managing Director",
                "lastName": "Rands",
                "photoUrl": "https://static.swapcard.com/public/images/7cefd223526446a39cd9fc92d3c167c2.jpeg",
                "organization": "Future of Hospitality Institute",
                "biography": "Paul leads the Future of Hospitality Institute, PKF hospitality group's think tank for the hotel and  living sectors. Future Living is its principal research project, now in its second two year phase, which brings together a community of industry stakeholders, cooperating alongside research institutions and universities to identify major changes and innovations for the future of the serviced living sector.\n\nPrior to joining Future of Hospitality Institute in 2022, Paul led international development and asset management for serviced apartment operator BridgeStreet, and previously held development roles with various operators in the hospitality sector.\n\nHe resides in the UK and is a Chartered Member of the Royal Institution of Chartered Surveyors (RICS).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzk1Nw==",
        "titleTranslations": [
            {
                "value": "Making Standalones Work - Bringing the Brand to Life in the Absence of a Co-Located Hotel",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 15:45:00",
        "endsAt": "2024-10-02 16:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/zgaR-wkwvYE\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Mitra",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMTcyMTk5LFVzZXJfMzI2NTUxNSk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Ghamsari",
                "photoUrl": "https://static.swapcard.com/public/images/1283699d1ef040a1a1ed098536a7b2eb.jpeg",
                "organization": "Persepolis Investments",
                "biography": "Coming from the United States, Mitra came to Spain in 2014 to start Persepolis Investments. Mitra has 15+ years of experience in investments and real estate. Coming from a Wall Street background, she has worked as a Portfolio Manager in hedge funds such as Laurion Capital and Autonomy Capital. She has a Master’s Degree in Computer Science & Management from Stanford University.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jean-Baptiste",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMDI5MTYyLFVzZXJfMTQ2ODI3OCk=",
                "jobTitle": "Regional VP Development Luxury Brands MEAT",
                "lastName": "Recher",
                "photoUrl": "https://static.swapcard.com/public/images/b7599a092b6942bc85b0e47624e17766.jpeg",
                "organization": "Accor",
                "biography": "As RVP Development Luxury Brands MEAT, Jean-Baptiste leads Accor Group's development in over 75 countries for luxury brands, including Orient Express, Raffles, Fairmont, and Sofitel. With well over a decade of experience at companies such as JLL and Marriott, he has held roles in real estate advisory, feasibility studies, and asset management across France, the UK, and the Middle East and Africa. Jean-Baptiste holds an MBA in International Hospitality Management from ESSEC Business School and a Master's in Hotel and Tourism Management from Hong Kong Polytechnic University.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Peter",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyMjkyMDY1LFVzZXJfMjA1MzM4NzMp",
                "jobTitle": "Principal and Managing Director",
                "lastName": "Bazeli",
                "photoUrl": "https://static.swapcard.com/public/images/d0bb1f67dd6444ebb02e890ec1dd96d1.jpeg",
                "organization": "Weitzman",
                "biography": "Peter Bazeli is a Principal and Managing Director of Weitzman, a development advisory firm based in New York City.  Peter’s core expertise is the conceptualization, planning and execution support for luxury residential and mixed-use developments in both urban and resort markets. As the leading branded residential development advisor in North America, Peter has consulted on several hundred branded residential development opportunities, often performing a critical ongoing role in a property’s successful development and sales program.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Rosa",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDM2OTEwLFVzZXJfODE1NTUzNSk=",
                "jobTitle": "Senior Business Development Director",
                "lastName": "Piro",
                "photoUrl": "https://static.swapcard.com/public/images/08f9fc81218941db8921678dc03d98ca.jpeg",
                "organization": "Arada",
                "biography": "Rosa Piro’s wide portfolio of responsibilities includes the expansion of Arada’s interests via new projects, as well as evaluating investments in new business segments. She also oversees and maintains all commercial and institutional partnerships in healthcare, education, hospitality, and branded residences, adjusting the anchor strategy for each based on the needs of Arada’s communities. Rosa proposed and established the collaboration with Armani Group for Arada’s luxury residential project Armani Beach Residences at Palm Jumeirah, and she is currently working on establishing an ESG vertical to help the company work towards achieving sustainability goals.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjE0NjM4NA==",
        "titleTranslations": [
            {
                "value": "Shared Ownership in Dubai and Across Region. Is the Promise of Vacation Ownership, Fractional and Private Residence Clubs about to be Realized?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 16:30:00",
        "endsAt": "2024-10-02 16:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/MIZ5t1dysM0\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Barry",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTYyMDE5LFVzZXJfMjEzNTY5Njkp",
                "jobTitle": "President and Managing Director International Operations",
                "lastName": "Robinson",
                "photoUrl": "https://static.swapcard.com/public/images/390b7dc3654344f89acb74e89d46febd.jpeg",
                "organization": "Travel and Leisure Co",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jeff",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxNjkxOTI3LFVzZXJfMTc4MTEwNSk=",
                "jobTitle": "Chief Business Officer, Accor One Living",
                "lastName": "Tisdall",
                "photoUrl": "https://static.swapcard.com/public/images/93e21228749a4f0480a74e05cd7f65e4.jpeg",
                "organization": "Global Head of Mixed-Use, Accor",
                "biography": "Jeff Tisdall is Chief Business Officer, Accor One Living and Global Head of Mixed-Use. Accor One Living is an industry first mixed-use platform, focussed on the development and operation of branded residences. Leveraging Accor’s two decades of residential experience pioneered under iconic brands like Fairmont and Raffles, the Group is now developing trend setting residential solutions across luxury, lifestyle, premium and midscale segments.  \n\nPrior to joining Accor in 2013 (via FRHI Hotels and Resorts), Tisdall was the Managing Director of Singapore-based LIFT, where he served as branded residential advisor to FRHI and the Jumeirah Group. Previously, Tisdall worked with Wyndham Worldwide in Dubai, as Managing Director with responsibility for the company’s RCI and Registry Collection brands in the Middle East and North Africa region. He was also Vice President of Real Estate at Kingdom Hotel Investments, where he managed the company’s residential and commercial real estate portfolio. Earlier in his career, Tisdall spent 13 years with Intrawest, leaving as a Senior Vice President at the company’s premium vacation ownership division.  \n\nTisdall holds a degree from McGill University in Canada and lives in Dubai with his family.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjAyNzgyMg==",
        "titleTranslations": [
            {
                "value": "Future Telling – What Shapes and Forms will Branded Residences Take in Coming Years",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-10-02 16:45:00",
        "endsAt": "2024-10-02 17:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ml1Hzx_TTqc\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences-forum",
                "translations": [
                    {
                        "value": "Branded Residences Forum"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Bernardo",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMzMTM1Mjc4LFVzZXJfMjEwNTAzMTgp",
                "jobTitle": "Founder & Principal",
                "lastName": "Fort-Brescia",
                "photoUrl": "https://static.swapcard.com/public/images/bbcbb3e0ceee4d2aa8ef13e91b65fdff.jpeg",
                "organization": "Arquitectonica",
                "biography": "Bernardo Fort-Brescia is a founding principal of Arquitectonica. A native of Lima, he did his early studies in Peru and Europe where he learned multiple languages which would later prove useful for his international career. He studied architecture and urban planning at Princeton University and received a Master of Architecture from Harvard University, where he later taught. He moved to Florida in 1975 to teach at the University of Miami. In 1977 he founded Arquitectonica with a group of young architects and set up a studio in Coconut Grove. Bernardo led the charge of expanding the firm across the country and abroad. The firm is known as one of the pioneers of globalization in the architecture profession. With over 50 branded residential projects, attendees will gain valuable insights from a leading figure whose work continues to shape the sector across the globe.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Imran A",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyNDIyOTA0LFVzZXJfMTQ1MzY3NzMp",
                "jobTitle": "Executive Director Hospitality Development",
                "lastName": "Changezi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/965736d924cf4f0983b4237033eacf72.jpeg",
                "organization": "Diriyah Company",
                "biography": "Imran is a seasoned hospitality professional operator who has worked in Sales & Marketing, Revenue Management and Rooms Operations, subsequently rising through General Management & leadership positions in a number of international luxury hotel brands across 5 different continents covering countries including UAE, UK, USA, Azerbaijan, Egypt, Australia, and Zambia. \n\nIn his hospitality career spanning over 30 years, Imran spent 16 years with Jumeirah Hotels & Resorts where he led Sales & Marketing functions at property, cluster & at corporate level before growing in operational and executive management roles at iconic hotels such as Jumeirah Beach Hotel, Jumeirah Emirates Towers and Burj Al Arab. Imran then continued to build upon his professional credentials further by working in leadership roles with the Four Seasons, Accor, Anantara and The Aga Khan Foundation. \n\nImran joined Diriyah Company in 2020 to manage its business development function for the hospitality assets. He has since then enjoyed consistent growth & recognition whilst contributing to the organization’s hospitality asset development strategy, positioning, selection of hotel & branded residence operators and leading Hotel & Branded Residences Management Agreement negotiations. \n\nIn 2023, Imran was given additional responsibilities in Diriyah and appointed as ‘Centre of Expertise’ (COE) for Hospitality Asset Class in Diriyah Company. He currently leads the Hospitality Development practice as Executive Director and is responsible for strategic guidance and leadership across a diverse portfolio of 40 hotels & resorts and 18 Luxury Branded Residence projects currently under development across 5 masterplans. \n\nImran holds an MBA degree from the prestigious London Business School, UK and earned his General Managers Program (GMP) certification from Cornell University, USA.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Pier Paolo",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ5OTM4LFVzZXJfMjAyNTI3Nzcp",
                "jobTitle": "CEO & President",
                "lastName": "Righi",
                "photoUrl": "https://static.swapcard.com/public/images/79c118f294c24c3b90c2504e9ba9b93b.jpeg",
                "organization": "Karl Lagerfeld",
                "biography": "Pier Paolo Righi, CEO & President of KARL LAGERFELD, is half-Italian and half-German, and has over 30 years of experience in the international fashion, sports and lifestyle industries.\n\nSince joining KARL LAGERFELD in 2011, Righi spearheaded the launch of the KARL LAGERFELD brand and helped grow its consumer sales to more than $1.5 billion to date. For many years, he worked in tandem and close collaboration with the late design icon Karl Lagerfeld, the former creative director of his namesake House, as well as Chanel and Fendi.\n\nUnder Righi’s leadership, the House has expanded globally and successfully ventured into new categories beyond fashion, including residential projects and hospitality. This includes the first KARL LAGERFELD branded luxury hotel in Macau, plus luxury residential developments in Spain, Portugal, the UAE and Southeast Asia.\n\nPrior to joining KARL LAGERFELD, Righi worked for nearly a decade at Nike, including seven years as General Manager CEMEA. He has also held various senior management positions within international groups including Tommy Hilfiger and Pentland Brands Limited. Righi has lived in Amsterdam, Frankfurt, Munich, Milan and Paris. He currently serves in several non-executive boards across various industries.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Riyan",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMxODQ1MTA0LFVzZXJfMTU0MTIzMzEp",
                "jobTitle": "Founder",
                "lastName": "Itani",
                "photoUrl": "https://static.swapcard.com/public/images/0a8fedf8c19444388ccf07bf5208b2c7.jpeg",
                "organization": "Global Branded Residences",
                "biography": "For over 20 years, Riyan Itani has specialised in providing branded and luxury residential development consultancy in the global urban and resort sectors. His experience covers brand /operator selection and contract negotiation, strategic development advice, feasibility studies, and brand premium studies. Considered a global market-leader in branded residential advisory, Riyan is a multi-award-winning consultant and has worked on over 130 branded residential schemes across the globe.\n\nGlobal Branded Residences (GBR) is a specialist development consultancy firm that provides market & data-driven advisory services for branded residential developments around the world, delivered by a team of renowned industry leaders. GBR’s services range from brand / operator selection and negotiation to product & pricing definition, as well as feasibility studies and brand premium studies.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Peter",
                "id": "U3BlYWtlcihFdmVudF8xNzUxMzUzLEV2ZW50UGVvcGxlXzMyOTEwOTg1LFVzZXJfMTkyNzE0MTAp",
                "jobTitle": "Futurist and Founder of AI & Communications agency",
                "lastName": "Heneghan",
                "photoUrl": "https://static.swapcard.com/public/images/536c882dc333446f810758bd092173ef.webp",
                "organization": "The Future Communicator",
                "biography": "Peter Heneghan, Founder of The Future Communicator, is an award-winning AI and communications expert with experience at BBC News, Channel 4, BuzzFeed, and 10 Downing Street. As the UK Government's Chief Digital Communicator, he modernized its strategy. His agency delivers AI-driven strategies for high-end clients, including the UN, Arts Council England, a Formula One team, and luxury brands. Peter helps luxury businesses stay ahead of trends, enhancing customer experiences and efficiency. With expertise in AI adoption, he ensures smooth integration of both technology and staff. He’s a Cannes Lions Grand Prix winner and guest lecturer at London Business School.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences Forum"
        ]
    }
]